/* eslint-disable */
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /** AWSFile Type */
  AWSFile: { input: any; output: any; }
  /** AchSourceDetail Type */
  AchSourceDetail: { input: any; output: any; }
  /** AgencyQualificationAttributeValue Type */
  AgencyQualificationAttributeValue: { input: any; output: any; }
  /** A date string, such as 2007-12-03, compliant with the `full-date` format outlined in section 5.6 of the RFC 3339 profile of the ISO 8601 standard for representation of dates and times using the Gregorian calendar. */
  Date: { input: any; output: any; }
  /** A date and time, represented as an ISO-8601 string */
  DateTime: { input: string; output: string; }
  /** The `JSON` scalar type represents JSON values as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSON: { input: Record<string, any>; output: Record<string, any>; }
  /** ProfessionalQualificationAttributeValue Type */
  ProfessionalQualificationAttributeValue: { input: any; output: any; }
  /** The tz field in PG/JS Format */
  TZ: { input: any; output: any; }
  /** A time string at UTC, such as 10:15:30Z, compliant with the `full-time` format outlined in section 5.6 of the RFC 3339profile of the ISO 8601 standard for representation of dates and times using the Gregorian calendar. */
  Time: { input: any; output: any; }
  /** A field whose value is a generic Universally Unique Identifier: https://en.wikipedia.org/wiki/Universally_unique_identifier. */
  UUID: { input: any; output: any; }
};

export type Account = {
  __typename?: 'Account';
  account_billing_groups: Maybe<Array<Maybe<AccountBillingGroup>>>;
  account_locations: Maybe<Array<Maybe<AccountLocation>>>;
  account_type: Scalars['String']['output'];
  address_city: Maybe<Scalars['String']['output']>;
  address_first: Maybe<Scalars['String']['output']>;
  address_second: Maybe<Scalars['String']['output']>;
  address_zip: Maybe<Scalars['String']['output']>;
  administrator: Maybe<Administrator>;
  agency: Maybe<Agency>;
  agency_id: Maybe<Scalars['Int']['output']>;
  announcements_already_seen: Array<Maybe<Scalars['String']['output']>>;
  billing_groups: Maybe<Array<Maybe<BillingGroup>>>;
  calculated_group_node_ids: Array<Scalars['Int']['output']>;
  calculated_permissions: Scalars['JSON']['output'];
  company: Maybe<Company>;
  company_id: Maybe<Scalars['Int']['output']>;
  coordinates: Maybe<Coordinates>;
  created_at: Scalars['DateTime']['output'];
  current_sign_in_at: Maybe<Scalars['DateTime']['output']>;
  custom_permissions: Scalars['JSON']['output'];
  direct_locations: Array<Location>;
  email: Scalars['String']['output'];
  email_notification: Maybe<Scalars['Boolean']['output']>;
  encrypted_password: Maybe<Scalars['String']['output']>;
  external_id: Maybe<Scalars['String']['output']>;
  first_name: Maybe<Scalars['String']['output']>;
  group_node_ids: Array<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  invite_last_sent_at: Maybe<Scalars['DateTime']['output']>;
  is_saas_professional: Maybe<Scalars['Boolean']['output']>;
  last_name: Maybe<Scalars['String']['output']>;
  last_sign_in_at: Maybe<Scalars['DateTime']['output']>;
  locations: Maybe<Array<Maybe<Location>>>;
  middle_name: Maybe<Scalars['String']['output']>;
  migrated_person_id: Maybe<Scalars['Int']['output']>;
  name: Maybe<Scalars['String']['output']>;
  notification_settings: Scalars['JSON']['output'];
  permission_groups: Maybe<Array<Maybe<PermissionGroup>>>;
  phone_number: Maybe<Scalars['String']['output']>;
  phone_number_sms_enabled: Maybe<Scalars['Boolean']['output']>;
  primary_locations: Maybe<Array<Maybe<Location>>>;
  professional: Maybe<Professional>;
  remember_created_at: Maybe<Scalars['DateTime']['output']>;
  reset_password_sent_at: Maybe<Scalars['DateTime']['output']>;
  reset_password_token: Maybe<Scalars['String']['output']>;
  sign_in_count: Scalars['Int']['output'];
  sign_up_completed_at: Maybe<Scalars['DateTime']['output']>;
  sms_notification: Scalars['Boolean']['output'];
  sms_notification_bulk: Scalars['Boolean']['output'];
  ssn_last_4: Maybe<Scalars['String']['output']>;
  state: Maybe<State>;
  state_id: Maybe<Scalars['Int']['output']>;
  status: Maybe<Scalars['String']['output']>;
  title: Maybe<Scalars['String']['output']>;
  uid: Scalars['String']['output'];
  unsubscribe: Scalars['Boolean']['output'];
  unsubscribe_token: Maybe<Scalars['String']['output']>;
  updated_at: Scalars['DateTime']['output'];
  user_hash: Maybe<Scalars['String']['output']>;
};

export type AccountBillingGroup = {
  __typename?: 'AccountBillingGroup';
  account: Account;
  account_id: Scalars['Int']['output'];
  billing_group: BillingGroup;
  billing_group_id: Scalars['Int']['output'];
  created_at: Scalars['DateTime']['output'];
  id: Scalars['Int']['output'];
  updated_at: Scalars['DateTime']['output'];
};

export type AccountBillingGroupOrderInput = {
  account_id: InputMaybe<Scalars['Boolean']['input']>;
  billing_group_id: InputMaybe<Scalars['Boolean']['input']>;
  created_at: InputMaybe<Scalars['Boolean']['input']>;
  id: InputMaybe<Scalars['Boolean']['input']>;
  updated_at: InputMaybe<Scalars['Boolean']['input']>;
};

export type AccountBillingGroupQueryInput = {
  filter: InputMaybe<AccountBillingGroupWhereInput>;
  orderBy: InputMaybe<AccountBillingGroupOrderInput>;
  page: InputMaybe<Scalars['Int']['input']>;
  perPage: InputMaybe<Scalars['Int']['input']>;
  search: InputMaybe<AccountBillingGroupSearchInput>;
};

export type AccountBillingGroupSearchInput = {
  billing_group_ids: InputMaybe<Scalars['Int']['input']>;
  /**
   * *Constraints:*
   * * Maximal length: `150`
   *
   */
  q: InputMaybe<Scalars['String']['input']>;
};

export type AccountBillingGroupWhereInput = {
  account_id: InputMaybe<Scalars['Int']['input']>;
  billing_group_id: InputMaybe<Scalars['Int']['input']>;
  created_at: InputMaybe<Scalars['DateTime']['input']>;
  id: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  updated_at: InputMaybe<Scalars['DateTime']['input']>;
};

export type AccountLocation = {
  __typename?: 'AccountLocation';
  account: Account;
  account_id: Scalars['Int']['output'];
  created_at: Scalars['DateTime']['output'];
  id: Scalars['Int']['output'];
  location: Location;
  location_id: Scalars['Int']['output'];
  source: Scalars['String']['output'];
  updated_at: Scalars['DateTime']['output'];
};

export type AccountLocationOrderInput = {
  account_id: InputMaybe<Scalars['Boolean']['input']>;
  created_at: InputMaybe<Scalars['Boolean']['input']>;
  id: InputMaybe<Scalars['Boolean']['input']>;
  location_id: InputMaybe<Scalars['Boolean']['input']>;
  updated_at: InputMaybe<Scalars['Boolean']['input']>;
};

export type AccountLocationQueryInput = {
  filter: InputMaybe<AccountLocationWhereInput>;
  orderBy: InputMaybe<AccountLocationOrderInput>;
  page: InputMaybe<Scalars['Int']['input']>;
  perPage: InputMaybe<Scalars['Int']['input']>;
  search: InputMaybe<AccountLocationSearchInput>;
};

export type AccountLocationSearchInput = {
  location_ids: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  /**
   * *Constraints:*
   * * Maximal length: `150`
   *
   */
  q: InputMaybe<Scalars['String']['input']>;
};

export type AccountLocationWhereInput = {
  account_id: InputMaybe<Scalars['Int']['input']>;
  created_at: InputMaybe<Scalars['DateTime']['input']>;
  id: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  location_id: InputMaybe<Scalars['Int']['input']>;
  updated_at: InputMaybe<Scalars['DateTime']['input']>;
};

export type AccountOrderInput = {
  account_type: InputMaybe<Scalars['Boolean']['input']>;
  address_city: InputMaybe<Scalars['Boolean']['input']>;
  address_first: InputMaybe<Scalars['Boolean']['input']>;
  address_second: InputMaybe<Scalars['Boolean']['input']>;
  address_zip: InputMaybe<Scalars['Boolean']['input']>;
  calculated_permissions: InputMaybe<Scalars['Boolean']['input']>;
  company_id: InputMaybe<Scalars['Boolean']['input']>;
  created_at: InputMaybe<Scalars['Boolean']['input']>;
  current_sign_in_at: InputMaybe<Scalars['Boolean']['input']>;
  current_sign_in_ip: InputMaybe<Scalars['Boolean']['input']>;
  custom_permissions: InputMaybe<Scalars['Boolean']['input']>;
  email: InputMaybe<Scalars['Boolean']['input']>;
  email_notification: InputMaybe<Scalars['Boolean']['input']>;
  encrypted_password: InputMaybe<Scalars['Boolean']['input']>;
  first_name: InputMaybe<Scalars['Boolean']['input']>;
  id: InputMaybe<Scalars['Boolean']['input']>;
  invite_last_sent_at: InputMaybe<Scalars['Boolean']['input']>;
  last_name: InputMaybe<Scalars['Boolean']['input']>;
  last_sign_in_at: InputMaybe<Scalars['Boolean']['input']>;
  last_sign_in_ip: InputMaybe<Scalars['Boolean']['input']>;
  middle_name: InputMaybe<Scalars['Boolean']['input']>;
  migrated_person_id: InputMaybe<Scalars['Boolean']['input']>;
  phone_number: InputMaybe<Scalars['Boolean']['input']>;
  remember_created_at: InputMaybe<Scalars['Boolean']['input']>;
  reset_password_sent_at: InputMaybe<Scalars['Boolean']['input']>;
  reset_password_token: InputMaybe<Scalars['Boolean']['input']>;
  sign_in_count: InputMaybe<Scalars['Boolean']['input']>;
  sms_notification: InputMaybe<Scalars['Boolean']['input']>;
  sms_notification_bulk: InputMaybe<Scalars['Boolean']['input']>;
  ssn_last_4: InputMaybe<Scalars['Boolean']['input']>;
  state_id: InputMaybe<Scalars['Boolean']['input']>;
  tsv: InputMaybe<Scalars['Boolean']['input']>;
  uid: InputMaybe<Scalars['Boolean']['input']>;
  unsubscribe: InputMaybe<Scalars['Boolean']['input']>;
  unsubscribe_token: InputMaybe<Scalars['Boolean']['input']>;
  updated_at: InputMaybe<Scalars['Boolean']['input']>;
};

export type AccountQueryInput = {
  filter: InputMaybe<AccountWhereInput>;
  orderBy: InputMaybe<AccountOrderInput>;
  page: InputMaybe<Scalars['Int']['input']>;
  perPage: InputMaybe<Scalars['Int']['input']>;
  search: InputMaybe<AccountSearchInput>;
};

export type AccountSearchInput = {
  account_types: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  billing_group_ids: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  id: InputMaybe<Scalars['Int']['input']>;
  is_clinical_contact_for_location_id: InputMaybe<Scalars['Int']['input']>;
  is_clinical_contact_for_location_ids: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  location_ids: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  permission_group_id: InputMaybe<Scalars['Int']['input']>;
  permission_group_ids: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  /**
   * *Constraints:*
   * * Maximal length: `150`
   *
   */
  q: InputMaybe<Scalars['String']['input']>;
  related_to_facility_account: InputMaybe<RelatedToFacilityAccountInput>;
  status: InputMaybe<Scalars['String']['input']>;
};

export type AccountWhereInput = {
  account_type: InputMaybe<Scalars['String']['input']>;
  address_city: InputMaybe<Scalars['String']['input']>;
  address_first: InputMaybe<Scalars['String']['input']>;
  address_second: InputMaybe<Scalars['String']['input']>;
  address_zip: InputMaybe<Scalars['String']['input']>;
  agency_id: InputMaybe<Scalars['Int']['input']>;
  calculated_permissions: InputMaybe<Scalars['JSON']['input']>;
  company_id: InputMaybe<Scalars['Int']['input']>;
  created_at: InputMaybe<Scalars['DateTime']['input']>;
  current_sign_in_at: InputMaybe<Scalars['DateTime']['input']>;
  custom_permissions: InputMaybe<Scalars['JSON']['input']>;
  email: InputMaybe<Scalars['String']['input']>;
  email_notification: InputMaybe<Scalars['Boolean']['input']>;
  encrypted_password: InputMaybe<Scalars['String']['input']>;
  first_name: InputMaybe<Scalars['String']['input']>;
  id: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  invite_last_sent_at: InputMaybe<Scalars['DateTime']['input']>;
  last_name: InputMaybe<Scalars['String']['input']>;
  last_sign_in_at: InputMaybe<Scalars['DateTime']['input']>;
  middle_name: InputMaybe<Scalars['String']['input']>;
  migrated_person_id: InputMaybe<Scalars['Int']['input']>;
  phone_number: InputMaybe<Scalars['String']['input']>;
  remember_created_at: InputMaybe<Scalars['DateTime']['input']>;
  reset_password_sent_at: InputMaybe<Scalars['DateTime']['input']>;
  reset_password_token: InputMaybe<Scalars['String']['input']>;
  sign_in_count: InputMaybe<Scalars['Int']['input']>;
  sms_notification: InputMaybe<Scalars['Boolean']['input']>;
  sms_notification_bulk: InputMaybe<Scalars['Boolean']['input']>;
  ssn_last_4: InputMaybe<Scalars['String']['input']>;
  state_id: InputMaybe<Scalars['Int']['input']>;
  status: InputMaybe<Scalars['String']['input']>;
  uid: InputMaybe<Scalars['String']['input']>;
  unsubscribe: InputMaybe<Scalars['Boolean']['input']>;
  unsubscribe_token: InputMaybe<Scalars['String']['input']>;
  updated_at: InputMaybe<Scalars['DateTime']['input']>;
};

export type Administrator = {
  __typename?: 'Administrator';
  account: Maybe<Account>;
  account_id: Maybe<Scalars['Int']['output']>;
  created_at: Maybe<Scalars['DateTime']['output']>;
  department: Maybe<Scalars['String']['output']>;
  id: Maybe<Scalars['Int']['output']>;
  paused: Maybe<Scalars['Boolean']['output']>;
  role: Maybe<Scalars['Int']['output']>;
  status: Maybe<Scalars['String']['output']>;
  type: Maybe<Scalars['String']['output']>;
  updated_at: Maybe<Scalars['DateTime']['output']>;
};

export type AdministratorOrderInput = {
  created_at: InputMaybe<Scalars['Boolean']['input']>;
  first_name: InputMaybe<Scalars['Boolean']['input']>;
  id: InputMaybe<Scalars['Boolean']['input']>;
  last_name: InputMaybe<Scalars['Boolean']['input']>;
  paused: InputMaybe<Scalars['Boolean']['input']>;
  person_id: InputMaybe<Scalars['Boolean']['input']>;
  role: InputMaybe<Scalars['Boolean']['input']>;
  status: InputMaybe<Scalars['Boolean']['input']>;
  type: InputMaybe<Scalars['Boolean']['input']>;
  updated_at: InputMaybe<Scalars['Boolean']['input']>;
};

export type AdministratorQueryInput = {
  filter: InputMaybe<AdministratorWhereInput>;
  orderBy: InputMaybe<AdministratorOrderInput>;
  page: InputMaybe<Scalars['Int']['input']>;
  perPage: InputMaybe<Scalars['Int']['input']>;
  search: InputMaybe<AdministratorSearchInput>;
};

export type AdministratorSearchInput = {
  account_type: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  created_at: InputMaybe<Scalars['DateTime']['input']>;
  department: InputMaybe<Scalars['String']['input']>;
  first_name: InputMaybe<Scalars['String']['input']>;
  id: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  last_name: InputMaybe<Scalars['String']['input']>;
  paused: InputMaybe<Scalars['Boolean']['input']>;
  permission_group_id: InputMaybe<Scalars['Int']['input']>;
  permission_group_roles: InputMaybe<Array<Role>>;
  person_id: InputMaybe<Scalars['Int']['input']>;
  professional_account_id: InputMaybe<Scalars['Int']['input']>;
  /**
   * *Constraints:*
   * * Maximal length: `150`
   *
   */
  q: InputMaybe<Scalars['String']['input']>;
  role: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  status: InputMaybe<Scalars['String']['input']>;
  type: InputMaybe<Scalars['String']['input']>;
  updated_at: InputMaybe<Scalars['DateTime']['input']>;
};

export type AdministratorWhereInput = {
  account_type: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  created_at: InputMaybe<Scalars['DateTime']['input']>;
  department: InputMaybe<Scalars['String']['input']>;
  first_name: InputMaybe<Scalars['String']['input']>;
  id: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  last_name: InputMaybe<Scalars['String']['input']>;
  paused: InputMaybe<Scalars['Boolean']['input']>;
  permission_group_id: InputMaybe<Scalars['Int']['input']>;
  permission_group_roles: InputMaybe<Array<Role>>;
  person_id: InputMaybe<Scalars['Int']['input']>;
  professional_account_id: InputMaybe<Scalars['Int']['input']>;
  role: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  status: InputMaybe<Scalars['String']['input']>;
  type: InputMaybe<Scalars['String']['input']>;
  updated_at: InputMaybe<Scalars['DateTime']['input']>;
};

export type Agency = {
  __typename?: 'Agency';
  address_city: Maybe<Scalars['String']['output']>;
  address_first: Maybe<Scalars['String']['output']>;
  address_second: Maybe<Scalars['String']['output']>;
  address_zip: Maybe<Scalars['String']['output']>;
  agency_locations: Maybe<Array<Maybe<AgencyLocation>>>;
  agency_qualifications: Array<AgencyQualification>;
  created_at: Scalars['DateTime']['output'];
  id: Scalars['Int']['output'];
  legal_name: Maybe<Scalars['String']['output']>;
  locations: Maybe<Array<Maybe<Location>>>;
  name: Maybe<Scalars['String']['output']>;
  phone_number: Maybe<Scalars['String']['output']>;
  state: Maybe<State>;
  status: Maybe<Scalars['String']['output']>;
  updated_at: Scalars['DateTime']['output'];
};

export type AgencyChargeOverrides = {
  __typename?: 'AgencyChargeOverrides';
  agency_charge_rate_cents: Maybe<Scalars['Int']['output']>;
  location: Maybe<Scalars['JSON']['output']>;
  position: Maybe<Scalars['JSON']['output']>;
  position_id: Maybe<Scalars['Int']['output']>;
  specialty: Maybe<Scalars['JSON']['output']>;
  specialty_id: Maybe<Scalars['Int']['output']>;
};

export type AgencyChargeOverridesQueryInput = {
  page: InputMaybe<Scalars['Int']['input']>;
  perPage: InputMaybe<Scalars['Int']['input']>;
  search: InputMaybe<AgencyChargeOverridesSearchInput>;
};

export type AgencyChargeOverridesSearchInput = {
  agency_id: InputMaybe<Scalars['Int']['input']>;
  location_ids: InputMaybe<Array<Scalars['Int']['input']>>;
  position_id: InputMaybe<Scalars['Int']['input']>;
  specialty_id: InputMaybe<Scalars['Int']['input']>;
};

export type AgencyLocation = {
  __typename?: 'AgencyLocation';
  agency: Maybe<Agency>;
  agency_id: Maybe<Scalars['Int']['output']>;
  agency_tier: Maybe<Scalars['Int']['output']>;
  auto_publish_assignments_to_professionals: Maybe<Scalars['Boolean']['output']>;
  auto_publish_per_diem_to_professionals: Maybe<Scalars['Boolean']['output']>;
  bill_rate_percent: Maybe<Scalars['Float']['output']>;
  id: Scalars['Int']['output'];
  location: Maybe<Location>;
  location_id: Maybe<Scalars['Int']['output']>;
  status: Maybe<Scalars['String']['output']>;
  vms_fee: Maybe<Scalars['Float']['output']>;
};

export type AgencyLocationOrderInput = {
  created_at: InputMaybe<Scalars['Boolean']['input']>;
  id: InputMaybe<Scalars['Boolean']['input']>;
  status: InputMaybe<Scalars['Boolean']['input']>;
  updated_at: InputMaybe<Scalars['Boolean']['input']>;
};

export type AgencyLocationPositionRateSetting = {
  __typename?: 'AgencyLocationPositionRateSetting';
  active: Maybe<Scalars['Boolean']['output']>;
  agency: Maybe<Agency>;
  agency_charge_rate_cents: Maybe<Scalars['Int']['output']>;
  agency_id: Maybe<Scalars['Int']['output']>;
  agency_location_position_rate_setting: Maybe<AgencyPositionSettings>;
  agency_location_position_rate_setting_active: Maybe<Scalars['Boolean']['output']>;
  agency_location_position_rate_setting_id: Maybe<Scalars['Int']['output']>;
  audits: Maybe<Array<Maybe<Audit>>>;
  created_at: Maybe<Scalars['DateTime']['output']>;
  id: Maybe<Scalars['String']['output']>;
  location: Maybe<Location>;
  location_id: Maybe<Scalars['Int']['output']>;
  location_position_rate_setting_active: Maybe<Scalars['Boolean']['output']>;
  location_position_rate_setting_id: Maybe<Scalars['Int']['output']>;
  market_position_rate_setting_active: Maybe<Scalars['Boolean']['output']>;
  market_position_rate_setting_id: Maybe<Scalars['Int']['output']>;
  original_id: Maybe<Scalars['Int']['output']>;
  position: Maybe<Position>;
  position_id: Maybe<Scalars['Int']['output']>;
  settings: Maybe<AgencyPositionSettings>;
  specialty: Maybe<Specialty>;
  specialty_id: Maybe<Scalars['Int']['output']>;
  state_position_rate_setting_active: Maybe<Scalars['Boolean']['output']>;
  state_position_rate_setting_id: Maybe<Scalars['Int']['output']>;
  updated_at: Maybe<Scalars['DateTime']['output']>;
};

export type AgencyLocationPositionRateSettingOrderInput = {
  active: InputMaybe<Scalars['Boolean']['input']>;
  agency_id: InputMaybe<Scalars['Int']['input']>;
  created_at: InputMaybe<Scalars['Boolean']['input']>;
  id: InputMaybe<Scalars['Boolean']['input']>;
  location_id: InputMaybe<Scalars['Int']['input']>;
  position: InputMaybe<PositionOrderInput>;
  position_id: InputMaybe<Scalars['Boolean']['input']>;
  specialty_id: InputMaybe<Scalars['Int']['input']>;
  updated_at: InputMaybe<Scalars['Boolean']['input']>;
};

export type AgencyLocationPositionRateSettingQueryInput = {
  filter: InputMaybe<AgencyLocationPositionRateSettingWhereInput>;
  orderBy: InputMaybe<AgencyLocationPositionRateSettingOrderInput>;
  page: InputMaybe<Scalars['Int']['input']>;
  perPage: InputMaybe<Scalars['Int']['input']>;
  search: InputMaybe<AgencyLocationPositionRateSettingSearchInput>;
};

export type AgencyLocationPositionRateSettingSearchInput = {
  agency_id: InputMaybe<Scalars['Int']['input']>;
  has_agency_rates: InputMaybe<Scalars['Boolean']['input']>;
  location_id: InputMaybe<Scalars['Int']['input']>;
  location_ids: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  market_id: InputMaybe<Scalars['Int']['input']>;
  position_id: InputMaybe<Scalars['Int']['input']>;
  position_ids: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  specialty_id: InputMaybe<Scalars['Int']['input']>;
  specialty_ids: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};

export type AgencyLocationPositionRateSettingWhereInput = {
  active: InputMaybe<Scalars['Boolean']['input']>;
  agency_id: InputMaybe<Scalars['Int']['input']>;
  created_at: InputMaybe<Scalars['DateTime']['input']>;
  id: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  include_parents: InputMaybe<Scalars['Boolean']['input']>;
  location_id: InputMaybe<Scalars['Int']['input']>;
  location_ids: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  position_id: InputMaybe<Scalars['Int']['input']>;
  specialty_id: InputMaybe<Scalars['Int']['input']>;
  updated_at: InputMaybe<Scalars['DateTime']['input']>;
};

export type AgencyLocationQueryInput = {
  filter: InputMaybe<AgencyLocationWhereInput>;
  orderBy: InputMaybe<AgencyLocationOrderInput>;
  page: InputMaybe<Scalars['Int']['input']>;
  perPage: InputMaybe<Scalars['Int']['input']>;
  search: InputMaybe<AgencyLocationSearchInput>;
};

export type AgencyLocationRateSetting = {
  __typename?: 'AgencyLocationRateSetting';
  active: Maybe<Scalars['Boolean']['output']>;
  agency: Maybe<Agency>;
  agency_id: Maybe<Scalars['Int']['output']>;
  created_at: Maybe<Scalars['DateTime']['output']>;
  enable_differential_recommendations: Maybe<Scalars['Boolean']['output']>;
  id: Maybe<Scalars['Int']['output']>;
  location: Maybe<Location>;
  location_id: Maybe<Scalars['Int']['output']>;
  settings: Maybe<Scalars['JSON']['output']>;
  updated_at: Maybe<Scalars['DateTime']['output']>;
};

export type AgencyLocationRateSettingOrderInput = {
  active: InputMaybe<Scalars['Boolean']['input']>;
  agency_id: InputMaybe<Scalars['Boolean']['input']>;
  created_at: InputMaybe<Scalars['Boolean']['input']>;
  id: InputMaybe<Scalars['Boolean']['input']>;
  location_id: InputMaybe<Scalars['Boolean']['input']>;
  updated_at: InputMaybe<Scalars['Boolean']['input']>;
};

export type AgencyLocationRateSettingQueryInput = {
  filter: InputMaybe<AgencyLocationRateSettingWhereInput>;
  orderBy: InputMaybe<AgencyLocationRateSettingOrderInput>;
  page: InputMaybe<Scalars['Int']['input']>;
  perPage: InputMaybe<Scalars['Int']['input']>;
  search: InputMaybe<AgencyLocationRateSettingSearchInput>;
};

export type AgencyLocationRateSettingSearchInput = {
  agency_id: InputMaybe<Scalars['Int']['input']>;
  location_id: InputMaybe<Scalars['Int']['input']>;
  location_ids: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};

export type AgencyLocationRateSettingWhereInput = {
  active: InputMaybe<Scalars['Boolean']['input']>;
  agency_id: InputMaybe<Scalars['Int']['input']>;
  id: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  include_parents: InputMaybe<Scalars['Boolean']['input']>;
  location_id: InputMaybe<Scalars['Int']['input']>;
};

export type AgencyLocationSearchInput = {
  /**
   * *Constraints:*
   * * Maximal length: `150`
   *
   */
  q: InputMaybe<Scalars['String']['input']>;
  statuses: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type AgencyLocationWhereInput = {
  agency_id: InputMaybe<Scalars['Int']['input']>;
  created_at: InputMaybe<Scalars['DateTime']['input']>;
  id: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  location_id: InputMaybe<Scalars['Int']['input']>;
  status: InputMaybe<Scalars['String']['input']>;
  updated_at: InputMaybe<Scalars['DateTime']['input']>;
};

export type AgencyOrderInput = {
  created_at: InputMaybe<Scalars['Boolean']['input']>;
  id: InputMaybe<Scalars['Boolean']['input']>;
  name: InputMaybe<Scalars['Boolean']['input']>;
  updated_at: InputMaybe<Scalars['Boolean']['input']>;
};

export type AgencyPositionSettings = {
  __typename?: 'AgencyPositionSettings';
  agency_charge_rate_cents: Maybe<Scalars['Int']['output']>;
  agency_release_lead_time_hours: Maybe<Scalars['Int']['output']>;
  assignment_bonus_tier1_travel_amount_cents: Maybe<Scalars['Int']['output']>;
  assignment_bonus_tier1_travel_amount_tcv_cents: Maybe<Scalars['Int']['output']>;
  assignment_bonus_tier2_travel_amount_cents: Maybe<Scalars['Int']['output']>;
  assignment_bonus_tier2_travel_amount_tcv_cents: Maybe<Scalars['Int']['output']>;
  can_post_assignment: Maybe<Scalars['Boolean']['output']>;
  can_post_job: Maybe<Scalars['Boolean']['output']>;
  charge_on_call_hourly_rate_cents: Maybe<Scalars['Float']['output']>;
  charge_on_call_hourly_rate_currency: Maybe<Scalars['String']['output']>;
  charge_overtime_multiplier: Maybe<Scalars['Float']['output']>;
  charge_rate_cents: Maybe<Scalars['Int']['output']>;
  fee_percent: Maybe<Scalars['String']['output']>;
  margin_percent_1099: Maybe<Scalars['String']['output']>;
  margin_percent_w2_local: Maybe<Scalars['String']['output']>;
  margin_percent_w2_tcv: Maybe<Scalars['String']['output']>;
  margin_percent_w2_travel: Maybe<Scalars['String']['output']>;
  margin_w2_tcv_cents: Maybe<Scalars['Int']['output']>;
  on_call_fee_percent: Maybe<Scalars['String']['output']>;
  payout_on_call_hourly_rate_cents: Maybe<Scalars['Int']['output']>;
  payout_on_call_hourly_rate_currency: Maybe<Scalars['String']['output']>;
  payout_overtime_multiplier: Maybe<Scalars['Float']['output']>;
  ten99_assignment: Maybe<Scalars['JSON']['output']>;
  ten99_per_diem: Maybe<Scalars['JSON']['output']>;
  w2: Maybe<Scalars['JSON']['output']>;
  w2_fee_percent: Maybe<Scalars['String']['output']>;
  w2_per_diem: Maybe<Scalars['JSON']['output']>;
};

export type AgencyQualification = {
  __typename?: 'AgencyQualification';
  admin_agency_qualification_attributes: Array<AgencyQualificationAttribute>;
  agency: Maybe<Agency>;
  agency_id: Maybe<Scalars['Int']['output']>;
  agency_qualification_attributes: Array<AgencyQualificationAttribute>;
  created_at: Scalars['DateTime']['output'];
  credential_rejected_reason: Maybe<CredentialRejectedReason>;
  credential_rejected_reason_id: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  last_updated_by_admin: Maybe<Account>;
  last_updated_by_admin_id: Maybe<Scalars['Int']['output']>;
  metadata: Maybe<Scalars['JSON']['output']>;
  qualification: Maybe<Qualification>;
  qualification_id: Maybe<Scalars['Int']['output']>;
  status: Scalars['String']['output'];
  updated_at: Scalars['DateTime']['output'];
};

export type AgencyQualificationAttribute = {
  __typename?: 'AgencyQualificationAttribute';
  agency_qualification: Maybe<AgencyQualification>;
  agency_qualification_id: Maybe<Scalars['Int']['output']>;
  created_at: Scalars['DateTime']['output'];
  id: Scalars['Int']['output'];
  metadata: Maybe<Scalars['JSON']['output']>;
  qualification_attribute: Maybe<QualificationAttribute>;
  qualification_attribute_id: Maybe<Scalars['Int']['output']>;
  state: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
  updated_at: Scalars['DateTime']['output'];
  value: Scalars['AgencyQualificationAttributeValue']['output'];
};

export type AgencyQualificationAttributeOrderInput = {
  created_at: InputMaybe<Scalars['Boolean']['input']>;
  id: InputMaybe<Scalars['Boolean']['input']>;
  type: InputMaybe<Scalars['Boolean']['input']>;
  updated_at: InputMaybe<Scalars['Boolean']['input']>;
};

export type AgencyQualificationAttributeQueryInput = {
  filter: InputMaybe<AgencyQualificationAttributeWhereInput>;
  orderBy: InputMaybe<AgencyQualificationAttributeOrderInput>;
  page: InputMaybe<Scalars['Int']['input']>;
  perPage: InputMaybe<Scalars['Int']['input']>;
  search: InputMaybe<AgencyQualificationAttributeSearchInput>;
};

export type AgencyQualificationAttributeSearchInput = {
  qa_active: InputMaybe<Scalars['Boolean']['input']>;
  qa_input_sources: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type AgencyQualificationAttributeWhereInput = {
  agency_qualification_id: InputMaybe<Scalars['Int']['input']>;
  id: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  qualification_attribute_id: InputMaybe<Scalars['Int']['input']>;
  type: InputMaybe<Scalars['String']['input']>;
};

export type AgencyQualificationOrderInput = {
  agency_id: InputMaybe<Scalars['Boolean']['input']>;
  created_at: InputMaybe<Scalars['Boolean']['input']>;
  credential_rejected_reason_id: InputMaybe<Scalars['Boolean']['input']>;
  id: InputMaybe<Scalars['Boolean']['input']>;
  last_updated_by_admin_id: InputMaybe<Scalars['Boolean']['input']>;
  license_id: InputMaybe<Scalars['Boolean']['input']>;
  license_status: InputMaybe<Scalars['Boolean']['input']>;
  status: InputMaybe<Scalars['Boolean']['input']>;
  updated_at: InputMaybe<Scalars['Boolean']['input']>;
};

export type AgencyQualificationQueryInput = {
  filter: InputMaybe<AgencyQualificationWhereInput>;
  orderBy: InputMaybe<AgencyQualificationOrderInput>;
  page: InputMaybe<Scalars['Int']['input']>;
  perPage: InputMaybe<Scalars['Int']['input']>;
  search: InputMaybe<AgencyQualificationSearchInput>;
};

export type AgencyQualificationSearchInput = {
  agency_id: InputMaybe<Scalars['Int']['input']>;
  kind: InputMaybe<Scalars['Int']['input']>;
  not_archived: InputMaybe<Scalars['Boolean']['input']>;
  qualification_ids: InputMaybe<Array<Scalars['Int']['input']>>;
  qualification_type: InputMaybe<Scalars['String']['input']>;
  qualification_types: InputMaybe<Array<Scalars['String']['input']>>;
  statuses: InputMaybe<Array<Scalars['String']['input']>>;
};

export type AgencyQualificationWhereInput = {
  agency_id: InputMaybe<Scalars['Int']['input']>;
  created_at: InputMaybe<Scalars['DateTime']['input']>;
  credential_rejected_reason_id: InputMaybe<Scalars['Int']['input']>;
  id: InputMaybe<Array<Scalars['Int']['input']>>;
  kind: InputMaybe<Scalars['Int']['input']>;
  last_updated_by_admin_id: InputMaybe<Scalars['Int']['input']>;
  license_id: InputMaybe<Scalars['Int']['input']>;
  license_status: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Scalars['String']['input']>;
  updated_at: InputMaybe<Scalars['DateTime']['input']>;
};

export type AgencyQueryInput = {
  filter: InputMaybe<AgencyWhereInput>;
  orderBy: InputMaybe<AgencyOrderInput>;
  page: InputMaybe<Scalars['Int']['input']>;
  perPage: InputMaybe<Scalars['Int']['input']>;
  search: InputMaybe<DefaultSearchInput>;
};

export type AgencySearchInput = {
  /**
   * *Constraints:*
   * * Maximal length: `150`
   *
   */
  q: InputMaybe<Scalars['String']['input']>;
};

export type AgencyWhereInput = {
  created_at: InputMaybe<Scalars['DateTime']['input']>;
  id: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  name: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Scalars['String']['input']>;
  updated_at: InputMaybe<Scalars['DateTime']['input']>;
};

export type AppVersion = {
  __typename?: 'AppVersion';
  appName: Scalars['String']['output'];
  major: Scalars['Int']['output'];
  minor: Scalars['Int']['output'];
  patch: Scalars['Int']['output'];
};

export type ApplicationRequirement = {
  __typename?: 'ApplicationRequirement';
  base: Scalars['Boolean']['output'];
  condition: Condition;
  condition_id: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  kind: Maybe<Scalars['String']['output']>;
  medely: Scalars['Boolean']['output'];
  position: Maybe<Position>;
  position_id: Maybe<Scalars['Int']['output']>;
  specialty: Maybe<Specialty>;
  specialty_id: Maybe<Scalars['Int']['output']>;
  state: Maybe<State>;
  state_id: Maybe<Scalars['Int']['output']>;
};

export type ApplicationRequirementOrderInput = {
  id: InputMaybe<Scalars['Boolean']['input']>;
  position_id: InputMaybe<Scalars['Boolean']['input']>;
};

export type ApplicationRequirementQueryInput = {
  filter: InputMaybe<ApplicationRequirementWhereInput>;
  orderBy: InputMaybe<ApplicationRequirementOrderInput>;
  page: InputMaybe<Scalars['Int']['input']>;
  perPage: InputMaybe<Scalars['Int']['input']>;
  search: InputMaybe<ApplicationRequirementSearchInput>;
};

export type ApplicationRequirementSearchInput = {
  position_ids: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  /**
   * *Constraints:*
   * * Maximal length: `150`
   *
   */
  q: InputMaybe<Scalars['String']['input']>;
};

export type ApplicationRequirementWhereInput = {
  id: InputMaybe<Scalars['Int']['input']>;
  kind: InputMaybe<Scalars['String']['input']>;
  medely: InputMaybe<Scalars['Boolean']['input']>;
  position_id: InputMaybe<Scalars['Int']['input']>;
  specialty_id: InputMaybe<Scalars['Int']['input']>;
  state_id: InputMaybe<Scalars['Int']['input']>;
};

export enum ApplicationVersion {
  Original = 'original',
  Prescreening = 'prescreening'
}

export type Approval = {
  __typename?: 'Approval';
  approval_groups: Array<ApprovalGroup>;
  approval_rule: ApprovalRule;
  approval_rule_id: Scalars['Int']['output'];
  approver_account: Maybe<Account>;
  approver_account_id: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  rejection_reason: Maybe<Scalars['String']['output']>;
  status: ApprovalStatus;
  tier: Scalars['Int']['output'];
};

export type ApprovalGroup = {
  __typename?: 'ApprovalGroup';
  account_ids: Array<Scalars['Int']['output']>;
  accounts: Array<Account>;
  company: Company;
  company_id: Scalars['Int']['output'];
  deleted_at: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type ApprovalGroupOrderInput = {
  id: InputMaybe<Scalars['Boolean']['input']>;
  name: InputMaybe<Scalars['Boolean']['input']>;
};

export type ApprovalGroupQueryInput = {
  filter: InputMaybe<ApprovalGroupWhereInput>;
  orderBy: InputMaybe<ApprovalGroupOrderInput>;
  page: InputMaybe<Scalars['Int']['input']>;
  perPage: InputMaybe<Scalars['Int']['input']>;
  search: InputMaybe<ApprovalGroupSearchInput>;
};

export type ApprovalGroupSearchInput = {
  account_id: InputMaybe<Scalars['Int']['input']>;
  company_id: InputMaybe<Scalars['Int']['input']>;
  id: InputMaybe<Scalars['Int']['input']>;
  is_active: InputMaybe<Scalars['Boolean']['input']>;
};

export type ApprovalGroupWhereInput = {
  company_id: InputMaybe<Scalars['Int']['input']>;
  id: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};

export type ApprovalOrderInput = {
  id: InputMaybe<Scalars['Boolean']['input']>;
};

export type ApprovalQueryInput = {
  filter: InputMaybe<ApprovalWhereInput>;
  orderBy: InputMaybe<ApprovalOrderInput>;
  page: InputMaybe<Scalars['Int']['input']>;
  perPage: InputMaybe<Scalars['Int']['input']>;
  search: InputMaybe<DefaultSearchInput>;
};

export type ApprovalRule = {
  __typename?: 'ApprovalRule';
  id: Scalars['Int']['output'];
  name: Maybe<Scalars['String']['output']>;
  percentage_over: Maybe<Scalars['Float']['output']>;
};

export enum ApprovalStatus {
  Approved = 'approved',
  Expired = 'expired',
  Pending = 'pending',
  Rejected = 'rejected'
}

export type ApprovalWhereInput = {
  id: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};

export type Assignment = {
  __typename?: 'Assignment';
  adjust_rate_calculator: Maybe<Scalars['Boolean']['output']>;
  administrator: Maybe<Administrator>;
  administrator_id: Maybe<Scalars['Int']['output']>;
  adp_fee_burden_cents: Scalars['Int']['output'];
  agency_base_hourly_rate_cents: Maybe<Scalars['Float']['output']>;
  all_conditions_met: Maybe<Scalars['Boolean']['output']>;
  assignment_billing_groups: Maybe<Array<Maybe<AssignmentBillingGroup>>>;
  assignment_bonus_tier1_travel_amount_cents: Maybe<Scalars['Int']['output']>;
  assignment_bonus_tier1_travel_amount_tcv_cents: Maybe<Scalars['Int']['output']>;
  assignment_bonus_tier2_travel_amount_cents: Maybe<Scalars['Int']['output']>;
  assignment_bonus_tier2_travel_amount_tcv_cents: Maybe<Scalars['Int']['output']>;
  assignment_locations: Maybe<Array<Maybe<AssignmentLocation>>>;
  assignment_request_applied_count: Maybe<Scalars['Int']['output']>;
  assignment_request_offer_sent_count: Maybe<Scalars['Int']['output']>;
  assignment_request_status_counts: Maybe<AssignmentRequestStatusCounts>;
  assignment_requests: Maybe<Array<Maybe<AssignmentRequest>>>;
  attendance_policy: Scalars['Boolean']['output'];
  available_professional_count: Maybe<Scalars['Int']['output']>;
  billable_orientation_hours: Scalars['Float']['output'];
  booked_at: Maybe<Scalars['DateTime']['output']>;
  booked_method: Maybe<Scalars['String']['output']>;
  booked_source: Maybe<Scalars['String']['output']>;
  call_requirements: Maybe<Scalars['String']['output']>;
  can_accept: Maybe<Scalars['Boolean']['output']>;
  can_apply: Maybe<Scalars['Boolean']['output']>;
  canceled_by_professional: Scalars['Boolean']['output'];
  cancellation_fee_charge_hours: Maybe<Scalars['Int']['output']>;
  cancellation_fee_window: Maybe<Scalars['Int']['output']>;
  cancellation_policy: Maybe<Scalars['String']['output']>;
  cancellation_reason: Maybe<Scalars['String']['output']>;
  charge_base_hourly_rate_cents: Scalars['Int']['output'];
  charge_base_hourly_rate_currency: Scalars['String']['output'];
  charge_blended_hourly_rate_cents: Maybe<Scalars['Float']['output']>;
  charge_callback_multiplier: Maybe<Scalars['Float']['output']>;
  charge_double_overtime_multiplier: Maybe<Scalars['Float']['output']>;
  charge_max_daily_ot_hours: Maybe<Scalars['Int']['output']>;
  charge_max_daily_regular_hours: Maybe<Scalars['Int']['output']>;
  charge_max_weekly_regular_hours: Maybe<Scalars['Int']['output']>;
  charge_on_call_hourly_rate_cents: Scalars['Int']['output'];
  charge_on_call_hourly_rate_currency: Scalars['String']['output'];
  charge_overtime_frequency: Maybe<Scalars['String']['output']>;
  charge_overtime_multiplier: Scalars['Float']['output'];
  charge_overtime_rate: Maybe<Scalars['Float']['output']>;
  charge_per_week_cents: Maybe<Scalars['Int']['output']>;
  clinical_contact: Maybe<Account>;
  clinical_contact_account_id: Maybe<Scalars['Int']['output']>;
  company: Maybe<Company>;
  company_id: Maybe<Scalars['Int']['output']>;
  completed_early: Maybe<Scalars['Boolean']['output']>;
  compliance_burden_cents: Scalars['Int']['output'];
  conditions: Array<Condition>;
  contract_total_hours: Maybe<Scalars['String']['output']>;
  covid_care: Scalars['Boolean']['output'];
  created_at: Scalars['DateTime']['output'];
  /** This should be only used for 'local' assignments */
  distance_in_miles: Maybe<Scalars['Int']['output']>;
  ehr_system: Maybe<EhrSystem>;
  ehr_system_id: Maybe<Scalars['Int']['output']>;
  ends_date: Maybe<Scalars['Date']['output']>;
  ends_time: Maybe<Scalars['DateTime']['output']>;
  enforce_guaranteed_minimum_hours: Maybe<Scalars['Boolean']['output']>;
  estimated_total_hours: Maybe<Scalars['Float']['output']>;
  estimated_unpaid_break_time_minutes: Maybe<Scalars['Int']['output']>;
  estimated_unpaid_break_time_per_week_cents: Maybe<Scalars['Int']['output']>;
  existing_job_hours: Scalars['Float']['output'];
  extension_id: Maybe<Scalars['Int']['output']>;
  extension_status: Maybe<Scalars['String']['output']>;
  facility_cancellation_hours: Maybe<Scalars['Int']['output']>;
  facility_number: Maybe<Scalars['String']['output']>;
  federal_unemployment_max_burden_cents: Scalars['Int']['output'];
  federal_unemployment_percent_burden_multiplier: Scalars['Float']['output'];
  fee_percent: Maybe<Scalars['Float']['output']>;
  first_to_apply: Maybe<Scalars['Boolean']['output']>;
  flexible_starts_date: Scalars['Boolean']['output'];
  float_requirements: Maybe<Scalars['String']['output']>;
  great_pay: Maybe<Scalars['Boolean']['output']>;
  gross_margin: Scalars['Float']['output'];
  gross_profit_cents: Scalars['Int']['output'];
  guaranteed_hours_string: Maybe<Scalars['String']['output']>;
  guaranteed_minimum_hours: Maybe<Scalars['Int']['output']>;
  has_applied: Maybe<Scalars['Boolean']['output']>;
  hours_per_shift: Maybe<Scalars['Float']['output']>;
  hours_per_week: Maybe<Scalars['Float']['output']>;
  id: Scalars['Int']['output'];
  invoices: Maybe<Array<Maybe<Invoice>>>;
  is_extension: Maybe<Scalars['Boolean']['output']>;
  is_travel: Maybe<Scalars['Boolean']['output']>;
  is_w2: Maybe<Scalars['Boolean']['output']>;
  jobs: Maybe<Array<Maybe<Job>>>;
  jobs_detail: Maybe<Scalars['String']['output']>;
  jobs_detail_raw: Maybe<Scalars['String']['output']>;
  kind: Maybe<Scalars['String']['output']>;
  /** This should be only used for 'travel' assignments */
  less_than_300_miles_away: Maybe<Scalars['Boolean']['output']>;
  local_only: Maybe<Scalars['Boolean']['output']>;
  location_info: Maybe<Scalars['String']['output']>;
  locations: Maybe<Array<Maybe<Location>>>;
  lodging_per_diem_cents: Scalars['Int']['output'];
  lunch_break: Maybe<Scalars['Boolean']['output']>;
  max_lodging_per_diem_cents: Scalars['Int']['output'];
  max_mie_per_diem_cents: Scalars['Int']['output'];
  medical_burden_cents: Scalars['Int']['output'];
  medicare_burden_multiplier: Scalars['Float']['output'];
  mie_per_diem_cents: Scalars['Int']['output'];
  mileage_requirement: Maybe<Scalars['Int']['output']>;
  min_taxable_rate_cents: Maybe<Scalars['Int']['output']>;
  min_years_of_experience: Maybe<Scalars['Float']['output']>;
  missing_condition_ids: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  needs_item_url: Scalars['Boolean']['output'];
  non_billable_orientation_burden_hours: Scalars['Float']['output'];
  nontaxable_amount_cents: Maybe<Scalars['Float']['output']>;
  notes: Maybe<Scalars['String']['output']>;
  number_of_openings: Maybe<Scalars['Int']['output']>;
  number_of_shifts_per_week: Maybe<Scalars['Int']['output']>;
  number_of_weeks: Maybe<Scalars['Int']['output']>;
  offer: Maybe<Scalars['String']['output']>;
  on_call_fee_percent: Maybe<Scalars['Float']['output']>;
  on_hold: Scalars['Boolean']['output'];
  onboarding_due_date: Maybe<Scalars['Date']['output']>;
  one_time_bonus_burden_cents: Scalars['Int']['output'];
  order_number: Maybe<Scalars['String']['output']>;
  original_assignment_id: Maybe<Scalars['Int']['output']>;
  other_burden_multiplier: Scalars['Float']['output'];
  patient_population: Maybe<Scalars['String']['output']>;
  paused: Scalars['Boolean']['output'];
  pay_per_week_cents: Maybe<Scalars['Int']['output']>;
  payout_base_hourly_rate_cents: Scalars['Int']['output'];
  payout_base_hourly_rate_currency: Scalars['String']['output'];
  payout_callback_multiplier: Maybe<Scalars['Float']['output']>;
  payout_double_overtime_multiplier: Maybe<Scalars['Float']['output']>;
  payout_max_daily_ot_hours: Maybe<Scalars['Int']['output']>;
  payout_max_daily_regular_hours: Maybe<Scalars['Int']['output']>;
  payout_max_weekly_regular_hours: Maybe<Scalars['Int']['output']>;
  payout_on_call_hourly_rate_cents: Scalars['Int']['output'];
  payout_on_call_hourly_rate_currency: Scalars['String']['output'];
  payout_overtime_frequency: Maybe<Scalars['String']['output']>;
  payout_overtime_multiplier: Scalars['Float']['output'];
  payout_taxable_hourly_rate_cents: Scalars['Int']['output'];
  payout_taxable_hourly_rate_currency: Scalars['String']['output'];
  per_diem: Scalars['Boolean']['output'];
  position_display_names: Maybe<Scalars['String']['output']>;
  positions: Maybe<Array<Maybe<Position>>>;
  posting_field_contents: Maybe<Scalars['JSON']['output']>;
  preferred_facility_rate_cents: Scalars['Int']['output'];
  preferred_professional_rate_cents: Scalars['Int']['output'];
  primary_location: Maybe<Location>;
  professional: Maybe<Professional>;
  professional_assignment_favorites: Maybe<Array<Maybe<ProfessionalAssignmentFavorite>>>;
  professional_can_create_job: Scalars['Boolean']['output'];
  professional_id: Maybe<Scalars['Int']['output']>;
  professional_number: Maybe<Scalars['String']['output']>;
  recruiter: Maybe<Administrator>;
  recruiter_id: Maybe<Scalars['Int']['output']>;
  referral_reward_cents: Scalars['Int']['output'];
  referrer_professional: Maybe<Professional>;
  referrer_professional_id: Maybe<Scalars['Int']['output']>;
  require_physical_signature: Scalars['Boolean']['output'];
  schedule_known: Maybe<Scalars['Boolean']['output']>;
  schedule_type: Scalars['String']['output'];
  scrubs_provided: Scalars['Boolean']['output'];
  self_schedule: Scalars['Boolean']['output'];
  signed_addendum: Maybe<Scalars['Boolean']['output']>;
  social_security_burden_multiplier: Scalars['Float']['output'];
  specialties: Maybe<Array<Maybe<Specialty>>>;
  specialty_labels: Maybe<Scalars['String']['output']>;
  starts_date: Maybe<Scalars['Date']['output']>;
  starts_time: Maybe<Scalars['DateTime']['output']>;
  state_unemployment_max_burden_cents: Scalars['Int']['output'];
  state_unemployment_percent_burden_multiplier: Scalars['Float']['output'];
  status: Scalars['String']['output'];
  submittal_max: Maybe<Scalars['Int']['output']>;
  surgery_type_display_names: Maybe<Scalars['String']['output']>;
  surgery_types: Maybe<Array<Maybe<SurgeryType>>>;
  suspicious: Maybe<Scalars['Boolean']['output']>;
  taxable_amount_cents: Maybe<Scalars['Float']['output']>;
  track_unpaid_breaks: Scalars['Boolean']['output'];
  travel_reimbursement_burden_cents: Scalars['Int']['output'];
  unit: Maybe<Scalars['String']['output']>;
  updated_at: Scalars['DateTime']['output'];
  user: Maybe<User>;
  user_id: Maybe<Scalars['Int']['output']>;
  variable_shift_times: Maybe<Scalars['Boolean']['output']>;
  vms_assignment: Maybe<VmsAssignment>;
  vms_assignment_id: Maybe<Scalars['Int']['output']>;
  vms_auto_update: Maybe<Scalars['Boolean']['output']>;
  vms_contact_email: Maybe<Scalars['String']['output']>;
  vms_contact_name: Maybe<Scalars['String']['output']>;
  vms_contact_phone: Maybe<Scalars['String']['output']>;
  vms_fee_burden_multiplier: Scalars['Float']['output'];
  vms_fee_percent: Maybe<Scalars['Float']['output']>;
  vms_order_url: Maybe<Scalars['String']['output']>;
  vms_partnership: Maybe<Scalars['Boolean']['output']>;
  w2_contract: Maybe<Scalars['AWSFile']['output']>;
  weekly_guaranteed_minimum_hours: Maybe<Scalars['Int']['output']>;
};


export type AssignmentCan_AcceptArgs = {
  professional_id?: InputMaybe<Scalars['Int']['input']>;
};


export type AssignmentCan_ApplyArgs = {
  professional_id?: InputMaybe<Scalars['Int']['input']>;
};


export type AssignmentDistance_In_MilesArgs = {
  professional_id?: InputMaybe<Scalars['Int']['input']>;
};


export type AssignmentExisting_Job_HoursArgs = {
  range: DateRangeInput;
};


export type AssignmentHas_AppliedArgs = {
  professional_id: Scalars['Int']['input'];
};


export type AssignmentLess_Than_300_Miles_AwayArgs = {
  professional_id?: InputMaybe<Scalars['Int']['input']>;
};


export type AssignmentMissing_Condition_IdsArgs = {
  professional_id?: InputMaybe<Scalars['Int']['input']>;
};

export type AssignmentAgencyFilterInput = {
  professional_agency_id: InputMaybe<Scalars['Int']['input']>;
};

export type AssignmentBillingGroup = {
  __typename?: 'AssignmentBillingGroup';
  assignment: Assignment;
  assignment_id: Scalars['Int']['output'];
  billing_group: BillingGroup;
  billing_group_id: Scalars['Int']['output'];
  created_at: Scalars['DateTime']['output'];
  id: Scalars['Int']['output'];
  updated_at: Scalars['DateTime']['output'];
};

export type AssignmentBillingGroupOrderInput = {
  assignment_id: InputMaybe<Scalars['Boolean']['input']>;
  billing_group_id: InputMaybe<Scalars['Boolean']['input']>;
  created_at: InputMaybe<Scalars['Boolean']['input']>;
  id: InputMaybe<Scalars['Boolean']['input']>;
  updated_at: InputMaybe<Scalars['Boolean']['input']>;
};

export type AssignmentBillingGroupQueryInput = {
  filter: InputMaybe<AssignmentBillingGroupWhereInput>;
  orderBy: InputMaybe<AssignmentBillingGroupOrderInput>;
  page: InputMaybe<Scalars['Int']['input']>;
  perPage: InputMaybe<Scalars['Int']['input']>;
  search: InputMaybe<AssignmentBillingGroupSearchInput>;
};

export type AssignmentBillingGroupSearchInput = {
  /**
   * *Constraints:*
   * * Maximal length: `150`
   *
   */
  q: InputMaybe<Scalars['String']['input']>;
};

export type AssignmentBillingGroupWhereInput = {
  assignment_id: InputMaybe<Scalars['Int']['input']>;
  billing_group_id: InputMaybe<Scalars['Int']['input']>;
  created_at: InputMaybe<Scalars['String']['input']>;
  id: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  updated_at: InputMaybe<Scalars['String']['input']>;
};

export type AssignmentCalculatedFields = {
  __typename?: 'AssignmentCalculatedFields';
  facility_rate_blended_cents: Maybe<Scalars['Int']['output']>;
  professional_rate_blended_cents: Maybe<Scalars['Int']['output']>;
};

export type AssignmentCancellationReasons = {
  __typename?: 'AssignmentCancellationReasons';
  ten99: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  w2: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type AssignmentCancellationReasonsV2 = {
  __typename?: 'AssignmentCancellationReasonsV2';
  available: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  booked: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  draft: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  in_progress: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  matched: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type AssignmentDistanceCheckInput = {
  account_id: InputMaybe<Scalars['Int']['input']>;
  distance: InputMaybe<Scalars['Int']['input']>;
};

export type AssignmentDistanceLocationFilterInput = {
  compact: InputMaybe<Scalars['Boolean']['input']>;
  location_areas: InputMaybe<DistanceRadiusFilterInput>;
  state_ids: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};

export type AssignmentLocation = {
  __typename?: 'AssignmentLocation';
  assignment: Assignment;
  assignment_id: Scalars['Int']['output'];
  created_at: Scalars['DateTime']['output'];
  id: Scalars['Int']['output'];
  location: Location;
  location_id: Scalars['Int']['output'];
  primary_location: Scalars['Boolean']['output'];
  updated_at: Scalars['DateTime']['output'];
};

export type AssignmentLocationOrderInput = {
  assignment_id: InputMaybe<Scalars['Boolean']['input']>;
  created_at: InputMaybe<Scalars['Boolean']['input']>;
  id: InputMaybe<Scalars['Boolean']['input']>;
  location_id: InputMaybe<Scalars['Boolean']['input']>;
  primary_location: InputMaybe<Scalars['Boolean']['input']>;
  updated_at: InputMaybe<Scalars['Boolean']['input']>;
};

export type AssignmentLocationQueryInput = {
  filter: InputMaybe<AssignmentLocationWhereInput>;
  orderBy: InputMaybe<AssignmentLocationOrderInput>;
  page: InputMaybe<Scalars['Int']['input']>;
  perPage: InputMaybe<Scalars['Int']['input']>;
  search: InputMaybe<AssignmentLocationSearchInput>;
};

export type AssignmentLocationSearchInput = {
  location_ids: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  /**
   * *Constraints:*
   * * Maximal length: `150`
   *
   */
  q: InputMaybe<Scalars['String']['input']>;
};

export type AssignmentLocationWhereInput = {
  assignment_id: InputMaybe<Scalars['Int']['input']>;
  created_at: InputMaybe<Scalars['DateTime']['input']>;
  id: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  location_id: InputMaybe<Scalars['Int']['input']>;
  primary_location: InputMaybe<Scalars['Boolean']['input']>;
  updated_at: InputMaybe<Scalars['DateTime']['input']>;
};

export type AssignmentMeta = {
  __typename?: 'AssignmentMeta';
  is_travel: Maybe<Scalars['Boolean']['output']>;
  is_w2: Maybe<Scalars['Boolean']['output']>;
  local_only: Maybe<Scalars['Boolean']['output']>;
};

export type AssignmentOrderInput = {
  adjust_rate_calculator: InputMaybe<Scalars['Boolean']['input']>;
  administrator_id: InputMaybe<Scalars['Boolean']['input']>;
  booked_at: InputMaybe<Scalars['Boolean']['input']>;
  charge_base_hourly_rate_cents: InputMaybe<Scalars['Boolean']['input']>;
  charge_per_week_cents: InputMaybe<Scalars['Boolean']['input']>;
  company_id: InputMaybe<Scalars['Boolean']['input']>;
  completed_early: InputMaybe<Scalars['Boolean']['input']>;
  created_at: InputMaybe<Scalars['Boolean']['input']>;
  ends_date: InputMaybe<Scalars['Boolean']['input']>;
  ends_time: InputMaybe<Scalars['Boolean']['input']>;
  estimated_total_hours: InputMaybe<Scalars['Boolean']['input']>;
  facility_rate_blended_cents: InputMaybe<Scalars['Boolean']['input']>;
  hours_per_shift: InputMaybe<Scalars['Boolean']['input']>;
  id: InputMaybe<Scalars['Boolean']['input']>;
  invoice_id: InputMaybe<Scalars['Boolean']['input']>;
  jobs_detail: InputMaybe<Scalars['Boolean']['input']>;
  lodging_per_diem_cents: InputMaybe<Scalars['Boolean']['input']>;
  lunch_break: InputMaybe<Scalars['Boolean']['input']>;
  mie_per_diem_cents: InputMaybe<Scalars['Boolean']['input']>;
  nontaxable_amount_cents: InputMaybe<Scalars['Boolean']['input']>;
  notes: InputMaybe<Scalars['Boolean']['input']>;
  number_of_openings: InputMaybe<Scalars['Boolean']['input']>;
  number_of_shifts_per_week: InputMaybe<Scalars['Boolean']['input']>;
  number_of_weeks: InputMaybe<Scalars['Boolean']['input']>;
  on_hold: InputMaybe<Scalars['Boolean']['input']>;
  onboarding_due_date: InputMaybe<Scalars['Boolean']['input']>;
  order_number: InputMaybe<Scalars['Boolean']['input']>;
  patient_population: InputMaybe<Scalars['Boolean']['input']>;
  paused: InputMaybe<Scalars['Boolean']['input']>;
  pay_per_week_cents: InputMaybe<Scalars['Boolean']['input']>;
  payout_base_hourly_rate_cents: InputMaybe<Scalars['Boolean']['input']>;
  position_display_names: InputMaybe<Scalars['Boolean']['input']>;
  preferred_facility_rate_cents: InputMaybe<Scalars['Boolean']['input']>;
  preferred_professional_rate_cents: InputMaybe<Scalars['Boolean']['input']>;
  professional_id: InputMaybe<Scalars['Boolean']['input']>;
  professional_rate_blended_cents: InputMaybe<Scalars['Boolean']['input']>;
  rate_calculator_id: InputMaybe<Scalars['Boolean']['input']>;
  recruiter_id: InputMaybe<Scalars['Boolean']['input']>;
  schedule_known: InputMaybe<Scalars['Boolean']['input']>;
  schedule_type: InputMaybe<Scalars['Boolean']['input']>;
  self_schedule: InputMaybe<Scalars['Boolean']['input']>;
  specialty_labels: InputMaybe<Scalars['Boolean']['input']>;
  starts_date: InputMaybe<Scalars['Boolean']['input']>;
  starts_time: InputMaybe<Scalars['Boolean']['input']>;
  status: InputMaybe<Scalars['Boolean']['input']>;
  submittal_max: InputMaybe<Scalars['Boolean']['input']>;
  surgery_type_display_names: InputMaybe<Scalars['Boolean']['input']>;
  suspicious: InputMaybe<Scalars['Boolean']['input']>;
  taxable_amount_cents: InputMaybe<Scalars['Boolean']['input']>;
  taxable_hourly_rate_cents: InputMaybe<Scalars['Boolean']['input']>;
  updated_at: InputMaybe<Scalars['Boolean']['input']>;
  user_id: InputMaybe<Scalars['Boolean']['input']>;
  vms_type: InputMaybe<Scalars['Boolean']['input']>;
};

export type AssignmentPanelCount = {
  __typename?: 'AssignmentPanelCount';
  count: Scalars['Int']['output'];
  location: Location;
};

export type AssignmentQueryInput = {
  filter: InputMaybe<AssignmentWhereInput>;
  orderBy: InputMaybe<AssignmentOrderInput>;
  page: InputMaybe<Scalars['Int']['input']>;
  perPage: InputMaybe<Scalars['Int']['input']>;
  search: InputMaybe<AssignmentSearchInput>;
};

export type AssignmentRequest = {
  __typename?: 'AssignmentRequest';
  asap: Scalars['Boolean']['output'];
  assignment: Maybe<Assignment>;
  assignment_id: Maybe<Scalars['Int']['output']>;
  bonus_type: Maybe<Scalars['String']['output']>;
  cam_notes: Maybe<Scalars['String']['output']>;
  cam_reject_reason: Maybe<Scalars['String']['output']>;
  contract_type: Maybe<Scalars['String']['output']>;
  coordinate_distance: Maybe<Scalars['Float']['output']>;
  created_at: Scalars['DateTime']['output'];
  exceptions: Maybe<Scalars['String']['output']>;
  favorited_by: Maybe<Scalars['String']['output']>;
  first_experience_date: Maybe<Scalars['Date']['output']>;
  has_contract: Maybe<Scalars['Boolean']['output']>;
  has_missing_availability: Maybe<Scalars['Boolean']['output']>;
  has_missing_education: Maybe<Scalars['Boolean']['output']>;
  has_missing_ehr_software: Maybe<Scalars['Boolean']['output']>;
  has_missing_experience: Maybe<Scalars['Boolean']['output']>;
  has_missing_identity: Maybe<Scalars['Boolean']['output']>;
  has_missing_information: Maybe<Scalars['Boolean']['output']>;
  has_missing_references: Maybe<Scalars['Boolean']['output']>;
  has_missing_work_history: Maybe<Scalars['Boolean']['output']>;
  has_unexplained_work_gaps: Maybe<Scalars['Boolean']['output']>;
  has_upload: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['Int']['output'];
  interview_availability: Maybe<Scalars['String']['output']>;
  interview_notes: Maybe<Scalars['String']['output']>;
  is_favorite: Scalars['Boolean']['output'];
  is_favorite_any_facility: Scalars['Boolean']['output'];
  is_favorite_this_facility: Scalars['Boolean']['output'];
  note: Maybe<Scalars['String']['output']>;
  num_shifts_worked: Maybe<Scalars['Int']['output']>;
  num_shifts_worked_here: Maybe<Scalars['Int']['output']>;
  offer_cancellation_reason: Maybe<AssignmentRequestCancellationReasons>;
  offer_sent_date: Maybe<Scalars['Date']['output']>;
  offer_source: Maybe<Scalars['String']['output']>;
  phone_screening_request: Maybe<PhoneScreeningRequest>;
  preferred_start_date: Maybe<Scalars['Date']['output']>;
  professional: Maybe<Professional>;
  professional_id: Maybe<Scalars['Int']['output']>;
  professional_position_recent_experience: Maybe<Array<Maybe<ProfessionalRecentExperience>>>;
  professional_prev_worked_here: Maybe<Scalars['String']['output']>;
  recommended: Scalars['Boolean']['output'];
  recruiter_notes: Maybe<Scalars['String']['output']>;
  referrer_professional: Maybe<Professional>;
  rejection_reason: Maybe<Scalars['String']['output']>;
  relevant_qualification_ids: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  start_date: Maybe<Scalars['String']['output']>;
  status: Maybe<Scalars['String']['output']>;
  submitted_to_vms: Scalars['Boolean']['output'];
  submitting_cam: Maybe<Account>;
  submitting_cam_id: Maybe<Scalars['Int']['output']>;
  time_off_request: Maybe<Scalars['String']['output']>;
  travel_profile_strength: Maybe<Scalars['Int']['output']>;
  unapplied_at: Maybe<Scalars['DateTime']['output']>;
  unapply_reason: Maybe<Scalars['String']['output']>;
  updated_at: Scalars['DateTime']['output'];
  upload: Maybe<Scalars['AWSFile']['output']>;
  viewed: Maybe<Scalars['Boolean']['output']>;
  vms_application_status: Maybe<Scalars['String']['output']>;
  vms_application_submitted_at: Maybe<Scalars['DateTime']['output']>;
  vms_profile_status: Maybe<Scalars['String']['output']>;
  vms_profile_submitted_at: Maybe<Scalars['DateTime']['output']>;
  vms_reject_reason: Maybe<Scalars['String']['output']>;
};


export type AssignmentRequestProfessional_Position_Recent_ExperienceArgs = {
  within_past_years?: Scalars['Int']['input'];
};

export enum AssignmentRequestCancellationReasons {
  FilledByOtherAgency = 'filled_by_other_agency',
  LowPatientCensus = 'low_patient_census',
  Mistake = 'mistake',
  NoApplicants = 'no_applicants',
  TooExpensive = 'too_expensive',
  UtilizingOwnStaff = 'utilizing_own_staff',
  WishNotToWorkWithMedely = 'wish_not_to_work_with_medely'
}

export type AssignmentRequestOrderInput = {
  assignment_id: InputMaybe<Scalars['Boolean']['input']>;
  created_at: InputMaybe<Scalars['Boolean']['input']>;
  id: InputMaybe<Scalars['Boolean']['input']>;
  phone_screening_request_id: InputMaybe<Scalars['Boolean']['input']>;
  professional_id: InputMaybe<Scalars['Boolean']['input']>;
  status: InputMaybe<Scalars['Boolean']['input']>;
  submitted_to_vms: InputMaybe<Scalars['Boolean']['input']>;
  travel_profile_strength: InputMaybe<Scalars['Boolean']['input']>;
  updated_at: InputMaybe<Scalars['Boolean']['input']>;
  vms_application_status: InputMaybe<Scalars['Boolean']['input']>;
  vms_application_submitted_at: InputMaybe<Scalars['Boolean']['input']>;
  vms_profile_status: InputMaybe<Scalars['Boolean']['input']>;
  vms_profile_submitted_at: InputMaybe<Scalars['Boolean']['input']>;
};

export type AssignmentRequestQueryInput = {
  filter: InputMaybe<AssignmentRequestWhereInput>;
  orderBy: InputMaybe<AssignmentRequestOrderInput>;
  page: InputMaybe<Scalars['Int']['input']>;
  perPage: InputMaybe<Scalars['Int']['input']>;
  search: InputMaybe<AssignmentRequestSearchInput>;
};

export type AssignmentRequestSearchInput = {
  assignment_id: InputMaybe<Scalars['Int']['input']>;
  assignment_status: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  assignment_type: InputMaybe<Scalars['String']['input']>;
  cam_id: InputMaybe<Scalars['Int']['input']>;
  contract_range: InputMaybe<ContractRangeInput>;
  created_at: InputMaybe<Scalars['DateTime']['input']>;
  facility_account_id: InputMaybe<Scalars['Int']['input']>;
  health_system_id: InputMaybe<Scalars['Int']['input']>;
  location_ids: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  msp_id: InputMaybe<Scalars['Int']['input']>;
  on_hold: InputMaybe<Scalars['Boolean']['input']>;
  position_ids: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  professional_account_id: InputMaybe<Scalars['Int']['input']>;
  professional_id: InputMaybe<Scalars['Int']['input']>;
  professional_name: InputMaybe<Scalars['String']['input']>;
  profile_strength: InputMaybe<Scalars['Int']['input']>;
  /**
   * *Constraints:*
   * * Maximal length: `150`
   *
   */
  q: InputMaybe<Scalars['String']['input']>;
  recruiter_id: InputMaybe<Scalars['Int']['input']>;
  statuses: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  vms_application_submitted_at: InputMaybe<Scalars['DateTime']['input']>;
  vms_profile_submitted_at: InputMaybe<Scalars['DateTime']['input']>;
  vms_type_id: InputMaybe<Scalars['Int']['input']>;
};

export type AssignmentRequestStatusCounts = {
  __typename?: 'AssignmentRequestStatusCounts';
  active_count: Maybe<Scalars['Int']['output']>;
  awaiting_count: Maybe<Scalars['Int']['output']>;
  interview_count: Maybe<Scalars['Int']['output']>;
  offer_count: Maybe<Scalars['Int']['output']>;
};

export type AssignmentRequestWhereInput = {
  assignment_id: InputMaybe<Scalars['Int']['input']>;
  assignment_status: InputMaybe<Scalars['String']['input']>;
  created_at: InputMaybe<Scalars['DateTime']['input']>;
  id: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  phone_screening_request_id: InputMaybe<Scalars['Int']['input']>;
  professional_id: InputMaybe<Scalars['Int']['input']>;
  recruiter_id: InputMaybe<Scalars['Int']['input']>;
  status: InputMaybe<Scalars['String']['input']>;
  submitted_to_vms: InputMaybe<Scalars['Boolean']['input']>;
  updated_at: InputMaybe<Scalars['DateTime']['input']>;
  viewed: InputMaybe<Scalars['Boolean']['input']>;
  vms_application_status: InputMaybe<Scalars['String']['input']>;
  vms_profile_status: InputMaybe<Scalars['String']['input']>;
};

export enum AssignmentSchedule {
  Day = 'day',
  Evening = 'evening',
  Night = 'night'
}

export type AssignmentSearchInput = {
  administrator_id: InputMaybe<Scalars['Int']['input']>;
  agency_filter: InputMaybe<AssignmentAgencyFilterInput>;
  all_position_ids: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  assignment_request_status: InputMaybe<Scalars['String']['input']>;
  compact: InputMaybe<Scalars['Boolean']['input']>;
  company_id: InputMaybe<Scalars['Int']['input']>;
  contract_length_in_weeks: InputMaybe<ContractLengthInWeeksInput>;
  contract_range: InputMaybe<ContractRangeInput>;
  created_at: InputMaybe<Scalars['Date']['input']>;
  default_sort: InputMaybe<Scalars['String']['input']>;
  distance_check: InputMaybe<AssignmentDistanceCheckInput>;
  distance_sort: InputMaybe<Scalars['String']['input']>;
  duration_sort: InputMaybe<Scalars['String']['input']>;
  ends_date: InputMaybe<Scalars['Date']['input']>;
  ends_date_from: InputMaybe<Scalars['Date']['input']>;
  ends_date_to: InputMaybe<Scalars['Date']['input']>;
  expiring_date: InputMaybe<Scalars['Date']['input']>;
  favorited_by_professional_id: InputMaybe<Scalars['Int']['input']>;
  flexible_starts_date: InputMaybe<Scalars['Boolean']['input']>;
  has_extension: InputMaybe<Scalars['Boolean']['input']>;
  has_pending_offers: InputMaybe<Scalars['Boolean']['input']>;
  has_travel_stipend: InputMaybe<Scalars['String']['input']>;
  health_system_id: InputMaybe<Scalars['Int']['input']>;
  ignore_location_ids: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  ignore_location_type_ids: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  is_1099: InputMaybe<Scalars['Boolean']['input']>;
  is_extension: InputMaybe<Scalars['Boolean']['input']>;
  is_underbooked: InputMaybe<DateRangeInput>;
  is_w2: InputMaybe<Scalars['Boolean']['input']>;
  local_only: InputMaybe<Scalars['Boolean']['input']>;
  location_filter: InputMaybe<AssignmentDistanceLocationFilterInput>;
  location_id: InputMaybe<Scalars['Int']['input']>;
  location_ids: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  location_type_ids: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  market_id: InputMaybe<Scalars['Int']['input']>;
  market_ids: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  marketplace: InputMaybe<Scalars['Boolean']['input']>;
  msp_id: InputMaybe<Scalars['Int']['input']>;
  new_applicants: InputMaybe<Scalars['Boolean']['input']>;
  new_assignment: InputMaybe<Scalars['Boolean']['input']>;
  no_vms_company: InputMaybe<Scalars['Boolean']['input']>;
  not_applied_by_pro_id: InputMaybe<Scalars['Int']['input']>;
  on_hold: InputMaybe<Scalars['Boolean']['input']>;
  onboarding_due_date: InputMaybe<Scalars['Date']['input']>;
  paused: InputMaybe<Scalars['Boolean']['input']>;
  paused_or_applied_by_professional_id: InputMaybe<Scalars['Int']['input']>;
  pay_sort: InputMaybe<Scalars['String']['input']>;
  phone_screening_request_status: InputMaybe<Scalars['String']['input']>;
  plan: InputMaybe<Scalars['Int']['input']>;
  position_display_name: InputMaybe<Scalars['String']['input']>;
  position_ids: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  position_name: InputMaybe<Scalars['String']['input']>;
  professional_account_id: InputMaybe<Scalars['Int']['input']>;
  professional_name: InputMaybe<Scalars['String']['input']>;
  /**
   * *Constraints:*
   * * Maximal length: `150`
   *
   */
  q: InputMaybe<Scalars['String']['input']>;
  recommended_assignments: InputMaybe<RecommendedAssignmentInput>;
  recruiter_id: InputMaybe<Scalars['Int']['input']>;
  sales_associate_id: InputMaybe<Scalars['Int']['input']>;
  schedule: InputMaybe<Array<InputMaybe<AssignmentSchedule>>>;
  shift_length: InputMaybe<ShiftLengthInput>;
  shift_times: InputMaybe<Scalars['Int']['input']>;
  specialty_ids: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  starts_date: InputMaybe<Scalars['Date']['input']>;
  state_abbreviation: InputMaybe<Scalars['String']['input']>;
  state_id: InputMaybe<Scalars['Int']['input']>;
  status: InputMaybe<Scalars['String']['input']>;
  statuses: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  surgery_type_id: InputMaybe<Scalars['Int']['input']>;
  time_of_day: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  track_unpaid_breaks: InputMaybe<Scalars['Boolean']['input']>;
  travel: InputMaybe<Scalars['String']['input']>;
  vms_type_id: InputMaybe<Scalars['Int']['input']>;
  weekly_rate_cents: InputMaybe<Scalars['Int']['input']>;
};

export type AssignmentWhereInput = {
  adjust_rate_calculator: InputMaybe<Scalars['Boolean']['input']>;
  administrator_id: InputMaybe<Scalars['Int']['input']>;
  booked_at: InputMaybe<Scalars['DateTime']['input']>;
  charge_base_hourly_rate_cents: InputMaybe<Scalars['Int']['input']>;
  charge_per_week_cents: InputMaybe<Scalars['Int']['input']>;
  completed_early: InputMaybe<Scalars['Boolean']['input']>;
  covid_care: InputMaybe<Scalars['Boolean']['input']>;
  created_at: InputMaybe<Scalars['DateTime']['input']>;
  ends_date: InputMaybe<Scalars['DateTime']['input']>;
  ends_time: InputMaybe<Scalars['DateTime']['input']>;
  estimated_total_hours: InputMaybe<Scalars['Float']['input']>;
  facility_rate_blended_cents: InputMaybe<Scalars['Float']['input']>;
  flexible_starts_date: InputMaybe<Scalars['Boolean']['input']>;
  hours_per_shift: InputMaybe<Scalars['Float']['input']>;
  id: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  invoice_id: InputMaybe<Scalars['Int']['input']>;
  jobs_detail: InputMaybe<Scalars['String']['input']>;
  lodging_per_diem_cents: InputMaybe<Scalars['Int']['input']>;
  lunch_break: InputMaybe<Scalars['Boolean']['input']>;
  mie_per_diem_cents: InputMaybe<Scalars['Int']['input']>;
  nontaxable_amount_cents: InputMaybe<Scalars['Float']['input']>;
  notes: InputMaybe<Scalars['String']['input']>;
  number_of_shifts_per_week: InputMaybe<Scalars['Int']['input']>;
  number_of_weeks: InputMaybe<Scalars['Int']['input']>;
  on_hold: InputMaybe<Scalars['Boolean']['input']>;
  onboarding_due_date: InputMaybe<Scalars['DateTime']['input']>;
  order_number: InputMaybe<Scalars['String']['input']>;
  patient_population: InputMaybe<Scalars['String']['input']>;
  paused: InputMaybe<Scalars['Boolean']['input']>;
  pay_per_week_cents: InputMaybe<Scalars['Int']['input']>;
  payout_base_hourly_rate_cents: InputMaybe<Scalars['Int']['input']>;
  per_diem: InputMaybe<Scalars['Boolean']['input']>;
  position_display_names: InputMaybe<Scalars['String']['input']>;
  preferred_facility_rate_cents: InputMaybe<Scalars['Int']['input']>;
  preferred_professional_rate_cents: InputMaybe<Scalars['Int']['input']>;
  professional_id: InputMaybe<Scalars['Int']['input']>;
  professional_rate_blended_cents: InputMaybe<Scalars['Float']['input']>;
  rate_calculator_id: InputMaybe<Scalars['Int']['input']>;
  recruiter_id: InputMaybe<Scalars['Int']['input']>;
  schedule_known: InputMaybe<Scalars['Boolean']['input']>;
  schedule_type: InputMaybe<Scalars['String']['input']>;
  self_schedule: InputMaybe<Scalars['Boolean']['input']>;
  specialty_labels: InputMaybe<Scalars['String']['input']>;
  starts_date: InputMaybe<Scalars['DateTime']['input']>;
  starts_time: InputMaybe<Scalars['DateTime']['input']>;
  status: InputMaybe<Scalars['String']['input']>;
  submittal_max: InputMaybe<Scalars['Int']['input']>;
  surgery_type_display_names: InputMaybe<Scalars['String']['input']>;
  suspicious: InputMaybe<Scalars['Boolean']['input']>;
  taxable_amount_cents: InputMaybe<Scalars['Float']['input']>;
  taxable_hourly_rate_cents: InputMaybe<Scalars['Float']['input']>;
  track_unpaid_breaks: InputMaybe<Scalars['Boolean']['input']>;
  updated_at: InputMaybe<Scalars['DateTime']['input']>;
  user_id: InputMaybe<Scalars['Int']['input']>;
  vms_assignment_id: InputMaybe<Scalars['Int']['input']>;
};

export type Audit = {
  __typename?: 'Audit';
  account: Maybe<Account>;
  action: Maybe<Scalars['String']['output']>;
  associated_id: Maybe<Scalars['Int']['output']>;
  associated_type: Maybe<Scalars['String']['output']>;
  auditable_id: Maybe<Scalars['Int']['output']>;
  auditable_type: Maybe<Scalars['String']['output']>;
  audited_changes: Maybe<Scalars['JSON']['output']>;
  created_at: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['Int']['output'];
  user_id: Maybe<Scalars['Int']['output']>;
};

export type AuditOrderInput = {
  id: InputMaybe<Scalars['Boolean']['input']>;
};

export type AuditQueryInput = {
  filter: InputMaybe<AuditWhereInput>;
  orderBy: InputMaybe<AuditOrderInput>;
  page: InputMaybe<Scalars['Int']['input']>;
  perPage: InputMaybe<Scalars['Int']['input']>;
  search: InputMaybe<DefaultSearchInput>;
};

export type AuditWhereInput = {
  id: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};

export type AvailableAssignmentsMeta = {
  __typename?: 'AvailableAssignmentsMeta';
  count: Maybe<Scalars['Int']['output']>;
  /** @deprecated Field no longer supported */
  rankingType: Maybe<Scalars['String']['output']>;
};

export type AvailableJobSort = {
  order: InputMaybe<Scalars['String']['input']>;
  professional_id: InputMaybe<Scalars['Int']['input']>;
  sort_type: InputMaybe<Scalars['String']['input']>;
};

export type BackgroundCheck = {
  __typename?: 'BackgroundCheck';
  candidate_id: Maybe<Scalars['String']['output']>;
  candidate_status: Maybe<Scalars['String']['output']>;
  completed_on: Maybe<Scalars['DateTime']['output']>;
  created_at: Scalars['DateTime']['output'];
  id: Scalars['Int']['output'];
  notes: Maybe<Scalars['String']['output']>;
  professional: Maybe<Professional>;
  professional_id: Maybe<Scalars['Int']['output']>;
  report_id: Maybe<Scalars['String']['output']>;
  report_status: Maybe<Scalars['String']['output']>;
  updated_at: Scalars['DateTime']['output'];
};

export type BackgroundCheckOrderInput = {
  candidate_id: InputMaybe<Scalars['Boolean']['input']>;
  candidate_status: InputMaybe<Scalars['Boolean']['input']>;
  created_at: InputMaybe<Scalars['Boolean']['input']>;
  id: InputMaybe<Scalars['Boolean']['input']>;
  notes: InputMaybe<Scalars['Boolean']['input']>;
  professional_id: InputMaybe<Scalars['Boolean']['input']>;
  report_id: InputMaybe<Scalars['Boolean']['input']>;
  report_status: InputMaybe<Scalars['Boolean']['input']>;
  updated_at: InputMaybe<Scalars['Boolean']['input']>;
};

export type BackgroundCheckQueryInput = {
  filter: InputMaybe<BackgroundCheckWhereInput>;
  orderBy: InputMaybe<BackgroundCheckOrderInput>;
  page: InputMaybe<Scalars['Int']['input']>;
  perPage: InputMaybe<Scalars['Int']['input']>;
  search: InputMaybe<DefaultSearchInput>;
};

export type BackgroundCheckWhereInput = {
  candidate_id: InputMaybe<Scalars['String']['input']>;
  candidate_status: InputMaybe<Scalars['String']['input']>;
  created_at: InputMaybe<Scalars['DateTime']['input']>;
  id: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  notes: InputMaybe<Scalars['String']['input']>;
  professional_id: InputMaybe<Scalars['Int']['input']>;
  report_id: InputMaybe<Scalars['String']['input']>;
  report_status: InputMaybe<Scalars['String']['input']>;
  updated_at: InputMaybe<Scalars['DateTime']['input']>;
};

export type BalanceSheet = {
  __typename?: 'BalanceSheet';
  close_period: Maybe<Scalars['Int']['output']>;
  closed: Maybe<Scalars['Boolean']['output']>;
  created_at: Scalars['DateTime']['output'];
  date: Maybe<Scalars['String']['output']>;
  expense_adjustments: Maybe<Array<Maybe<ExpenseAdjustment>>>;
  finantial_transactions: Maybe<Array<Maybe<FinancialTransaction>>>;
  first_datetime: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['Int']['output'];
  job_billings: Maybe<Array<Maybe<JobBilling>>>;
  jobs: Maybe<Array<Maybe<Job>>>;
  month: Maybe<Scalars['String']['output']>;
  revenue_adjustments: Maybe<Array<Maybe<RevenueAdjustment>>>;
  total_cents: Scalars['Int']['output'];
  total_currency: Scalars['String']['output'];
  updated_at: Scalars['DateTime']['output'];
  year: Maybe<Scalars['String']['output']>;
};

export type BalanceSheetOrderInput = {
  close_period: InputMaybe<Scalars['Boolean']['input']>;
  first_datetime: InputMaybe<Scalars['Boolean']['input']>;
  id: InputMaybe<Scalars['Boolean']['input']>;
};

export type BalanceSheetQueryInput = {
  filter: InputMaybe<BalanceSheetWhereInput>;
  orderBy: InputMaybe<BalanceSheetOrderInput>;
  page: InputMaybe<Scalars['Int']['input']>;
  perPage: InputMaybe<Scalars['Int']['input']>;
  search: InputMaybe<BalanceSheetSearchInput>;
};

export type BalanceSheetSearchInput = {
  close_period: InputMaybe<Scalars['Int']['input']>;
  closed: InputMaybe<Scalars['Boolean']['input']>;
  first_datetime: InputMaybe<Scalars['DateTime']['input']>;
  id: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  month: InputMaybe<Scalars['Int']['input']>;
  /**
   * *Constraints:*
   * * Maximal length: `150`
   *
   */
  q: InputMaybe<Scalars['String']['input']>;
  year: InputMaybe<Scalars['Int']['input']>;
};

export type BalanceSheetWhereInput = {
  closed: InputMaybe<Scalars['Boolean']['input']>;
  created_at: InputMaybe<Scalars['DateTime']['input']>;
  first_datetime: InputMaybe<Scalars['DateTime']['input']>;
  id: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  total_cents: InputMaybe<Scalars['Int']['input']>;
  total_currency: InputMaybe<Scalars['String']['input']>;
  updated_at: InputMaybe<Scalars['DateTime']['input']>;
};

export type BillingActivity = {
  __typename?: 'BillingActivity';
  billing_group_id: Maybe<Scalars['Int']['output']>;
  created_at: Maybe<Scalars['DateTime']['output']>;
  description: Maybe<Scalars['String']['output']>;
  id: Maybe<Scalars['Int']['output']>;
  running_total_cents: Maybe<Scalars['Int']['output']>;
  status: Maybe<Scalars['String']['output']>;
  total_cents: Maybe<Scalars['Int']['output']>;
  type: Maybe<Scalars['String']['output']>;
};

export type BillingActivityOrderInput = {
  created_at: InputMaybe<Scalars['Boolean']['input']>;
};

export type BillingActivityQueryInput = {
  billing_group_id: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<BillingActivityOrderInput>;
  page: InputMaybe<Scalars['Int']['input']>;
  perPage: InputMaybe<Scalars['Int']['input']>;
  search: InputMaybe<BillingActivitySearchInput>;
};

export type BillingActivitySearchInput = {
  billing_group_ids: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  ends_time: InputMaybe<Scalars['DateTime']['input']>;
  max_amount: InputMaybe<Scalars['Int']['input']>;
  min_amount: InputMaybe<Scalars['Int']['input']>;
  starts_time: InputMaybe<Scalars['DateTime']['input']>;
  types: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type BillingContact = {
  __typename?: 'BillingContact';
  billing_group_id: Maybe<Scalars['Int']['output']>;
  email: Maybe<Scalars['String']['output']>;
  first_name: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  last_name: Maybe<Scalars['String']['output']>;
  phone_number: Maybe<Scalars['String']['output']>;
  user: Maybe<User>;
  user_id: Maybe<Scalars['Int']['output']>;
};

export type BillingContactOrderInput = {
  first_name: InputMaybe<Scalars['Boolean']['input']>;
  id: InputMaybe<Scalars['Boolean']['input']>;
  last_name: InputMaybe<Scalars['Boolean']['input']>;
};

export type BillingContactQueryInput = {
  filter: InputMaybe<BillingContactWhereInput>;
  orderBy: InputMaybe<BillingContactOrderInput>;
  page: InputMaybe<Scalars['Int']['input']>;
  perPage: InputMaybe<Scalars['Int']['input']>;
  search: InputMaybe<DefaultSearchInput>;
};

export type BillingContactWhereInput = {
  email: InputMaybe<Scalars['String']['input']>;
  first_name: InputMaybe<Scalars['String']['input']>;
  id: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  last_name: InputMaybe<Scalars['String']['input']>;
  phone_number: InputMaybe<Scalars['String']['input']>;
  user_id: InputMaybe<Scalars['Int']['input']>;
};

export type BillingGroup = {
  __typename?: 'BillingGroup';
  account_billing_groups: Maybe<Array<Maybe<AccountBillingGroup>>>;
  account_summary_emails: Scalars['Boolean']['output'];
  ach_source_detail: Maybe<Scalars['AchSourceDetail']['output']>;
  assignment_billing_groups: Maybe<Array<Maybe<AssignmentBillingGroup>>>;
  auto_pay: Scalars['Boolean']['output'];
  balance_cents: Scalars['Int']['output'];
  balance_currency: Scalars['String']['output'];
  bank_last: Maybe<Scalars['String']['output']>;
  billing: Scalars['String']['output'];
  billing_group_management_company: Maybe<BillingGroupManagementCompany>;
  billing_group_management_company_id: Maybe<Scalars['Int']['output']>;
  billing_group_parent: Maybe<BillingGroupParent>;
  billing_group_parent_id: Maybe<Scalars['Int']['output']>;
  billing_rep: Maybe<Scalars['Int']['output']>;
  business_tax_id: Maybe<Scalars['String']['output']>;
  charge_on_call_hourly_rate_cents: Scalars['Int']['output'];
  charge_on_call_hourly_rate_currency: Scalars['String']['output'];
  check_line_of_credit: Maybe<Scalars['Boolean']['output']>;
  collections_late_fee_percent: Maybe<Scalars['Float']['output']>;
  collections_rep: Maybe<Scalars['Int']['output']>;
  company: Company;
  company_id: Scalars['Int']['output'];
  created_at: Scalars['DateTime']['output'];
  credit_insurance_limit: Maybe<Scalars['Int']['output']>;
  current_due_cents: Maybe<Scalars['Int']['output']>;
  duns: Maybe<Scalars['Int']['output']>;
  eh_id: Maybe<Scalars['String']['output']>;
  funding_sources: Maybe<Array<Maybe<FundingSource>>>;
  has_dun_and_bradstreet: Scalars['Boolean']['output'];
  has_past_due: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['Int']['output'];
  invoice_emails: Scalars['Boolean']['output'];
  last_credit_review: Maybe<Scalars['DateTime']['output']>;
  legal_name: Maybe<Scalars['String']['output']>;
  line_of_credit_cents: Scalars['Int']['output'];
  line_of_credit_currency: Scalars['String']['output'];
  location_billing_groups: Maybe<Array<Maybe<LocationBillingGroup>>>;
  locations: Maybe<Array<Maybe<Location>>>;
  msa: Scalars['Boolean']['output'];
  name: Maybe<Scalars['String']['output']>;
  net_term: Maybe<Scalars['Int']['output']>;
  original_user_id: Maybe<Scalars['Int']['output']>;
  past_due_allowance_amount_cents: Scalars['Int']['output'];
  past_due_cents: Maybe<Scalars['Int']['output']>;
  payment_due_date: Maybe<Scalars['String']['output']>;
  payment_gateway: Scalars['Boolean']['output'];
  plaid_account_id: Maybe<Scalars['String']['output']>;
  plaid_token: Maybe<Scalars['String']['output']>;
  plan: Scalars['String']['output'];
  remaining_credit_cents: Maybe<Scalars['Int']['output']>;
  statement_fee_percent: Maybe<Scalars['Float']['output']>;
  statements: Maybe<Array<Maybe<Statement>>>;
  status: Scalars['String']['output'];
  stripe_ach_credit_transfer_id: Maybe<Scalars['String']['output']>;
  stripe_bank_account_token: Maybe<Scalars['String']['output']>;
  stripe_customer_id: Maybe<Scalars['String']['output']>;
  stripe_last_4: Maybe<Scalars['String']['output']>;
  tier: Maybe<Scalars['String']['output']>;
  total_due_cents: Maybe<Scalars['Int']['output']>;
  track_unpaid_breaks: Scalars['Boolean']['output'];
  uid: Scalars['String']['output'];
  updated_at: Scalars['DateTime']['output'];
  vms_fee_percent: Maybe<Scalars['Float']['output']>;
};

export type BillingGroupCreditLimitCalculation = {
  __typename?: 'BillingGroupCreditLimitCalculation';
  billing_group_id: Maybe<Scalars['Int']['output']>;
  credit_percentage_used: Maybe<Scalars['Float']['output']>;
  line_of_credit_cents: Maybe<Scalars['Int']['output']>;
  remaining_credit_cents: Maybe<Scalars['Int']['output']>;
};

export type BillingGroupCreditLimitCalculationOrderInput = {
  billing_group_id: InputMaybe<Scalars['Boolean']['input']>;
};

export type BillingGroupCreditLimitCalculationQueryInput = {
  filter: InputMaybe<BillingGroupCreditLimitCalculationWhereInput>;
  orderBy: InputMaybe<BillingGroupCreditLimitCalculationOrderInput>;
  page: InputMaybe<Scalars['Int']['input']>;
  perPage: InputMaybe<Scalars['Int']['input']>;
  search: InputMaybe<BillingGroupCreditLimitCalculationSearchInput>;
};

export type BillingGroupCreditLimitCalculationSearchInput = {
  billing_group_id: InputMaybe<Scalars['Int']['input']>;
  billing_group_uid: InputMaybe<Scalars['String']['input']>;
  payment_gateway: InputMaybe<Scalars['Boolean']['input']>;
};

export type BillingGroupCreditLimitCalculationWhereInput = {
  billing_group_id: InputMaybe<Scalars['Int']['input']>;
};

export type BillingGroupManagementCompany = {
  __typename?: 'BillingGroupManagementCompany';
  created_at: Scalars['DateTime']['output'];
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  updated_at: Scalars['DateTime']['output'];
};

export type BillingGroupManagementCompanyOrderInput = {
  id: InputMaybe<Scalars['Boolean']['input']>;
  name: InputMaybe<Scalars['Boolean']['input']>;
};

export type BillingGroupManagementCompanyQueryInput = {
  filter: InputMaybe<BillingGroupManagementCompanyWhereInput>;
  orderBy: InputMaybe<BillingGroupManagementCompanyOrderInput>;
  page: InputMaybe<Scalars['Int']['input']>;
  perPage: InputMaybe<Scalars['Int']['input']>;
  search: InputMaybe<BillingGroupManagementCompanySearchInput>;
};

export type BillingGroupManagementCompanySearchInput = {
  billing_group_ids: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  id: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  name: InputMaybe<Scalars['String']['input']>;
  /**
   * *Constraints:*
   * * Maximal length: `150`
   *
   */
  q: InputMaybe<Scalars['String']['input']>;
};

export type BillingGroupManagementCompanyWhereInput = {
  created_at: InputMaybe<Scalars['DateTime']['input']>;
  id: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  updated_at: InputMaybe<Scalars['DateTime']['input']>;
};

export type BillingGroupOrderInput = {
  account_summary_emails: InputMaybe<Scalars['Boolean']['input']>;
  auto_pay: InputMaybe<Scalars['Boolean']['input']>;
  balance_cents: InputMaybe<Scalars['Boolean']['input']>;
  balance_currency: InputMaybe<Scalars['Boolean']['input']>;
  bank_last: InputMaybe<Scalars['Boolean']['input']>;
  billing: InputMaybe<Scalars['Boolean']['input']>;
  business_tax_id: InputMaybe<Scalars['Boolean']['input']>;
  charge_on_call_hourly_rate_cents: InputMaybe<Scalars['Boolean']['input']>;
  charge_on_call_hourly_rate_currency: InputMaybe<Scalars['Boolean']['input']>;
  check_line_of_credit: InputMaybe<Scalars['Boolean']['input']>;
  company_id: InputMaybe<Scalars['Boolean']['input']>;
  created_at: InputMaybe<Scalars['Boolean']['input']>;
  id: InputMaybe<Scalars['Boolean']['input']>;
  invoice_emails: InputMaybe<Scalars['Boolean']['input']>;
  line_of_credit_cents: InputMaybe<Scalars['Boolean']['input']>;
  line_of_credit_currency: InputMaybe<Scalars['Boolean']['input']>;
  name: InputMaybe<Scalars['Boolean']['input']>;
  net_term: InputMaybe<Scalars['Boolean']['input']>;
  original_user_id: InputMaybe<Scalars['Boolean']['input']>;
  payment_gateway: InputMaybe<Scalars['Boolean']['input']>;
  plaid_account_id: InputMaybe<Scalars['Boolean']['input']>;
  plaid_token: InputMaybe<Scalars['Boolean']['input']>;
  plan: InputMaybe<Scalars['Boolean']['input']>;
  status: InputMaybe<Scalars['Boolean']['input']>;
  stripe_ach_credit_transfer_id: InputMaybe<Scalars['Boolean']['input']>;
  stripe_bank_account_token: InputMaybe<Scalars['Boolean']['input']>;
  stripe_customer_id: InputMaybe<Scalars['Boolean']['input']>;
  stripe_last_4: InputMaybe<Scalars['Boolean']['input']>;
  uid: InputMaybe<Scalars['Boolean']['input']>;
  updated_at: InputMaybe<Scalars['Boolean']['input']>;
  vms_fee_percent: InputMaybe<Scalars['Boolean']['input']>;
};

export type BillingGroupParent = {
  __typename?: 'BillingGroupParent';
  created_at: Scalars['DateTime']['output'];
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  updated_at: Scalars['DateTime']['output'];
};

export type BillingGroupParentOrderInput = {
  id: InputMaybe<Scalars['Boolean']['input']>;
  name: InputMaybe<Scalars['Boolean']['input']>;
};

export type BillingGroupParentQueryInput = {
  filter: InputMaybe<BillingGroupParentWhereInput>;
  orderBy: InputMaybe<BillingGroupParentOrderInput>;
  page: InputMaybe<Scalars['Int']['input']>;
  perPage: InputMaybe<Scalars['Int']['input']>;
  search: InputMaybe<BillingGroupParentSearchInput>;
};

export type BillingGroupParentSearchInput = {
  billing_group_ids: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  id: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  name: InputMaybe<Scalars['String']['input']>;
  /**
   * *Constraints:*
   * * Maximal length: `150`
   *
   */
  q: InputMaybe<Scalars['String']['input']>;
};

export type BillingGroupParentWhereInput = {
  created_at: InputMaybe<Scalars['DateTime']['input']>;
  id: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  name: InputMaybe<Scalars['String']['input']>;
  updated_at: InputMaybe<Scalars['DateTime']['input']>;
};

export type BillingGroupQueryInput = {
  filter: InputMaybe<BillingGroupWhereInput>;
  orderBy: InputMaybe<BillingGroupOrderInput>;
  page: InputMaybe<Scalars['Int']['input']>;
  perPage: InputMaybe<Scalars['Int']['input']>;
  search: InputMaybe<BillingGroupSearchInput>;
};

export type BillingGroupSearchInput = {
  account_id: InputMaybe<Scalars['Int']['input']>;
  billing_group_ids: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  has_balance: InputMaybe<Scalars['Boolean']['input']>;
  has_locations: InputMaybe<Scalars['Boolean']['input']>;
  health_system_id: InputMaybe<Scalars['Int']['input']>;
  location_type_ids: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  msp_id: InputMaybe<Scalars['Int']['input']>;
  name: InputMaybe<Scalars['String']['input']>;
  no_vms: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * *Constraints:*
   * * Maximal length: `150`
   *
   */
  q: InputMaybe<Scalars['String']['input']>;
  referral: InputMaybe<Scalars['String']['input']>;
  stripe_customer_id: InputMaybe<Scalars['String']['input']>;
  track_unpaid_breaks: InputMaybe<Scalars['Boolean']['input']>;
  utm_campaign: InputMaybe<Scalars['String']['input']>;
  utm_source: InputMaybe<Scalars['String']['input']>;
  vms_type_id: InputMaybe<Scalars['Int']['input']>;
};

export type BillingGroupWhereInput = {
  account_summary_emails: InputMaybe<Scalars['Boolean']['input']>;
  auto_pay: InputMaybe<Scalars['Boolean']['input']>;
  balance_cents: InputMaybe<Scalars['Int']['input']>;
  balance_currency: InputMaybe<Scalars['String']['input']>;
  bank_last: InputMaybe<Scalars['Int']['input']>;
  billing: InputMaybe<Scalars['String']['input']>;
  billing_group_management_company_id: InputMaybe<Scalars['Int']['input']>;
  billing_group_parent_id: InputMaybe<Scalars['Int']['input']>;
  business_tax_id: InputMaybe<Scalars['String']['input']>;
  charge_on_call_hourly_rate_cents: InputMaybe<Scalars['Int']['input']>;
  charge_on_call_hourly_rate_currency: InputMaybe<Scalars['String']['input']>;
  check_line_of_credit: InputMaybe<Scalars['Boolean']['input']>;
  company_id: InputMaybe<Scalars['Int']['input']>;
  created_at: InputMaybe<Scalars['DateTime']['input']>;
  has_balance: InputMaybe<Scalars['Boolean']['input']>;
  health_system_id: InputMaybe<Scalars['Int']['input']>;
  id: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  invoice_emails: InputMaybe<Scalars['Boolean']['input']>;
  line_of_credit_cents: InputMaybe<Scalars['Int']['input']>;
  line_of_credit_currency: InputMaybe<Scalars['String']['input']>;
  location_type_ids: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  msp_id: InputMaybe<Scalars['Int']['input']>;
  net_term: InputMaybe<Scalars['Int']['input']>;
  no_vms: InputMaybe<Scalars['Boolean']['input']>;
  original_user_id: InputMaybe<Scalars['Int']['input']>;
  past_due_allowance_amount_cents: InputMaybe<Scalars['Int']['input']>;
  payment_gateway: InputMaybe<Scalars['Boolean']['input']>;
  plaid_account_id: InputMaybe<Scalars['String']['input']>;
  plaid_token: InputMaybe<Scalars['String']['input']>;
  plan: InputMaybe<Scalars['String']['input']>;
  referral: InputMaybe<Scalars['String']['input']>;
  saas_primary: InputMaybe<Scalars['Boolean']['input']>;
  status: InputMaybe<Scalars['String']['input']>;
  stripe_ach_credit_transfer_id: InputMaybe<Scalars['String']['input']>;
  stripe_bank_account_token: InputMaybe<Scalars['String']['input']>;
  stripe_customer_id: InputMaybe<Scalars['String']['input']>;
  stripe_last_4: InputMaybe<Scalars['Int']['input']>;
  track_unpaid_breaks: InputMaybe<Scalars['Boolean']['input']>;
  uid: InputMaybe<Scalars['String']['input']>;
  updated_at: InputMaybe<Scalars['DateTime']['input']>;
  utm_campaign: InputMaybe<Scalars['String']['input']>;
  utm_source: InputMaybe<Scalars['String']['input']>;
  vms_fee_percent: InputMaybe<Scalars['Float']['input']>;
  vms_type_id: InputMaybe<Scalars['Int']['input']>;
};

export type BlockedTimes = {
  __typename?: 'BlockedTimes';
  current_ends_time: Scalars['DateTime']['output'];
  current_starts_time: Scalars['DateTime']['output'];
  location_id: Scalars['Int']['output'];
  professional_id: Scalars['Int']['output'];
};

export type Bookability = {
  gte_starts_time: Scalars['DateTime']['input'];
  job_id: Scalars['Int']['input'];
  lte_starts_time: Scalars['DateTime']['input'];
};

export type Break = {
  __typename?: 'Break';
  created_at: Scalars['DateTime']['output'];
  duration_minutes: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  job: Maybe<Job>;
  job_id: Maybe<Scalars['Int']['output']>;
  starts_time: Maybe<Scalars['DateTime']['output']>;
  updated_at: Scalars['DateTime']['output'];
  waived: Maybe<Scalars['Boolean']['output']>;
};

export type BreakOrderInput = {
  created_at: InputMaybe<Scalars['Boolean']['input']>;
  duration_minutes: InputMaybe<Scalars['Boolean']['input']>;
  id: InputMaybe<Scalars['Boolean']['input']>;
  job_id: InputMaybe<Scalars['Boolean']['input']>;
  locations_ids: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  professional_account_id: InputMaybe<Scalars['Int']['input']>;
  professional_id: InputMaybe<Scalars['Int']['input']>;
  starts_time: InputMaybe<Scalars['Boolean']['input']>;
  updated_at: InputMaybe<Scalars['Boolean']['input']>;
};

export type BreakQueryInput = {
  filter: InputMaybe<BreakWhereInput>;
  orderBy: InputMaybe<BreakOrderInput>;
  page: InputMaybe<Scalars['Int']['input']>;
  perPage: InputMaybe<Scalars['Int']['input']>;
  search: InputMaybe<BreakSearchInput>;
};

export type BreakSearchInput = {
  location_ids: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  professional_account_id: InputMaybe<Scalars['Int']['input']>;
  /**
   * *Constraints:*
   * * Maximal length: `150`
   *
   */
  q: InputMaybe<Scalars['String']['input']>;
};

export type BreakWhereInput = {
  created_at: InputMaybe<Scalars['DateTime']['input']>;
  duration_minutes: InputMaybe<Scalars['Int']['input']>;
  id: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  job_id: InputMaybe<Scalars['Int']['input']>;
  starts_time: InputMaybe<Scalars['DateTime']['input']>;
  updated_at: InputMaybe<Scalars['DateTime']['input']>;
  waived: InputMaybe<Scalars['Boolean']['input']>;
};

export type Cancellation = {
  __typename?: 'Cancellation';
  booked_at: Maybe<Scalars['DateTime']['output']>;
  cancellation_reason: Maybe<CancellationReason>;
  cleared: Scalars['Boolean']['output'];
  created_at: Scalars['DateTime']['output'];
  id: Scalars['Int']['output'];
  job: Maybe<Job>;
  job_starts_date: Maybe<Scalars['DateTime']['output']>;
  job_starts_time: Maybe<Scalars['DateTime']['output']>;
  location: Maybe<Location>;
  market_name: Maybe<Scalars['String']['output']>;
  note: Maybe<Scalars['String']['output']>;
  personable: Maybe<Personable>;
  personable_id: Maybe<Scalars['Int']['output']>;
  personable_type: Maybe<Scalars['String']['output']>;
  professional: Maybe<Professional>;
  state_name: Maybe<Scalars['String']['output']>;
  updated_at: Scalars['DateTime']['output'];
  window: Scalars['String']['output'];
};

export type CancellationOrderInput = {
  booked_at: InputMaybe<Scalars['Boolean']['input']>;
  cancellation_reason_id: InputMaybe<Scalars['Boolean']['input']>;
  cleared: InputMaybe<Scalars['Boolean']['input']>;
  created_at: InputMaybe<Scalars['Boolean']['input']>;
  id: InputMaybe<Scalars['Boolean']['input']>;
  job_id: InputMaybe<Scalars['Boolean']['input']>;
  job_starts_date: InputMaybe<Scalars['Boolean']['input']>;
  job_starts_time: InputMaybe<Scalars['Boolean']['input']>;
  market: InputMaybe<Scalars['Boolean']['input']>;
  personable_id: InputMaybe<Scalars['Boolean']['input']>;
  personable_type: InputMaybe<Scalars['Boolean']['input']>;
  state: InputMaybe<Scalars['Boolean']['input']>;
  updated_at: InputMaybe<Scalars['Boolean']['input']>;
};

export type CancellationQueryInput = {
  filter: InputMaybe<CancellationWhereInput>;
  orderBy: InputMaybe<CancellationOrderInput>;
  page: InputMaybe<Scalars['Int']['input']>;
  perPage: InputMaybe<Scalars['Int']['input']>;
  search: InputMaybe<DefaultSearchInput>;
};

export type CancellationReason = {
  __typename?: 'CancellationReason';
  active: Scalars['Boolean']['output'];
  created_at: Scalars['DateTime']['output'];
  id: Scalars['Int']['output'];
  label: Maybe<Scalars['String']['output']>;
  role: Maybe<Scalars['Int']['output']>;
  slug: Scalars['String']['output'];
  updated_at: Scalars['DateTime']['output'];
};

export type CancellationReasonOrderInput = {
  active: InputMaybe<Scalars['Boolean']['input']>;
  created_at: InputMaybe<Scalars['Boolean']['input']>;
  id: InputMaybe<Scalars['Boolean']['input']>;
  label: InputMaybe<Scalars['Boolean']['input']>;
  role: InputMaybe<Scalars['Boolean']['input']>;
  slug: InputMaybe<Scalars['String']['input']>;
  updated_at: InputMaybe<Scalars['Boolean']['input']>;
};

export type CancellationReasonQueryInput = {
  filter: InputMaybe<CancellationReasonWhereInput>;
  orderBy: InputMaybe<CancellationReasonOrderInput>;
  page: InputMaybe<Scalars['Int']['input']>;
  perPage: InputMaybe<Scalars['Int']['input']>;
  search: InputMaybe<DefaultSearchInput>;
};

export type CancellationReasonWhereInput = {
  account_ids: InputMaybe<Scalars['Int']['input']>;
  active: InputMaybe<Scalars['Boolean']['input']>;
  created_at: InputMaybe<Scalars['DateTime']['input']>;
  id: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  label: InputMaybe<Scalars['String']['input']>;
  location_ids: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  location_role: InputMaybe<Scalars['Int']['input']>;
  professional_account_id: InputMaybe<Scalars['Int']['input']>;
  professional_role: InputMaybe<Scalars['Int']['input']>;
  role: InputMaybe<Scalars['Int']['input']>;
  slug: InputMaybe<Scalars['String']['input']>;
  updated_at: InputMaybe<Scalars['DateTime']['input']>;
};

export type CancellationSearchInput = {
  location_ids: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  professional_account_id: InputMaybe<Scalars['Int']['input']>;
  /**
   * *Constraints:*
   * * Maximal length: `150`
   *
   */
  q: InputMaybe<Scalars['String']['input']>;
};

export type CancellationWhereInput = {
  booked_at: InputMaybe<Scalars['DateTime']['input']>;
  cancellation_reason_id: InputMaybe<Scalars['Int']['input']>;
  cleared: InputMaybe<Scalars['Boolean']['input']>;
  created_at: InputMaybe<Scalars['DateTime']['input']>;
  id: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  job_id: InputMaybe<Scalars['Int']['input']>;
  job_starts_date: InputMaybe<Scalars['DateTime']['input']>;
  job_starts_time: InputMaybe<Scalars['DateTime']['input']>;
  market: InputMaybe<Scalars['String']['input']>;
  personable_id: InputMaybe<Scalars['Int']['input']>;
  personable_type: InputMaybe<Scalars['String']['input']>;
  state: InputMaybe<Scalars['String']['input']>;
  updated_at: InputMaybe<Scalars['DateTime']['input']>;
  window: InputMaybe<Scalars['String']['input']>;
};

export type CapsReport = {
  __typename?: 'CapsReport';
  id: Scalars['Int']['output'];
  professional: Maybe<Professional>;
  status: Maybe<Scalars['String']['output']>;
};

export type CapsReportOrderInput = {
  id: InputMaybe<Scalars['Boolean']['input']>;
  professional_id: InputMaybe<Scalars['Boolean']['input']>;
  status: InputMaybe<Scalars['Boolean']['input']>;
};

export type CapsReportQueryInput = {
  filter: InputMaybe<CapsReportWhereInput>;
  orderBy: InputMaybe<CapsReportOrderInput>;
  page: InputMaybe<Scalars['Int']['input']>;
  perPage: InputMaybe<Scalars['Int']['input']>;
  search: InputMaybe<CapsReportSearchInput>;
};

export type CapsReportSearchInput = {
  professional_id: InputMaybe<Scalars['Int']['input']>;
  professional_ids: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  status: InputMaybe<Scalars['String']['input']>;
  statuses: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CapsReportWhereInput = {
  id: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  professional_id: InputMaybe<Scalars['Int']['input']>;
  status: InputMaybe<Scalars['String']['input']>;
};

export type Check = {
  __typename?: 'Check';
  amount_cents: Scalars['Int']['output'];
  created_at: Scalars['DateTime']['output'];
  id: Scalars['Int']['output'];
  note: Maybe<Scalars['String']['output']>;
  number: Maybe<Scalars['String']['output']>;
  statement: Maybe<Statement>;
  stripe_invoice_item_id: Maybe<Scalars['String']['output']>;
  updated_at: Scalars['DateTime']['output'];
};

export type CheckIn = {
  __typename?: 'CheckIn';
  accepted: Maybe<Scalars['Boolean']['output']>;
  clock_event_attachments: Maybe<Array<Maybe<ClockEventAttachment>>>;
  created_at: Scalars['DateTime']['output'];
  distance: Maybe<Scalars['Float']['output']>;
  facility_adjusted_time: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['Int']['output'];
  job: Maybe<Job>;
  job_id: Maybe<Scalars['Int']['output']>;
  job_starts_time: Maybe<Scalars['DateTime']['output']>;
  latitude: Maybe<Scalars['Float']['output']>;
  location: Maybe<Location>;
  location_id: Maybe<Scalars['Int']['output']>;
  longitude: Maybe<Scalars['Float']['output']>;
  manual_override: Maybe<Scalars['Boolean']['output']>;
  professional: Maybe<Professional>;
  professional_id: Maybe<Scalars['Int']['output']>;
  time: Maybe<Scalars['DateTime']['output']>;
  updated_at: Scalars['DateTime']['output'];
};

export type CheckInOrderInput = {
  accepted: InputMaybe<Scalars['Boolean']['input']>;
  created_at: InputMaybe<Scalars['Boolean']['input']>;
  distance: InputMaybe<Scalars['Boolean']['input']>;
  id: InputMaybe<Scalars['Boolean']['input']>;
  job_id: InputMaybe<Scalars['Boolean']['input']>;
  job_starts_time: InputMaybe<Scalars['Boolean']['input']>;
  latitude: InputMaybe<Scalars['Boolean']['input']>;
  location_id: InputMaybe<Scalars['Boolean']['input']>;
  longitude: InputMaybe<Scalars['Boolean']['input']>;
  manual_override: InputMaybe<Scalars['Boolean']['input']>;
  professional_id: InputMaybe<Scalars['Boolean']['input']>;
  time: InputMaybe<Scalars['Boolean']['input']>;
  updated_at: InputMaybe<Scalars['Boolean']['input']>;
};

export type CheckInQueryInput = {
  filter: InputMaybe<CheckInWhereInput>;
  orderBy: InputMaybe<CheckInOrderInput>;
  page: InputMaybe<Scalars['Int']['input']>;
  perPage: InputMaybe<Scalars['Int']['input']>;
  search: InputMaybe<CheckInSearchInput>;
};

export type CheckInSearchInput = {
  accepted: InputMaybe<Scalars['Boolean']['input']>;
  created_at: InputMaybe<Scalars['DateTime']['input']>;
  date_from: InputMaybe<Scalars['DateTime']['input']>;
  date_to: InputMaybe<Scalars['DateTime']['input']>;
  distance: InputMaybe<Scalars['Float']['input']>;
  job_id: InputMaybe<Scalars['Int']['input']>;
  job_starts_time: InputMaybe<Scalars['DateTime']['input']>;
  latitude: InputMaybe<Scalars['Float']['input']>;
  location_id: InputMaybe<Scalars['Int']['input']>;
  longitude: InputMaybe<Scalars['Float']['input']>;
  manual_override: InputMaybe<Scalars['Boolean']['input']>;
  professional_id: InputMaybe<Scalars['Int']['input']>;
  /**
   * *Constraints:*
   * * Maximal length: `150`
   *
   */
  q: InputMaybe<Scalars['String']['input']>;
  time: InputMaybe<Scalars['DateTime']['input']>;
  updated_at: InputMaybe<Scalars['DateTime']['input']>;
};

export type CheckInWhereInput = {
  accepted: InputMaybe<Scalars['Boolean']['input']>;
  created_at: InputMaybe<Scalars['DateTime']['input']>;
  distance: InputMaybe<Scalars['Float']['input']>;
  id: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  job_id: InputMaybe<Scalars['Int']['input']>;
  job_starts_time: InputMaybe<Scalars['DateTime']['input']>;
  latitude: InputMaybe<Scalars['Float']['input']>;
  location_id: InputMaybe<Scalars['Int']['input']>;
  longitude: InputMaybe<Scalars['Float']['input']>;
  manual_override: InputMaybe<Scalars['Boolean']['input']>;
  professional_id: InputMaybe<Scalars['Int']['input']>;
  time: InputMaybe<Scalars['DateTime']['input']>;
  updated_at: InputMaybe<Scalars['DateTime']['input']>;
};

export type CheckOrderInput = {
  amount_cents: InputMaybe<Scalars['Boolean']['input']>;
  created_at: InputMaybe<Scalars['Boolean']['input']>;
  id: InputMaybe<Scalars['Boolean']['input']>;
  note: InputMaybe<Scalars['Boolean']['input']>;
  number: InputMaybe<Scalars['Boolean']['input']>;
  statement_id: InputMaybe<Scalars['Boolean']['input']>;
  stripe_invoice_item_id: InputMaybe<Scalars['Boolean']['input']>;
  updated_at: InputMaybe<Scalars['Boolean']['input']>;
};

export type CheckOut = {
  __typename?: 'CheckOut';
  accepted: Maybe<Scalars['Boolean']['output']>;
  clock_event_attachments: Maybe<Array<Maybe<ClockEventAttachment>>>;
  created_at: Scalars['DateTime']['output'];
  distance: Maybe<Scalars['Float']['output']>;
  id: Scalars['Int']['output'];
  job: Maybe<Job>;
  job_id: Maybe<Scalars['Int']['output']>;
  latitude: Maybe<Scalars['Float']['output']>;
  location: Maybe<Location>;
  location_id: Maybe<Scalars['Int']['output']>;
  longitude: Maybe<Scalars['Float']['output']>;
  manual_override: Maybe<Scalars['Boolean']['output']>;
  professional: Maybe<Professional>;
  professional_id: Maybe<Scalars['Int']['output']>;
  time: Maybe<Scalars['DateTime']['output']>;
  updated_at: Scalars['DateTime']['output'];
};

export type CheckOutOrderInput = {
  accepted: InputMaybe<Scalars['Boolean']['input']>;
  created_at: InputMaybe<Scalars['Boolean']['input']>;
  distance: InputMaybe<Scalars['Boolean']['input']>;
  id: InputMaybe<Scalars['Boolean']['input']>;
  job_id: InputMaybe<Scalars['Boolean']['input']>;
  latitude: InputMaybe<Scalars['Boolean']['input']>;
  location_id: InputMaybe<Scalars['Boolean']['input']>;
  longitude: InputMaybe<Scalars['Boolean']['input']>;
  manual_override: InputMaybe<Scalars['Boolean']['input']>;
  professional_id: InputMaybe<Scalars['Boolean']['input']>;
  time: InputMaybe<Scalars['Boolean']['input']>;
  updated_at: InputMaybe<Scalars['Boolean']['input']>;
};

export type CheckOutQueryInput = {
  filter: InputMaybe<CheckOutWhereInput>;
  orderBy: InputMaybe<CheckOutOrderInput>;
  page: InputMaybe<Scalars['Int']['input']>;
  perPage: InputMaybe<Scalars['Int']['input']>;
  search: InputMaybe<CheckOutSearchInput>;
};

export type CheckOutSearchInput = {
  accepted: InputMaybe<Scalars['Boolean']['input']>;
  created_at: InputMaybe<Scalars['DateTime']['input']>;
  date_from: InputMaybe<Scalars['DateTime']['input']>;
  date_to: InputMaybe<Scalars['DateTime']['input']>;
  distance: InputMaybe<Scalars['Float']['input']>;
  job_id: InputMaybe<Scalars['Int']['input']>;
  job_starts_time: InputMaybe<Scalars['DateTime']['input']>;
  latitude: InputMaybe<Scalars['Float']['input']>;
  location_id: InputMaybe<Scalars['Int']['input']>;
  longitude: InputMaybe<Scalars['Float']['input']>;
  manual_override: InputMaybe<Scalars['Boolean']['input']>;
  professional_id: InputMaybe<Scalars['Int']['input']>;
  /**
   * *Constraints:*
   * * Maximal length: `150`
   *
   */
  q: InputMaybe<Scalars['String']['input']>;
  time: InputMaybe<Scalars['DateTime']['input']>;
  updated_at: InputMaybe<Scalars['DateTime']['input']>;
};

export type CheckOutWhereInput = {
  accepted: InputMaybe<Scalars['Boolean']['input']>;
  created_at: InputMaybe<Scalars['DateTime']['input']>;
  distance: InputMaybe<Scalars['String']['input']>;
  id: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  job_id: InputMaybe<Scalars['Int']['input']>;
  latitude: InputMaybe<Scalars['Float']['input']>;
  location_id: InputMaybe<Scalars['Int']['input']>;
  longitude: InputMaybe<Scalars['Float']['input']>;
  manual_override: InputMaybe<Scalars['Boolean']['input']>;
  professional_id: InputMaybe<Scalars['Int']['input']>;
  time: InputMaybe<Scalars['DateTime']['input']>;
  updated_at: InputMaybe<Scalars['DateTime']['input']>;
};

export type CheckQueryInput = {
  filter: InputMaybe<CheckWhereInput>;
  orderBy: InputMaybe<CheckOrderInput>;
  page: InputMaybe<Scalars['Int']['input']>;
  perPage: InputMaybe<Scalars['Int']['input']>;
  search: InputMaybe<DefaultSearchInput>;
};

export type CheckWhereInput = {
  amount_cents: InputMaybe<Scalars['Int']['input']>;
  created_at: InputMaybe<Scalars['DateTime']['input']>;
  id: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  note: InputMaybe<Scalars['String']['input']>;
  number: InputMaybe<Scalars['String']['input']>;
  statement_id: InputMaybe<Scalars['Int']['input']>;
  stripe_invoice_item_id: InputMaybe<Scalars['String']['input']>;
  updated_at: InputMaybe<Scalars['DateTime']['input']>;
};

export type ClinicalContact = {
  __typename?: 'ClinicalContact';
  active: Maybe<Scalars['Boolean']['output']>;
  email: Maybe<Scalars['String']['output']>;
  first_name: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  last_name: Scalars['String']['output'];
  location: Maybe<Location>;
  location_id: Maybe<Scalars['Int']['output']>;
  phone_number: Scalars['String']['output'];
  user_id: Maybe<Scalars['Int']['output']>;
};

export type ClinicalContactOrderInput = {
  first_name: InputMaybe<Scalars['Boolean']['input']>;
  id: InputMaybe<Scalars['Boolean']['input']>;
  last_name: InputMaybe<Scalars['Boolean']['input']>;
  phone_number: InputMaybe<Scalars['Boolean']['input']>;
};

export type ClinicalContactQueryInput = {
  filter: InputMaybe<ClinicalContactWhereInput>;
  orderBy: InputMaybe<ClinicalContactOrderInput>;
  page: InputMaybe<Scalars['Int']['input']>;
  perPage: InputMaybe<Scalars['Int']['input']>;
  search: InputMaybe<DefaultSearchInput>;
};

export type ClinicalContactWhereInput = {
  first_name: InputMaybe<Scalars['String']['input']>;
  id: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  last_name: InputMaybe<Scalars['String']['input']>;
  location_id: InputMaybe<Scalars['Int']['input']>;
  phone_number: InputMaybe<Scalars['String']['input']>;
  user_id: InputMaybe<Scalars['Int']['input']>;
};

export type ClockEventAttachment = {
  __typename?: 'ClockEventAttachment';
  clock_event_id: Scalars['Int']['output'];
  clock_event_type: Scalars['String']['output'];
  created_at: Scalars['DateTime']['output'];
  file: Maybe<Scalars['AWSFile']['output']>;
  id: Scalars['Int']['output'];
  metadata: Maybe<Scalars['JSON']['output']>;
  /** @deprecated Field no longer supported */
  reason: Maybe<Scalars['String']['output']>;
  reasons: Maybe<Scalars['JSON']['output']>;
  updated_at: Scalars['DateTime']['output'];
};

export type ClockEventAttachmentOrderInput = {
  id: InputMaybe<Scalars['Boolean']['input']>;
};

export type ClockEventAttachmentQueryInput = {
  filter: InputMaybe<ClockEventAttachmentWhereInput>;
  orderBy: InputMaybe<ClockEventAttachmentOrderInput>;
  page: InputMaybe<Scalars['Int']['input']>;
  perPage: InputMaybe<Scalars['Int']['input']>;
  search: InputMaybe<ClockEventAttachmentSearchInput>;
};

export type ClockEventAttachmentSearchInput = {
  id: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  job_id: InputMaybe<Scalars['Int']['input']>;
  location_ids: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};

export type ClockEventAttachmentWhereInput = {
  clock_event_id: InputMaybe<Scalars['Int']['input']>;
  clock_event_type: InputMaybe<Scalars['String']['input']>;
  id: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};

export type Company = {
  __typename?: 'Company';
  accepted_tos: Maybe<Scalars['Boolean']['output']>;
  account_manager: Maybe<Administrator>;
  account_manager_id: Maybe<Scalars['Int']['output']>;
  accounts: Maybe<Array<Maybe<Account>>>;
  agency_enabled: Scalars['Boolean']['output'];
  billing_groups: Maybe<Array<Maybe<BillingGroup>>>;
  created_at: Scalars['DateTime']['output'];
  detailed_notes: Maybe<Scalars['String']['output']>;
  disable_rate_editing: Scalars['Boolean']['output'];
  disabled_at: Maybe<Scalars['DateTime']['output']>;
  display_pro_ehr_information: Scalars['Boolean']['output'];
  dispute_submission_window_days: Maybe<Scalars['Int']['output']>;
  has_billing_manager: Scalars['Boolean']['output'];
  has_onboarded_location: Scalars['Boolean']['output'];
  health_system: Maybe<HealthSystem>;
  health_system_id: Maybe<Scalars['Int']['output']>;
  hide_invoicing_during_onboarding: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
  last_time_job_posted_at: Maybe<Scalars['DateTime']['output']>;
  locations: Maybe<Array<Maybe<Location>>>;
  logo: Maybe<Scalars['AWSFile']['output']>;
  msp: Maybe<Msp>;
  msp_id: Maybe<Scalars['Int']['output']>;
  name: Scalars['String']['output'];
  onboarding_complete: Scalars['Boolean']['output'];
  original_user_id: Maybe<Scalars['Int']['output']>;
  other_referral_source: Maybe<Scalars['String']['output']>;
  phone_number: Maybe<Scalars['String']['output']>;
  referral: Maybe<Scalars['String']['output']>;
  referral_source: Maybe<ReferralSource>;
  referral_source_id: Maybe<Scalars['Int']['output']>;
  rfm: Scalars['String']['output'];
  rfrf: Scalars['Int']['output'];
  rfrm: Scalars['Int']['output'];
  rfrmm: Scalars['Int']['output'];
  saas_base_monthly_cents: Scalars['Int']['output'];
  saas_billing_group_id: Maybe<Scalars['Int']['output']>;
  saas_credentialing_enabled: Scalars['Boolean']['output'];
  saas_per_job_flat_fee_cents: Scalars['Int']['output'];
  saas_per_seat_monthly_cents: Scalars['Int']['output'];
  saas_plan: Scalars['String']['output'];
  saas_scheduling_enabled: Scalars['Boolean']['output'];
  sales_associate: Maybe<Administrator>;
  sales_associate_id: Maybe<Scalars['Int']['output']>;
  uid: Scalars['String']['output'];
  updated_at: Scalars['DateTime']['output'];
  verified: Scalars['Boolean']['output'];
  vms_type: Maybe<VmsType>;
  vms_type_id: Maybe<Scalars['Int']['output']>;
};

export type CompanyMedelyRequirements = {
  vms_type_id: InputMaybe<Scalars['Int']['input']>;
};

export type CompanyOrderInput = {
  created_at: InputMaybe<Scalars['Boolean']['input']>;
  detailed_notes: InputMaybe<Scalars['Boolean']['input']>;
  disabled_at: InputMaybe<Scalars['Boolean']['input']>;
  health_system_id: InputMaybe<Scalars['Boolean']['input']>;
  id: InputMaybe<Scalars['Boolean']['input']>;
  last_time_job_posted_at: InputMaybe<Scalars['Boolean']['input']>;
  msp_id: InputMaybe<Scalars['Boolean']['input']>;
  name: InputMaybe<Scalars['Boolean']['input']>;
  onboarding_complete: InputMaybe<Scalars['Boolean']['input']>;
  original_user_id: InputMaybe<Scalars['Boolean']['input']>;
  phone_number: InputMaybe<Scalars['Boolean']['input']>;
  referral: InputMaybe<Scalars['Boolean']['input']>;
  rfm: InputMaybe<Scalars['Boolean']['input']>;
  rfrf: InputMaybe<Scalars['Boolean']['input']>;
  rfrm: InputMaybe<Scalars['Boolean']['input']>;
  rfrmm: InputMaybe<Scalars['Boolean']['input']>;
  tsv: InputMaybe<Scalars['Boolean']['input']>;
  uid: InputMaybe<Scalars['Boolean']['input']>;
  updated_at: InputMaybe<Scalars['Boolean']['input']>;
  verified: InputMaybe<Scalars['Boolean']['input']>;
  vms_type_id: InputMaybe<Scalars['Boolean']['input']>;
};

export type CompanyQueryInput = {
  filter: InputMaybe<CompanyWhereInput>;
  orderBy: InputMaybe<CompanyOrderInput>;
  page: InputMaybe<Scalars['Int']['input']>;
  perPage: InputMaybe<Scalars['Int']['input']>;
  search: InputMaybe<CompanySearchInput>;
};

export type CompanySearchInput = {
  account_id: InputMaybe<Scalars['Int']['input']>;
  company_id: InputMaybe<Scalars['Int']['input']>;
  fill_ratio: InputMaybe<Scalars['Int']['input']>;
  has_balance: InputMaybe<Scalars['Boolean']['input']>;
  location_type_ids: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  market_ids: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  no_vms: InputMaybe<Scalars['Boolean']['input']>;
  onboarding_complete: InputMaybe<Scalars['Boolean']['input']>;
  phone_number: InputMaybe<Scalars['String']['input']>;
  plan: InputMaybe<Scalars['String']['input']>;
  professional_account_id: InputMaybe<Scalars['Int']['input']>;
  /**
   * *Constraints:*
   * * Maximal length: `150`
   *
   */
  q: InputMaybe<Scalars['String']['input']>;
  referral: InputMaybe<Scalars['String']['input']>;
  saas_credentialing_enabled: InputMaybe<Scalars['Boolean']['input']>;
  saas_scheduling_enabled: InputMaybe<Scalars['Boolean']['input']>;
  state_id: InputMaybe<Scalars['Int']['input']>;
  utm_campaign: InputMaybe<Scalars['String']['input']>;
  utm_source: InputMaybe<Scalars['String']['input']>;
  verified: InputMaybe<Scalars['Boolean']['input']>;
};

export type CompanyWhereInput = {
  created_at: InputMaybe<Scalars['DateTime']['input']>;
  detailed_notes: InputMaybe<Scalars['String']['input']>;
  disabled_at: InputMaybe<Scalars['DateTime']['input']>;
  health_system_id: InputMaybe<Scalars['Int']['input']>;
  id: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  last_time_job_posted_at: InputMaybe<Scalars['DateTime']['input']>;
  msp_id: InputMaybe<Scalars['Int']['input']>;
  name: InputMaybe<Scalars['String']['input']>;
  onboarding_complete: InputMaybe<Scalars['Boolean']['input']>;
  original_user_id: InputMaybe<Scalars['Int']['input']>;
  phone_number: InputMaybe<Scalars['String']['input']>;
  referral: InputMaybe<Scalars['String']['input']>;
  rfm: InputMaybe<Scalars['String']['input']>;
  rfrf: InputMaybe<Scalars['Int']['input']>;
  rfrm: InputMaybe<Scalars['Int']['input']>;
  rfrmm: InputMaybe<Scalars['Int']['input']>;
  updated_at: InputMaybe<Scalars['DateTime']['input']>;
  verified: InputMaybe<Scalars['Boolean']['input']>;
  vms_type_id: InputMaybe<Scalars['Int']['input']>;
};

export type Condition = {
  __typename?: 'Condition';
  condition_documents: Maybe<Array<Maybe<ConditionDocument>>>;
  condition_type: Scalars['String']['output'];
  display_category: Maybe<Scalars['String']['output']>;
  display_description: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  label: Scalars['String']['output'];
  name: Scalars['String']['output'];
  payload: Scalars['JSON']['output'];
  qualifications: Maybe<Array<Maybe<Qualification>>>;
  requirements: Maybe<Array<Maybe<Requirement>>>;
  slug: Scalars['String']['output'];
};

export type ConditionDocument = {
  __typename?: 'ConditionDocument';
  category: Maybe<Scalars['String']['output']>;
  condition: Condition;
  condition_id: Scalars['Int']['output'];
  created_at: Scalars['DateTime']['output'];
  file: Scalars['AWSFile']['output'];
  id: Scalars['Int']['output'];
  name: Maybe<Scalars['String']['output']>;
  updated_at: Scalars['DateTime']['output'];
};

export type ConditionDocumentOrderInput = {
  condition_id: InputMaybe<Scalars['Boolean']['input']>;
  created_at: InputMaybe<Scalars['Boolean']['input']>;
  id: InputMaybe<Scalars['Boolean']['input']>;
  name: InputMaybe<Scalars['Boolean']['input']>;
  updated_at: InputMaybe<Scalars['Boolean']['input']>;
};

export type ConditionDocumentQueryInput = {
  filter: InputMaybe<ConditionDocumentWhereInput>;
  orderBy: InputMaybe<ConditionDocumentOrderInput>;
  page: InputMaybe<Scalars['Int']['input']>;
  perPage: InputMaybe<Scalars['Int']['input']>;
  search: InputMaybe<ConditionDocumentSearchInput>;
};

export type ConditionDocumentSearchInput = {
  condition_id: InputMaybe<Scalars['Int']['input']>;
  created_at: InputMaybe<Scalars['DateTime']['input']>;
  id: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  name: InputMaybe<Scalars['String']['input']>;
  /**
   * *Constraints:*
   * * Maximal length: `150`
   *
   */
  q: InputMaybe<Scalars['String']['input']>;
  updated_at: InputMaybe<Scalars['DateTime']['input']>;
};

export type ConditionDocumentWhereInput = {
  condition_id: InputMaybe<Scalars['Int']['input']>;
  created_at: InputMaybe<Scalars['DateTime']['input']>;
  id: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  name: InputMaybe<Scalars['String']['input']>;
  updated_at: InputMaybe<Scalars['DateTime']['input']>;
};

export type ConditionOrderInput = {
  id: InputMaybe<Scalars['Boolean']['input']>;
};

export type ConditionQueryInput = {
  filter: InputMaybe<ConditionWhereInput>;
  orderBy: InputMaybe<ConditionOrderInput>;
  page: InputMaybe<Scalars['Int']['input']>;
  perPage: InputMaybe<Scalars['Int']['input']>;
  search: InputMaybe<ConditionSearchInput>;
};

export type ConditionSearchInput = {
  assignment_id: InputMaybe<Scalars['Int']['input']>;
  condition_ids: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  condition_types: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  displayable_only: InputMaybe<Scalars['Boolean']['input']>;
  expiring_conditions: InputMaybe<Expiring_Conditions_Input>;
  for_w2_on_boarding_only: InputMaybe<Scalars['Boolean']['input']>;
  kind: InputMaybe<Scalars['String']['input']>;
  label: InputMaybe<Scalars['String']['input']>;
  missing_conditions: InputMaybe<Missing_Conditions_Input>;
  position_id: InputMaybe<Scalars['Int']['input']>;
  professional_can_view: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * *Constraints:*
   * * Maximal length: `150`
   *
   */
  q: InputMaybe<Scalars['String']['input']>;
  required_conditions: InputMaybe<Required_Conditions_Input>;
  slug: InputMaybe<Scalars['String']['input']>;
  state_id: InputMaybe<Scalars['Int']['input']>;
};

export type ConditionWhereInput = {
  condition_type: InputMaybe<Scalars['String']['input']>;
  id: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  label: InputMaybe<Scalars['String']['input']>;
  slug: InputMaybe<Scalars['String']['input']>;
};

export enum ContextField {
  AccountId = 'ACCOUNT_ID',
  AgencyId = 'AGENCY_ID',
  ProfessionalId = 'PROFESSIONAL_ID'
}

export type Contract = {
  __typename?: 'Contract';
  administrator_id: Maybe<Scalars['Int']['output']>;
  assignment_id: Scalars['Int']['output'];
  contract_type: Scalars['String']['output'];
  created_at: Scalars['DateTime']['output'];
  document_id: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  professional_id: Maybe<Scalars['Int']['output']>;
  signed_at: Maybe<Scalars['DateTime']['output']>;
  updated_at: Scalars['DateTime']['output'];
  upload: Maybe<Scalars['AWSFile']['output']>;
};

export type ContractLengthInWeeksInput = {
  max: InputMaybe<Scalars['Int']['input']>;
  min: Scalars['Int']['input'];
};

export type ContractOrderInput = {
  administrator_id: InputMaybe<Scalars['Boolean']['input']>;
  assignment_id: InputMaybe<Scalars['Boolean']['input']>;
  contract_type: InputMaybe<Scalars['Boolean']['input']>;
  created_at: InputMaybe<Scalars['Boolean']['input']>;
  document_id: InputMaybe<Scalars['Boolean']['input']>;
  id: InputMaybe<Scalars['Boolean']['input']>;
  professional_id: InputMaybe<Scalars['Boolean']['input']>;
  signed_at: InputMaybe<Scalars['Boolean']['input']>;
  updated_at: InputMaybe<Scalars['Boolean']['input']>;
};

export type ContractQueryInput = {
  filter: InputMaybe<ContractWhereInput>;
  orderBy: InputMaybe<ProfessionalOrderInput>;
  page: InputMaybe<Scalars['Int']['input']>;
  perPage: InputMaybe<Scalars['Int']['input']>;
  search: InputMaybe<DefaultSearchInput>;
};

export type ContractRangeInput = {
  max: InputMaybe<Scalars['Int']['input']>;
  min: InputMaybe<Scalars['Int']['input']>;
};

export type ContractWhereInput = {
  administrator_id: InputMaybe<Scalars['Int']['input']>;
  assignment_id: InputMaybe<Scalars['Int']['input']>;
  contract_type: InputMaybe<Scalars['String']['input']>;
  created_at: InputMaybe<Scalars['DateTime']['input']>;
  document_id: InputMaybe<Scalars['String']['input']>;
  id: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  professional_account_id: InputMaybe<Scalars['Int']['input']>;
  professional_id: InputMaybe<Scalars['Int']['input']>;
  signed_at: InputMaybe<Scalars['DateTime']['input']>;
  updated_at: InputMaybe<Scalars['DateTime']['input']>;
};

export type Coordinates = {
  __typename?: 'Coordinates';
  latitude: Maybe<Scalars['Float']['output']>;
  longitude: Maybe<Scalars['Float']['output']>;
};

export type CoordinatesInput = {
  latitude: InputMaybe<Scalars['Float']['input']>;
  longitude: InputMaybe<Scalars['Float']['input']>;
};

export type CredentialRejectedReason = {
  __typename?: 'CredentialRejectedReason';
  created_at: Scalars['DateTime']['output'];
  id: Scalars['Int']['output'];
  label: Maybe<Scalars['String']['output']>;
  name: Maybe<Scalars['String']['output']>;
  rank: Maybe<Scalars['Int']['output']>;
  updated_at: Scalars['DateTime']['output'];
};

export type CredentialRejectedReasonOrderInput = {
  created_at: InputMaybe<Scalars['Boolean']['input']>;
  id: InputMaybe<Scalars['Boolean']['input']>;
  label: InputMaybe<Scalars['Boolean']['input']>;
  name: InputMaybe<Scalars['Boolean']['input']>;
  rank: InputMaybe<Scalars['Boolean']['input']>;
  updated_at: InputMaybe<Scalars['Boolean']['input']>;
};

export type CredentialRejectedReasonQueryInput = {
  filter: InputMaybe<CredentialRejectedReasonWhereInput>;
  orderBy: InputMaybe<CredentialRejectedReasonOrderInput>;
  page: InputMaybe<Scalars['Int']['input']>;
  perPage: InputMaybe<Scalars['Int']['input']>;
  search: InputMaybe<DefaultSearchInput>;
};

export type CredentialRejectedReasonWhereInput = {
  created_at: InputMaybe<Scalars['DateTime']['input']>;
  id: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  label: InputMaybe<Scalars['String']['input']>;
  name: InputMaybe<Scalars['String']['input']>;
  rank: InputMaybe<Scalars['Int']['input']>;
  updated_at: InputMaybe<Scalars['DateTime']['input']>;
};

export type CreditNote = {
  __typename?: 'CreditNote';
  amount_cents: Scalars['Int']['output'];
  created_at: Scalars['DateTime']['output'];
  id: Scalars['Int']['output'];
  memo: Maybe<Scalars['String']['output']>;
  statement: Statement;
  stripe_invoice_item_id: Maybe<Scalars['String']['output']>;
  updated_at: Scalars['DateTime']['output'];
};

export type CreditNoteOrderInput = {
  amount_cents: InputMaybe<Scalars['Boolean']['input']>;
  created_at: InputMaybe<Scalars['Boolean']['input']>;
  id: InputMaybe<Scalars['Boolean']['input']>;
  memo: InputMaybe<Scalars['Boolean']['input']>;
  statement_id: InputMaybe<Scalars['Boolean']['input']>;
  stripe_invoice_item_id: InputMaybe<Scalars['Boolean']['input']>;
  updated_at: InputMaybe<Scalars['Boolean']['input']>;
};

export type CreditNoteQueryInput = {
  filter: InputMaybe<CreditNoteWhereInput>;
  orderBy: InputMaybe<CreditNoteOrderInput>;
  page: InputMaybe<Scalars['Int']['input']>;
  perPage: InputMaybe<Scalars['Int']['input']>;
  search: InputMaybe<DefaultSearchInput>;
};

export type CreditNoteWhereInput = {
  amount_cents: InputMaybe<Scalars['Int']['input']>;
  created_at: InputMaybe<Scalars['DateTime']['input']>;
  id: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  memo: InputMaybe<Scalars['String']['input']>;
  statement_id: InputMaybe<Scalars['Int']['input']>;
  stripe_invoice_item_id: InputMaybe<Scalars['String']['input']>;
  updated_at: InputMaybe<Scalars['DateTime']['input']>;
};

export type CurrentDataOrderInput = {
  facilityRate: InputMaybe<Scalars['Boolean']['input']>;
  startDate: InputMaybe<Scalars['Boolean']['input']>;
};

export type CustomProfessionalProfileEhrSystem = {
  __typename?: 'CustomProfessionalProfileEhrSystem';
  created_at: Scalars['DateTime']['output'];
  id: Scalars['Int']['output'];
  label: Scalars['String']['output'];
  professional_profile: ProfessionalProfile;
  professional_profile_id: Scalars['Int']['output'];
  updated_at: Scalars['DateTime']['output'];
};

export type CustomProfessionalProfileEhrSystemOrderInput = {
  id: InputMaybe<Scalars['Boolean']['input']>;
  professional_id: InputMaybe<Scalars['Int']['input']>;
  professional_profile_id: InputMaybe<Scalars['Boolean']['input']>;
};

export type CustomProfessionalProfileEhrSystemQueryInput = {
  filter: InputMaybe<CustomProfessionalProfileEhrSystemWhereInput>;
  orderBy: InputMaybe<ProfessionalOrderInput>;
  page: InputMaybe<Scalars['Int']['input']>;
  perPage: InputMaybe<Scalars['Int']['input']>;
  search: InputMaybe<DefaultSearchInput>;
};

export type CustomProfessionalProfileEhrSystemWhereInput = {
  created_at: InputMaybe<Scalars['DateTime']['input']>;
  id: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  professional_id: InputMaybe<Scalars['Int']['input']>;
  professional_profile_id: InputMaybe<Scalars['Int']['input']>;
  updated_at: InputMaybe<Scalars['DateTime']['input']>;
};

export type DashboardStats = {
  __typename?: 'DashboardStats';
  booked_assignments_count: Maybe<Scalars['Int']['output']>;
  booked_jobs_count: Maybe<Scalars['Int']['output']>;
  offers_count: Maybe<Scalars['Int']['output']>;
  pending_applications_count: Maybe<Scalars['Int']['output']>;
  professional_account_id: Maybe<Scalars['Int']['output']>;
  requested_jobs_count: Maybe<Scalars['Int']['output']>;
};

export type DateRangeInput = {
  from: Scalars['Date']['input'];
  to: Scalars['Date']['input'];
};

export enum DecisionOption {
  DormantMarket = 'dormant_market',
  LowIncrementalityMarket = 'low_incrementality_market',
  Prioritize = 'prioritize',
  UnavailableMarket = 'unavailable_market'
}

export type DefaultSearchInput = {
  /**
   * *Constraints:*
   * * Maximal length: `150`
   *
   */
  q: InputMaybe<Scalars['String']['input']>;
};

export type DeprecatedInvoice = {
  __typename?: 'DeprecatedInvoice';
  approved_clock_in: Maybe<Scalars['DateTime']['output']>;
  approved_clock_out: Maybe<Scalars['DateTime']['output']>;
  assignment: Maybe<Assignment>;
  charge_total_cents: Maybe<Scalars['Int']['output']>;
  charge_total_currency: Scalars['String']['output'];
  created_at: Scalars['DateTime']['output'];
  deprecatedInvoiceable: Maybe<DeprecatedInvoiceable>;
  deprecatedInvoiceable_type: Maybe<Scalars['String']['output']>;
  fee_cents: Scalars['Int']['output'];
  hours_double: Maybe<Scalars['String']['output']>;
  hours_normal: Maybe<Scalars['String']['output']>;
  hours_time_half: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  invoiceable_id: Maybe<Scalars['Int']['output']>;
  job: Maybe<Job>;
  notes: Maybe<Scalars['String']['output']>;
  paid: Maybe<Scalars['Boolean']['output']>;
  pause: Scalars['Boolean']['output'];
  pause_professional_transfer: Maybe<Scalars['Boolean']['output']>;
  payout: Maybe<Payout>;
  professional: Maybe<Professional>;
  refunds: Maybe<Array<Maybe<Refund>>>;
  starts_date: Maybe<Scalars['DateTime']['output']>;
  statement: Maybe<Statement>;
  status: Maybe<Scalars['String']['output']>;
  stripe_charge_id: Maybe<Scalars['String']['output']>;
  stripe_deprecated_deprecatedInvoice_item_id: Maybe<Scalars['String']['output']>;
  stripe_transfer_id: Maybe<Scalars['String']['output']>;
  timecard: Maybe<Timecard>;
  total_hours: Maybe<Scalars['Float']['output']>;
  transfer_reversals: Maybe<Array<Maybe<TransferReversal>>>;
  transfer_total_cents: Maybe<Scalars['Int']['output']>;
  transfer_total_currency: Scalars['String']['output'];
  updated_at: Scalars['DateTime']['output'];
  user: Maybe<User>;
};

export type DeprecatedInvoiceOrderInput = {
  approved_clock_in: InputMaybe<Scalars['Boolean']['input']>;
  approved_clock_out: InputMaybe<Scalars['Boolean']['input']>;
  charge_total_cents: InputMaybe<Scalars['Boolean']['input']>;
  charge_total_currency: InputMaybe<Scalars['Boolean']['input']>;
  created_at: InputMaybe<Scalars['Boolean']['input']>;
  deprecatedInvoiceable_type: InputMaybe<Scalars['Boolean']['input']>;
  fee_cents: InputMaybe<Scalars['Boolean']['input']>;
  hours_double: InputMaybe<Scalars['Boolean']['input']>;
  hours_normal: InputMaybe<Scalars['Boolean']['input']>;
  hours_time_half: InputMaybe<Scalars['Boolean']['input']>;
  id: InputMaybe<Scalars['Boolean']['input']>;
  invoiceable_id: InputMaybe<Scalars['Boolean']['input']>;
  market: InputMaybe<Scalars['Boolean']['input']>;
  notes: InputMaybe<Scalars['Boolean']['input']>;
  paid: InputMaybe<Scalars['Boolean']['input']>;
  pause: InputMaybe<Scalars['Boolean']['input']>;
  pause_professional_transfer: InputMaybe<Scalars['Boolean']['input']>;
  payout_id: InputMaybe<Scalars['Boolean']['input']>;
  professional_id: InputMaybe<Scalars['Boolean']['input']>;
  starts_date: InputMaybe<Scalars['Boolean']['input']>;
  state: InputMaybe<Scalars['Boolean']['input']>;
  stripe_charge_id: InputMaybe<Scalars['Boolean']['input']>;
  stripe_deprecated_deprecatedInvoice_item_id: InputMaybe<Scalars['Boolean']['input']>;
  stripe_transfer_id: InputMaybe<Scalars['Boolean']['input']>;
  total_hours_: InputMaybe<Scalars['Boolean']['input']>;
  transfer_total_cents: InputMaybe<Scalars['Boolean']['input']>;
  transfer_total_currency: InputMaybe<Scalars['Boolean']['input']>;
  updated_at: InputMaybe<Scalars['Boolean']['input']>;
  user_id: InputMaybe<Scalars['Boolean']['input']>;
};

export type DeprecatedInvoiceQueryInput = {
  filter: InputMaybe<DeprecatedInvoiceWhereInput>;
  orderBy: InputMaybe<DeprecatedInvoiceOrderInput>;
  page: InputMaybe<Scalars['Int']['input']>;
  perPage: InputMaybe<Scalars['Int']['input']>;
  search: InputMaybe<DeprecatedInvoiceSearchInput>;
};

export enum DeprecatedInvoiceSearchByInput {
  DeprecatedInvoices = 'deprecatedInvoices',
  Jobs = 'jobs',
  Professionals = 'professionals',
  Users = 'users'
}

export type DeprecatedInvoiceSearchInput = {
  ends_date: InputMaybe<Scalars['Date']['input']>;
  market_id: InputMaybe<Scalars['Int']['input']>;
  paid: InputMaybe<Scalars['Boolean']['input']>;
  pause: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * *Constraints:*
   * * Maximal length: `150`
   *
   */
  q: InputMaybe<Scalars['String']['input']>;
  search_by: InputMaybe<DeprecatedInvoiceSearchByInput>;
  starts_date: InputMaybe<Scalars['Date']['input']>;
};

export type DeprecatedInvoiceWhereInput = {
  approved_clock_in: InputMaybe<Scalars['DateTime']['input']>;
  approved_clock_out: InputMaybe<Scalars['DateTime']['input']>;
  charge_total_cents: InputMaybe<Scalars['Int']['input']>;
  charge_total_currency: InputMaybe<Scalars['String']['input']>;
  created_at: InputMaybe<Scalars['DateTime']['input']>;
  deprecatedInvoiceable_type: InputMaybe<Scalars['String']['input']>;
  fee: InputMaybe<Scalars['Int']['input']>;
  hours_double: InputMaybe<Scalars['String']['input']>;
  hours_normal: InputMaybe<Scalars['String']['input']>;
  hours_time_half: InputMaybe<Scalars['String']['input']>;
  id: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  invoiceable_id: InputMaybe<Scalars['Int']['input']>;
  market: InputMaybe<Scalars['String']['input']>;
  notes: InputMaybe<Scalars['String']['input']>;
  paid: InputMaybe<Scalars['Boolean']['input']>;
  pause: InputMaybe<Scalars['Boolean']['input']>;
  pause_professional_transfer: InputMaybe<Scalars['Boolean']['input']>;
  payout_id: InputMaybe<Scalars['Int']['input']>;
  professional_id: InputMaybe<Scalars['Int']['input']>;
  starts_date: InputMaybe<Scalars['DateTime']['input']>;
  state: InputMaybe<Scalars['String']['input']>;
  stripe_charge_id: InputMaybe<Scalars['String']['input']>;
  stripe_deprecated_deprecatedInvoice_item_id: InputMaybe<Scalars['String']['input']>;
  stripe_transfer_id: InputMaybe<Scalars['String']['input']>;
  total_hours_: InputMaybe<Scalars['Float']['input']>;
  transfer_total_cents: InputMaybe<Scalars['Int']['input']>;
  transfer_total_currency: InputMaybe<Scalars['String']['input']>;
  updated_at: InputMaybe<Scalars['DateTime']['input']>;
  user_id: InputMaybe<Scalars['Int']['input']>;
};

export type DeprecatedInvoiceable = Job | Timecard;

export type DisabledReason = {
  __typename?: 'DisabledReason';
  created_at: Maybe<Scalars['DateTime']['output']>;
  display_name: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  name: Maybe<Scalars['String']['output']>;
  person_type: Maybe<Scalars['String']['output']>;
  updated_at: Maybe<Scalars['DateTime']['output']>;
};

export type DisabledReasonOrderInput = {
  created_at: InputMaybe<Scalars['Boolean']['input']>;
  display_name: InputMaybe<Scalars['Boolean']['input']>;
  id: InputMaybe<Scalars['Boolean']['input']>;
  name: InputMaybe<Scalars['Boolean']['input']>;
  person_type: InputMaybe<Scalars['Boolean']['input']>;
  updated_at: InputMaybe<Scalars['Boolean']['input']>;
};

export type DisabledReasonQueryInput = {
  filter: InputMaybe<DisabledReasonWhereInput>;
  orderBy: InputMaybe<DisabledReasonOrderInput>;
  page: InputMaybe<Scalars['Int']['input']>;
  perPage: InputMaybe<Scalars['Int']['input']>;
  search: InputMaybe<DefaultSearchInput>;
};

export type DisabledReasonWhereInput = {
  created_at: InputMaybe<Scalars['DateTime']['input']>;
  display_name: InputMaybe<Scalars['String']['input']>;
  id: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  name: InputMaybe<Scalars['String']['input']>;
  person_type: InputMaybe<Scalars['String']['input']>;
  updated_at: InputMaybe<Scalars['DateTime']['input']>;
};

export type Dispute = {
  __typename?: 'Dispute';
  adjusted_clock_in: Maybe<Scalars['DateTime']['output']>;
  adjusted_clock_out: Maybe<Scalars['DateTime']['output']>;
  adjusted_meal_break_minutes: Maybe<Scalars['Int']['output']>;
  adjusted_total_payout_cents: Maybe<Scalars['Int']['output']>;
  admin_notes: Maybe<Scalars['String']['output']>;
  assigned_to: Maybe<Administrator>;
  assigned_to_id: Maybe<Scalars['Int']['output']>;
  attachment: Maybe<Scalars['AWSFile']['output']>;
  category: Scalars['String']['output'];
  created_at: Scalars['DateTime']['output'];
  expense_adjustments: Maybe<Array<Maybe<ExpenseAdjustment>>>;
  facility_notes: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  invoice: Maybe<Invoice>;
  invoice_id: Maybe<Scalars['Int']['output']>;
  job: Maybe<Job>;
  job_id: Maybe<Scalars['Int']['output']>;
  original_clock_in: Maybe<Scalars['DateTime']['output']>;
  original_clock_out: Maybe<Scalars['DateTime']['output']>;
  original_meal_break_minutes: Maybe<Scalars['Int']['output']>;
  original_total_payout_cents: Maybe<Scalars['Int']['output']>;
  professional_notes: Maybe<Scalars['String']['output']>;
  reason: Scalars['String']['output'];
  resolution: Maybe<Scalars['String']['output']>;
  revenue_adjustments: Maybe<Array<Maybe<RevenueAdjustment>>>;
  status: Scalars['String']['output'];
  total_adjusted_minutes: Maybe<Scalars['Int']['output']>;
  updated_at: Scalars['DateTime']['output'];
};

export type DisputeOrderInput = {
  adjusted_clock_in: InputMaybe<Scalars['Boolean']['input']>;
  adjusted_clock_out: InputMaybe<Scalars['Boolean']['input']>;
  adjusted_meal_break_minutes: InputMaybe<Scalars['Boolean']['input']>;
  adjusted_total_payout_cents: InputMaybe<Scalars['Boolean']['input']>;
  admin_notes: InputMaybe<Scalars['Boolean']['input']>;
  assigned_to_id: InputMaybe<Scalars['Int']['input']>;
  category: InputMaybe<Scalars['Boolean']['input']>;
  created_at: InputMaybe<Scalars['Boolean']['input']>;
  facility_notes: InputMaybe<Scalars['Boolean']['input']>;
  id: InputMaybe<Scalars['Boolean']['input']>;
  invoice_id: InputMaybe<Scalars['Boolean']['input']>;
  job_id: InputMaybe<Scalars['Boolean']['input']>;
  original_clock_in: InputMaybe<Scalars['Boolean']['input']>;
  original_clock_out: InputMaybe<Scalars['Boolean']['input']>;
  original_meal_break_minutes: InputMaybe<Scalars['Boolean']['input']>;
  original_total_payout_cents: InputMaybe<Scalars['Boolean']['input']>;
  professional_notes: InputMaybe<Scalars['Boolean']['input']>;
  reason: InputMaybe<Scalars['Boolean']['input']>;
  resolution: InputMaybe<Scalars['Boolean']['input']>;
  status: InputMaybe<Scalars['String']['input']>;
  total_adjusted_minutes: InputMaybe<Scalars['Boolean']['input']>;
  updated_at: InputMaybe<Scalars['Boolean']['input']>;
};

export type DisputeQueryInput = {
  filter: InputMaybe<DisputeWhereInput>;
  orderBy: InputMaybe<DisputeOrderInput>;
  page: InputMaybe<Scalars['Int']['input']>;
  perPage: InputMaybe<Scalars['Int']['input']>;
  search: InputMaybe<DisputeSearchInput>;
};

export type DisputeSearchInput = {
  adjusted_clock_in: InputMaybe<Scalars['DateTime']['input']>;
  adjusted_clock_out: InputMaybe<Scalars['DateTime']['input']>;
  adjusted_meal_break_minutes: InputMaybe<Scalars['Int']['input']>;
  adjusted_total_payout_cents: InputMaybe<Scalars['Int']['input']>;
  admin_notes: InputMaybe<Scalars['String']['input']>;
  billing_group_id: InputMaybe<Scalars['Int']['input']>;
  category: InputMaybe<Scalars['String']['input']>;
  created_at: InputMaybe<Scalars['DateTime']['input']>;
  facility_notes: InputMaybe<Scalars['String']['input']>;
  id: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  invoice_id: InputMaybe<Scalars['Int']['input']>;
  job_id: InputMaybe<Scalars['Int']['input']>;
  location_id: InputMaybe<Scalars['Int']['input']>;
  original_clock_in: InputMaybe<Scalars['DateTime']['input']>;
  original_clock_out: InputMaybe<Scalars['DateTime']['input']>;
  original_meal_break_minutes: InputMaybe<Scalars['Int']['input']>;
  original_total_payout_cents: InputMaybe<Scalars['Int']['input']>;
  professional_account_id: InputMaybe<Scalars['Int']['input']>;
  professional_id: InputMaybe<Scalars['Int']['input']>;
  professional_notes: InputMaybe<Scalars['String']['input']>;
  /**
   * *Constraints:*
   * * Maximal length: `150`
   *
   */
  q: InputMaybe<Scalars['String']['input']>;
  reason: InputMaybe<Scalars['String']['input']>;
  resolution: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Scalars['String']['input']>;
  statuses: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  total_adjusted_minutes: InputMaybe<Scalars['Int']['input']>;
};

export type DisputeShiftWitness = {
  __typename?: 'DisputeShiftWitness';
  created_at: Scalars['DateTime']['output'];
  dispute: Maybe<Dispute>;
  dispute_id: Scalars['Int']['output'];
  email: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  name: Maybe<Scalars['String']['output']>;
  phone: Maybe<Scalars['String']['output']>;
  position: Maybe<Scalars['String']['output']>;
  updated_at: Scalars['DateTime']['output'];
};

export type DisputeShiftWitnessOrderInput = {
  created_at: InputMaybe<Scalars['Boolean']['input']>;
  dispute_id: InputMaybe<Scalars['Boolean']['input']>;
  email: InputMaybe<Scalars['Boolean']['input']>;
  id: InputMaybe<Scalars['Boolean']['input']>;
  name: InputMaybe<Scalars['Boolean']['input']>;
  phone: InputMaybe<Scalars['Boolean']['input']>;
  position: InputMaybe<Scalars['Boolean']['input']>;
  updated_at: InputMaybe<Scalars['Boolean']['input']>;
};

export type DisputeShiftWitnessQueryInput = {
  filter: InputMaybe<DisputeShiftWitnessWhereInput>;
  orderBy: InputMaybe<DisputeShiftWitnessOrderInput>;
  page: InputMaybe<Scalars['Int']['input']>;
  perPage: InputMaybe<Scalars['Int']['input']>;
  search: InputMaybe<DisputeShiftWitnessSearchInput>;
};

export type DisputeShiftWitnessSearchInput = {
  /**
   * *Constraints:*
   * * Maximal length: `150`
   *
   */
  q: InputMaybe<Scalars['String']['input']>;
};

export type DisputeShiftWitnessWhereInput = {
  created_at: InputMaybe<Scalars['DateTime']['input']>;
  dispute_id: InputMaybe<Scalars['Int']['input']>;
  email: InputMaybe<Scalars['String']['input']>;
  id: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  name: InputMaybe<Scalars['String']['input']>;
  phone: InputMaybe<Scalars['String']['input']>;
  position: InputMaybe<Scalars['String']['input']>;
  updated_at: InputMaybe<Scalars['DateTime']['input']>;
};

export type DisputeWhereInput = {
  adjusted_clock_in: InputMaybe<Scalars['DateTime']['input']>;
  adjusted_clock_out: InputMaybe<Scalars['DateTime']['input']>;
  adjusted_meal_break_minutes: InputMaybe<Scalars['Int']['input']>;
  adjusted_total_payout_cents: InputMaybe<Scalars['Int']['input']>;
  admin_notes: InputMaybe<Scalars['String']['input']>;
  assigned_to_id: InputMaybe<Scalars['Int']['input']>;
  category: InputMaybe<Scalars['String']['input']>;
  created_at: InputMaybe<Scalars['DateTime']['input']>;
  facility_notes: InputMaybe<Scalars['String']['input']>;
  id: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  invoice_id: InputMaybe<Scalars['Int']['input']>;
  job_id: InputMaybe<Scalars['Int']['input']>;
  location_id: InputMaybe<Scalars['Int']['input']>;
  original_clock_in: InputMaybe<Scalars['DateTime']['input']>;
  original_clock_out: InputMaybe<Scalars['DateTime']['input']>;
  original_meal_break_minutes: InputMaybe<Scalars['Int']['input']>;
  original_total_payout_cents: InputMaybe<Scalars['Int']['input']>;
  professional_notes: InputMaybe<Scalars['String']['input']>;
  reason: InputMaybe<Scalars['String']['input']>;
  resolution: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Scalars['String']['input']>;
  total_adjusted_minutes: InputMaybe<Scalars['Int']['input']>;
};

export type DistanceCheckInput = {
  account_id: InputMaybe<Scalars['Int']['input']>;
  distance: InputMaybe<Scalars['Int']['input']>;
};

export type DistanceRadiusFilterInput = {
  coordinates: InputMaybe<Array<InputMaybe<CoordinatesInput>>>;
  radius: InputMaybe<Scalars['Int']['input']>;
};

export type Education = {
  __typename?: 'Education';
  city: Maybe<Scalars['String']['output']>;
  created_at: Scalars['DateTime']['output'];
  degree_type: Maybe<Scalars['String']['output']>;
  end_date: Maybe<Scalars['Date']['output']>;
  field_of_study: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  location: Maybe<Scalars['String']['output']>;
  professional_id: Maybe<Scalars['Int']['output']>;
  school_name: Maybe<Scalars['String']['output']>;
  start_date: Maybe<Scalars['Date']['output']>;
  state: Maybe<State>;
  state_id: Maybe<Scalars['Int']['output']>;
  updated_at: Scalars['DateTime']['output'];
};

export type EducationOrderInput = {
  created_at: InputMaybe<Scalars['Boolean']['input']>;
  degree_type: InputMaybe<Scalars['Boolean']['input']>;
  end_date: InputMaybe<Scalars['Boolean']['input']>;
  field_of_study: InputMaybe<Scalars['Boolean']['input']>;
  id: InputMaybe<Scalars['Boolean']['input']>;
  location: InputMaybe<Scalars['Boolean']['input']>;
  professional_id: InputMaybe<Scalars['Boolean']['input']>;
  school_name: InputMaybe<Scalars['Boolean']['input']>;
  start_date: InputMaybe<Scalars['Boolean']['input']>;
  updated_at: InputMaybe<Scalars['Boolean']['input']>;
};

export type EducationQueryInput = {
  filter: InputMaybe<EducationWhereInput>;
  orderBy: InputMaybe<EducationOrderInput>;
  page: InputMaybe<Scalars['Int']['input']>;
  perPage: InputMaybe<Scalars['Int']['input']>;
  professional_id: InputMaybe<Scalars['Int']['input']>;
  search: InputMaybe<EducationSearchInput>;
};

export type EducationSearchInput = {
  location_ids: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  professional_account_id: InputMaybe<Scalars['Int']['input']>;
};

export type EducationWhereInput = {
  created_at: InputMaybe<Scalars['DateTime']['input']>;
  degree_type: InputMaybe<Scalars['String']['input']>;
  end_date: InputMaybe<Scalars['Date']['input']>;
  field_of_study: InputMaybe<Scalars['String']['input']>;
  id: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  location: InputMaybe<Scalars['String']['input']>;
  professional_id: InputMaybe<Scalars['Int']['input']>;
  school_name: InputMaybe<Scalars['String']['input']>;
  start_date: InputMaybe<Scalars['Date']['input']>;
  updated_at: InputMaybe<Scalars['DateTime']['input']>;
};

export type EhrSystem = {
  __typename?: 'EhrSystem';
  active: Scalars['Boolean']['output'];
  created_at: Scalars['DateTime']['output'];
  id: Scalars['Int']['output'];
  label: Maybe<Scalars['String']['output']>;
  maestro_identifier: Scalars['JSON']['output'];
  medefis_identifier: Maybe<Scalars['Int']['output']>;
  name: Maybe<Scalars['String']['output']>;
  updated_at: Scalars['DateTime']['output'];
};

export type EhrSystemOrderInput = {
  active: InputMaybe<Scalars['Boolean']['input']>;
  created_at: InputMaybe<Scalars['Boolean']['input']>;
  id: InputMaybe<Scalars['Boolean']['input']>;
  label: InputMaybe<Scalars['Boolean']['input']>;
  name: InputMaybe<Scalars['Boolean']['input']>;
  updated_at: InputMaybe<Scalars['Boolean']['input']>;
};

export type EhrSystemQueryInput = {
  filter: InputMaybe<EhrSystemWhereInput>;
  orderBy: InputMaybe<EhrSystemOrderInput>;
  page: InputMaybe<Scalars['Int']['input']>;
  perPage: InputMaybe<Scalars['Int']['input']>;
  search: InputMaybe<EhrSystemSearchInput>;
};

export type EhrSystemSearchInput = {
  professional_id: InputMaybe<Scalars['Int']['input']>;
};

export type EhrSystemWhereInput = {
  active: InputMaybe<Scalars['Boolean']['input']>;
  created_at: InputMaybe<Scalars['DateTime']['input']>;
  id: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  label: InputMaybe<Scalars['String']['input']>;
  name: InputMaybe<Scalars['String']['input']>;
  professional_id: InputMaybe<Scalars['Int']['input']>;
  updated_at: InputMaybe<Scalars['DateTime']['input']>;
};

export type EmergencyContact = {
  __typename?: 'EmergencyContact';
  first_name: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  last_name: Maybe<Scalars['String']['output']>;
  phone_number: Maybe<Scalars['String']['output']>;
  professional: Maybe<Professional>;
  professional_id: Maybe<Scalars['Int']['output']>;
};

export type EmergencyContactOrderInput = {
  first_name: InputMaybe<Scalars['Boolean']['input']>;
  id: InputMaybe<Scalars['Boolean']['input']>;
  last_name: InputMaybe<Scalars['Boolean']['input']>;
};

export type EmergencyContactQueryInput = {
  filter: InputMaybe<EmergencyContactWhereInput>;
  orderBy: InputMaybe<EmergencyContactOrderInput>;
  page: InputMaybe<Scalars['Int']['input']>;
  perPage: InputMaybe<Scalars['Int']['input']>;
  search: InputMaybe<EmergencyContactSearchInput>;
};

export type EmergencyContactSearchInput = {
  professional_account_id: InputMaybe<Scalars['Int']['input']>;
  /**
   * *Constraints:*
   * * Maximal length: `150`
   *
   */
  q: InputMaybe<Scalars['String']['input']>;
};

export type EmergencyContactWhereInput = {
  first_name: InputMaybe<Scalars['String']['input']>;
  id: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  last_name: InputMaybe<Scalars['String']['input']>;
  phone_number: InputMaybe<Scalars['String']['input']>;
  professional_id: InputMaybe<Scalars['Int']['input']>;
};

export type ExpenseAdjustment = {
  __typename?: 'ExpenseAdjustment';
  amount_cents: Scalars['Int']['output'];
  amount_currency: Scalars['String']['output'];
  balance_sheet: Maybe<BalanceSheet>;
  balance_sheet_id: Maybe<Scalars['Int']['output']>;
  created_at: Scalars['DateTime']['output'];
  description: Maybe<Scalars['String']['output']>;
  dispute: Maybe<Dispute>;
  dispute_id: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  job: Maybe<Job>;
  job_id: Maybe<Scalars['Int']['output']>;
  make_payable_at: Maybe<Scalars['DateTime']['output']>;
  notes: Maybe<Scalars['String']['output']>;
  past_month_adjustment: Scalars['Boolean']['output'];
  payout: Maybe<Payout>;
  payout_id: Maybe<Scalars['Int']['output']>;
  primary_adjustment: Scalars['Boolean']['output'];
  taxable_type: Maybe<Scalars['String']['output']>;
  timecard: Maybe<Timecard>;
  updated_at: Scalars['DateTime']['output'];
};

export type ExpenseAdjustmentOrderInput = {
  balance_sheet_id: InputMaybe<Scalars['Boolean']['input']>;
  id: InputMaybe<Scalars['Boolean']['input']>;
  job_id: InputMaybe<Scalars['Boolean']['input']>;
  payout_id: InputMaybe<Scalars['Boolean']['input']>;
};

export type ExpenseAdjustmentQueryInput = {
  filter: InputMaybe<ExpenseAdjustmentWhereInput>;
  orderBy: InputMaybe<ExpenseAdjustmentOrderInput>;
  page: InputMaybe<Scalars['Int']['input']>;
  perPage: InputMaybe<Scalars['Int']['input']>;
  search: InputMaybe<ExpenseAdjustmentSearchInput>;
};

export type ExpenseAdjustmentSearchInput = {
  balance_sheet_id: InputMaybe<Scalars['Int']['input']>;
  dispute_id: InputMaybe<Scalars['Int']['input']>;
  id: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  job_id: InputMaybe<Scalars['Int']['input']>;
  past_month_adjustment: InputMaybe<Scalars['Boolean']['input']>;
  payout_id: InputMaybe<Scalars['Int']['input']>;
  professional_account_id: InputMaybe<Scalars['Int']['input']>;
  professional_id: InputMaybe<Scalars['Int']['input']>;
  /**
   * *Constraints:*
   * * Maximal length: `150`
   *
   */
  q: InputMaybe<Scalars['String']['input']>;
  taxable_type: InputMaybe<Scalars['String']['input']>;
};

export type ExpenseAdjustmentWhereInput = {
  balance_sheet_id: InputMaybe<Scalars['Int']['input']>;
  created_at: InputMaybe<Scalars['DateTime']['input']>;
  dispute_id: InputMaybe<Scalars['Int']['input']>;
  id: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  job_id: InputMaybe<Scalars['Int']['input']>;
  past_month_adjustment: InputMaybe<Scalars['Boolean']['input']>;
  payout_id: InputMaybe<Scalars['Int']['input']>;
  taxable_type: InputMaybe<Scalars['String']['input']>;
  timecard_id: InputMaybe<Scalars['Int']['input']>;
  updated_at: InputMaybe<Scalars['DateTime']['input']>;
};

export type ExternalAccount = {
  __typename?: 'ExternalAccount';
  account_type: Maybe<Scalars['String']['output']>;
  bank_name: Maybe<Scalars['String']['output']>;
  brand: Maybe<Scalars['String']['output']>;
  created_at: Scalars['DateTime']['output'];
  exp_month: Maybe<Scalars['Int']['output']>;
  exp_year: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  instant_pay_eligible: Maybe<Scalars['Boolean']['output']>;
  last4: Maybe<Scalars['String']['output']>;
  stripe_account: Maybe<StripeAccount>;
  stripe_account_id: Maybe<Scalars['Int']['output']>;
  stripe_id: Scalars['String']['output'];
  updated_at: Scalars['DateTime']['output'];
};

export type ExternalAccountOrderInput = {
  account_type: InputMaybe<Scalars['Boolean']['input']>;
  bank_name: InputMaybe<Scalars['Boolean']['input']>;
  brand: InputMaybe<Scalars['Boolean']['input']>;
  created_at: InputMaybe<Scalars['Boolean']['input']>;
  exp_month: InputMaybe<Scalars['Boolean']['input']>;
  exp_year: InputMaybe<Scalars['Boolean']['input']>;
  id: InputMaybe<Scalars['Boolean']['input']>;
  instant_pay_eligible: InputMaybe<Scalars['Boolean']['input']>;
  last4: InputMaybe<Scalars['Boolean']['input']>;
  stripe_account_id: InputMaybe<Scalars['Boolean']['input']>;
  stripe_id: InputMaybe<Scalars['Boolean']['input']>;
  updated_at: InputMaybe<Scalars['Boolean']['input']>;
};

export type ExternalAccountQueryInput = {
  filter: InputMaybe<ExternalAccountWhereInput>;
  orderBy: InputMaybe<ExternalAccountOrderInput>;
  page: InputMaybe<Scalars['Int']['input']>;
  perPage: InputMaybe<Scalars['Int']['input']>;
  search: InputMaybe<ExternalAccountSearchInput>;
};

export type ExternalAccountSearchInput = {
  active: InputMaybe<Scalars['Boolean']['input']>;
  professional_id: InputMaybe<Scalars['Int']['input']>;
  verified: InputMaybe<Scalars['Boolean']['input']>;
};

export type ExternalAccountWhereInput = {
  account_type: InputMaybe<Scalars['String']['input']>;
  bank_name: InputMaybe<Scalars['String']['input']>;
  brand: InputMaybe<Scalars['String']['input']>;
  created_at: InputMaybe<Scalars['DateTime']['input']>;
  exp_month: InputMaybe<Scalars['Int']['input']>;
  exp_year: InputMaybe<Scalars['Int']['input']>;
  id: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  instant_pay_eligible: InputMaybe<Scalars['Boolean']['input']>;
  last4: InputMaybe<Scalars['String']['input']>;
  stripe_account_id: InputMaybe<Scalars['Int']['input']>;
  stripe_id: InputMaybe<Scalars['String']['input']>;
  updated_at: InputMaybe<Scalars['DateTime']['input']>;
};

export type FacilityConnection = {
  __typename?: 'FacilityConnection';
  created_at: Scalars['DateTime']['output'];
  facility: Maybe<User>;
  facility_id: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  updated_at: Scalars['DateTime']['output'];
  user: Maybe<User>;
  user_id: Maybe<Scalars['Int']['output']>;
};

export type FacilityConnectionOrderInput = {
  facility_id: InputMaybe<Scalars['Boolean']['input']>;
  id: InputMaybe<Scalars['Boolean']['input']>;
  updated_at: InputMaybe<Scalars['Boolean']['input']>;
  user_id: InputMaybe<Scalars['Boolean']['input']>;
};

export type FacilityConnectionQueryInput = {
  filter: InputMaybe<FacilityConnectionWhereInput>;
  orderBy: InputMaybe<ProfessionalOrderInput>;
  page: InputMaybe<Scalars['Int']['input']>;
  perPage: InputMaybe<Scalars['Int']['input']>;
  search: InputMaybe<DefaultSearchInput>;
};

export type FacilityConnectionWhereInput = {
  created_at: InputMaybe<Scalars['DateTime']['input']>;
  facility_id: InputMaybe<Scalars['Int']['input']>;
  id: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  updated_at: InputMaybe<Scalars['DateTime']['input']>;
  user_id: InputMaybe<Scalars['Int']['input']>;
};

export type FavoritesPanelRow = {
  __typename?: 'FavoritesPanelRow';
  is_blocked: Scalars['Boolean']['output'];
  is_favorited: Scalars['Boolean']['output'];
  job_id: Scalars['Int']['output'];
  location_id: Scalars['Int']['output'];
  location_name: Scalars['String']['output'];
  positions: Array<Position>;
  professional_id: Scalars['Int']['output'];
  professional_name: Scalars['String']['output'];
  starts_date: Scalars['Date']['output'];
  starts_time: Scalars['DateTime']['output'];
};

export type FinancialTransaction = {
  __typename?: 'FinancialTransaction';
  amount_cents: Scalars['Int']['output'];
  amount_currency: Scalars['String']['output'];
  amount_left_cents: Scalars['Int']['output'];
  amount_left_currency: Scalars['String']['output'];
  balance_sheet: Maybe<BalanceSheet>;
  balance_sheet_id: Maybe<Scalars['Int']['output']>;
  billing_group: Maybe<BillingGroup>;
  billing_group_id: Maybe<Scalars['Int']['output']>;
  created_at: Scalars['DateTime']['output'];
  data_source: Scalars['String']['output'];
  facility_notes: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  itemized_transactions: Maybe<Array<Maybe<ItemizedTransaction>>>;
  kind: Maybe<Scalars['String']['output']>;
  original_financial_transaction_id: Maybe<Scalars['Int']['output']>;
  revenue_date: Scalars['DateTime']['output'];
  transaction_id: Maybe<Scalars['String']['output']>;
  updated_at: Scalars['DateTime']['output'];
  user_id: Maybe<Scalars['Int']['output']>;
  yaypay_external_id: Maybe<Scalars['String']['output']>;
};

export type FinancialTransactionOrderInput = {
  amount_cents: InputMaybe<Scalars['Boolean']['input']>;
  amount_left_cents: InputMaybe<Scalars['Boolean']['input']>;
  created_at: InputMaybe<Scalars['Boolean']['input']>;
  id: InputMaybe<Scalars['Boolean']['input']>;
  kind: InputMaybe<Scalars['Boolean']['input']>;
  original_financial_transaction_id: InputMaybe<Scalars['Boolean']['input']>;
  transaction_id: InputMaybe<Scalars['Boolean']['input']>;
};

export type FinancialTransactionQueryInput = {
  filter: InputMaybe<FinancialTransactionWhereInput>;
  orderBy: InputMaybe<FinancialTransactionOrderInput>;
  page: InputMaybe<Scalars['Int']['input']>;
  perPage: InputMaybe<Scalars['Int']['input']>;
  search: InputMaybe<FinancialTransactionSearchInput>;
};

export type FinancialTransactionSearchInput = {
  amount_cents: InputMaybe<Scalars['Int']['input']>;
  amount_left_cents: InputMaybe<Scalars['Int']['input']>;
  balance_sheet_id: InputMaybe<Scalars['Int']['input']>;
  billing_group_id: InputMaybe<Scalars['Int']['input']>;
  can_refund: InputMaybe<Scalars['Boolean']['input']>;
  created_at: InputMaybe<Scalars['DateTime']['input']>;
  ends_date: InputMaybe<Scalars['Date']['input']>;
  id: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  kind: InputMaybe<Scalars['String']['input']>;
  original_financial_transaction_id: InputMaybe<Scalars['Int']['input']>;
  /**
   * *Constraints:*
   * * Maximal length: `150`
   *
   */
  q: InputMaybe<Scalars['String']['input']>;
  starts_date: InputMaybe<Scalars['Date']['input']>;
  transaction_id: InputMaybe<Scalars['String']['input']>;
  unapplied: InputMaybe<Scalars['Boolean']['input']>;
};

export type FinancialTransactionWhereInput = {
  amount_cents: InputMaybe<Scalars['Int']['input']>;
  amount_currency: InputMaybe<Scalars['String']['input']>;
  amount_left_cents: InputMaybe<Scalars['Int']['input']>;
  amount_left_currency: InputMaybe<Scalars['String']['input']>;
  balance_sheet_id: InputMaybe<Scalars['Int']['input']>;
  billing_group_id: InputMaybe<Scalars['Int']['input']>;
  created_at: InputMaybe<Scalars['DateTime']['input']>;
  id: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  kind: InputMaybe<Scalars['String']['input']>;
  original_financial_transaction_id: InputMaybe<Scalars['Int']['input']>;
  transaction_id: InputMaybe<Scalars['String']['input']>;
};

export type ForLocations = {
  for_job: InputMaybe<Scalars['Boolean']['input']>;
  location_ids: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};

export type ForLocationsJobsInput = {
  location_ids: Array<Scalars['Int']['input']>;
};

export type ForPositionLocations = {
  for_job: InputMaybe<Scalars['Boolean']['input']>;
  location_ids: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  position_ids: Array<InputMaybe<Scalars['Int']['input']>>;
};

export type ForTimeTrackingInput = {
  ends_time: InputMaybe<Scalars['DateTime']['input']>;
  for_type: InputMaybe<ForTimeTrackingInputType>;
  location_ids: Array<InputMaybe<Scalars['Int']['input']>>;
  starts_time: InputMaybe<Scalars['DateTime']['input']>;
};

export enum ForTimeTrackingInputType {
  AssignmentShift = 'assignment_shift',
  PerDiem = 'per_diem'
}

export type FundingSource = {
  __typename?: 'FundingSource';
  account_type: Maybe<Scalars['String']['output']>;
  active: Maybe<Scalars['Boolean']['output']>;
  bank_name: Maybe<Scalars['String']['output']>;
  billing_group: Maybe<BillingGroup>;
  brand: Maybe<Scalars['String']['output']>;
  created_at: Scalars['DateTime']['output'];
  exp_month: Maybe<Scalars['Int']['output']>;
  exp_year: Maybe<Scalars['Int']['output']>;
  hosted_verification_url: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  instant_pay_eligible: Scalars['Boolean']['output'];
  last4: Maybe<Scalars['String']['output']>;
  personable: Maybe<Personable>;
  personable_id: Maybe<Scalars['Int']['output']>;
  personable_type: Maybe<Scalars['String']['output']>;
  professional: Maybe<Professional>;
  status: Maybe<Scalars['String']['output']>;
  stripe_id: Maybe<Scalars['String']['output']>;
  updated_at: Scalars['DateTime']['output'];
  user: Maybe<User>;
};

export type FundingSourceOrderInput = {
  account_type: InputMaybe<Scalars['Boolean']['input']>;
  bank_name: InputMaybe<Scalars['Boolean']['input']>;
  brand: InputMaybe<Scalars['Boolean']['input']>;
  created_at: InputMaybe<Scalars['Boolean']['input']>;
  exp_month: InputMaybe<Scalars['Boolean']['input']>;
  exp_year: InputMaybe<Scalars['Boolean']['input']>;
  id: InputMaybe<Scalars['Boolean']['input']>;
  last4: InputMaybe<Scalars['Boolean']['input']>;
  personable_id: InputMaybe<Scalars['Boolean']['input']>;
  personable_type: InputMaybe<Scalars['Boolean']['input']>;
  stripe_id: InputMaybe<Scalars['Boolean']['input']>;
  updated_at: InputMaybe<Scalars['Boolean']['input']>;
};

export type FundingSourceQueryInput = {
  filter: InputMaybe<FundingSourceWhereInput>;
  orderBy: InputMaybe<FundingSourceOrderInput>;
  page: InputMaybe<Scalars['Int']['input']>;
  perPage: InputMaybe<Scalars['Int']['input']>;
  search: InputMaybe<DefaultSearchInput>;
};

export type FundingSourceWhereInput = {
  account_type: InputMaybe<Scalars['String']['input']>;
  bank_name: InputMaybe<Scalars['String']['input']>;
  brand: InputMaybe<Scalars['String']['input']>;
  created_at: InputMaybe<Scalars['DateTime']['input']>;
  exp_month: InputMaybe<Scalars['Int']['input']>;
  exp_year: InputMaybe<Scalars['Int']['input']>;
  id: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  last4: InputMaybe<Scalars['String']['input']>;
  personable_id: InputMaybe<Scalars['Int']['input']>;
  personable_type: InputMaybe<Scalars['String']['input']>;
  stripe_id: InputMaybe<Scalars['String']['input']>;
  updated_at: InputMaybe<Scalars['DateTime']['input']>;
};

export type GetBlockedTimesInput = {
  assignment_id: InputMaybe<Scalars['Int']['input']>;
  is_w2: InputMaybe<Scalars['Int']['input']>;
  job_id: InputMaybe<Scalars['Int']['input']>;
  job_times: Job_Time_Ranges;
  location_id: InputMaybe<Scalars['Int']['input']>;
  professional_ids: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};

export type HealthSystem = {
  __typename?: 'HealthSystem';
  companies: Maybe<Array<Maybe<Company>>>;
  created_at: Scalars['DateTime']['output'];
  id: Scalars['Int']['output'];
  label: Maybe<Scalars['String']['output']>;
  name: Maybe<Scalars['String']['output']>;
  updated_at: Scalars['DateTime']['output'];
  users: Maybe<Array<Maybe<User>>>;
};

export type HealthSystemOrderInput = {
  created_at: InputMaybe<Scalars['Boolean']['input']>;
  id: InputMaybe<Scalars['Boolean']['input']>;
  label: InputMaybe<Scalars['Boolean']['input']>;
  name: InputMaybe<Scalars['Boolean']['input']>;
  updated_at: InputMaybe<Scalars['Boolean']['input']>;
};

export type HealthSystemQueryInput = {
  filter: InputMaybe<HealthSystemWhereInput>;
  orderBy: InputMaybe<HealthSystemOrderInput>;
  page: InputMaybe<Scalars['Int']['input']>;
  perPage: InputMaybe<Scalars['Int']['input']>;
  search: InputMaybe<DefaultSearchInput>;
};

export type HealthSystemWhereInput = {
  created_at: InputMaybe<Scalars['DateTime']['input']>;
  id: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  label: InputMaybe<Scalars['String']['input']>;
  name: InputMaybe<Scalars['String']['input']>;
  updated_at: InputMaybe<Scalars['DateTime']['input']>;
};

export type InterviewAvailability = {
  __typename?: 'InterviewAvailability';
  end: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['Int']['output'];
  start: Maybe<Scalars['DateTime']['output']>;
  starts_time: Maybe<Scalars['DateTime']['output']>;
  title: Maybe<Scalars['String']['output']>;
  user: Maybe<User>;
  user_id: Maybe<Scalars['Int']['output']>;
};

export type InterviewAvailabilityOrderInput = {
  id: InputMaybe<Scalars['Boolean']['input']>;
  starts_time: InputMaybe<Scalars['Boolean']['input']>;
  user_id: InputMaybe<Scalars['Boolean']['input']>;
};

export type InterviewAvailabilityQueryInput = {
  filter: InputMaybe<InterviewAvailabilityWhereInput>;
  orderBy: InputMaybe<InterviewAvailabilityOrderInput>;
  page: InputMaybe<Scalars['Int']['input']>;
  perPage: InputMaybe<Scalars['Int']['input']>;
  search: InputMaybe<InterviewAvailabilitySearchInput>;
};

export type InterviewAvailabilitySearchInput = {
  id: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  /**
   * *Constraints:*
   * * Maximal length: `150`
   *
   */
  q: InputMaybe<Scalars['String']['input']>;
  start_gte: InputMaybe<Scalars['DateTime']['input']>;
  start_lte: InputMaybe<Scalars['DateTime']['input']>;
  starts_time: InputMaybe<Scalars['DateTime']['input']>;
  user_id: InputMaybe<Scalars['Int']['input']>;
};

export type InterviewAvailabilityWhereInput = {
  id: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  starts_time: InputMaybe<Scalars['DateTime']['input']>;
  user_id: InputMaybe<Scalars['Int']['input']>;
};

export type Invoice = {
  __typename?: 'Invoice';
  agency_id: Maybe<Scalars['Int']['output']>;
  amount_due_cents: Maybe<Scalars['Int']['output']>;
  assignment: Maybe<Assignment>;
  assignment_id: Maybe<Scalars['Int']['output']>;
  balance_cents: Scalars['Int']['output'];
  balance_currency: Scalars['String']['output'];
  billing_group: Maybe<BillingGroup>;
  billing_group_id: Maybe<Scalars['Int']['output']>;
  billing_id: Maybe<Scalars['String']['output']>;
  child_invoice_links: Maybe<Array<Maybe<InvoicesLink>>>;
  created_at: Scalars['DateTime']['output'];
  days_late: Maybe<Scalars['Int']['output']>;
  disputes: Maybe<Array<Maybe<Dispute>>>;
  due_date: Maybe<Scalars['Date']['output']>;
  ends_time: Maybe<Scalars['DateTime']['output']>;
  failed_count: Maybe<Scalars['Int']['output']>;
  failed_reason: Maybe<Scalars['String']['output']>;
  fee_percent: Maybe<Scalars['Float']['output']>;
  id: Scalars['Int']['output'];
  invoice_locked_balance_sheet_id: Maybe<Scalars['Int']['output']>;
  invoice_paid_balance_sheet_id: Maybe<Scalars['Int']['output']>;
  invoice_type: Maybe<Scalars['String']['output']>;
  itemized_transactions: Maybe<Array<Maybe<ItemizedTransaction>>>;
  job_count: Maybe<Scalars['Int']['output']>;
  jobs: Maybe<Array<Maybe<Job>>>;
  locked_at: Maybe<Scalars['DateTime']['output']>;
  paid_date: Maybe<Scalars['DateTime']['output']>;
  parent_invoice_links: Maybe<Array<Maybe<InvoicesLink>>>;
  processing_fee_cents: Scalars['Int']['output'];
  processing_fee_currency: Scalars['String']['output'];
  processing_fee_stripe_invoice_item_id: Maybe<Scalars['String']['output']>;
  revenue_adjustments: Maybe<Array<Maybe<RevenueAdjustment>>>;
  starts_time: Scalars['DateTime']['output'];
  statement: Maybe<Statement>;
  statement_id: Maybe<Scalars['Int']['output']>;
  status: Maybe<Scalars['String']['output']>;
  stripe_invoice_id: Maybe<Scalars['String']['output']>;
  stripe_invoice_number: Maybe<Scalars['String']['output']>;
  stripe_invoice_url: Maybe<Scalars['String']['output']>;
  stripe_payment_intents: Maybe<Array<Maybe<StripePaymentIntent>>>;
  sub_total_cents: Scalars['Int']['output'];
  sub_total_currency: Scalars['String']['output'];
  timecard_ids: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  total_breaks_hours: Maybe<Scalars['Float']['output']>;
  total_callback_hours: Maybe<Scalars['Float']['output']>;
  total_cents: Scalars['Int']['output'];
  total_currency: Scalars['String']['output'];
  total_double_hours: Maybe<Scalars['Float']['output']>;
  total_hours: Maybe<Scalars['Float']['output']>;
  total_on_call_hours: Maybe<Scalars['Float']['output']>;
  total_overtime_hours: Maybe<Scalars['Float']['output']>;
  total_regular_hours: Maybe<Scalars['Float']['output']>;
  updated_at: Scalars['DateTime']['output'];
  voucher_id: Maybe<Scalars['String']['output']>;
  voucher_processing_status: Maybe<Scalars['String']['output']>;
};

export type InvoiceOrderInput = {
  approved_clock_in: InputMaybe<Scalars['Boolean']['input']>;
  approved_clock_out: InputMaybe<Scalars['Boolean']['input']>;
  assignment_id: InputMaybe<Scalars['Boolean']['input']>;
  billing_group_id: InputMaybe<Scalars['Int']['input']>;
  charge_total_cents: InputMaybe<Scalars['Boolean']['input']>;
  charge_total_currency: InputMaybe<Scalars['Boolean']['input']>;
  created_at: InputMaybe<Scalars['Boolean']['input']>;
  due_date: InputMaybe<Scalars['Boolean']['input']>;
  ends_time: InputMaybe<Scalars['Boolean']['input']>;
  failed_count: InputMaybe<Scalars['Boolean']['input']>;
  failed_reason: InputMaybe<Scalars['Boolean']['input']>;
  fee_cents: InputMaybe<Scalars['Boolean']['input']>;
  hours_double: InputMaybe<Scalars['Boolean']['input']>;
  hours_normal: InputMaybe<Scalars['Boolean']['input']>;
  hours_time_half: InputMaybe<Scalars['Boolean']['input']>;
  id: InputMaybe<Scalars['Boolean']['input']>;
  invoiceable_id: InputMaybe<Scalars['Boolean']['input']>;
  invoiceable_type: InputMaybe<Scalars['Boolean']['input']>;
  market: InputMaybe<Scalars['Boolean']['input']>;
  notes: InputMaybe<Scalars['Boolean']['input']>;
  paid: InputMaybe<Scalars['Boolean']['input']>;
  pause: InputMaybe<Scalars['Boolean']['input']>;
  pause_professional_transfer: InputMaybe<Scalars['Boolean']['input']>;
  professional_id: InputMaybe<Scalars['Boolean']['input']>;
  starts_time: InputMaybe<Scalars['Boolean']['input']>;
  state: InputMaybe<Scalars['Boolean']['input']>;
  stripe_charge_id: InputMaybe<Scalars['Boolean']['input']>;
  stripe_invoice_item_id: InputMaybe<Scalars['Boolean']['input']>;
  stripe_transfer_id: InputMaybe<Scalars['Boolean']['input']>;
  total_cents: InputMaybe<Scalars['Boolean']['input']>;
  total_hours_: InputMaybe<Scalars['Boolean']['input']>;
  transfer_total_cents: InputMaybe<Scalars['Boolean']['input']>;
  transfer_total_currency: InputMaybe<Scalars['Boolean']['input']>;
  updated_at: InputMaybe<Scalars['Boolean']['input']>;
  user_id: InputMaybe<Scalars['Boolean']['input']>;
};

export type InvoiceQueryInput = {
  filter: InputMaybe<InvoiceWhereInput>;
  orderBy: InputMaybe<InvoiceOrderInput>;
  page: InputMaybe<Scalars['Int']['input']>;
  perPage: InputMaybe<Scalars['Int']['input']>;
  search: InputMaybe<InvoiceSearchInput>;
};

export enum InvoiceSearchByInput {
  Invoices = 'invoices',
  Jobs = 'jobs',
  Professionals = 'professionals',
  Users = 'users'
}

export type InvoiceSearchInput = {
  account_manager_id: InputMaybe<Scalars['Int']['input']>;
  billing_group_id: InputMaybe<Scalars['Int']['input']>;
  billing_group_ids: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  billing_group_uid: InputMaybe<Scalars['String']['input']>;
  billing_id: InputMaybe<Scalars['String']['input']>;
  days_late: InputMaybe<Scalars['Int']['input']>;
  ends_date: InputMaybe<Scalars['Date']['input']>;
  ends_time: InputMaybe<Scalars['Date']['input']>;
  failed_payments: InputMaybe<Scalars['Boolean']['input']>;
  failing_payments: InputMaybe<Scalars['Boolean']['input']>;
  for_assignment: InputMaybe<Scalars['Boolean']['input']>;
  hide_locked: InputMaybe<Scalars['Boolean']['input']>;
  hide_zero_value_invoices: InputMaybe<Scalars['Boolean']['input']>;
  invoice_type: InputMaybe<Scalars['String']['input']>;
  kinds: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  location_ids: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  market_ids: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  no_breaks: InputMaybe<Scalars['Boolean']['input']>;
  open_payment_gateway: InputMaybe<Scalars['Boolean']['input']>;
  paid: InputMaybe<Scalars['Boolean']['input']>;
  pause: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * *Constraints:*
   * * Maximal length: `150`
   *
   */
  q: InputMaybe<Scalars['String']['input']>;
  search_by: InputMaybe<InvoiceSearchByInput>;
  starts_date: InputMaybe<Scalars['Date']['input']>;
  starts_time: InputMaybe<Scalars['Date']['input']>;
  statement_id: InputMaybe<Scalars['Int']['input']>;
  status: InputMaybe<Scalars['String']['input']>;
  statuses: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  total_cents: InputMaybe<Scalars['Int']['input']>;
  user_ids: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  voucher_id: InputMaybe<Scalars['String']['input']>;
};

export enum InvoiceStatus {
  Approved = 'approved',
  Disputed = 'disputed',
  Due = 'due',
  Paid = 'paid',
  PastDue = 'past_due',
  Pending = 'pending',
  Void = 'void'
}

export type InvoiceStatusBillingGroupCountsInput = {
  billing_group_ids: Array<Scalars['Int']['input']>;
  statuses: Array<InvoiceStatus>;
};

export type InvoiceStatusBillingGroupCountsResult = {
  __typename?: 'InvoiceStatusBillingGroupCountsResult';
  billing_group_id: Scalars['Int']['output'];
  invoice_count: Scalars['Int']['output'];
};

export type InvoiceWhereInput = {
  approved_clock_in: InputMaybe<Scalars['DateTime']['input']>;
  approved_clock_out: InputMaybe<Scalars['DateTime']['input']>;
  assignment_id: InputMaybe<Scalars['Int']['input']>;
  billing_group_id: InputMaybe<Scalars['Int']['input']>;
  billing_id: InputMaybe<Scalars['String']['input']>;
  charge_total_cents: InputMaybe<Scalars['Int']['input']>;
  charge_total_currency: InputMaybe<Scalars['String']['input']>;
  created_at: InputMaybe<Scalars['DateTime']['input']>;
  ends_time: InputMaybe<Scalars['Date']['input']>;
  failed_count: InputMaybe<Scalars['Int']['input']>;
  failed_reason: InputMaybe<Scalars['String']['input']>;
  fee: InputMaybe<Scalars['Int']['input']>;
  hours_double: InputMaybe<Scalars['String']['input']>;
  hours_normal: InputMaybe<Scalars['String']['input']>;
  hours_time_half: InputMaybe<Scalars['String']['input']>;
  id: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  invoice_type: InputMaybe<Scalars['String']['input']>;
  invoiceable_id: InputMaybe<Scalars['Int']['input']>;
  invoiceable_type: InputMaybe<Scalars['String']['input']>;
  market: InputMaybe<Scalars['String']['input']>;
  notes: InputMaybe<Scalars['String']['input']>;
  paid: InputMaybe<Scalars['Boolean']['input']>;
  pause: InputMaybe<Scalars['Boolean']['input']>;
  pause_professional_transfer: InputMaybe<Scalars['Boolean']['input']>;
  professional_id: InputMaybe<Scalars['Int']['input']>;
  starts_time: InputMaybe<Scalars['Date']['input']>;
  state: InputMaybe<Scalars['String']['input']>;
  statement_id: InputMaybe<Scalars['Int']['input']>;
  status: InputMaybe<Scalars['String']['input']>;
  stripe_charge_id: InputMaybe<Scalars['String']['input']>;
  stripe_invoice_item_id: InputMaybe<Scalars['String']['input']>;
  stripe_transfer_id: InputMaybe<Scalars['String']['input']>;
  timecard_id: InputMaybe<Scalars['Int']['input']>;
  total_cents: InputMaybe<Scalars['Int']['input']>;
  total_hours_: InputMaybe<Scalars['Float']['input']>;
  transfer_total_cents: InputMaybe<Scalars['Int']['input']>;
  transfer_total_currency: InputMaybe<Scalars['String']['input']>;
  updated_at: InputMaybe<Scalars['DateTime']['input']>;
  voucher_id: InputMaybe<Scalars['String']['input']>;
};

export type Invoiceable = Job | Timecard;

export type InvoicesLink = {
  __typename?: 'InvoicesLink';
  child_invoice_id: Maybe<Scalars['Int']['output']>;
  created_at: Scalars['DateTime']['output'];
  id: Scalars['Int']['output'];
  parent_invoice_id: Maybe<Scalars['Int']['output']>;
  updated_at: Scalars['DateTime']['output'];
};

export type InvoicesTotals = {
  __typename?: 'InvoicesTotals';
  filtered_breaks_hours: Maybe<Scalars['Float']['output']>;
  filtered_callback_hours: Maybe<Scalars['Float']['output']>;
  filtered_double_hours: Maybe<Scalars['Float']['output']>;
  filtered_on_call_hours: Maybe<Scalars['Float']['output']>;
  filtered_overtime_hours: Maybe<Scalars['Float']['output']>;
  filtered_regular_hours: Maybe<Scalars['Float']['output']>;
  filtered_total_hours: Maybe<Scalars['Float']['output']>;
};

export type ItemizedTransaction = {
  __typename?: 'ItemizedTransaction';
  amount_cents: Scalars['Int']['output'];
  amount_currency: Scalars['String']['output'];
  balance_sheet_id: Scalars['Int']['output'];
  billing_group_id: Maybe<Scalars['Int']['output']>;
  created_at: Scalars['DateTime']['output'];
  description: Maybe<Scalars['String']['output']>;
  financial_transaction: Maybe<FinancialTransaction>;
  financial_transaction_id: Maybe<Scalars['Int']['output']>;
  from_source: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  invoice: Maybe<Invoice>;
  invoice_id: Maybe<Scalars['Int']['output']>;
  labels: Maybe<Scalars['JSON']['output']>;
  location: Maybe<Location>;
  location_id: Maybe<Scalars['Int']['output']>;
  notes: Maybe<Scalars['String']['output']>;
  reversed_itemized_transaction_id: Maybe<Scalars['Int']['output']>;
  to_source: Maybe<Scalars['String']['output']>;
  updated_at: Scalars['DateTime']['output'];
};

export type ItemizedTransactionOrderInput = {
  amount_cents: InputMaybe<Scalars['Boolean']['input']>;
  billing_group_id: InputMaybe<Scalars['Int']['input']>;
  created_at: InputMaybe<Scalars['Boolean']['input']>;
  financial_transaction_id: InputMaybe<Scalars['Boolean']['input']>;
  from_source: InputMaybe<Scalars['Boolean']['input']>;
  id: InputMaybe<Scalars['Boolean']['input']>;
  invoice_id: InputMaybe<Scalars['Boolean']['input']>;
};

export type ItemizedTransactionQueryInput = {
  billing_group_id: InputMaybe<Scalars['Int']['input']>;
  filter: InputMaybe<ItemizedTransactionWhereInput>;
  orderBy: InputMaybe<ItemizedTransactionOrderInput>;
  page: InputMaybe<Scalars['Int']['input']>;
  perPage: InputMaybe<Scalars['Int']['input']>;
  search: InputMaybe<ItemizedTransactionSearchInput>;
};

export type ItemizedTransactionSearchInput = {
  amount_cents: InputMaybe<Scalars['Int']['input']>;
  amount_currency: InputMaybe<Scalars['String']['input']>;
  billing_group_id: InputMaybe<Scalars['Int']['input']>;
  created_at: InputMaybe<Scalars['DateTime']['input']>;
  financial_transaction_id: InputMaybe<Scalars['Int']['input']>;
  from_source: InputMaybe<Scalars['String']['input']>;
  id: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  invoice_id: InputMaybe<Scalars['Int']['input']>;
  /**
   * *Constraints:*
   * * Maximal length: `150`
   *
   */
  q: InputMaybe<Scalars['String']['input']>;
  to_source: InputMaybe<Scalars['String']['input']>;
};

export type ItemizedTransactionWhereInput = {
  amount_cents: InputMaybe<Scalars['Int']['input']>;
  amount_currency: InputMaybe<Scalars['String']['input']>;
  billing_group_id: InputMaybe<Scalars['Int']['input']>;
  created_at: InputMaybe<Scalars['DateTime']['input']>;
  financial_transaction_id: InputMaybe<Scalars['Int']['input']>;
  from_source: InputMaybe<Scalars['String']['input']>;
  id: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  invoice_id: InputMaybe<Scalars['Int']['input']>;
  to_source: InputMaybe<Scalars['String']['input']>;
};

export type Job = {
  __typename?: 'Job';
  adjust_rate_calculator: Maybe<Scalars['Boolean']['output']>;
  admin_notes: Maybe<Scalars['String']['output']>;
  agency_job_profile: Maybe<JobProfile>;
  agency_requested_by_facility: Scalars['Boolean']['output'];
  approval_requestee_notes: Maybe<Scalars['String']['output']>;
  approval_status: Maybe<ApprovalStatus>;
  approval_violated_parameters: Maybe<Scalars['JSON']['output']>;
  approvals: Array<Approval>;
  approved_clock_in: Maybe<Scalars['DateTime']['output']>;
  approved_clock_out: Maybe<Scalars['DateTime']['output']>;
  assignment: Maybe<Assignment>;
  assignment_id: Maybe<Scalars['Int']['output']>;
  attachment: Maybe<Scalars['AWSFile']['output']>;
  available_for_agency_to_book_non_favorites: Scalars['Boolean']['output'];
  available_professional_count: Maybe<Scalars['Int']['output']>;
  /** @deprecated use plural balance_sheets */
  balance_sheet: Maybe<BalanceSheet>;
  balance_sheets: Maybe<Array<Maybe<BalanceSheet>>>;
  billing_group: Maybe<BillingGroup>;
  billing_group_id: Maybe<Scalars['Int']['output']>;
  bonus_one_time: Maybe<Scalars['Int']['output']>;
  bonus_one_time_cents: Maybe<Scalars['Int']['output']>;
  bonus_one_time_cents_for_account_id: Maybe<Scalars['Int']['output']>;
  bonus_one_time_payout: Maybe<Scalars['Int']['output']>;
  bonus_one_time_payout_cents: Maybe<Scalars['Int']['output']>;
  booked_at: Maybe<Scalars['DateTime']['output']>;
  breaks: Maybe<Array<Maybe<Break>>>;
  callback_ends_time: Maybe<Scalars['DateTime']['output']>;
  callback_starts_time: Maybe<Scalars['DateTime']['output']>;
  can_book_job: Maybe<Scalars['Boolean']['output']>;
  canceled_by_location: Maybe<Scalars['Boolean']['output']>;
  canceled_by_professional: Maybe<Scalars['Boolean']['output']>;
  cancellation_fee_charge_hours: Maybe<Scalars['Int']['output']>;
  cancellation_fee_window: Maybe<Scalars['Int']['output']>;
  cancellation_reason_id: Maybe<Scalars['Int']['output']>;
  charge_base_hourly_rate_cents: Maybe<Scalars['Int']['output']>;
  charge_base_hourly_rate_currency: Scalars['String']['output'];
  charge_bonus_cents: Maybe<Scalars['Int']['output']>;
  charge_callback_multiplier: Maybe<Scalars['Float']['output']>;
  charge_double_overtime_multiplier: Maybe<Scalars['Float']['output']>;
  charge_on_call_hourly_rate_cents: Maybe<Scalars['Int']['output']>;
  charge_on_call_hourly_rate_currency: Scalars['String']['output'];
  charge_overtime_frequency: Maybe<Scalars['String']['output']>;
  charge_overtime_multiplier: Maybe<Scalars['Float']['output']>;
  check_ins: Maybe<Array<Maybe<CheckIn>>>;
  check_outs: Maybe<Array<Maybe<CheckOut>>>;
  cleared_no_show: Scalars['Boolean']['output'];
  clinical_contact: Maybe<Account>;
  clinical_contact_account_id: Maybe<Scalars['Int']['output']>;
  /** @deprecated not currently populated, use location object */
  clock_in_early_window: Maybe<Scalars['Int']['output']>;
  /** @deprecated to be removed in favor of maximum_late_clock_out_grace_period_minutes */
  clock_out_late_window: Maybe<Scalars['Int']['output']>;
  closed: Maybe<Scalars['Boolean']['output']>;
  condition_ids: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  covid_care: Scalars['Boolean']['output'];
  created_at: Scalars['DateTime']['output'];
  created_by: Maybe<Account>;
  created_by_account_id: Maybe<Scalars['Int']['output']>;
  current_ends_time: Maybe<Scalars['DateTime']['output']>;
  current_starts_time: Maybe<Scalars['DateTime']['output']>;
  custom_onboarding_docs: Maybe<Array<Maybe<ConditionDocument>>>;
  detail: Maybe<Scalars['String']['output']>;
  did_user_modify_time: Maybe<Scalars['Boolean']['output']>;
  direct_post: Scalars['Boolean']['output'];
  dispute_review_approval_deadline: Maybe<Scalars['DateTime']['output']>;
  disputes: Maybe<Array<Maybe<Dispute>>>;
  distance_in_miles: Maybe<Scalars['Int']['output']>;
  enable_geo_fence: Maybe<Scalars['Boolean']['output']>;
  ends_date: Maybe<Scalars['Date']['output']>;
  ends_time: Maybe<Scalars['DateTime']['output']>;
  ends_time_: Maybe<Scalars['DateTime']['output']>;
  estimated_rate_cents: Maybe<Scalars['Int']['output']>;
  estimated_unpaid_break_time_minutes: Maybe<Scalars['Int']['output']>;
  expense_adjustment_total_cents: Maybe<Scalars['Int']['output']>;
  expense_adjustments: Array<ExpenseAdjustment>;
  extended_by_location: Scalars['Boolean']['output'];
  extended_by_professional: Scalars['Boolean']['output'];
  facility_number: Maybe<Scalars['String']['output']>;
  favorite_ids: Array<Scalars['String']['output']>;
  geo_fence_radius: Maybe<Scalars['Int']['output']>;
  great_pay: Maybe<Scalars['Boolean']['output']>;
  guaranteed_minimum_hours: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  invoices: Maybe<Array<Maybe<Invoice>>>;
  is_w2: Maybe<Scalars['Boolean']['output']>;
  job_audits: Maybe<Array<Maybe<Audit>>>;
  /** @deprecated use plural job_billings */
  job_billing: Maybe<JobBilling>;
  job_billing_sums: Maybe<JobBillingSum>;
  /** @deprecated use job_billing_sums with invoice_id */
  job_billing_sums_for_invoice: Maybe<JobBillingSum>;
  /** @deprecated use job_billing_sums with payout_id */
  job_billing_sums_for_payout: Maybe<JobBillingSum>;
  job_billings: Array<JobBilling>;
  job_irregularities: Array<JobIrregularity>;
  job_price_differentials: Maybe<Array<Maybe<JobPriceDifferential>>>;
  job_profile_for_account_id: Maybe<JobProfile>;
  job_profiles: Maybe<Array<Maybe<JobProfile>>>;
  /** @deprecated use JobProfile. see https://medely.atlassian.net/browse/PLAT2-1109 */
  job_publishing_group: Maybe<JobPublishingGroup>;
  job_publishing_group_id: Maybe<Scalars['Int']['output']>;
  job_rate_tracked_events: Maybe<Array<Maybe<JobRateTrackedEvent>>>;
  job_track: Maybe<JobTrack>;
  last_cancellation: Maybe<LastCancellation>;
  location: Maybe<Location>;
  location_id: Maybe<Scalars['Int']['output']>;
  market_id: Maybe<Scalars['Int']['output']>;
  market_name: Maybe<Scalars['String']['output']>;
  /** @deprecated deprecated in favor of 'marketplace_job_profile' */
  marketplace_bonus_one_time_cents: Maybe<Scalars['Int']['output']>;
  /** @deprecated deprecated in favor of 'marketplace_job_profile' */
  marketplace_charge_base_hourly_rate_cents: Maybe<Scalars['Int']['output']>;
  marketplace_job_profile: Maybe<JobProfile>;
  /** @deprecated deprecated in favor of 'marketplace_job_profile' */
  marketplace_payout_base_hourly_rate_cents: Maybe<Scalars['Int']['output']>;
  /** @deprecated removing. this was a job_publishing_groups relic and job_publishing_groups is going away */
  max_possible_bonus_one_time_cents: Maybe<Scalars['Int']['output']>;
  max_possible_charge_base_hourly_rate_cents: Maybe<Scalars['Int']['output']>;
  missed_clock_out: Maybe<Scalars['Boolean']['output']>;
  missing_condition_ids: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  new_to_facility: Scalars['Boolean']['output'];
  offer_source: Maybe<Scalars['String']['output']>;
  on_call_ends_time: Maybe<Scalars['DateTime']['output']>;
  on_call_starts_time: Maybe<Scalars['DateTime']['output']>;
  optional_condition_ids: Array<Scalars['Int']['output']>;
  override_minimum: Maybe<Scalars['Boolean']['output']>;
  override_professional_specialty_requirement: Maybe<Scalars['Boolean']['output']>;
  override_rates: Maybe<Scalars['Boolean']['output']>;
  parking_reimbursement_cents: Maybe<Scalars['Int']['output']>;
  patient_population: Maybe<Scalars['String']['output']>;
  paused: Scalars['Boolean']['output'];
  /** @deprecated use plural payouts */
  payout: Maybe<Payout>;
  payout_base_hourly_rate_cents: Maybe<Scalars['Int']['output']>;
  payout_base_hourly_rate_cents_for_account_id: Maybe<Scalars['Int']['output']>;
  payout_base_hourly_rate_currency: Scalars['String']['output'];
  payout_bonus_cents: Maybe<Scalars['Int']['output']>;
  payout_callback_multiplier: Maybe<Scalars['Float']['output']>;
  payout_double_overtime_multiplier: Maybe<Scalars['Float']['output']>;
  payout_facility_bonus_cents: Maybe<Scalars['Int']['output']>;
  payout_on_call_hourly_rate_cents: Maybe<Scalars['Int']['output']>;
  payout_on_call_hourly_rate_currency: Scalars['String']['output'];
  payout_overtime_frequency: Maybe<Scalars['String']['output']>;
  payout_overtime_multiplier: Maybe<Scalars['Float']['output']>;
  payout_taxable_hourly_rate_cents: Maybe<Scalars['Int']['output']>;
  payout_taxable_hourly_rate_currency: Scalars['String']['output'];
  payouts: Maybe<Array<Maybe<Payout>>>;
  position_display_names: Maybe<Scalars['String']['output']>;
  position_ids: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  positions: Maybe<Array<Maybe<Position>>>;
  posting_field_contents: Maybe<Scalars['JSON']['output']>;
  primary_publishing_group_member: Scalars['Boolean']['output'];
  pro_confirmed_at: Maybe<Scalars['DateTime']['output']>;
  professional: Maybe<Professional>;
  professional_can_adjust_times: Maybe<Scalars['Boolean']['output']>;
  professional_can_cancel: Maybe<Scalars['Boolean']['output']>;
  professional_id: Maybe<Scalars['Int']['output']>;
  professional_number: Maybe<Scalars['String']['output']>;
  professional_submitted_time: Maybe<Scalars['DateTime']['output']>;
  rate_calculator: Maybe<RateCalculator>;
  rate_currency: Maybe<Scalars['String']['output']>;
  release_audience: Scalars['String']['output'];
  release_to_marketplace_strategy: Scalars['String']['output'];
  release_to_platform: Scalars['Int']['output'];
  released_to_professionals: Maybe<Scalars['Boolean']['output']>;
  requested_by_facility: Maybe<Scalars['Boolean']['output']>;
  require_upload_on_clock_out: Maybe<Scalars['Boolean']['output']>;
  requires_sca_onboarding_condition: Maybe<Scalars['Boolean']['output']>;
  reserved_for_favorites_only: Scalars['Boolean']['output'];
  revenue_adjustment_total_cents: Maybe<Scalars['Int']['output']>;
  revenue_adjustments: Maybe<Array<Maybe<RevenueAdjustment>>>;
  revenue_date: Maybe<Scalars['Date']['output']>;
  review: Maybe<Review>;
  scrubs_provided: Scalars['Boolean']['output'];
  shift_type: Maybe<Scalars['String']['output']>;
  specialties: Maybe<Array<Maybe<Specialty>>>;
  specialty_labels: Maybe<Scalars['String']['output']>;
  starts_date: Maybe<Scalars['Date']['output']>;
  starts_time: Maybe<Scalars['DateTime']['output']>;
  starts_time_: Maybe<Scalars['DateTime']['output']>;
  state_: Maybe<Scalars['String']['output']>;
  status: Maybe<JobStatus>;
  surgery_type_display_names: Maybe<Scalars['String']['output']>;
  surgery_types: Maybe<Array<Maybe<SurgeryType>>>;
  suspicious: Maybe<Scalars['Boolean']['output']>;
  timecard: Maybe<Timecard>;
  timecard_id: Maybe<Scalars['Int']['output']>;
  total_payout_bonus_cents: Maybe<Scalars['Int']['output']>;
  track_unpaid_breaks: Scalars['Boolean']['output'];
  updated_at: Scalars['DateTime']['output'];
  updated_in_cancellation_window: Maybe<Scalars['Boolean']['output']>;
  user: Maybe<User>;
  user_id: Maybe<Scalars['Int']['output']>;
};


export type JobAgency_Job_ProfileArgs = {
  agency_id?: InputMaybe<Scalars['Int']['input']>;
};


export type JobAgency_Requested_By_FacilityArgs = {
  agency_id: Scalars['Int']['input'];
};


export type JobAvailable_For_Agency_To_Book_Non_FavoritesArgs = {
  agency_id?: InputMaybe<Scalars['Int']['input']>;
};


export type JobBonus_One_Time_Cents_For_Account_IdArgs = {
  account_id?: InputMaybe<Scalars['Int']['input']>;
};


export type JobCan_Book_JobArgs = {
  account_id?: InputMaybe<Scalars['Int']['input']>;
};


export type JobCustom_Onboarding_DocsArgs = {
  account_id?: InputMaybe<Scalars['String']['input']>;
};


export type JobDistance_In_MilesArgs = {
  professional_id: Scalars['Int']['input'];
};


export type JobJob_Billing_SumsArgs = {
  billing_id: InputMaybe<Scalars['String']['input']>;
  invoice_id: InputMaybe<Scalars['Int']['input']>;
  payout_id: InputMaybe<Scalars['Int']['input']>;
};


export type JobJob_Billing_Sums_For_InvoiceArgs = {
  invoice_id: InputMaybe<Scalars['Int']['input']>;
};


export type JobJob_Billing_Sums_For_PayoutArgs = {
  payout_id: InputMaybe<Scalars['Int']['input']>;
};


export type JobJob_Profile_For_Account_IdArgs = {
  account_id?: InputMaybe<Scalars['Int']['input']>;
};


export type JobMissing_Condition_IdsArgs = {
  account_id?: InputMaybe<Scalars['Int']['input']>;
};


export type JobPayout_Base_Hourly_Rate_Cents_For_Account_IdArgs = {
  account_id?: InputMaybe<Scalars['Int']['input']>;
};


export type JobReleased_To_ProfessionalsArgs = {
  agency_id?: InputMaybe<Scalars['Int']['input']>;
};


export type JobRequested_By_FacilityArgs = {
  professional_id: Scalars['Int']['input'];
};

export type JobBilling = {
  __typename?: 'JobBilling';
  balance_sheet: Maybe<BalanceSheet>;
  balance_sheet_id: Maybe<Scalars['Int']['output']>;
  charge_callback_amount_cents: Scalars['Int']['output'];
  charge_callback_hours: Maybe<Scalars['Float']['output']>;
  charge_double_amount_cents: Scalars['Int']['output'];
  charge_double_hours: Maybe<Scalars['Float']['output']>;
  charge_overtime_amount_cents: Scalars['Int']['output'];
  charge_overtime_hours: Maybe<Scalars['Float']['output']>;
  charge_regular_amount_cents: Scalars['Int']['output'];
  charge_regular_hours: Maybe<Scalars['Float']['output']>;
  charge_total_amount_cents: Scalars['Int']['output'];
  charge_total_amount_currency: Scalars['String']['output'];
  created_at: Scalars['DateTime']['output'];
  expense_adjustment_total_cents: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  invoice: Maybe<Invoice>;
  invoice_id: Maybe<Scalars['Int']['output']>;
  job: Maybe<Job>;
  job_id: Maybe<Scalars['Int']['output']>;
  job_status: Maybe<Scalars['String']['output']>;
  locked_at: Maybe<Scalars['DateTime']['output']>;
  make_chargeable_at: Maybe<Scalars['DateTime']['output']>;
  make_payable_at: Maybe<Scalars['DateTime']['output']>;
  original_job_billing_id: Maybe<Scalars['Int']['output']>;
  past_month_adjustment: Maybe<Scalars['Boolean']['output']>;
  payout: Maybe<Payout>;
  payout_callback_amount_cents: Scalars['Int']['output'];
  payout_callback_hours: Maybe<Scalars['Float']['output']>;
  payout_double_amount_cents: Scalars['Int']['output'];
  payout_double_hours: Maybe<Scalars['Float']['output']>;
  payout_id: Maybe<Scalars['Int']['output']>;
  payout_overtime_amount_cents: Scalars['Int']['output'];
  payout_overtime_hours: Maybe<Scalars['Float']['output']>;
  payout_regular_amount_cents: Scalars['Int']['output'];
  payout_regular_hours: Maybe<Scalars['Float']['output']>;
  payout_total_amount_cents: Scalars['Int']['output'];
  payout_total_amount_currency: Scalars['String']['output'];
  revenue_adjustment_total_cents: Maybe<Scalars['Int']['output']>;
  total_breaks_hours: Maybe<Scalars['Float']['output']>;
  total_breaks_minutes: Maybe<Scalars['Int']['output']>;
  total_hours: Maybe<Scalars['Float']['output']>;
  total_on_call_hours: Maybe<Scalars['Float']['output']>;
  updated_at: Scalars['DateTime']['output'];
};

export type JobBillingOrderInput = {
  id: InputMaybe<Scalars['Boolean']['input']>;
  invoice_id: InputMaybe<Scalars['Boolean']['input']>;
  job_id: InputMaybe<Scalars['Boolean']['input']>;
  payout_id: InputMaybe<Scalars['Boolean']['input']>;
};

export type JobBillingQueryInput = {
  filter: InputMaybe<JobBillingWhereInput>;
  orderBy: InputMaybe<JobBillingOrderInput>;
  page: InputMaybe<Scalars['Int']['input']>;
  perPage: InputMaybe<Scalars['Int']['input']>;
  search: InputMaybe<JobBillingSearchInput>;
};

export type JobBillingSearchInput = {
  job_status: InputMaybe<Scalars['String']['input']>;
  location_id: InputMaybe<Scalars['Int']['input']>;
  professional_id: InputMaybe<Scalars['Int']['input']>;
};

export type JobBillingSum = {
  __typename?: 'JobBillingSum';
  charge_callback_amount_cents: Maybe<Scalars['Int']['output']>;
  charge_callback_hours: Maybe<Scalars['Float']['output']>;
  charge_double_amount_cents: Maybe<Scalars['Int']['output']>;
  charge_double_hours: Maybe<Scalars['Float']['output']>;
  charge_overtime_amount_cents: Maybe<Scalars['Int']['output']>;
  charge_overtime_hours: Maybe<Scalars['Float']['output']>;
  charge_regular_amount_cents: Maybe<Scalars['Int']['output']>;
  charge_regular_hours: Maybe<Scalars['Float']['output']>;
  charge_total_amount_cents: Maybe<Scalars['Int']['output']>;
  payout_callback_amount_cents: Maybe<Scalars['Float']['output']>;
  payout_callback_hours: Maybe<Scalars['Float']['output']>;
  payout_double_amount_cents: Maybe<Scalars['Float']['output']>;
  payout_double_hours: Maybe<Scalars['Float']['output']>;
  payout_overtime_amount_cents: Maybe<Scalars['Float']['output']>;
  payout_overtime_hours: Maybe<Scalars['Float']['output']>;
  payout_regular_amount_cents: Maybe<Scalars['Float']['output']>;
  payout_regular_hours: Maybe<Scalars['Float']['output']>;
  payout_total_amount_cents: Maybe<Scalars['Int']['output']>;
  total_breaks_hours: Maybe<Scalars['Float']['output']>;
  total_breaks_minutes: Maybe<Scalars['Int']['output']>;
  total_hours: Maybe<Scalars['Float']['output']>;
  total_on_call_hours: Maybe<Scalars['Float']['output']>;
};

export type JobBillingWhereInput = {
  balance_sheet_id: InputMaybe<Scalars['Int']['input']>;
  charge_total_amount_cents: InputMaybe<Scalars['Int']['input']>;
  created_at: InputMaybe<Scalars['DateTime']['input']>;
  id: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  invoice_id: InputMaybe<Scalars['Int']['input']>;
  job_id: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  payout_id: InputMaybe<Scalars['Int']['input']>;
  payout_total_amount_cents: InputMaybe<Scalars['Int']['input']>;
  updated_at: InputMaybe<Scalars['DateTime']['input']>;
};

export type JobIrregularity = {
  __typename?: 'JobIrregularity';
  approved_at: Maybe<Scalars['DateTime']['output']>;
  approved_by_account_id: Maybe<Scalars['Int']['output']>;
  created_at: Scalars['DateTime']['output'];
  id: Scalars['Int']['output'];
  irregularity_type: Scalars['String']['output'];
  job: Job;
  job_id: Scalars['Int']['output'];
  label: Scalars['String']['output'];
  status: Scalars['String']['output'];
  updated_at: Scalars['DateTime']['output'];
};

export type JobIrregularityOrderInput = {
  approved_at: InputMaybe<Scalars['Boolean']['input']>;
  approved_by_account_id: InputMaybe<Scalars['Int']['input']>;
  created_at: InputMaybe<Scalars['Boolean']['input']>;
  id: InputMaybe<Scalars['Boolean']['input']>;
  irregularity_type: InputMaybe<Scalars['String']['input']>;
  job_id: InputMaybe<Scalars['Boolean']['input']>;
  label: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Scalars['String']['input']>;
  updated_at: InputMaybe<Scalars['Boolean']['input']>;
};

export type JobIrregularityQueryInput = {
  filter: InputMaybe<JobIrregularityWhereInput>;
  orderBy: InputMaybe<JobIrregularityOrderInput>;
  page: InputMaybe<Scalars['Int']['input']>;
  perPage: InputMaybe<Scalars['Int']['input']>;
  search: InputMaybe<JobIrregularitySearchInput>;
};

export type JobIrregularitySearchInput = {
  approved_at: InputMaybe<Scalars['DateTime']['input']>;
  approved_by_account_id: InputMaybe<Scalars['Int']['input']>;
  id: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  irregularity_type: InputMaybe<Scalars['String']['input']>;
  job_id: InputMaybe<Scalars['Int']['input']>;
  label: InputMaybe<Scalars['String']['input']>;
  location_ids: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  /**
   * *Constraints:*
   * * Maximal length: `150`
   *
   */
  q: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Scalars['String']['input']>;
  statuses: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type JobIrregularityWhereInput = {
  approved_at: InputMaybe<Scalars['DateTime']['input']>;
  approved_by_account_id: InputMaybe<Scalars['Int']['input']>;
  created_at: InputMaybe<Scalars['DateTime']['input']>;
  id: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  irregularity_type: InputMaybe<Scalars['String']['input']>;
  job_id: InputMaybe<Scalars['Int']['input']>;
  label: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Scalars['String']['input']>;
};

export type JobOrderInput = {
  adjust_rate_calculator: InputMaybe<Scalars['Boolean']['input']>;
  admin_notes: InputMaybe<Scalars['Boolean']['input']>;
  approved_clock_in: InputMaybe<Scalars['Boolean']['input']>;
  approved_clock_out: InputMaybe<Scalars['Boolean']['input']>;
  assignment_id: InputMaybe<Scalars['Boolean']['input']>;
  bonus_one_time: InputMaybe<Scalars['Boolean']['input']>;
  bonus_one_time_cents: InputMaybe<Scalars['Boolean']['input']>;
  bonus_one_time_payout: InputMaybe<Scalars['Boolean']['input']>;
  bonus_one_time_payout_cents: InputMaybe<Scalars['Boolean']['input']>;
  booked_at: InputMaybe<Scalars['Boolean']['input']>;
  canceled_by_location: InputMaybe<Scalars['Boolean']['input']>;
  canceled_by_professional: InputMaybe<Scalars['Boolean']['input']>;
  charge_base_hourly_rate_cents: InputMaybe<Scalars['Boolean']['input']>;
  charge_bonus_cents: InputMaybe<Scalars['Boolean']['input']>;
  charge_on_call_hourly_rate_cents: InputMaybe<Scalars['Boolean']['input']>;
  cleared_no_show: InputMaybe<Scalars['Boolean']['input']>;
  created_at: InputMaybe<Scalars['Boolean']['input']>;
  detail: InputMaybe<Scalars['Boolean']['input']>;
  ends_date: InputMaybe<Scalars['Boolean']['input']>;
  ends_time: InputMaybe<Scalars['Boolean']['input']>;
  ends_time_: InputMaybe<Scalars['Boolean']['input']>;
  estimated_rate_cents: InputMaybe<Scalars['Boolean']['input']>;
  extended_by_location: InputMaybe<Scalars['Boolean']['input']>;
  extended_by_professional: InputMaybe<Scalars['Boolean']['input']>;
  id: InputMaybe<Scalars['Boolean']['input']>;
  invoice_id: InputMaybe<Scalars['Boolean']['input']>;
  job_track_id: InputMaybe<Scalars['Boolean']['input']>;
  market_id: InputMaybe<Scalars['Boolean']['input']>;
  market_name: InputMaybe<Scalars['Boolean']['input']>;
  override_minimum: InputMaybe<Scalars['Boolean']['input']>;
  override_professional_specialty_requirement: InputMaybe<Scalars['Boolean']['input']>;
  parking_reimbursement_cents: InputMaybe<Scalars['Boolean']['input']>;
  patient_population: InputMaybe<Scalars['Boolean']['input']>;
  payout_base_hourly_rate_cents: InputMaybe<Scalars['Boolean']['input']>;
  payout_bonus_cents: InputMaybe<Scalars['Boolean']['input']>;
  payout_on_call_hourly_rate_cents: InputMaybe<Scalars['Boolean']['input']>;
  phone_number: InputMaybe<Scalars['Boolean']['input']>;
  position_display_names: InputMaybe<Scalars['Boolean']['input']>;
  primary_phone_number: InputMaybe<Scalars['Boolean']['input']>;
  professional_can_cancel: InputMaybe<Scalars['Boolean']['input']>;
  professional_id: InputMaybe<Scalars['Boolean']['input']>;
  rate_calculator_id: InputMaybe<Scalars['Boolean']['input']>;
  rate_currency: InputMaybe<Scalars['Boolean']['input']>;
  release_to_platform: InputMaybe<Scalars['Boolean']['input']>;
  specialty_labels: InputMaybe<Scalars['Boolean']['input']>;
  starts_date: InputMaybe<Scalars['Boolean']['input']>;
  starts_time: InputMaybe<Scalars['Boolean']['input']>;
  starts_time_: InputMaybe<Scalars['Boolean']['input']>;
  state_: InputMaybe<Scalars['Boolean']['input']>;
  status: InputMaybe<Scalars['Boolean']['input']>;
  surgery_type_display_names: InputMaybe<Scalars['Boolean']['input']>;
  suspicious: InputMaybe<Scalars['Boolean']['input']>;
  updated_at: InputMaybe<Scalars['Boolean']['input']>;
  updated_in_cancellation_window: InputMaybe<Scalars['Boolean']['input']>;
  user_id: InputMaybe<Scalars['Boolean']['input']>;
};

export type JobPriceDifferential = {
  __typename?: 'JobPriceDifferential';
  id: Scalars['Int']['output'];
  job: Job;
  recommendation_used: Scalars['Boolean']['output'];
  slug: Scalars['String']['output'];
  value_cents: Scalars['Int']['output'];
};

export type JobPriceDifferentialOrderInput = {
  created_at: InputMaybe<Scalars['Boolean']['input']>;
  id: InputMaybe<Scalars['Boolean']['input']>;
  job_id: InputMaybe<Scalars['Boolean']['input']>;
  recommendation_used: InputMaybe<Scalars['Boolean']['input']>;
  slug: InputMaybe<Scalars['Boolean']['input']>;
  updated_at: InputMaybe<Scalars['Boolean']['input']>;
  value_cents: InputMaybe<Scalars['Boolean']['input']>;
};

export type JobPriceDifferentialQueryInput = {
  filter: InputMaybe<JobPriceDifferentialWhereInput>;
  orderBy: InputMaybe<JobPriceDifferentialOrderInput>;
  page: InputMaybe<Scalars['Int']['input']>;
  perPage: InputMaybe<Scalars['Int']['input']>;
  search: InputMaybe<JobPriceDifferentialSearchInput>;
};

export type JobPriceDifferentialSearchInput = {
  job_id: InputMaybe<Scalars['Int']['input']>;
  recommendation_used: InputMaybe<Scalars['Boolean']['input']>;
  slug: InputMaybe<Scalars['String']['input']>;
  value_cents: InputMaybe<Scalars['Int']['input']>;
};

export type JobPriceDifferentialWhereInput = {
  created_at: InputMaybe<Scalars['DateTime']['input']>;
  id: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  job_id: InputMaybe<Scalars['Int']['input']>;
  recommendation_used: InputMaybe<Scalars['Boolean']['input']>;
  slug: InputMaybe<Scalars['String']['input']>;
  updated_at: InputMaybe<Scalars['DateTime']['input']>;
  value_cents: InputMaybe<Scalars['Int']['input']>;
};

export type JobProfile = {
  __typename?: 'JobProfile';
  active: Scalars['Boolean']['output'];
  agency_id: Maybe<Scalars['Int']['output']>;
  available_for_booking_by_favorite_professionals_at: Maybe<Scalars['DateTime']['output']>;
  available_for_booking_by_professionals_at: Maybe<Scalars['DateTime']['output']>;
  bonus_one_time_cents: Scalars['Int']['output'];
  charge_base_hourly_rate_cents: Scalars['Int']['output'];
  charge_callback_multiplier: Maybe<Scalars['Float']['output']>;
  charge_double_overtime_multiplier: Maybe<Scalars['Float']['output']>;
  charge_max_daily_ot_hours: Maybe<Scalars['Float']['output']>;
  charge_max_daily_regular_hours: Maybe<Scalars['Float']['output']>;
  charge_max_weekly_regular_hours: Maybe<Scalars['Float']['output']>;
  charge_on_call_hourly_rate_cents: Scalars['Int']['output'];
  charge_overtime_multiplier: Scalars['Float']['output'];
  charge_seventh_day_rule_enabled: Maybe<Scalars['Boolean']['output']>;
  condition_ids: Array<Scalars['Int']['output']>;
  conditions: Array<Condition>;
  created_at: Scalars['DateTime']['output'];
  id: Scalars['Int']['output'];
  job: Job;
  job_id: Scalars['Int']['output'];
  /** @deprecated Field no longer supported */
  marketplace: Scalars['Boolean']['output'];
  override_rates: Scalars['Boolean']['output'];
  payout_base_hourly_rate_cents: Scalars['Int']['output'];
  payout_callback_multiplier: Maybe<Scalars['Float']['output']>;
  payout_double_overtime_multiplier: Maybe<Scalars['Float']['output']>;
  payout_facility_bonus_cents: Scalars['Int']['output'];
  payout_kind: Scalars['String']['output'];
  payout_max_daily_ot_hours: Maybe<Scalars['Float']['output']>;
  payout_max_daily_regular_hours: Maybe<Scalars['Float']['output']>;
  payout_max_weekly_regular_hours: Maybe<Scalars['Float']['output']>;
  payout_on_call_hourly_rate_cents: Scalars['Int']['output'];
  payout_overtime_multiplier: Scalars['Float']['output'];
  payout_seventh_day_rule_enabled: Maybe<Scalars['Boolean']['output']>;
  payout_taxable_hourly_rate_cents: Scalars['Int']['output'];
  professional_type: Scalars['String']['output'];
  published_to_professionals_at: Maybe<Scalars['DateTime']['output']>;
  updated_at: Scalars['DateTime']['output'];
};

export type JobProfileOrderInput = {
  id: InputMaybe<Scalars['Boolean']['input']>;
  job_id: InputMaybe<Scalars['Boolean']['input']>;
};

export type JobProfileQueryInput = {
  filter: InputMaybe<JobProfileWhereInput>;
  orderBy: InputMaybe<JobProfileOrderInput>;
  page: InputMaybe<Scalars['Int']['input']>;
  perPage: InputMaybe<Scalars['Int']['input']>;
  search: InputMaybe<JobProfileSearchInput>;
};

export type JobProfileSearchInput = {
  agency_id: InputMaybe<Scalars['Int']['input']>;
  job_id: InputMaybe<Scalars['Int']['input']>;
};

export type JobProfileWhereInput = {
  id: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  job_id: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};

export type JobPublishingGroup = {
  __typename?: 'JobPublishingGroup';
  id: Scalars['Int']['output'];
  publish_to_marketplace_offset_hours: Maybe<Scalars['Int']['output']>;
};

export type JobPublishingGroupOrderInput = {
  id: InputMaybe<Scalars['Boolean']['input']>;
};

export type JobPublishingGroupQueryInput = {
  filter: InputMaybe<JobPublishingGroupWhereInput>;
  orderBy: InputMaybe<JobPublishingGroupOrderInput>;
  page: InputMaybe<Scalars['Int']['input']>;
  perPage: InputMaybe<Scalars['Int']['input']>;
  search: InputMaybe<JobPublishingGroupSearchInput>;
};

export type JobPublishingGroupSearchInput = {
  id: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  /**
   * *Constraints:*
   * * Maximal length: `150`
   *
   */
  q: InputMaybe<Scalars['String']['input']>;
};

export type JobPublishingGroupWhereInput = {
  id: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};

export type JobQueryInput = {
  filter: InputMaybe<JobWhereInput>;
  orderBy: InputMaybe<JobOrderInput>;
  page: InputMaybe<Scalars['Int']['input']>;
  perPage: InputMaybe<Scalars['Int']['input']>;
  search: InputMaybe<JobSearchInput>;
};

export type JobRateTrackedEvent = {
  __typename?: 'JobRateTrackedEvent';
  charge_min_hourly_rate_cents: Maybe<Scalars['Int']['output']>;
  charge_posted_hourly_rate_cents: Scalars['Int']['output'];
  charge_recommended_hourly_rate_cents: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  job: Job;
  price_differentials: Maybe<Scalars['JSON']['output']>;
};

export type JobRateTrackedEventOrderInput = {
  charge_min_hourly_rate_cents: InputMaybe<Scalars['Boolean']['input']>;
  charge_posted_hourly_rate_cents: InputMaybe<Scalars['Boolean']['input']>;
  charge_recommended_hourly_rate_cents: InputMaybe<Scalars['Boolean']['input']>;
  created_at: InputMaybe<Scalars['Boolean']['input']>;
  id: InputMaybe<Scalars['Boolean']['input']>;
  job_id: InputMaybe<Scalars['Boolean']['input']>;
  updated_at: InputMaybe<Scalars['Boolean']['input']>;
};

export type JobRateTrackedEventQueryInput = {
  filter: InputMaybe<JobRateTrackedEventWhereInput>;
  orderBy: InputMaybe<JobRateTrackedEventOrderInput>;
  page: InputMaybe<Scalars['Int']['input']>;
  perPage: InputMaybe<Scalars['Int']['input']>;
  search: InputMaybe<JobRateTrackedEventSearchInput>;
};

export type JobRateTrackedEventSearchInput = {
  charge_min_hourly_rate_cents: InputMaybe<Scalars['Int']['input']>;
  charge_posted_hourly_rate_cents: InputMaybe<Scalars['Int']['input']>;
  charge_recommended_hourly_rate_cents: InputMaybe<Scalars['Int']['input']>;
  job_id: InputMaybe<Scalars['Int']['input']>;
};

export type JobRateTrackedEventWhereInput = {
  charge_min_hourly_rate_cents: InputMaybe<Scalars['Int']['input']>;
  charge_posted_hourly_rate_cents: InputMaybe<Scalars['Int']['input']>;
  charge_recommended_hourly_rate_cents: InputMaybe<Scalars['Int']['input']>;
  created_at: InputMaybe<Scalars['DateTime']['input']>;
  id: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  job_id: InputMaybe<Scalars['Int']['input']>;
  updated_at: InputMaybe<Scalars['DateTime']['input']>;
};

export enum JobSchedule {
  Day = 'day',
  Evening = 'evening',
  Night = 'night'
}

export enum JobSearchByInput {
  Jobs = 'jobs',
  Professionals = 'professionals',
  Users = 'users'
}

export type JobSearchInput = {
  account_id: InputMaybe<Scalars['Int']['input']>;
  account_manager_id: InputMaybe<Scalars['Int']['input']>;
  agency_id: InputMaybe<Scalars['Int']['input']>;
  all_position_ids: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  available_job_sort: InputMaybe<AvailableJobSort>;
  billing_group_plan: InputMaybe<Scalars['String']['input']>;
  block_all: InputMaybe<Scalars['Boolean']['input']>;
  blocked_times: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  booked_by_agency: InputMaybe<Scalars['Boolean']['input']>;
  daily_rate_cents: InputMaybe<Scalars['Int']['input']>;
  default_agency_sort: InputMaybe<Scalars['Boolean']['input']>;
  distance_check: InputMaybe<DistanceCheckInput>;
  duration_sort: InputMaybe<Scalars['String']['input']>;
  ends_date: InputMaybe<Scalars['Date']['input']>;
  ends_time_from: InputMaybe<Scalars['DateTime']['input']>;
  ends_time_to: InputMaybe<Scalars['DateTime']['input']>;
  filter_specialty_ids: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  first_job_booked: InputMaybe<Scalars['Boolean']['input']>;
  first_job_posted: InputMaybe<Scalars['Boolean']['input']>;
  has_approvals_for_account_id: InputMaybe<Scalars['Int']['input']>;
  has_pay_boost: InputMaybe<Scalars['Boolean']['input']>;
  ignore_location_ids: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  invoice_id: InputMaybe<Scalars['Int']['input']>;
  job_type: InputMaybe<Scalars['String']['input']>;
  location_ids: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  location_type_id: InputMaybe<Scalars['Int']['input']>;
  location_type_ids: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  market_ids: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  no_breaks: InputMaybe<Scalars['Boolean']['input']>;
  not_draft: InputMaybe<Scalars['Boolean']['input']>;
  not_void: InputMaybe<Scalars['Boolean']['input']>;
  pay_sort: InputMaybe<Scalars['String']['input']>;
  payout_id: InputMaybe<Scalars['Int']['input']>;
  payout_kind: InputMaybe<Scalars['String']['input']>;
  position_ids: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  pro_can_book_sort_id: InputMaybe<Scalars['Int']['input']>;
  professional_account_id: InputMaybe<Scalars['Int']['input']>;
  professional_available_id: InputMaybe<Scalars['Int']['input']>;
  professional_id: InputMaybe<Scalars['Int']['input']>;
  professional_id_requested_by_facility: InputMaybe<Scalars['Int']['input']>;
  /**
   * *Constraints:*
   * * Maximal length: `150`
   *
   */
  q: InputMaybe<Scalars['String']['input']>;
  saas_check: InputMaybe<SaasCheckInput>;
  sales_associate_id: InputMaybe<Scalars['Int']['input']>;
  schedule: InputMaybe<Array<InputMaybe<JobSchedule>>>;
  scheduler_location_ids: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  search_by: InputMaybe<JobSearchByInput>;
  shift_hours: InputMaybe<Scalars['Int']['input']>;
  shift_length: InputMaybe<ShiftLengthInput>;
  specialty_ids: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  starts_date: InputMaybe<Scalars['Date']['input']>;
  starts_or_ends_date: InputMaybe<Scalars['Date']['input']>;
  starts_time: InputMaybe<Scalars['DateTime']['input']>;
  status: InputMaybe<Scalars['String']['input']>;
  statuses: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  time_of_day: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  track_unpaid_breaks: InputMaybe<Scalars['Boolean']['input']>;
  used_favorites: InputMaybe<Scalars['Boolean']['input']>;
  validate_favorite_only_professional_id: InputMaybe<Scalars['Int']['input']>;
  validate_favorite_professional_id: InputMaybe<Scalars['Int']['input']>;
};

export enum JobStatus {
  Active = 'active',
  Booked = 'booked',
  Canceled = 'canceled',
  CanceledWithFee = 'canceled_with_fee',
  ClockedIn = 'clocked_in',
  ClockedOut = 'clocked_out',
  Completed = 'completed',
  Disputed = 'disputed',
  Draft = 'draft',
  HeldForDisputeReview = 'held_for_dispute_review',
  LateCancellation = 'late_cancellation',
  MissedShift = 'missed_shift',
  NoShow = 'no_show',
  Open = 'open',
  Unavailable = 'unavailable',
  Unfilled = 'unfilled',
  Void = 'void'
}

export type JobStatusLocationCountsInput = {
  location_ids: Array<Scalars['Int']['input']>;
  statuses: Array<JobStatus>;
};

export type JobStatusLocationCountsResult = {
  __typename?: 'JobStatusLocationCountsResult';
  job_count: Scalars['Int']['output'];
  location_id: Scalars['Int']['output'];
};

export type JobSurgeryType = {
  __typename?: 'JobSurgeryType';
  created_at: Scalars['DateTime']['output'];
  id: Scalars['Int']['output'];
  job: Maybe<Job>;
  surgeryType: Maybe<SurgeryType>;
  updated_at: Scalars['DateTime']['output'];
};

export type JobSurgeryTypeQueryInput = {
  filter: InputMaybe<JobSurgeryTypeWhereInput>;
  page: InputMaybe<Scalars['Int']['input']>;
  perPage: InputMaybe<Scalars['Int']['input']>;
  search: InputMaybe<DefaultSearchInput>;
};

export type JobSurgeryTypeWhereInput = {
  created_at: InputMaybe<Scalars['DateTime']['input']>;
  id: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  updated_at: InputMaybe<Scalars['DateTime']['input']>;
};

export type JobTemplate = {
  __typename?: 'JobTemplate';
  covid_care: Maybe<Scalars['Boolean']['output']>;
  created_at: Scalars['DateTime']['output'];
  detail: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  kind: Maybe<Scalars['String']['output']>;
  location: Maybe<Location>;
  location_id: Maybe<Scalars['Int']['output']>;
  patient_population: Maybe<Scalars['String']['output']>;
  positions: Maybe<Array<Maybe<Position>>>;
  posting_field_contents: Maybe<Scalars['JSON']['output']>;
  specialties: Maybe<Array<Maybe<Specialty>>>;
  surgery_types: Maybe<Array<Maybe<SurgeryType>>>;
  updated_at: Scalars['DateTime']['output'];
};

export type JobTemplateOrderInput = {
  covid_care: InputMaybe<Scalars['Boolean']['input']>;
  created_at: InputMaybe<Scalars['Boolean']['input']>;
  detail: InputMaybe<Scalars['Boolean']['input']>;
  id: InputMaybe<Scalars['Boolean']['input']>;
  kind: InputMaybe<Scalars['Boolean']['input']>;
  patient_population: InputMaybe<Scalars['Boolean']['input']>;
  updated_at: InputMaybe<Scalars['Boolean']['input']>;
  user_id: InputMaybe<Scalars['Boolean']['input']>;
};

export type JobTemplateQueryInput = {
  filter: InputMaybe<JobTemplateWhereInput>;
  orderBy: InputMaybe<JobTemplateOrderInput>;
  page: InputMaybe<Scalars['Int']['input']>;
  perPage: InputMaybe<Scalars['Int']['input']>;
  search: InputMaybe<DefaultSearchInput>;
};

export type JobTemplateWhereInput = {
  covid_care: InputMaybe<Scalars['Boolean']['input']>;
  created_at: InputMaybe<Scalars['DateTime']['input']>;
  detail: InputMaybe<Scalars['String']['input']>;
  id: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  kind: InputMaybe<Scalars['Int']['input']>;
  location_id: InputMaybe<Scalars['Int']['input']>;
  location_ids: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  patient_population: InputMaybe<Scalars['Int']['input']>;
  position_id: InputMaybe<Scalars['Int']['input']>;
  updated_at: InputMaybe<Scalars['DateTime']['input']>;
  user_id: InputMaybe<Scalars['Int']['input']>;
};

export type JobTrack = {
  __typename?: 'JobTrack';
  complete: Maybe<Scalars['Boolean']['output']>;
  created_at: Scalars['DateTime']['output'];
  id: Scalars['Int']['output'];
  job: Maybe<Job>;
  professional_id: Maybe<Scalars['Int']['output']>;
  updated_at: Scalars['DateTime']['output'];
  user_id: Maybe<Scalars['Int']['output']>;
};

export type JobTrackOrderInput = {
  complete: InputMaybe<Scalars['Boolean']['input']>;
  created_at: InputMaybe<Scalars['Boolean']['input']>;
  id: InputMaybe<Scalars['Boolean']['input']>;
  job_id: InputMaybe<Scalars['Boolean']['input']>;
  professional_id: InputMaybe<Scalars['Boolean']['input']>;
  updated_at: InputMaybe<Scalars['Boolean']['input']>;
  user_id: InputMaybe<Scalars['Boolean']['input']>;
};

export type JobTrackQueryInput = {
  filter: InputMaybe<JobTrackWhereInput>;
  orderBy: InputMaybe<JobTrackOrderInput>;
  page: InputMaybe<Scalars['Int']['input']>;
  perPage: InputMaybe<Scalars['Int']['input']>;
  search: InputMaybe<DefaultSearchInput>;
};

export type JobTrackWhereInput = {
  complete: InputMaybe<Scalars['Boolean']['input']>;
  created_at: InputMaybe<Scalars['DateTime']['input']>;
  id: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  job_id: InputMaybe<Scalars['Int']['input']>;
  professional_id: InputMaybe<Scalars['Int']['input']>;
  updated_at: InputMaybe<Scalars['DateTime']['input']>;
  user_id: InputMaybe<Scalars['Int']['input']>;
};

export type JobWhereInput = {
  adjust_rate_calculator: InputMaybe<Scalars['Boolean']['input']>;
  admin_notes: InputMaybe<Scalars['String']['input']>;
  approved_clock_in: InputMaybe<Scalars['DateTime']['input']>;
  approved_clock_out: InputMaybe<Scalars['DateTime']['input']>;
  assignment_id: InputMaybe<Scalars['Int']['input']>;
  attachment: InputMaybe<Scalars['String']['input']>;
  bonus_one_time: InputMaybe<Scalars['Int']['input']>;
  bonus_one_time_payout: InputMaybe<Scalars['Int']['input']>;
  bonus_one_time_payout_cents: InputMaybe<Scalars['Int']['input']>;
  booked_at: InputMaybe<Scalars['DateTime']['input']>;
  canceled_by_location: InputMaybe<Scalars['Boolean']['input']>;
  canceled_by_professional: InputMaybe<Scalars['Boolean']['input']>;
  charge_base_hourly_rate_cents: InputMaybe<Scalars['Int']['input']>;
  charge_bonus_cents: InputMaybe<Scalars['Int']['input']>;
  charge_on_call_hourly_rate_cents: InputMaybe<Scalars['Int']['input']>;
  cleared_no_show: InputMaybe<Scalars['Boolean']['input']>;
  covid_care: InputMaybe<Scalars['Boolean']['input']>;
  created_at: InputMaybe<Scalars['DateTime']['input']>;
  detail: InputMaybe<Scalars['String']['input']>;
  ends_date: InputMaybe<Scalars['Date']['input']>;
  ends_time: InputMaybe<Scalars['DateTime']['input']>;
  ends_time_: InputMaybe<Scalars['DateTime']['input']>;
  estimated_rate_cents: InputMaybe<Scalars['Int']['input']>;
  extended_by_location: InputMaybe<Scalars['Boolean']['input']>;
  extended_by_professional: InputMaybe<Scalars['Boolean']['input']>;
  facility_number: InputMaybe<Scalars['String']['input']>;
  id: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  invoice_id: InputMaybe<Scalars['Int']['input']>;
  is_w2: InputMaybe<Scalars['Boolean']['input']>;
  job_billing_id: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  job_track_id: InputMaybe<Scalars['Int']['input']>;
  location_id: InputMaybe<Scalars['Int']['input']>;
  market_id: InputMaybe<Scalars['Int']['input']>;
  market_name: InputMaybe<Scalars['String']['input']>;
  override_minimum: InputMaybe<Scalars['Boolean']['input']>;
  override_professional_specialty_requirement: InputMaybe<Scalars['Boolean']['input']>;
  parking_reimbursement_cents: InputMaybe<Scalars['Int']['input']>;
  patient_population: InputMaybe<Scalars['String']['input']>;
  payout_base_hourly_rate_cents: InputMaybe<Scalars['Int']['input']>;
  payout_bonus_cents: InputMaybe<Scalars['Int']['input']>;
  payout_on_call_hourly_rate_cents: InputMaybe<Scalars['Int']['input']>;
  position_display_names: InputMaybe<Scalars['String']['input']>;
  primary_phone_number: InputMaybe<Scalars['String']['input']>;
  primary_publishing_group_member: InputMaybe<Scalars['Boolean']['input']>;
  professional_can_cancel: InputMaybe<Scalars['Boolean']['input']>;
  professional_id: InputMaybe<Scalars['Int']['input']>;
  professional_number: InputMaybe<Scalars['String']['input']>;
  rate_calculator_id: InputMaybe<Scalars['Int']['input']>;
  rate_currency: InputMaybe<Scalars['String']['input']>;
  release_audience: InputMaybe<Scalars['String']['input']>;
  release_to_platform: InputMaybe<Scalars['Int']['input']>;
  specialty_labels: InputMaybe<Scalars['String']['input']>;
  starts_date: InputMaybe<Scalars['Date']['input']>;
  starts_time: InputMaybe<Scalars['DateTime']['input']>;
  starts_time_: InputMaybe<Scalars['DateTime']['input']>;
  state_: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Scalars['String']['input']>;
  surgery_type_display_names: InputMaybe<Scalars['String']['input']>;
  suspicious: InputMaybe<Scalars['Boolean']['input']>;
  timecard_id: InputMaybe<Scalars['Int']['input']>;
  track_unpaid_breaks: InputMaybe<Scalars['Boolean']['input']>;
  updated_at: InputMaybe<Scalars['DateTime']['input']>;
  updated_in_cancellation_window: InputMaybe<Scalars['Boolean']['input']>;
  user_id: InputMaybe<Scalars['Int']['input']>;
};

export type JobsBoard = {
  __typename?: 'JobsBoard';
  active_job: Scalars['Boolean']['output'];
  board: Scalars['String']['output'];
  category: Maybe<Scalars['String']['output']>;
  city: Scalars['String']['output'];
  created_at: Scalars['DateTime']['output'];
  description: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  job_type: Scalars['String']['output'];
  jobs_board_positions: Maybe<Array<Maybe<JobsBoardPosition>>>;
  kind: Maybe<Scalars['String']['output']>;
  market: Maybe<Market>;
  market_id: Maybe<Scalars['Int']['output']>;
  position_names: Maybe<Scalars['String']['output']>;
  positions: Maybe<Array<Maybe<Position>>>;
  requirements_description: Maybe<Scalars['String']['output']>;
  role: Scalars['String']['output'];
  salary: Scalars['String']['output'];
  state: Scalars['String']['output'];
  title: Scalars['String']['output'];
  updated_at: Scalars['DateTime']['output'];
  zip: Maybe<Scalars['String']['output']>;
};

export type JobsBoardOrderInput = {
  active_job: InputMaybe<Scalars['Boolean']['input']>;
  board: InputMaybe<Scalars['Boolean']['input']>;
  category: InputMaybe<Scalars['Boolean']['input']>;
  city: InputMaybe<Scalars['Boolean']['input']>;
  created_at: InputMaybe<Scalars['Boolean']['input']>;
  description: InputMaybe<Scalars['Boolean']['input']>;
  id: InputMaybe<Scalars['Boolean']['input']>;
  job_type: InputMaybe<Scalars['Boolean']['input']>;
  market_id: InputMaybe<Scalars['Int']['input']>;
  position_names: InputMaybe<Scalars['Boolean']['input']>;
  role: InputMaybe<Scalars['Boolean']['input']>;
  salary: InputMaybe<Scalars['Boolean']['input']>;
  state: InputMaybe<Scalars['Boolean']['input']>;
  title: InputMaybe<Scalars['Boolean']['input']>;
  updated_at: InputMaybe<Scalars['Boolean']['input']>;
  zip: InputMaybe<Scalars['Boolean']['input']>;
};

export type JobsBoardPosition = {
  __typename?: 'JobsBoardPosition';
  created_at: Scalars['DateTime']['output'];
  id: Scalars['Int']['output'];
  jobs_board: Maybe<JobsBoard>;
  position: Maybe<Position>;
  updated_at: Scalars['DateTime']['output'];
};

export type JobsBoardPositionQueryInput = {
  filter: InputMaybe<JobsBoardPositionWhereInput>;
  page: InputMaybe<Scalars['Int']['input']>;
  perPage: InputMaybe<Scalars['Int']['input']>;
  search: InputMaybe<DefaultSearchInput>;
};

export type JobsBoardPositionWhereInput = {
  created_at: InputMaybe<Scalars['DateTime']['input']>;
  id: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  updated_at: InputMaybe<Scalars['DateTime']['input']>;
};

export type JobsBoardQueryInput = {
  filter: InputMaybe<JobsBoardWhereInput>;
  orderBy: InputMaybe<JobsBoardOrderInput>;
  page: InputMaybe<Scalars['Int']['input']>;
  perPage: InputMaybe<Scalars['Int']['input']>;
  search: InputMaybe<JobsBoardSearchInput>;
};

export type JobsBoardSearchInput = {
  active_job: InputMaybe<Scalars['Boolean']['input']>;
  city: InputMaybe<Scalars['String']['input']>;
  market_id: InputMaybe<Scalars['String']['input']>;
  position_ids: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  /**
   * *Constraints:*
   * * Maximal length: `150`
   *
   */
  q: InputMaybe<Scalars['String']['input']>;
  state: InputMaybe<Scalars['String']['input']>;
};

export type JobsBoardWhereInput = {
  active_job: InputMaybe<Scalars['Boolean']['input']>;
  board: InputMaybe<Scalars['String']['input']>;
  category: InputMaybe<Scalars['String']['input']>;
  city: InputMaybe<Scalars['String']['input']>;
  created_at: InputMaybe<Scalars['DateTime']['input']>;
  description: InputMaybe<Scalars['String']['input']>;
  id: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  job_type: InputMaybe<Scalars['String']['input']>;
  market_id: InputMaybe<Scalars['Int']['input']>;
  position_names: InputMaybe<Scalars['String']['input']>;
  role: InputMaybe<Scalars['String']['input']>;
  salary: InputMaybe<Scalars['String']['input']>;
  state: InputMaybe<Scalars['String']['input']>;
  title: InputMaybe<Scalars['String']['input']>;
  updated_at: InputMaybe<Scalars['DateTime']['input']>;
  zip: InputMaybe<Scalars['String']['input']>;
};

export type JobsTotals = {
  __typename?: 'JobsTotals';
  filtered_break_hours: Maybe<Scalars['Float']['output']>;
  filtered_double_hours: Maybe<Scalars['Float']['output']>;
  filtered_overtime_hours: Maybe<Scalars['Float']['output']>;
  filtered_regular_hours: Maybe<Scalars['Float']['output']>;
  filtered_total_hours: Maybe<Scalars['Float']['output']>;
};

export type LastCancellation = {
  __typename?: 'LastCancellation';
  created_at: Maybe<Scalars['DateTime']['output']>;
  note: Maybe<Scalars['String']['output']>;
  other_reason: Maybe<Scalars['String']['output']>;
  reason: Maybe<Scalars['String']['output']>;
};

export type LastWeekJobDetails = {
  __typename?: 'LastWeekJobDetails';
  median_booked_jobs_time_in_minutes: Scalars['Int']['output'];
  posted_jobs_count: Scalars['Int']['output'];
};

export type LineOfCredit = {
  __typename?: 'LineOfCredit';
  amount: Maybe<Scalars['Int']['output']>;
  amount_cents: Maybe<Scalars['Int']['output']>;
  created_at: Maybe<Scalars['DateTime']['output']>;
  id: Maybe<Scalars['Int']['output']>;
  updated_at: Maybe<Scalars['DateTime']['output']>;
};

export type LineOfCreditOrderInput = {
  amount: InputMaybe<Scalars['Boolean']['input']>;
  amount_cents: InputMaybe<Scalars['Boolean']['input']>;
  created_at: InputMaybe<Scalars['Boolean']['input']>;
  id: InputMaybe<Scalars['Boolean']['input']>;
  updated_at: InputMaybe<Scalars['Boolean']['input']>;
};

export type LineOfCreditQueryInput = {
  filter: InputMaybe<LineOfCreditWhereInput>;
  orderBy: InputMaybe<LineOfCreditOrderInput>;
  page: InputMaybe<Scalars['Int']['input']>;
  perPage: InputMaybe<Scalars['Int']['input']>;
  search: InputMaybe<DefaultSearchInput>;
};

export type LineOfCreditWhereInput = {
  amount: InputMaybe<Scalars['Int']['input']>;
  amount_cents: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  created_at: InputMaybe<Scalars['DateTime']['input']>;
  id: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  updated_at: InputMaybe<Scalars['DateTime']['input']>;
};

export type ListMeta = {
  __typename?: 'ListMeta';
  count: Maybe<Scalars['Int']['output']>;
};

export type LocalRateRule = {
  __typename?: 'LocalRateRule';
  applies_to: Scalars['String']['output'];
  force_draft: Maybe<Scalars['Boolean']['output']>;
  health_system_id: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  local_okay: Scalars['Boolean']['output'];
  location_id: Maybe<Scalars['Int']['output']>;
  mileage_cutoff: Maybe<Scalars['Int']['output']>;
  msp_id: Maybe<Scalars['Int']['output']>;
  offset_amount_cents: Maybe<Scalars['Int']['output']>;
  offset_percentage: Maybe<Scalars['Float']['output']>;
  rate_origin: Maybe<Scalars['String']['output']>;
  vms_type_id: Maybe<Scalars['Int']['output']>;
};

export type LocalRateRuleOrderInput = {
  applies_to: InputMaybe<Scalars['Boolean']['input']>;
  force_draft: InputMaybe<Scalars['Boolean']['input']>;
  health_system_id: InputMaybe<Scalars['Boolean']['input']>;
  id: InputMaybe<Scalars['Boolean']['input']>;
  local_okay: InputMaybe<Scalars['Boolean']['input']>;
  location_id: InputMaybe<Scalars['Boolean']['input']>;
  mileage_cutoff: InputMaybe<Scalars['Boolean']['input']>;
  msp_id: InputMaybe<Scalars['Boolean']['input']>;
  rate_origin: InputMaybe<Scalars['Boolean']['input']>;
  vms_type_id: InputMaybe<Scalars['Boolean']['input']>;
};

export type LocalRateRuleQueryInput = {
  filter: InputMaybe<LocalRateRuleWhereInput>;
  orderBy: InputMaybe<LocalRateRuleOrderInput>;
  page: InputMaybe<Scalars['Int']['input']>;
  perPage: InputMaybe<Scalars['Int']['input']>;
  search: InputMaybe<LocalRateRuleSearchInput>;
};

export type LocalRateRuleSearchInput = {
  id: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};

export type LocalRateRuleWhereInput = {
  applies_to: InputMaybe<Scalars['String']['input']>;
  force_draft: InputMaybe<Scalars['Boolean']['input']>;
  health_system_id: InputMaybe<Scalars['Int']['input']>;
  id: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  local_okay: InputMaybe<Scalars['Boolean']['input']>;
  location_id: InputMaybe<Scalars['Int']['input']>;
  mileage_cutoff: InputMaybe<Scalars['Int']['input']>;
  msp_id: InputMaybe<Scalars['Int']['input']>;
  offset_amount_cents: InputMaybe<Scalars['Int']['input']>;
  offset_percentage: InputMaybe<Scalars['Int']['input']>;
  rate_origin: InputMaybe<Scalars['String']['input']>;
  vms_type_id: InputMaybe<Scalars['Int']['input']>;
};

export type Location = {
  __typename?: 'Location';
  about: Maybe<Scalars['String']['output']>;
  account_locations: Maybe<Array<Maybe<AccountLocation>>>;
  account_manager: Maybe<Administrator>;
  account_manager_id: Maybe<Scalars['Int']['output']>;
  accounts: Maybe<Array<Maybe<Account>>>;
  address_city: Maybe<Scalars['String']['output']>;
  address_first: Maybe<Scalars['String']['output']>;
  address_second: Maybe<Scalars['String']['output']>;
  address_zip: Maybe<Scalars['String']['output']>;
  agencies: Maybe<Array<Maybe<Agency>>>;
  allow_assignments: Scalars['Boolean']['output'];
  allow_per_diem_jobs: Scalars['Boolean']['output'];
  allow_reserved_for_favorites: Scalars['Boolean']['output'];
  approval_free_late_clock_out_grace_period_minutes: Scalars['Int']['output'];
  billing_groups: Maybe<Array<Maybe<BillingGroup>>>;
  cancellation_fee_charge_hours: Maybe<Scalars['Int']['output']>;
  cancellation_fee_window: Maybe<Scalars['Int']['output']>;
  clinical_contacts: Maybe<Array<Maybe<ClinicalContact>>>;
  clock_in_early_window: Scalars['Int']['output'];
  /** @deprecated to be removed in favor of maximum_late_clock_out_grace_period_minutes */
  clock_out_late_window: Maybe<Scalars['Int']['output']>;
  common_shift_length_hours: Scalars['Int']['output'];
  company: Maybe<Company>;
  company_id: Maybe<Scalars['Int']['output']>;
  coordinates: Maybe<Coordinates>;
  covid_requirement: Maybe<Scalars['String']['output']>;
  created_at: Maybe<Scalars['DateTime']['output']>;
  detailed_notes: Maybe<Scalars['String']['output']>;
  drug_screening_required: Maybe<Scalars['Boolean']['output']>;
  enable_geo_fence: Scalars['Boolean']['output'];
  external_id: Maybe<Scalars['String']['output']>;
  facility_can_adjust_times: Maybe<Scalars['Boolean']['output']>;
  full_address: Maybe<Scalars['String']['output']>;
  geo_fence_radius: Maybe<Scalars['Int']['output']>;
  guaranteed_minimum_hours: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  ignore_signature_when_creating_meal_break: Scalars['Boolean']['output'];
  in_geo_fence_range: Maybe<Scalars['Boolean']['output']>;
  job_count: Maybe<Scalars['Int']['output']>;
  label: Maybe<Scalars['String']['output']>;
  last_time_job_posted: Maybe<Scalars['DateTime']['output']>;
  location_billing_groups: Maybe<Array<Maybe<LocationBillingGroup>>>;
  location_confirmation_job_irregularities_enabled: Scalars['Boolean']['output'];
  location_position_rate_settings: Array<LocationPositionRateSetting>;
  location_positions: Maybe<Array<Maybe<LocationPosition>>>;
  location_rate_settings: Array<LocationRateSetting>;
  location_type: LocationType;
  location_type_id: Scalars['Int']['output'];
  locked: Maybe<Scalars['Boolean']['output']>;
  manager_accounts: Maybe<Array<Maybe<Account>>>;
  market: Maybe<Market>;
  market_id: Maybe<Scalars['Int']['output']>;
  maximum_late_clock_out_grace_period_minutes: Scalars['Int']['output'];
  mileage_requirement: Maybe<Scalars['Int']['output']>;
  min_years_of_experience: Maybe<Scalars['Float']['output']>;
  name: Maybe<Scalars['String']['output']>;
  non_billable_orientation_burden_hours: Scalars['Int']['output'];
  original_user_id: Maybe<Scalars['Int']['output']>;
  parking_cost_cents: Scalars['Int']['output'];
  parking_free: Scalars['Boolean']['output'];
  parking_instructions: Maybe<Scalars['String']['output']>;
  parking_reimbursed: Scalars['Boolean']['output'];
  parking_reimbursement_cents: Scalars['Int']['output'];
  parking_reimbursement_currency: Scalars['String']['output'];
  parking_validated: Scalars['Boolean']['output'];
  phone_number: Maybe<Scalars['String']['output']>;
  positions: Maybe<Array<Maybe<Position>>>;
  primary_account_id: Maybe<Scalars['Int']['output']>;
  primary_billing_group: Maybe<BillingGroup>;
  primary_billing_group_id: Maybe<Scalars['Int']['output']>;
  pro_pool_enabled: Scalars['Boolean']['output'];
  professional_can_adjust_times: Scalars['Boolean']['output'];
  require_facility_timecard_system_photo_on_clock_in: Scalars['Boolean']['output'];
  require_facility_timecard_system_photo_on_clock_out: Scalars['Boolean']['output'];
  require_upload_on_clock_out: Scalars['Boolean']['output'];
  requirements: Array<Requirement>;
  sales_associate: Maybe<Administrator>;
  sales_associate_id: Maybe<Scalars['Int']['output']>;
  scrubs_provided: Scalars['Boolean']['output'];
  /** @deprecated renamed with suffice _minutes */
  start_clock_in_early_window: Scalars['Int']['output'];
  start_clock_in_early_window_minutes: Scalars['Int']['output'];
  state: Maybe<State>;
  state_id: Maybe<Scalars['Int']['output']>;
  status: Scalars['String']['output'];
  timezone_lookup: Maybe<Scalars['String']['output']>;
  unit: Maybe<Scalars['String']['output']>;
  updated_at: Scalars['DateTime']['output'];
  vms_user: Maybe<VmsUser>;
  vms_user_id: Maybe<Scalars['Int']['output']>;
};


export type LocationIn_Geo_Fence_RangeArgs = {
  lat: Scalars['Float']['input'];
  lon: Scalars['Float']['input'];
};

export type LocationAssignmentIssueCountsInput = {
  search: LocationAssignmentIssueCountsSearchInput;
};

export type LocationAssignmentIssueCountsSearchInput = {
  location_ids: InputMaybe<Array<Scalars['Int']['input']>>;
  range: DateRangeInput;
};

export type LocationBillingGroup = {
  __typename?: 'LocationBillingGroup';
  billing_group: BillingGroup;
  billing_group_id: Scalars['Int']['output'];
  created_at: Scalars['DateTime']['output'];
  id: Scalars['Int']['output'];
  location: Location;
  location_id: Scalars['Int']['output'];
  primary_billing_group: Scalars['Boolean']['output'];
  updated_at: Scalars['DateTime']['output'];
};

export type LocationBillingGroupOrderInput = {
  billing_group_id: InputMaybe<Scalars['Boolean']['input']>;
  created_at: InputMaybe<Scalars['Boolean']['input']>;
  id: InputMaybe<Scalars['Boolean']['input']>;
  location_id: InputMaybe<Scalars['Boolean']['input']>;
  primary_billing_group: InputMaybe<Scalars['Boolean']['input']>;
  updated_at: InputMaybe<Scalars['Boolean']['input']>;
};

export type LocationBillingGroupQueryInput = {
  filter: InputMaybe<LocationBillingGroupWhereInput>;
  orderBy: InputMaybe<LocationBillingGroupOrderInput>;
  page: InputMaybe<Scalars['Int']['input']>;
  perPage: InputMaybe<Scalars['Int']['input']>;
  search: InputMaybe<LocationBillingGroupSearchInput>;
};

export type LocationBillingGroupSearchInput = {
  /**
   * *Constraints:*
   * * Maximal length: `150`
   *
   */
  q: InputMaybe<Scalars['String']['input']>;
};

export type LocationBillingGroupWhereInput = {
  billing_group_id: InputMaybe<Scalars['Int']['input']>;
  created_at: InputMaybe<Scalars['DateTime']['input']>;
  id: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  location_id: InputMaybe<Scalars['Int']['input']>;
  primary_billing_group: InputMaybe<Scalars['Boolean']['input']>;
  updated_at: InputMaybe<Scalars['DateTime']['input']>;
};

export type LocationBlockReason = {
  __typename?: 'LocationBlockReason';
  active: Maybe<Scalars['Boolean']['output']>;
  created_at: Scalars['DateTime']['output'];
  id: Scalars['Int']['output'];
  kind: Maybe<Scalars['String']['output']>;
  label: Maybe<Scalars['String']['output']>;
  relationships: Maybe<Array<Maybe<Relationship>>>;
  slug: Scalars['String']['output'];
  updated_at: Scalars['DateTime']['output'];
};

export type LocationBlockReasonOrderInput = {
  created_at: InputMaybe<Scalars['Boolean']['input']>;
  id: InputMaybe<Scalars['Boolean']['input']>;
  kind: InputMaybe<Scalars['Boolean']['input']>;
  label: InputMaybe<Scalars['Boolean']['input']>;
  updated_at: InputMaybe<Scalars['Boolean']['input']>;
};

export type LocationBlockReasonQueryInput = {
  filter: InputMaybe<LocationBlockReasonWhereInput>;
  orderBy: InputMaybe<LocationBlockReasonOrderInput>;
  page: InputMaybe<Scalars['Int']['input']>;
  perPage: InputMaybe<Scalars['Int']['input']>;
  search: InputMaybe<DefaultSearchInput>;
};

export type LocationBlockReasonWhereInput = {
  active: InputMaybe<Scalars['Boolean']['input']>;
  created_at: InputMaybe<Scalars['DateTime']['input']>;
  id: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  kind: InputMaybe<Scalars['String']['input']>;
  label: InputMaybe<Scalars['String']['input']>;
  updated_at: InputMaybe<Scalars['DateTime']['input']>;
};

export type LocationGroup = {
  __typename?: 'LocationGroup';
  account_ids: Array<Scalars['Int']['output']>;
  calculated_descendant_ids: Array<Scalars['Int']['output']>;
  child_group_ids: Array<Scalars['Int']['output']>;
  company_id: Scalars['Int']['output'];
  description: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  location_ids: Array<Scalars['Int']['output']>;
  name: Scalars['String']['output'];
};

export type LocationGroupOrderInput = {
  id: InputMaybe<Scalars['Boolean']['input']>;
  name: InputMaybe<Scalars['Boolean']['input']>;
};

export type LocationGroupQueryInput = {
  filter: InputMaybe<LocationGroupWhereInput>;
  orderBy: InputMaybe<LocationGroupOrderInput>;
  page: InputMaybe<Scalars['Int']['input']>;
  perPage: InputMaybe<Scalars['Int']['input']>;
  search: InputMaybe<LocationGroupSearchInput>;
};

export type LocationGroupSearchInput = {
  company_id: InputMaybe<Scalars['Int']['input']>;
};

export type LocationGroupWhereInput = {
  company_id: InputMaybe<Scalars['Int']['input']>;
  group_node_ids: InputMaybe<Array<Scalars['Int']['input']>>;
  id: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type LocationOrderInput = {
  about: InputMaybe<Scalars['Boolean']['input']>;
  account_manager_id: InputMaybe<Scalars['Boolean']['input']>;
  address_city: InputMaybe<Scalars['Boolean']['input']>;
  address_first: InputMaybe<Scalars['Boolean']['input']>;
  address_second: InputMaybe<Scalars['Boolean']['input']>;
  address_zip: InputMaybe<Scalars['Boolean']['input']>;
  allow_assignments: InputMaybe<Scalars['Boolean']['input']>;
  allow_per_diem_jobs: InputMaybe<Scalars['Boolean']['input']>;
  boolean: InputMaybe<Scalars['Boolean']['input']>;
  cancellation_fee_charge_hours: InputMaybe<Scalars['Boolean']['input']>;
  cancellation_fee_window: InputMaybe<Scalars['Boolean']['input']>;
  company_id: InputMaybe<Scalars['Boolean']['input']>;
  coordinates: InputMaybe<Scalars['Boolean']['input']>;
  created_at: InputMaybe<Scalars['Boolean']['input']>;
  detailed_notes: InputMaybe<Scalars['Boolean']['input']>;
  drug_screening_required: InputMaybe<Scalars['Boolean']['input']>;
  guaranteed_minimum_hours: InputMaybe<Scalars['Boolean']['input']>;
  id: InputMaybe<Scalars['Boolean']['input']>;
  last_time_job_posted: InputMaybe<Scalars['Boolean']['input']>;
  location_type_id: InputMaybe<Scalars['Boolean']['input']>;
  market_id: InputMaybe<Scalars['Boolean']['input']>;
  name: InputMaybe<Scalars['Boolean']['input']>;
  non_billable_orientation_burden_hours: InputMaybe<Scalars['Boolean']['input']>;
  original_user_id: InputMaybe<Scalars['Boolean']['input']>;
  parking_reimbursement_cents: InputMaybe<Scalars['Boolean']['input']>;
  parking_reimbursement_currency: InputMaybe<Scalars['Boolean']['input']>;
  phone_number: InputMaybe<Scalars['Boolean']['input']>;
  primary_account_id: InputMaybe<Scalars['Boolean']['input']>;
  primary_billing_group_id: InputMaybe<Scalars['Boolean']['input']>;
  sales_associate_id: InputMaybe<Scalars['Boolean']['input']>;
  state_id: InputMaybe<Scalars['Boolean']['input']>;
  timezone_lookup: InputMaybe<Scalars['Boolean']['input']>;
  updated_at: InputMaybe<Scalars['Boolean']['input']>;
};

export type LocationPosition = {
  __typename?: 'LocationPosition';
  created_at: Scalars['DateTime']['output'];
  id: Scalars['Int']['output'];
  location: Location;
  location_id: Scalars['Int']['output'];
  position: Position;
  position_id: Scalars['Int']['output'];
  updated_at: Scalars['DateTime']['output'];
};

export type LocationPositionOrderInput = {
  created_at: InputMaybe<Scalars['Boolean']['input']>;
  id: InputMaybe<Scalars['Boolean']['input']>;
  location_id: InputMaybe<Scalars['Boolean']['input']>;
  position_id: InputMaybe<Scalars['Boolean']['input']>;
  updated_at: InputMaybe<Scalars['Boolean']['input']>;
};

export type LocationPositionQueryInput = {
  filter: InputMaybe<LocationPositionWhereInput>;
  orderBy: InputMaybe<LocationPositionOrderInput>;
  page: InputMaybe<Scalars['Int']['input']>;
  perPage: InputMaybe<Scalars['Int']['input']>;
  search: InputMaybe<LocationPositionSearchInput>;
};

export type LocationPositionRateSetting = {
  __typename?: 'LocationPositionRateSetting';
  active: Maybe<Scalars['Boolean']['output']>;
  audits: Maybe<Array<Maybe<Audit>>>;
  created_at: Maybe<Scalars['DateTime']['output']>;
  expires_at: Maybe<Scalars['DateTime']['output']>;
  id: Maybe<Scalars['String']['output']>;
  location: Maybe<Location>;
  location_id: Maybe<Scalars['Int']['output']>;
  location_position_rate_setting: Maybe<PositionSettings>;
  location_position_rate_setting_active: Maybe<Scalars['Boolean']['output']>;
  location_position_rate_setting_id: Maybe<Scalars['Int']['output']>;
  market_position_rate_setting_active: Maybe<Scalars['Boolean']['output']>;
  market_position_rate_setting_id: Maybe<Scalars['Int']['output']>;
  original_id: Maybe<Scalars['Int']['output']>;
  position: Maybe<Position>;
  position_id: Maybe<Scalars['Int']['output']>;
  settings: Maybe<PositionSettings>;
  specialty: Maybe<Specialty>;
  specialty_id: Maybe<Scalars['Int']['output']>;
  state_position_rate_setting_active: Maybe<Scalars['Boolean']['output']>;
  state_position_rate_setting_id: Maybe<Scalars['Int']['output']>;
  updated_at: Maybe<Scalars['DateTime']['output']>;
};

export type LocationPositionRateSettingOrderInput = {
  active: InputMaybe<Scalars['Boolean']['input']>;
  created_at: InputMaybe<Scalars['Boolean']['input']>;
  id: InputMaybe<Scalars['Boolean']['input']>;
  location_id: InputMaybe<Scalars['Int']['input']>;
  position: InputMaybe<PositionOrderInput>;
  position_id: InputMaybe<Scalars['Boolean']['input']>;
  specialty_id: InputMaybe<Scalars['Int']['input']>;
  updated_at: InputMaybe<Scalars['Boolean']['input']>;
};

export type LocationPositionRateSettingQueryInput = {
  filter: InputMaybe<LocationPositionRateSettingWhereInput>;
  orderBy: InputMaybe<LocationPositionRateSettingOrderInput>;
  page: InputMaybe<Scalars['Int']['input']>;
  perPage: InputMaybe<Scalars['Int']['input']>;
  search: InputMaybe<LocationPositionRateSettingSearchInput>;
};

export type LocationPositionRateSettingSearchInput = {
  below_market_rate: InputMaybe<Scalars['Boolean']['input']>;
  location_id: InputMaybe<Scalars['Int']['input']>;
  location_ids: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  position_id: InputMaybe<Scalars['Int']['input']>;
  position_ids: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  specialty_id: InputMaybe<Scalars['Int']['input']>;
  specialty_ids: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  updated_at_from: InputMaybe<Scalars['Date']['input']>;
};

export type LocationPositionRateSettingWhereInput = {
  active: InputMaybe<Scalars['Boolean']['input']>;
  created_at: InputMaybe<Scalars['DateTime']['input']>;
  for_assignment: InputMaybe<Scalars['Boolean']['input']>;
  for_job: InputMaybe<Scalars['Boolean']['input']>;
  id: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  include_parents: InputMaybe<Scalars['Boolean']['input']>;
  location_id: InputMaybe<Scalars['Int']['input']>;
  location_ids: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  max_only: InputMaybe<Scalars['Boolean']['input']>;
  position_id: InputMaybe<Scalars['Int']['input']>;
  specialty_id: InputMaybe<Scalars['Int']['input']>;
  updated_at: InputMaybe<Scalars['DateTime']['input']>;
};

export type LocationPositionSearchInput = {
  /**
   * *Constraints:*
   * * Maximal length: `150`
   *
   */
  q: InputMaybe<Scalars['String']['input']>;
};

export type LocationPositionWhereInput = {
  created_at: InputMaybe<Scalars['DateTime']['input']>;
  id: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  location_id: InputMaybe<Scalars['Int']['input']>;
  location_ids: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  position_id: InputMaybe<Scalars['Int']['input']>;
  updated_at: InputMaybe<Scalars['DateTime']['input']>;
};

export type LocationQueryInput = {
  filter: InputMaybe<LocationWhereInput>;
  orderBy: InputMaybe<LocationOrderInput>;
  page: InputMaybe<Scalars['Int']['input']>;
  perPage: InputMaybe<Scalars['Int']['input']>;
  search: InputMaybe<LocationSearchInput>;
};

export type LocationRateSetting = {
  __typename?: 'LocationRateSetting';
  active: Maybe<Scalars['Boolean']['output']>;
  created_at: Scalars['DateTime']['output'];
  enable_differential_recommendations: Maybe<Scalars['Boolean']['output']>;
  id: Maybe<Scalars['Int']['output']>;
  location: Maybe<Location>;
  location_id: Maybe<Scalars['Int']['output']>;
  settings: Maybe<Scalars['JSON']['output']>;
  updated_at: Scalars['DateTime']['output'];
};

export type LocationRateSettingOrderInput = {
  active: InputMaybe<Scalars['Boolean']['input']>;
  created_at: InputMaybe<Scalars['Boolean']['input']>;
  id: InputMaybe<Scalars['Boolean']['input']>;
  location_id: InputMaybe<Scalars['Boolean']['input']>;
  updated_at: InputMaybe<Scalars['Boolean']['input']>;
};

export type LocationRateSettingQueryInput = {
  filter: InputMaybe<LocationRateSettingWhereInput>;
  orderBy: InputMaybe<LocationRateSettingOrderInput>;
  page: InputMaybe<Scalars['Int']['input']>;
  perPage: InputMaybe<Scalars['Int']['input']>;
  search: InputMaybe<LocationRateSettingSearchInput>;
};

export type LocationRateSettingSearchInput = {
  location_id: InputMaybe<Scalars['Int']['input']>;
  location_ids: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};

export type LocationRateSettingWhereInput = {
  active: InputMaybe<Scalars['Boolean']['input']>;
  id: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  include_parents: InputMaybe<Scalars['Boolean']['input']>;
  location_id: InputMaybe<Scalars['Int']['input']>;
};

export type LocationSearchInput = {
  account_id: InputMaybe<Scalars['Int']['input']>;
  account_manager_id: InputMaybe<Scalars['Int']['input']>;
  address_first: InputMaybe<Scalars['String']['input']>;
  billing_group_id: InputMaybe<Scalars['Int']['input']>;
  billing_group_ids: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  fill_ratio: InputMaybe<Scalars['Int']['input']>;
  has_balance: InputMaybe<Scalars['Boolean']['input']>;
  health_system_id: InputMaybe<Scalars['Int']['input']>;
  location_ids: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  location_type_id: InputMaybe<Scalars['Int']['input']>;
  market_ids: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  msp_id: InputMaybe<Scalars['Int']['input']>;
  name: InputMaybe<Scalars['String']['input']>;
  near_location: InputMaybe<NearLocationInput>;
  no_vms: InputMaybe<Scalars['Boolean']['input']>;
  onboarding_complete: InputMaybe<Scalars['Boolean']['input']>;
  phone_number: InputMaybe<Scalars['String']['input']>;
  plan: InputMaybe<Scalars['String']['input']>;
  professional_account_id: InputMaybe<Scalars['Int']['input']>;
  /**
   * *Constraints:*
   * * Maximal length: `150`
   *
   */
  q: InputMaybe<Scalars['String']['input']>;
  referral: InputMaybe<Scalars['String']['input']>;
  sales_associate_id: InputMaybe<Scalars['Int']['input']>;
  state_id: InputMaybe<Scalars['Int']['input']>;
  utm_campaign: InputMaybe<Scalars['String']['input']>;
  utm_source: InputMaybe<Scalars['String']['input']>;
  verified: InputMaybe<Scalars['Boolean']['input']>;
  vms_type_id: InputMaybe<Scalars['Int']['input']>;
};

export type LocationType = {
  __typename?: 'LocationType';
  active: Maybe<Scalars['Boolean']['output']>;
  admin_only: Scalars['Boolean']['output'];
  created_at: Scalars['DateTime']['output'];
  id: Scalars['Int']['output'];
  label: Maybe<Scalars['String']['output']>;
  location_type_positions: Maybe<Array<Maybe<LocationTypePosition>>>;
  positions: Maybe<Array<Maybe<Position>>>;
  rank: Scalars['Int']['output'];
  updated_at: Scalars['DateTime']['output'];
};

export type LocationTypeOrderInput = {
  active: InputMaybe<Scalars['Boolean']['input']>;
  created_at: InputMaybe<Scalars['Boolean']['input']>;
  id: InputMaybe<Scalars['Boolean']['input']>;
  label: InputMaybe<Scalars['Boolean']['input']>;
  rank: InputMaybe<Scalars['Boolean']['input']>;
  updated_at: InputMaybe<Scalars['Boolean']['input']>;
};

export type LocationTypePosition = {
  __typename?: 'LocationTypePosition';
  created_at: Scalars['DateTime']['output'];
  id: Scalars['Int']['output'];
  location_type: Maybe<LocationType>;
  position: Maybe<Position>;
  updated_at: Scalars['DateTime']['output'];
};

export type LocationTypePositionOrderInput = {
  created_at: InputMaybe<Scalars['Boolean']['input']>;
  id: InputMaybe<Scalars['Boolean']['input']>;
  location_type_id: InputMaybe<Scalars['Boolean']['input']>;
  position_id: InputMaybe<Scalars['Boolean']['input']>;
  updated_at: InputMaybe<Scalars['Boolean']['input']>;
};

export type LocationTypePositionQueryInput = {
  filter: InputMaybe<LocationTypePositionWhereInput>;
  orderBy: InputMaybe<LocationTypePositionOrderInput>;
  page: InputMaybe<Scalars['Int']['input']>;
  perPage: InputMaybe<Scalars['Int']['input']>;
  search: InputMaybe<DefaultSearchInput>;
};

export type LocationTypePositionWhereInput = {
  created_at: InputMaybe<Scalars['DateTime']['input']>;
  id: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  location_type_id: InputMaybe<Scalars['Int']['input']>;
  position_id: InputMaybe<Scalars['Int']['input']>;
  updated_at: InputMaybe<Scalars['DateTime']['input']>;
};

export type LocationTypeQueryInput = {
  filter: InputMaybe<LocationTypeWhereInput>;
  orderBy: InputMaybe<LocationTypeOrderInput>;
  page: InputMaybe<Scalars['Int']['input']>;
  perPage: InputMaybe<Scalars['Int']['input']>;
  search: InputMaybe<DefaultSearchInput>;
};

export type LocationTypeWhereInput = {
  active: InputMaybe<Scalars['Boolean']['input']>;
  active_without_admin_only: InputMaybe<Scalars['Boolean']['input']>;
  admin_only: InputMaybe<Scalars['Boolean']['input']>;
  created_at: InputMaybe<Scalars['DateTime']['input']>;
  id: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  label: InputMaybe<Scalars['String']['input']>;
  updated_at: InputMaybe<Scalars['DateTime']['input']>;
};

export type LocationWhereInput = {
  about: InputMaybe<Scalars['String']['input']>;
  account_manager_id: InputMaybe<Scalars['Int']['input']>;
  address_city: InputMaybe<Scalars['String']['input']>;
  address_first: InputMaybe<Scalars['String']['input']>;
  address_second: InputMaybe<Scalars['String']['input']>;
  address_zip: InputMaybe<Scalars['String']['input']>;
  allow_per_diem_jobs: InputMaybe<Scalars['Boolean']['input']>;
  boolean: InputMaybe<Scalars['Boolean']['input']>;
  cancellation_fee_charge_hours: InputMaybe<Scalars['Int']['input']>;
  cancellation_fee_window: InputMaybe<Scalars['Int']['input']>;
  company_id: InputMaybe<Scalars['Int']['input']>;
  coordinates: InputMaybe<Scalars['String']['input']>;
  created_at: InputMaybe<Scalars['DateTime']['input']>;
  detailed_notes: InputMaybe<Scalars['String']['input']>;
  drug_screening_required: InputMaybe<Scalars['Boolean']['input']>;
  guaranteed_minimum_hours: InputMaybe<Scalars['Int']['input']>;
  has_balance: InputMaybe<Scalars['Boolean']['input']>;
  health_system_id: InputMaybe<Scalars['Int']['input']>;
  id: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  last_time_job_posted: InputMaybe<Scalars['DateTime']['input']>;
  location_type_id: InputMaybe<Scalars['Int']['input']>;
  market_id: InputMaybe<Scalars['Int']['input']>;
  msp_id: InputMaybe<Scalars['Int']['input']>;
  name: InputMaybe<Scalars['String']['input']>;
  no_vms: InputMaybe<Scalars['Boolean']['input']>;
  non_billable_orientation_burden_hours: InputMaybe<Scalars['Int']['input']>;
  original_user_id: InputMaybe<Scalars['Int']['input']>;
  parking_free: InputMaybe<Scalars['Boolean']['input']>;
  parking_reimbursed: InputMaybe<Scalars['Boolean']['input']>;
  parking_reimbursement_cents: InputMaybe<Scalars['Int']['input']>;
  parking_reimbursement_currency: InputMaybe<Scalars['String']['input']>;
  parking_validated: InputMaybe<Scalars['Boolean']['input']>;
  phone_number: InputMaybe<Scalars['String']['input']>;
  primary_account_id: InputMaybe<Scalars['Int']['input']>;
  primary_billing_group_id: InputMaybe<Scalars['Int']['input']>;
  referral: InputMaybe<Scalars['String']['input']>;
  sales_associate_id: InputMaybe<Scalars['Int']['input']>;
  state_id: InputMaybe<Scalars['Int']['input']>;
  status: InputMaybe<Scalars['String']['input']>;
  timezone_lookup: InputMaybe<Scalars['String']['input']>;
  updated_at: InputMaybe<Scalars['DateTime']['input']>;
  utm_campaign: InputMaybe<Scalars['String']['input']>;
  utm_source: InputMaybe<Scalars['String']['input']>;
  vms_type_id: InputMaybe<Scalars['Int']['input']>;
  vms_user_id: InputMaybe<Scalars['Int']['input']>;
};

export type Market = {
  __typename?: 'Market';
  created_at: Scalars['DateTime']['output'];
  display_name: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  locations: Maybe<Array<Maybe<Location>>>;
  market_locations: Maybe<Array<Maybe<MarketLocation>>>;
  name: Maybe<Scalars['String']['output']>;
  position_names: Maybe<Scalars['String']['output']>;
  positions: Maybe<Array<Maybe<Position>>>;
  professionals: Maybe<Array<Maybe<Professional>>>;
  state: Maybe<State>;
  state_id: Maybe<Scalars['Int']['output']>;
  state_name: Maybe<Scalars['String']['output']>;
  timezone: Maybe<Scalars['TZ']['output']>;
  updated_at: Scalars['DateTime']['output'];
  users: Maybe<Array<Maybe<User>>>;
};

export type MarketLocation = {
  __typename?: 'MarketLocation';
  city: Maybe<Scalars['String']['output']>;
  county: Maybe<Scalars['String']['output']>;
  created_at: Scalars['DateTime']['output'];
  id: Scalars['Int']['output'];
  market: Market;
  updated_at: Scalars['DateTime']['output'];
  zip_code: Scalars['String']['output'];
};

export type MarketLocationOrderInput = {
  city: InputMaybe<Scalars['Boolean']['input']>;
  county: InputMaybe<Scalars['Boolean']['input']>;
  created_at: InputMaybe<Scalars['Boolean']['input']>;
  id: InputMaybe<Scalars['Boolean']['input']>;
  market_id: InputMaybe<Scalars['Boolean']['input']>;
  updated_at: InputMaybe<Scalars['Boolean']['input']>;
  zip_code: InputMaybe<Scalars['Boolean']['input']>;
};

export type MarketLocationQueryInput = {
  filter: InputMaybe<MarketLocationWhereInput>;
  orderBy: InputMaybe<MarketLocationOrderInput>;
  page: InputMaybe<Scalars['Int']['input']>;
  perPage: InputMaybe<Scalars['Int']['input']>;
  search: InputMaybe<MarketLocationSearchInput>;
};

export type MarketLocationSearchInput = {
  /**
   * *Constraints:*
   * * Maximal length: `150`
   *
   */
  q: InputMaybe<Scalars['String']['input']>;
};

export type MarketLocationWhereInput = {
  city: InputMaybe<Scalars['String']['input']>;
  county: InputMaybe<Scalars['String']['input']>;
  created_at: InputMaybe<Scalars['DateTime']['input']>;
  id: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  market_id: InputMaybe<Scalars['Int']['input']>;
  updated_at: InputMaybe<Scalars['DateTime']['input']>;
  zip_code: InputMaybe<Scalars['String']['input']>;
};

export type MarketOrderInput = {
  created_at: InputMaybe<Scalars['Boolean']['input']>;
  display_name: InputMaybe<Scalars['Boolean']['input']>;
  id: InputMaybe<Scalars['Boolean']['input']>;
  name: InputMaybe<Scalars['Boolean']['input']>;
  position_names: InputMaybe<Scalars['Boolean']['input']>;
  state_id: InputMaybe<Scalars['Boolean']['input']>;
  state_name: InputMaybe<Scalars['Boolean']['input']>;
  updated_at: InputMaybe<Scalars['Boolean']['input']>;
};

export type MarketPositionRateSetting = {
  __typename?: 'MarketPositionRateSetting';
  active: Maybe<Scalars['Boolean']['output']>;
  agency_charge_rate_cents: Maybe<Scalars['Int']['output']>;
  audits: Maybe<Array<Maybe<Audit>>>;
  created_at: Maybe<Scalars['DateTime']['output']>;
  id: Maybe<Scalars['String']['output']>;
  last_rate_review: Maybe<Scalars['Date']['output']>;
  market: Maybe<Market>;
  market_id: Maybe<Scalars['Int']['output']>;
  market_position_rate_setting: Maybe<PositionSettings>;
  market_position_rate_setting_active: Maybe<Scalars['Boolean']['output']>;
  market_position_rate_setting_id: Maybe<Scalars['Int']['output']>;
  position: Maybe<Position>;
  position_id: Maybe<Scalars['Int']['output']>;
  professional_rate: Array<Scalars['Int']['output']>;
  recommended_rate_setting: Maybe<MarketPositionRecommendedRateSetting>;
  settings: Maybe<PositionSettings>;
  specialty: Maybe<Specialty>;
  specialty_id: Maybe<Scalars['Int']['output']>;
  state_position_rate_setting_active: Maybe<Scalars['Boolean']['output']>;
  state_position_rate_setting_id: Maybe<Scalars['Int']['output']>;
  updated_at: Maybe<Scalars['DateTime']['output']>;
};

export type MarketPositionRateSettingOrderInput = {
  active: InputMaybe<Scalars['Boolean']['input']>;
  created_at: InputMaybe<Scalars['Boolean']['input']>;
  id: InputMaybe<Scalars['Boolean']['input']>;
  last_rate_review: InputMaybe<Scalars['Boolean']['input']>;
  market_id: InputMaybe<Scalars['Int']['input']>;
  position_id: InputMaybe<Scalars['Boolean']['input']>;
  specialty_id: InputMaybe<Scalars['Int']['input']>;
  updated_at: InputMaybe<Scalars['Boolean']['input']>;
};

export type MarketPositionRateSettingQueryInput = {
  filter: InputMaybe<MarketPositionRateSettingWhereInput>;
  orderBy: InputMaybe<MarketPositionRateSettingOrderInput>;
  page: InputMaybe<Scalars['Int']['input']>;
  perPage: InputMaybe<Scalars['Int']['input']>;
  search: InputMaybe<MarketPositionRateSettingSearchInput>;
};

export type MarketPositionRateSettingSearchInput = {
  below_state_rate: InputMaybe<Scalars['Boolean']['input']>;
  has_agency_rates: InputMaybe<Scalars['Boolean']['input']>;
  last_rate_review_from: InputMaybe<Scalars['Date']['input']>;
  location_ids: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  market_id: InputMaybe<Scalars['Int']['input']>;
  position_id: InputMaybe<Scalars['Int']['input']>;
  position_ids: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  specialty_id: InputMaybe<Scalars['Int']['input']>;
  specialty_ids: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};

export type MarketPositionRateSettingWhereInput = {
  active: InputMaybe<Scalars['Boolean']['input']>;
  created_at: InputMaybe<Scalars['DateTime']['input']>;
  for_assignment: InputMaybe<Scalars['Boolean']['input']>;
  for_job: InputMaybe<Scalars['Boolean']['input']>;
  id: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  include_parents: InputMaybe<Scalars['Boolean']['input']>;
  market_id: InputMaybe<Scalars['Int']['input']>;
  position_id: InputMaybe<Scalars['Int']['input']>;
  specialty_id: InputMaybe<Scalars['Int']['input']>;
  updated_at: InputMaybe<Scalars['DateTime']['input']>;
};

export type MarketPositionRecommendedRateSetting = {
  __typename?: 'MarketPositionRecommendedRateSetting';
  holiday_differential_cents: Scalars['Int']['output'];
  overnight_differential_cents: Scalars['Int']['output'];
  short_lead_time_0_to_6_hours_differential_cents: Scalars['Int']['output'];
  short_lead_time_6_to_12_hours_differential_cents: Scalars['Int']['output'];
  short_lead_time_12_to_24_hours_differential_cents: Scalars['Int']['output'];
  weekend_differential_cents: Scalars['Int']['output'];
};

export type MarketQueryInput = {
  filter: InputMaybe<MarketWhereInput>;
  orderBy: InputMaybe<MarketOrderInput>;
  page: InputMaybe<Scalars['Int']['input']>;
  perPage: InputMaybe<Scalars['Int']['input']>;
  search: InputMaybe<MarketSearchInput>;
};

export type MarketRateSetting = {
  __typename?: 'MarketRateSetting';
  active: Maybe<Scalars['Boolean']['output']>;
  created_at: Maybe<Scalars['DateTime']['output']>;
  id: Maybe<Scalars['Int']['output']>;
  market: Maybe<Market>;
  market_id: Maybe<Scalars['Int']['output']>;
  settings: Maybe<Scalars['JSON']['output']>;
  updated_at: Maybe<Scalars['DateTime']['output']>;
};

export type MarketRateSettingOrderInput = {
  active: InputMaybe<Scalars['Boolean']['input']>;
  created_at: InputMaybe<Scalars['Boolean']['input']>;
  id: InputMaybe<Scalars['Boolean']['input']>;
  market_id: InputMaybe<Scalars['Int']['input']>;
  updated_at: InputMaybe<Scalars['Boolean']['input']>;
};

export type MarketRateSettingQueryInput = {
  filter: InputMaybe<MarketRateSettingWhereInput>;
  orderBy: InputMaybe<MarketRateSettingOrderInput>;
  page: InputMaybe<Scalars['Int']['input']>;
  perPage: InputMaybe<Scalars['Int']['input']>;
  search: InputMaybe<MarketRateSettingSearchInput>;
};

export type MarketRateSettingSearchInput = {
  market_id: InputMaybe<Scalars['Int']['input']>;
};

export type MarketRateSettingWhereInput = {
  active: InputMaybe<Scalars['Boolean']['input']>;
  id: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  include_parents: InputMaybe<Scalars['Boolean']['input']>;
  market_id: InputMaybe<Scalars['Int']['input']>;
};

export type MarketSearchInput = {
  created_at: InputMaybe<Scalars['DateTime']['input']>;
  display_name: InputMaybe<Scalars['String']['input']>;
  id: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  name: InputMaybe<Scalars['String']['input']>;
  position_names: InputMaybe<Scalars['String']['input']>;
  /**
   * *Constraints:*
   * * Maximal length: `150`
   *
   */
  q: InputMaybe<Scalars['String']['input']>;
  state_id: InputMaybe<Scalars['Int']['input']>;
  state_name: InputMaybe<Scalars['String']['input']>;
  state_zip_codes: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  updated_at: InputMaybe<Scalars['DateTime']['input']>;
  zip_codes: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type MarketWhereInput = {
  created_at: InputMaybe<Scalars['DateTime']['input']>;
  display_name: InputMaybe<Scalars['String']['input']>;
  id: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  name: InputMaybe<Scalars['String']['input']>;
  position_names: InputMaybe<Scalars['String']['input']>;
  state_id: InputMaybe<Scalars['Int']['input']>;
  state_name: InputMaybe<Scalars['String']['input']>;
  updated_at: InputMaybe<Scalars['DateTime']['input']>;
};

export type MarketsProfessional = {
  __typename?: 'MarketsProfessional';
  market_id: Scalars['Int']['output'];
  professional_id: Maybe<Scalars['Int']['output']>;
};

export type MarketsProfessionalOrderInput = {
  market_id: InputMaybe<Scalars['Boolean']['input']>;
  professional_id: InputMaybe<Scalars['Boolean']['input']>;
};

export type MarketsProfessionalQueryInput = {
  filter: InputMaybe<MarketsProfessionalWhereInput>;
  orderBy: InputMaybe<MarketsProfessionalOrderInput>;
  page: InputMaybe<Scalars['Int']['input']>;
  perPage: InputMaybe<Scalars['Int']['input']>;
  search: InputMaybe<MarketsProfessionalSearchInput>;
};

export type MarketsProfessionalSearchInput = {
  /**
   * *Constraints:*
   * * Maximal length: `150`
   *
   */
  q: InputMaybe<Scalars['String']['input']>;
};

export type MarketsProfessionalWhereInput = {
  market_id: InputMaybe<Scalars['Int']['input']>;
  professional_id: InputMaybe<Scalars['Int']['input']>;
};

export type MetabaseEmbed = {
  __typename?: 'MetabaseEmbed';
  signed_token: Maybe<Scalars['String']['output']>;
};

export type MetabaseEmbedQueryInput = {
  dashboard_id: Scalars['Int']['input'];
  date_range: InputMaybe<DateRangeInput>;
  location_ids: InputMaybe<Array<Scalars['Int']['input']>>;
  positions: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  types: InputMaybe<Array<InputMaybe<MetabaseTypes>>>;
};

export enum MetabaseTypes {
  Agency = 'agency',
  Medely = 'medely'
}

export type Msp = {
  __typename?: 'Msp';
  companies: Maybe<Array<Maybe<Company>>>;
  created_at: Scalars['DateTime']['output'];
  id: Scalars['Int']['output'];
  label: Maybe<Scalars['String']['output']>;
  name: Maybe<Scalars['String']['output']>;
  updated_at: Scalars['DateTime']['output'];
  users: Maybe<Array<Maybe<User>>>;
};

export type MspOrderInput = {
  created_at: InputMaybe<Scalars['Boolean']['input']>;
  id: InputMaybe<Scalars['Boolean']['input']>;
  label: InputMaybe<Scalars['Boolean']['input']>;
  name: InputMaybe<Scalars['Boolean']['input']>;
  updated_at: InputMaybe<Scalars['Boolean']['input']>;
};

export type MspQueryInput = {
  filter: InputMaybe<MspWhereInput>;
  orderBy: InputMaybe<MspOrderInput>;
  page: InputMaybe<Scalars['Int']['input']>;
  perPage: InputMaybe<Scalars['Int']['input']>;
  search: InputMaybe<DefaultSearchInput>;
};

export type MspWhereInput = {
  created_at: InputMaybe<Scalars['DateTime']['input']>;
  id: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  label: InputMaybe<Scalars['String']['input']>;
  name: InputMaybe<Scalars['String']['input']>;
  updated_at: InputMaybe<Scalars['DateTime']['input']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  _: Maybe<Scalars['Boolean']['output']>;
};

export type NearLocationInput = {
  location_id: InputMaybe<Scalars['Int']['input']>;
  radius: InputMaybe<Scalars['Int']['input']>;
};

export type NetTerm = {
  __typename?: 'NetTerm';
  created_at: Maybe<Scalars['DateTime']['output']>;
  id: Maybe<Scalars['Int']['output']>;
  number_of_days: Maybe<Scalars['Int']['output']>;
  updated_at: Maybe<Scalars['DateTime']['output']>;
};

export type NetTermOrderInput = {
  created_at: InputMaybe<Scalars['Boolean']['input']>;
  id: InputMaybe<Scalars['Boolean']['input']>;
  number_of_days: InputMaybe<Scalars['Boolean']['input']>;
  updated_at: InputMaybe<Scalars['Boolean']['input']>;
};

export type NetTermQueryInput = {
  filter: InputMaybe<NetTermWhereInput>;
  orderBy: InputMaybe<NetTermOrderInput>;
  page: InputMaybe<Scalars['Int']['input']>;
  perPage: InputMaybe<Scalars['Int']['input']>;
  search: InputMaybe<DefaultSearchInput>;
};

export type NetTermWhereInput = {
  created_at: InputMaybe<Scalars['DateTime']['input']>;
  id: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  number_of_days: InputMaybe<Scalars['Int']['input']>;
  updated_at: InputMaybe<Scalars['DateTime']['input']>;
};

export type Note = {
  __typename?: 'Note';
  author: Maybe<Administrator>;
  author_id: Maybe<Scalars['Int']['output']>;
  billingGroup: Maybe<BillingGroup>;
  created_at: Scalars['DateTime']['output'];
  id: Scalars['Int']['output'];
  location: Maybe<Location>;
  professional: Maybe<Professional>;
  recipient: Maybe<Recipient>;
  recipient_id: Maybe<Scalars['Int']['output']>;
  recipient_name: Maybe<Scalars['String']['output']>;
  recipient_type: Maybe<Scalars['String']['output']>;
  text: Maybe<Scalars['String']['output']>;
  updated_at: Scalars['DateTime']['output'];
};

export type NoteOrderInput = {
  author_id: InputMaybe<Scalars['Boolean']['input']>;
  created_at: InputMaybe<Scalars['Boolean']['input']>;
  id: InputMaybe<Scalars['Boolean']['input']>;
  recipient_id: InputMaybe<Scalars['Boolean']['input']>;
  recipient_name: InputMaybe<Scalars['Boolean']['input']>;
  recipient_type: InputMaybe<Scalars['Boolean']['input']>;
  text: InputMaybe<Scalars['Boolean']['input']>;
  updated_at: InputMaybe<Scalars['Boolean']['input']>;
};

export type NoteQueryInput = {
  filter: InputMaybe<NoteWhereInput>;
  orderBy: InputMaybe<NoteOrderInput>;
  page: InputMaybe<Scalars['Int']['input']>;
  perPage: InputMaybe<Scalars['Int']['input']>;
  search: InputMaybe<DefaultSearchInput>;
};

export type NoteWhereInput = {
  author_id: InputMaybe<Scalars['Int']['input']>;
  created_at: InputMaybe<Scalars['DateTime']['input']>;
  id: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  recipient_id: InputMaybe<Scalars['Int']['input']>;
  recipient_name: InputMaybe<Scalars['String']['input']>;
  recipient_type: InputMaybe<Scalars['String']['input']>;
  text: InputMaybe<Scalars['String']['input']>;
  updated_at: InputMaybe<Scalars['DateTime']['input']>;
};

export type NursysEnrollment = {
  __typename?: 'NursysEnrollment';
  created_at: Scalars['DateTime']['output'];
  id: Scalars['Int']['output'];
  professional: Maybe<Professional>;
  professional_error: Maybe<Scalars['String']['output']>;
  professional_id: Maybe<Scalars['Int']['output']>;
  status: Maybe<Scalars['Int']['output']>;
  updated_at: Scalars['DateTime']['output'];
};

export type NursysEnrollmentOrderInput = {
  created_at: InputMaybe<Scalars['Boolean']['input']>;
  id: InputMaybe<Scalars['Boolean']['input']>;
  professional_error: InputMaybe<Scalars['Boolean']['input']>;
  professional_id: InputMaybe<Scalars['Boolean']['input']>;
  status: InputMaybe<Scalars['Boolean']['input']>;
  updated_at: InputMaybe<Scalars['Boolean']['input']>;
};

export type NursysEnrollmentQueryInput = {
  filter: InputMaybe<NursysEnrollmentWhereInput>;
  orderBy: InputMaybe<ProfessionalOrderInput>;
  page: InputMaybe<Scalars['Int']['input']>;
  perPage: InputMaybe<Scalars['Int']['input']>;
  search: InputMaybe<DefaultSearchInput>;
};

export type NursysEnrollmentWhereInput = {
  created_at: InputMaybe<Scalars['DateTime']['input']>;
  facility_id: InputMaybe<Scalars['Int']['input']>;
  id: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  professional_error: InputMaybe<Scalars['String']['input']>;
  professional_id: InputMaybe<Scalars['Int']['input']>;
  status: InputMaybe<Scalars['Int']['input']>;
  updated_at: InputMaybe<Scalars['DateTime']['input']>;
  user_id: InputMaybe<Scalars['Int']['input']>;
};

export type OnboardingFlowDecision = {
  __typename?: 'OnboardingFlowDecision';
  decision: DecisionOption;
};

export type Payment = {
  __typename?: 'Payment';
  account_type: Maybe<Scalars['String']['output']>;
  amount_cents: Scalars['Int']['output'];
  amount_currency: Scalars['String']['output'];
  arrival_date: Maybe<Scalars['DateTime']['output']>;
  created_at: Scalars['DateTime']['output'];
  failed_count: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  last_error_message: Maybe<Scalars['String']['output']>;
  last_payment_attempt_at: Maybe<Scalars['DateTime']['output']>;
  locked: Scalars['Boolean']['output'];
  payout: Maybe<Payout>;
  payout_id: Scalars['Int']['output'];
  processed_on: Maybe<Scalars['DateTime']['output']>;
  provider: Scalars['String']['output'];
  provider_payment_delivery_method: Scalars['String']['output'];
  provider_status: Maybe<Scalars['String']['output']>;
  provider_transaction_id: Maybe<Scalars['String']['output']>;
  status: Maybe<Scalars['String']['output']>;
  updated_at: Scalars['DateTime']['output'];
};

export type PaymentOrderInput = {
  account_type: InputMaybe<Scalars['Boolean']['input']>;
  amount_cents: InputMaybe<Scalars['Boolean']['input']>;
  amount_currency: InputMaybe<Scalars['Boolean']['input']>;
  arrival_date: InputMaybe<Scalars['Boolean']['input']>;
  created_at: InputMaybe<Scalars['Boolean']['input']>;
  failed_count: InputMaybe<Scalars['Boolean']['input']>;
  id: InputMaybe<Scalars['Boolean']['input']>;
  last_error_message: InputMaybe<Scalars['Boolean']['input']>;
  last_payment_attempt_at: InputMaybe<Scalars['Boolean']['input']>;
  locked: InputMaybe<Scalars['Boolean']['input']>;
  payout_id: InputMaybe<Scalars['Boolean']['input']>;
  processed_on: InputMaybe<Scalars['Boolean']['input']>;
  provider: InputMaybe<Scalars['Boolean']['input']>;
  provider_payment_delivery_method: InputMaybe<Scalars['Boolean']['input']>;
  provider_status: InputMaybe<Scalars['Boolean']['input']>;
  provider_transaction_id: InputMaybe<Scalars['Boolean']['input']>;
  status: InputMaybe<Scalars['Boolean']['input']>;
  updated_at: InputMaybe<Scalars['Boolean']['input']>;
};

export type PaymentQueryInput = {
  filter: InputMaybe<PaymentWhereInput>;
  orderBy: InputMaybe<PaymentOrderInput>;
  page: InputMaybe<Scalars['Int']['input']>;
  perPage: InputMaybe<Scalars['Int']['input']>;
  search: InputMaybe<DefaultSearchInput>;
};

export type PaymentWhereInput = {
  account_type: InputMaybe<Scalars['String']['input']>;
  amount_cents: InputMaybe<Scalars['Int']['input']>;
  amount_currency: InputMaybe<Scalars['String']['input']>;
  arrival_date: InputMaybe<Scalars['DateTime']['input']>;
  created_at: InputMaybe<Scalars['DateTime']['input']>;
  failed_count: InputMaybe<Scalars['Int']['input']>;
  id: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  last_error_message: InputMaybe<Scalars['String']['input']>;
  last_payment_attempt_at: InputMaybe<Scalars['DateTime']['input']>;
  locked: InputMaybe<Scalars['Boolean']['input']>;
  payout_id: InputMaybe<Scalars['Int']['input']>;
  processed_on: InputMaybe<Scalars['DateTime']['input']>;
  provider: InputMaybe<Scalars['String']['input']>;
  provider_payment_delivery_method: InputMaybe<Scalars['String']['input']>;
  provider_status: InputMaybe<Scalars['String']['input']>;
  provider_transaction_id: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Scalars['String']['input']>;
  updated_at: InputMaybe<Scalars['DateTime']['input']>;
};

export type Payout = {
  __typename?: 'Payout';
  account_type: Maybe<Scalars['String']['output']>;
  adp_id: Maybe<Scalars['String']['output']>;
  agency_estimated_pay_date: Maybe<Scalars['DateTime']['output']>;
  agency_payout_status: Scalars['String']['output'];
  amount_cents: Scalars['Int']['output'];
  amount_currency: Scalars['String']['output'];
  arrival_date: Maybe<Scalars['DateTime']['output']>;
  assignment: Maybe<Assignment>;
  assignment_id: Maybe<Scalars['Int']['output']>;
  aws_signature_url: Maybe<Scalars['AWSFile']['output']>;
  created_at: Scalars['DateTime']['output'];
  ends_time: Maybe<Scalars['DateTime']['output']>;
  expense_adjustments: Array<ExpenseAdjustment>;
  failed_count: Maybe<Scalars['Int']['output']>;
  failed_reason: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  job_billings: Array<JobBilling>;
  jobs: Maybe<Array<Maybe<Job>>>;
  kind: Maybe<Scalars['String']['output']>;
  notes: Maybe<Scalars['String']['output']>;
  pause: Scalars['Boolean']['output'];
  pay_by_date: Maybe<Scalars['DateTime']['output']>;
  payments: Maybe<Array<Maybe<Payment>>>;
  processed_on: Maybe<Scalars['DateTime']['output']>;
  professional: Maybe<Professional>;
  professional_id: Maybe<Scalars['Int']['output']>;
  signature_url: Maybe<Scalars['String']['output']>;
  source_type: Maybe<Scalars['String']['output']>;
  starts_time: Maybe<Scalars['DateTime']['output']>;
  status: Maybe<Scalars['String']['output']>;
  stripe_id: Maybe<Scalars['String']['output']>;
  stripe_transfer_id: Maybe<Scalars['String']['output']>;
  timecard_ids: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  updated_at: Scalars['DateTime']['output'];
  w2_submit_by_time: Maybe<Scalars['DateTime']['output']>;
};

export type PayoutOrderInput = {
  account_type: InputMaybe<Scalars['Boolean']['input']>;
  amount_cents: InputMaybe<Scalars['Boolean']['input']>;
  amount_currency: InputMaybe<Scalars['Boolean']['input']>;
  arrival_date: InputMaybe<Scalars['Boolean']['input']>;
  created_at: InputMaybe<Scalars['Boolean']['input']>;
  ends_time: InputMaybe<Scalars['Boolean']['input']>;
  failed_count: InputMaybe<Scalars['Boolean']['input']>;
  failed_reason: InputMaybe<Scalars['Boolean']['input']>;
  id: InputMaybe<Scalars['Boolean']['input']>;
  notes: InputMaybe<Scalars['Boolean']['input']>;
  pause: InputMaybe<Scalars['Boolean']['input']>;
  processed_on: InputMaybe<Scalars['Boolean']['input']>;
  professional_id: InputMaybe<Scalars['Boolean']['input']>;
  source_type: InputMaybe<Scalars['Boolean']['input']>;
  status: InputMaybe<Scalars['Boolean']['input']>;
  stripe_id: InputMaybe<Scalars['Boolean']['input']>;
  updated_at: InputMaybe<Scalars['Boolean']['input']>;
  w2_submit_by_time: InputMaybe<Scalars['Boolean']['input']>;
};

export type PayoutQueryInput = {
  filter: InputMaybe<PayoutWhereInput>;
  orderBy: InputMaybe<PayoutOrderInput>;
  page: InputMaybe<Scalars['Int']['input']>;
  perPage: InputMaybe<Scalars['Int']['input']>;
  search: InputMaybe<PayoutSearchInput>;
};

export type PayoutSearchInput = {
  account_id: InputMaybe<Scalars['Int']['input']>;
  agency_payout_statuses: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  created_from_date: InputMaybe<Scalars['Date']['input']>;
  created_to_date: InputMaybe<Scalars['Date']['input']>;
  ends_date_after: InputMaybe<Scalars['Date']['input']>;
  ends_time_from: InputMaybe<Scalars['Date']['input']>;
  ends_time_to: InputMaybe<Scalars['Date']['input']>;
  failed_payouts: InputMaybe<Scalars['Boolean']['input']>;
  failing_payouts: InputMaybe<Scalars['Boolean']['input']>;
  for_assignment: InputMaybe<Scalars['Boolean']['input']>;
  has_balance: InputMaybe<Scalars['Boolean']['input']>;
  hide_zero_value_payouts: InputMaybe<Scalars['Boolean']['input']>;
  id: InputMaybe<Scalars['Int']['input']>;
  professional_account_id: InputMaybe<Scalars['Int']['input']>;
  professional_id: InputMaybe<Scalars['Int']['input']>;
  professional_ids: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  /**
   * *Constraints:*
   * * Maximal length: `150`
   *
   */
  q: InputMaybe<Scalars['String']['input']>;
  starts_date_before: InputMaybe<Scalars['Date']['input']>;
  status: InputMaybe<Scalars['String']['input']>;
  statuses: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  w2_submit_by_time: InputMaybe<Scalars['Boolean']['input']>;
  w2_submit_by_time_from: InputMaybe<Scalars['DateTime']['input']>;
  w2_submit_by_time_to: InputMaybe<Scalars['DateTime']['input']>;
  w2_submit_from_date: InputMaybe<Scalars['Date']['input']>;
  w2_submit_to_date: InputMaybe<Scalars['Date']['input']>;
};

export type PayoutWhereInput = {
  account_type: InputMaybe<Scalars['String']['input']>;
  amount_cents: InputMaybe<Scalars['Int']['input']>;
  amount_currency: InputMaybe<Scalars['String']['input']>;
  arrival_date: InputMaybe<Scalars['DateTime']['input']>;
  assignment_id: InputMaybe<Scalars['Int']['input']>;
  created_at: InputMaybe<Scalars['DateTime']['input']>;
  failed_count: InputMaybe<Scalars['Int']['input']>;
  failed_reason: InputMaybe<Scalars['String']['input']>;
  id: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  notes: InputMaybe<Scalars['String']['input']>;
  pause: InputMaybe<Scalars['Boolean']['input']>;
  processed_on: InputMaybe<Scalars['DateTime']['input']>;
  professional_id: InputMaybe<Scalars['Int']['input']>;
  source_type: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Scalars['String']['input']>;
  stripe_id: InputMaybe<Scalars['String']['input']>;
  updated_at: InputMaybe<Scalars['DateTime']['input']>;
};

export type PermissionGroup = {
  __typename?: 'PermissionGroup';
  account_type: Scalars['String']['output'];
  created_at: Scalars['DateTime']['output'];
  description: Maybe<Scalars['String']['output']>;
  display_name: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  permissions: Scalars['JSON']['output'];
  role: Scalars['String']['output'];
  updated_at: Scalars['DateTime']['output'];
};

export type PermissionGroupOrderInput = {
  active: InputMaybe<Scalars['Boolean']['input']>;
  created_at: InputMaybe<Scalars['Boolean']['input']>;
  id: InputMaybe<Scalars['Boolean']['input']>;
  updated_at: InputMaybe<Scalars['Boolean']['input']>;
  user_id: InputMaybe<Scalars['Int']['input']>;
};

export type PermissionGroupQueryInput = {
  filter: InputMaybe<PermissionGroupWhereInput>;
  orderBy: InputMaybe<PermissionGroupOrderInput>;
  page: InputMaybe<Scalars['Int']['input']>;
  perPage: InputMaybe<Scalars['Int']['input']>;
  search: InputMaybe<PermissionGroupSearchInput>;
};

export type PermissionGroupSearchInput = {
  facility_role: InputMaybe<Scalars['Int']['input']>;
  id: InputMaybe<Scalars['Int']['input']>;
  professional_role: InputMaybe<Scalars['Int']['input']>;
};

export type PermissionGroupWhereInput = {
  account_type: InputMaybe<Scalars['String']['input']>;
  id: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};

export type Person = {
  __typename?: 'Person';
  address_city: Maybe<Scalars['String']['output']>;
  address_first: Maybe<Scalars['String']['output']>;
  address_second: Maybe<Scalars['String']['output']>;
  address_zip: Maybe<Scalars['String']['output']>;
  administrator: Maybe<Administrator>;
  created_at: Scalars['DateTime']['output'];
  current_sign_in_at: Maybe<Scalars['DateTime']['output']>;
  current_sign_in_ip: Maybe<Scalars['String']['output']>;
  email: Scalars['String']['output'];
  email_notification: Scalars['Boolean']['output'];
  encrypted_password: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  last_sign_in_at: Maybe<Scalars['DateTime']['output']>;
  last_sign_in_ip: Maybe<Scalars['String']['output']>;
  phone_number: Maybe<Scalars['String']['output']>;
  professional: Maybe<Professional>;
  remember_created_at: Maybe<Scalars['DateTime']['output']>;
  reset_password_sent_at: Maybe<Scalars['DateTime']['output']>;
  reset_password_token: Maybe<Scalars['String']['output']>;
  role: Maybe<Scalars['String']['output']>;
  role_record: Maybe<Scalars['String']['output']>;
  sign_in_count: Scalars['Int']['output'];
  sms_notification: Scalars['Boolean']['output'];
  sms_notification_bulk: Scalars['Boolean']['output'];
  ssn_last_4: Maybe<Scalars['String']['output']>;
  state: Maybe<State>;
  updated_at: Scalars['DateTime']['output'];
  user: Maybe<User>;
  utm_campaign: Maybe<Scalars['String']['output']>;
  utm_source: Maybe<Scalars['String']['output']>;
};

export type PersonDisabledReason = {
  __typename?: 'PersonDisabledReason';
  created_at: Maybe<Scalars['DateTime']['output']>;
  disabled_reason: Maybe<DisabledReason>;
  id: Maybe<Scalars['Int']['output']>;
  personable: Maybe<Personable>;
  personable_id: Maybe<Scalars['Int']['output']>;
  personable_type: Maybe<Scalars['String']['output']>;
  updated_at: Maybe<Scalars['DateTime']['output']>;
};

export type PersonDisabledReasonOrderInput = {
  created_at: InputMaybe<Scalars['Boolean']['input']>;
  disabled_reason_id: InputMaybe<Scalars['Boolean']['input']>;
  id: InputMaybe<Scalars['Boolean']['input']>;
  personable_id: InputMaybe<Scalars['Boolean']['input']>;
  personable_type: InputMaybe<Scalars['Boolean']['input']>;
  updated_at: InputMaybe<Scalars['Boolean']['input']>;
};

export type PersonDisabledReasonQueryInput = {
  filter: InputMaybe<PersonDisabledReasonWhereInput>;
  orderBy: InputMaybe<PersonDisabledReasonOrderInput>;
  page: InputMaybe<Scalars['Int']['input']>;
  perPage: InputMaybe<Scalars['Int']['input']>;
  search: InputMaybe<DefaultSearchInput>;
};

export type PersonDisabledReasonWhereInput = {
  created_at: InputMaybe<Scalars['DateTime']['input']>;
  disabled_reason_id: InputMaybe<Scalars['Int']['input']>;
  id: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  personable_id: InputMaybe<Scalars['Int']['input']>;
  personable_type: InputMaybe<Scalars['String']['input']>;
  updated_at: InputMaybe<Scalars['DateTime']['input']>;
};

export type PersonOrderInput = {
  address_city: InputMaybe<Scalars['Boolean']['input']>;
  address_first: InputMaybe<Scalars['Boolean']['input']>;
  address_second: InputMaybe<Scalars['Boolean']['input']>;
  address_zip: InputMaybe<Scalars['Boolean']['input']>;
  created_at: InputMaybe<Scalars['Boolean']['input']>;
  current_sign_in_at: InputMaybe<Scalars['Boolean']['input']>;
  current_sign_in_ip: InputMaybe<Scalars['Boolean']['input']>;
  email: InputMaybe<Scalars['Boolean']['input']>;
  encrypted_password: InputMaybe<Scalars['Boolean']['input']>;
  id: InputMaybe<Scalars['Boolean']['input']>;
  last_sign_in_at: InputMaybe<Scalars['Boolean']['input']>;
  last_sign_in_ip: InputMaybe<Scalars['Boolean']['input']>;
  phone_number: InputMaybe<Scalars['Boolean']['input']>;
  remember_created_at: InputMaybe<Scalars['Boolean']['input']>;
  reset_password_sent_at: InputMaybe<Scalars['Boolean']['input']>;
  reset_password_token: InputMaybe<Scalars['Boolean']['input']>;
  role: InputMaybe<Scalars['Boolean']['input']>;
  role_record: InputMaybe<Scalars['Boolean']['input']>;
  sign_in_count: InputMaybe<Scalars['Boolean']['input']>;
  ssn_last_4: InputMaybe<Scalars['Boolean']['input']>;
  state_id: InputMaybe<Scalars['Boolean']['input']>;
  updated_at: InputMaybe<Scalars['Boolean']['input']>;
};

export type PersonQueryInput = {
  filter: InputMaybe<PersonWhereInput>;
  orderBy: InputMaybe<PersonOrderInput>;
  page: InputMaybe<Scalars['Int']['input']>;
  perPage: InputMaybe<Scalars['Int']['input']>;
  search: InputMaybe<DefaultSearchInput>;
};

export type PersonWhereInput = {
  address_city: InputMaybe<Scalars['String']['input']>;
  address_first: InputMaybe<Scalars['String']['input']>;
  address_second: InputMaybe<Scalars['String']['input']>;
  address_zip: InputMaybe<Scalars['String']['input']>;
  created_at: InputMaybe<Scalars['DateTime']['input']>;
  current_sign_in_at: InputMaybe<Scalars['DateTime']['input']>;
  current_sign_in_ip: InputMaybe<Scalars['String']['input']>;
  email: InputMaybe<Scalars['String']['input']>;
  encrypted_password: InputMaybe<Scalars['String']['input']>;
  id: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  last_sign_in_at: InputMaybe<Scalars['DateTime']['input']>;
  last_sign_in_ip: InputMaybe<Scalars['String']['input']>;
  phone_number: InputMaybe<Scalars['String']['input']>;
  remember_created_at: InputMaybe<Scalars['DateTime']['input']>;
  reset_password_sent_at: InputMaybe<Scalars['DateTime']['input']>;
  reset_password_token: InputMaybe<Scalars['String']['input']>;
  role: InputMaybe<Scalars['String']['input']>;
  role_record: InputMaybe<Scalars['String']['input']>;
  sign_in_count: InputMaybe<Scalars['Int']['input']>;
  ssn_last_4: InputMaybe<Scalars['String']['input']>;
  state_id: InputMaybe<Scalars['Int']['input']>;
  updated_at: InputMaybe<Scalars['DateTime']['input']>;
  utm_campaign: InputMaybe<Scalars['String']['input']>;
  utm_source: InputMaybe<Scalars['String']['input']>;
};

export type Personable = BillingGroup | Location | Professional;

export type PhoneScreeningRequest = {
  __typename?: 'PhoneScreeningRequest';
  assignment_request: Maybe<AssignmentRequest>;
  assignment_request_id: Maybe<Scalars['Int']['output']>;
  conference_sid: Maybe<Scalars['String']['output']>;
  confirmed_phone_screening_time: Maybe<Scalars['DateTime']['output']>;
  created_at: Scalars['DateTime']['output'];
  id: Scalars['Int']['output'];
  interviewer_account_id: Maybe<Scalars['String']['output']>;
  interviewer_name: Maybe<Scalars['String']['output']>;
  masked_interviewer_phone_number: Maybe<Scalars['String']['output']>;
  masked_professional_phone_number: Maybe<Scalars['String']['output']>;
  masked_professional_phone_number_sid: Maybe<Scalars['String']['output']>;
  phone_screening_times: Maybe<Array<Maybe<Scalars['DateTime']['output']>>>;
  professional: Maybe<Professional>;
  professional_id: Maybe<Scalars['Int']['output']>;
  status: Scalars['String']['output'];
  updated_at: Scalars['DateTime']['output'];
};

export type PhoneScreeningRequestOrderInput = {
  assignment_id: InputMaybe<Scalars['Boolean']['input']>;
  assignment_request_id: InputMaybe<Scalars['Boolean']['input']>;
  conference_sid: InputMaybe<Scalars['Boolean']['input']>;
  confirmed_phone_screening_time: InputMaybe<Scalars['Boolean']['input']>;
  created_at: InputMaybe<Scalars['Boolean']['input']>;
  facility_contact_phone_number: InputMaybe<Scalars['Boolean']['input']>;
  id: InputMaybe<Scalars['Boolean']['input']>;
  interviewer_name: InputMaybe<Scalars['Boolean']['input']>;
  location_id: InputMaybe<Scalars['Boolean']['input']>;
  masked_interviewer_phone_number: InputMaybe<Scalars['Boolean']['input']>;
  masked_professional_phone_number: InputMaybe<Scalars['Boolean']['input']>;
  masked_professional_phone_number_sid: InputMaybe<Scalars['Boolean']['input']>;
  phone_screening_times: InputMaybe<Scalars['Boolean']['input']>;
  professional_id: InputMaybe<Scalars['Boolean']['input']>;
  status: InputMaybe<Scalars['Boolean']['input']>;
  updated_at: InputMaybe<Scalars['Boolean']['input']>;
};

export type PhoneScreeningRequestQueryInput = {
  filter: InputMaybe<PhoneScreeningRequestWhereInput>;
  orderBy: InputMaybe<PhoneScreeningRequestOrderInput>;
  page: InputMaybe<Scalars['Int']['input']>;
  perPage: InputMaybe<Scalars['Int']['input']>;
  search: InputMaybe<PhoneScreeningSearchInput>;
};

export type PhoneScreeningRequestWhereInput = {
  assignment_id: InputMaybe<Scalars['Int']['input']>;
  assignment_request_id: InputMaybe<Scalars['Int']['input']>;
  conference_sid: InputMaybe<Scalars['String']['input']>;
  confirmed_phone_screening_time: InputMaybe<Scalars['DateTime']['input']>;
  created_at: InputMaybe<Scalars['DateTime']['input']>;
  facility_contact_phone_number: InputMaybe<Scalars['String']['input']>;
  id: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  interviewer_account_id: InputMaybe<Scalars['Int']['input']>;
  interviewer_name: InputMaybe<Scalars['Boolean']['input']>;
  location_id: InputMaybe<Scalars['Int']['input']>;
  masked_interviewer_phone_number: InputMaybe<Scalars['Boolean']['input']>;
  masked_professional_phone_number: InputMaybe<Scalars['String']['input']>;
  masked_professional_phone_number_sid: InputMaybe<Scalars['String']['input']>;
  phone_screening_times: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  professional_id: InputMaybe<Scalars['Int']['input']>;
  status: InputMaybe<Scalars['String']['input']>;
  updated_at: InputMaybe<Scalars['DateTime']['input']>;
};

export type PhoneScreeningSearchInput = {
  date_from: InputMaybe<Scalars['Date']['input']>;
  date_to: InputMaybe<Scalars['Date']['input']>;
  interviewer_account_id: InputMaybe<Scalars['Int']['input']>;
};

export type PoolProfessionalInput = {
  id: Scalars['Int']['input'];
  location_id: Scalars['Int']['input'];
};

export type Position = {
  __typename?: 'Position';
  active: Scalars['Boolean']['output'];
  assignments: Maybe<Array<Maybe<Assignment>>>;
  created_at: Scalars['DateTime']['output'];
  display_name: Maybe<Scalars['String']['output']>;
  hospital_mark_up: Scalars['Float']['output'];
  id: Scalars['Int']['output'];
  incrementality: Maybe<Scalars['String']['output']>;
  invoices: Maybe<Array<Maybe<Invoice>>>;
  job_templates: Maybe<Array<Maybe<JobTemplate>>>;
  jobs: Maybe<Array<Maybe<Job>>>;
  kind: Maybe<Scalars['String']['output']>;
  lead_description: Maybe<Scalars['String']['output']>;
  lead_question: Maybe<Scalars['String']['output']>;
  license_names: Maybe<Scalars['String']['output']>;
  location_positions: Maybe<Array<Maybe<LocationPosition>>>;
  locations: Maybe<Array<Maybe<Location>>>;
  markets: Maybe<Array<Maybe<Market>>>;
  name: Maybe<Scalars['String']['output']>;
  nested_jobs: Maybe<Array<Maybe<Job>>>;
  professional_description: Maybe<Scalars['String']['output']>;
  professional_question: Maybe<Scalars['String']['output']>;
  professionals: Maybe<Array<Maybe<Professional>>>;
  qualifications_group: Maybe<QualificationsGroup>;
  qualifications_group_id: Maybe<Scalars['Int']['output']>;
  recommended_position_ids: Array<Scalars['Int']['output']>;
  recommended_positions: Array<Position>;
  requirements_description: Maybe<Scalars['String']['output']>;
  requires_specialty: Scalars['Boolean']['output'];
  responsibilities: Maybe<Scalars['String']['output']>;
  sequence: Scalars['Int']['output'];
  specialties: Maybe<Array<Maybe<Specialty>>>;
  specialty_list: Maybe<Scalars['String']['output']>;
  updated_at: Scalars['DateTime']['output'];
};


export type PositionIncrementalityArgs = {
  market_ids: Array<InputMaybe<Scalars['Int']['input']>>;
};


export type PositionJobsArgs = {
  gte_starts_date: Scalars['Date']['input'];
  location_id: Array<InputMaybe<Scalars['Int']['input']>>;
  lte_starts_date: Scalars['Date']['input'];
};

export type PositionOrderInput = {
  active: InputMaybe<Scalars['Boolean']['input']>;
  created_at: InputMaybe<Scalars['Boolean']['input']>;
  display_name: InputMaybe<Scalars['Boolean']['input']>;
  id: InputMaybe<Scalars['Boolean']['input']>;
  kind: InputMaybe<Scalars['Boolean']['input']>;
  license_names: InputMaybe<Scalars['Boolean']['input']>;
  name: InputMaybe<Scalars['Boolean']['input']>;
  professional_description: InputMaybe<Scalars['Boolean']['input']>;
  professional_question: InputMaybe<Scalars['Boolean']['input']>;
  qualifications_group_id: InputMaybe<Scalars['Boolean']['input']>;
  responsibilities: InputMaybe<Scalars['Boolean']['input']>;
  sequence: InputMaybe<Scalars['Boolean']['input']>;
  specialty_list: InputMaybe<Scalars['Boolean']['input']>;
  updated_at: InputMaybe<Scalars['Boolean']['input']>;
};

export type PositionPostingField = {
  __typename?: 'PositionPostingField';
  created_at: Scalars['DateTime']['output'];
  id: Scalars['Int']['output'];
  position: Maybe<Position>;
  position_id: Scalars['Int']['output'];
  posting_field: PostingField;
  posting_field_id: Scalars['Int']['output'];
};

export type PositionPostingFieldOrderInput = {
  id: InputMaybe<Scalars['Boolean']['input']>;
  position_id: InputMaybe<Scalars['Boolean']['input']>;
  posting_field_id: InputMaybe<Scalars['Boolean']['input']>;
};

export type PositionPostingFieldQueryInput = {
  filter: InputMaybe<PositionPostingFieldWhereInput>;
  orderBy: InputMaybe<PositionPostingFieldOrderInput>;
  page: InputMaybe<Scalars['Int']['input']>;
  perPage: InputMaybe<Scalars['Int']['input']>;
  search: InputMaybe<PositionPostingFieldSearchInput>;
};

export type PositionPostingFieldSearchInput = {
  id: InputMaybe<Scalars['Int']['input']>;
  position_id: InputMaybe<Scalars['Int']['input']>;
  posting_field_id: InputMaybe<Scalars['Int']['input']>;
};

export type PositionPostingFieldWhereInput = {
  id: InputMaybe<Scalars['Int']['input']>;
  position_id: InputMaybe<Scalars['Int']['input']>;
  posting_field_id: InputMaybe<Scalars['Int']['input']>;
};

export type PositionQueryInput = {
  filter: InputMaybe<PositionWhereInput>;
  orderBy: InputMaybe<PositionOrderInput>;
  page: InputMaybe<Scalars['Int']['input']>;
  perPage: InputMaybe<Scalars['Int']['input']>;
  search: InputMaybe<PositionSearchInput>;
};

export type PositionSearchInput = {
  active: InputMaybe<Scalars['Boolean']['input']>;
  agency_id: InputMaybe<Scalars['Int']['input']>;
  for_assignment: InputMaybe<Scalars['Boolean']['input']>;
  for_job: InputMaybe<Scalars['Boolean']['input']>;
  for_locations: InputMaybe<ForLocations>;
  for_locations_jobs: InputMaybe<ForLocationsJobsInput>;
  for_time_tracking: InputMaybe<ForTimeTrackingInput>;
  kinds: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  location_ids: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  position_ids: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  /**
   * *Constraints:*
   * * Maximal length: `150`
   *
   */
  q: InputMaybe<Scalars['String']['input']>;
  recommended_for_location_ids_sort: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  recommended_for_location_type_id_sort: InputMaybe<Scalars['Int']['input']>;
};

export type PositionSettings = {
  __typename?: 'PositionSettings';
  agency_charge_rate_cents: Maybe<Scalars['Int']['output']>;
  agency_release_lead_time_hours: Maybe<Scalars['Int']['output']>;
  assignment_bonus_tier1_travel_amount_cents: Maybe<Scalars['Int']['output']>;
  assignment_bonus_tier1_travel_amount_tcv_cents: Maybe<Scalars['Int']['output']>;
  assignment_bonus_tier2_travel_amount_cents: Maybe<Scalars['Int']['output']>;
  assignment_bonus_tier2_travel_amount_tcv_cents: Maybe<Scalars['Int']['output']>;
  can_post_assignment: Maybe<Scalars['Boolean']['output']>;
  can_post_job: Maybe<Scalars['Boolean']['output']>;
  charge_on_call_hourly_rate_cents: Maybe<Scalars['Float']['output']>;
  charge_on_call_hourly_rate_currency: Maybe<Scalars['String']['output']>;
  charge_overtime_multiplier: Maybe<Scalars['Float']['output']>;
  charge_rate_cents: Maybe<Scalars['Int']['output']>;
  charge_rate_minimum_cents: Maybe<Scalars['Int']['output']>;
  fee_percent: Maybe<Scalars['String']['output']>;
  margin_percent_1099: Maybe<Scalars['String']['output']>;
  margin_percent_w2_local: Maybe<Scalars['String']['output']>;
  margin_percent_w2_tcv: Maybe<Scalars['String']['output']>;
  margin_percent_w2_travel: Maybe<Scalars['String']['output']>;
  margin_w2_tcv_cents: Maybe<Scalars['Int']['output']>;
  on_call_fee_percent: Maybe<Scalars['String']['output']>;
  payout_on_call_hourly_rate_cents: Maybe<Scalars['Int']['output']>;
  payout_on_call_hourly_rate_currency: Maybe<Scalars['String']['output']>;
  payout_overtime_multiplier: Maybe<Scalars['Float']['output']>;
  ten99_assignment: Maybe<Scalars['JSON']['output']>;
  ten99_per_diem: Maybe<Scalars['JSON']['output']>;
  use_agency_charge_rate_cents: Maybe<Scalars['Boolean']['output']>;
  w2: Maybe<Scalars['JSON']['output']>;
  w2_fee_percent: Maybe<Scalars['String']['output']>;
  w2_per_diem: Maybe<Scalars['JSON']['output']>;
};

export type PositionSpecialty = {
  __typename?: 'PositionSpecialty';
  created_at: Scalars['DateTime']['output'];
  id: Scalars['Int']['output'];
  position: Maybe<Position>;
  specialty: Maybe<Specialty>;
  updated_at: Scalars['DateTime']['output'];
};

export type PositionSpecialtyOrderInput = {
  created_at: InputMaybe<Scalars['Boolean']['input']>;
  id: InputMaybe<Scalars['Boolean']['input']>;
  position_id: InputMaybe<Scalars['Boolean']['input']>;
  specialty_id: InputMaybe<Scalars['Boolean']['input']>;
  updated_at: InputMaybe<Scalars['Boolean']['input']>;
};

export type PositionSpecialtyQueryInput = {
  filter: InputMaybe<PositionSpecialtyWhereInput>;
  orderBy: InputMaybe<PositionSpecialtyOrderInput>;
  page: InputMaybe<Scalars['Int']['input']>;
  perPage: InputMaybe<Scalars['Int']['input']>;
  search: InputMaybe<DefaultSearchInput>;
};

export type PositionSpecialtyWhereInput = {
  created_at: InputMaybe<Scalars['DateTime']['input']>;
  id: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  position_id: InputMaybe<Scalars['Int']['input']>;
  specialty_id: InputMaybe<Scalars['Int']['input']>;
  updated_at: InputMaybe<Scalars['DateTime']['input']>;
};

export type PositionWhereInput = {
  active: InputMaybe<Scalars['Boolean']['input']>;
  created_at: InputMaybe<Scalars['DateTime']['input']>;
  display_name: InputMaybe<Scalars['String']['input']>;
  id: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  kind: InputMaybe<Scalars['String']['input']>;
  kinds: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  license_names: InputMaybe<Scalars['String']['input']>;
  name: InputMaybe<Scalars['String']['input']>;
  professional_description: InputMaybe<Scalars['String']['input']>;
  professional_question: InputMaybe<Scalars['String']['input']>;
  /**
   * *Constraints:*
   * * Maximal length: `150`
   *
   */
  q: InputMaybe<Scalars['String']['input']>;
  qualifications_group_id: InputMaybe<Scalars['Int']['input']>;
  responsibilities: InputMaybe<Scalars['String']['input']>;
  sequence: InputMaybe<Scalars['Int']['input']>;
  specialty_list: InputMaybe<Scalars['String']['input']>;
  updated_at: InputMaybe<Scalars['DateTime']['input']>;
};

export type PostingField = {
  __typename?: 'PostingField';
  constraints: Maybe<Scalars['JSON']['output']>;
  created_at: Scalars['DateTime']['output'];
  description: Scalars['String']['output'];
  field_type: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  label: Scalars['String']['output'];
  required: Scalars['Boolean']['output'];
  show_on_assignment: Scalars['Boolean']['output'];
  show_on_per_diem: Scalars['Boolean']['output'];
  slug: Maybe<Scalars['String']['output']>;
  updated_at: Scalars['DateTime']['output'];
};

export type PostingFieldOrderInput = {
  description: InputMaybe<Scalars['Boolean']['input']>;
  field_type: InputMaybe<Scalars['Boolean']['input']>;
  id: InputMaybe<Scalars['Boolean']['input']>;
  label: InputMaybe<Scalars['Boolean']['input']>;
  required: InputMaybe<Scalars['Boolean']['input']>;
  show_on_assignment: InputMaybe<Scalars['Boolean']['input']>;
  show_on_per_diem: InputMaybe<Scalars['Boolean']['input']>;
  slug: InputMaybe<Scalars['Boolean']['input']>;
};

export type PostingFieldQueryInput = {
  filter: InputMaybe<PostingFieldWhereInput>;
  orderBy: InputMaybe<PostingFieldOrderInput>;
  page: InputMaybe<Scalars['Int']['input']>;
  perPage: InputMaybe<Scalars['Int']['input']>;
  search: InputMaybe<PostingFieldSearchInput>;
};

export type PostingFieldSearchInput = {
  description: InputMaybe<Scalars['String']['input']>;
  field_type: InputMaybe<Scalars['String']['input']>;
  id: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  label: InputMaybe<Scalars['String']['input']>;
  position_ids: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  /**
   * *Constraints:*
   * * Maximal length: `150`
   *
   */
  q: InputMaybe<Scalars['String']['input']>;
  required: InputMaybe<Scalars['Boolean']['input']>;
  show_on_assignment: InputMaybe<Scalars['Boolean']['input']>;
  show_on_per_diem: InputMaybe<Scalars['Boolean']['input']>;
  slug: InputMaybe<Scalars['String']['input']>;
};

export type PostingFieldWhereInput = {
  description: InputMaybe<Scalars['String']['input']>;
  field_type: InputMaybe<Scalars['String']['input']>;
  id: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  label: InputMaybe<Scalars['String']['input']>;
  required: InputMaybe<Scalars['Boolean']['input']>;
  show_on_assignment: InputMaybe<Scalars['Boolean']['input']>;
  show_on_per_diem: InputMaybe<Scalars['Boolean']['input']>;
  slug: InputMaybe<Scalars['String']['input']>;
};

export type Professional = {
  __typename?: 'Professional';
  account: Maybe<Account>;
  account_id: Scalars['Int']['output'];
  adp_file_number: Maybe<Scalars['String']['output']>;
  all_time_total_earnings_cents: Maybe<Scalars['Int']['output']>;
  application_status: Scalars['String']['output'];
  application_version: ApplicationVersion;
  archive_reason: Maybe<Scalars['String']['output']>;
  assignments: Maybe<Array<Maybe<Assignment>>>;
  available: Maybe<Scalars['Boolean']['output']>;
  background_check_authorized: Scalars['Boolean']['output'];
  background_check_pqs: Maybe<Array<Maybe<ProfessionalQualification>>>;
  background_checks: Maybe<Array<Maybe<BackgroundCheck>>>;
  balance_cents: Scalars['Int']['output'];
  balance_currency: Scalars['String']['output'];
  bank_last: Maybe<Scalars['String']['output']>;
  booked_total_cents: Maybe<Scalars['Int']['output']>;
  business_tax_id: Maybe<Scalars['String']['output']>;
  calendly_invitee_uuid: Maybe<Scalars['String']['output']>;
  can_accept_assignment_offer: Maybe<Scalars['Boolean']['output']>;
  can_book_job: Scalars['Boolean']['output'];
  cancellation_ratio: Maybe<Scalars['Float']['output']>;
  capsReports: Maybe<Array<Maybe<CapsReport>>>;
  completed_video: Scalars['Boolean']['output'];
  created_at: Scalars['DateTime']['output'];
  credentials_status: Maybe<Scalars['String']['output']>;
  deactivation_reason: Maybe<Scalars['String']['output']>;
  detailed_notes: Maybe<Scalars['String']['output']>;
  dob: Maybe<Scalars['Date']['output']>;
  drug_screening_completed: Scalars['Boolean']['output'];
  emergency_contacts: Maybe<Array<Maybe<EmergencyContact>>>;
  has_active_funding_source: Maybe<Scalars['Boolean']['output']>;
  has_active_jobs_here: Maybe<Scalars['Boolean']['output']>;
  has_item: Maybe<Scalars['Boolean']['output']>;
  has_item_url: Maybe<Scalars['Boolean']['output']>;
  has_markets: Maybe<Scalars['Boolean']['output']>;
  has_upload_pdf: Scalars['Boolean']['output'];
  hours_need_updating: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
  in_nursys_list: Scalars['Boolean']['output'];
  invite_code: Maybe<Scalars['String']['output']>;
  is_any_favorite: Maybe<Scalars['Boolean']['output']>;
  is_blocked: Maybe<Scalars['Boolean']['output']>;
  is_favorite: Maybe<Scalars['Boolean']['output']>;
  jobs: Maybe<Array<Maybe<Job>>>;
  /** @deprecated use professionals.kinds instead */
  kind: Scalars['String']['output'];
  kinds: Array<Scalars['String']['output']>;
  last_updated_preferred_hours_at: Maybe<Scalars['DateTime']['output']>;
  late_clockin_ratio: Maybe<Scalars['Float']['output']>;
  markets: Maybe<Array<Maybe<Market>>>;
  migrated_lead_id: Maybe<Scalars['Int']['output']>;
  migrated_staff_id: Maybe<Scalars['Int']['output']>;
  most_recent_shift: Maybe<RecentShift>;
  name: Maybe<Scalars['String']['output']>;
  new_to_medely: Scalars['Boolean']['output'];
  nickname: Maybe<Scalars['String']['output']>;
  notes: Maybe<Array<Maybe<Note>>>;
  nursysEnrollments: Maybe<Array<Maybe<NursysEnrollment>>>;
  other_referral_source: Maybe<Scalars['String']['output']>;
  paylocity_external_id: Maybe<Scalars['String']['output']>;
  phone_interviewed: Maybe<Scalars['Boolean']['output']>;
  phone_screen_date_and_time: Maybe<Scalars['DateTime']['output']>;
  plaid_token: Maybe<Scalars['String']['output']>;
  positions: Maybe<Array<Maybe<Position>>>;
  positions_onboarding_complete: Maybe<Scalars['Boolean']['output']>;
  possible_duplicate: Maybe<Scalars['Boolean']['output']>;
  preferred_hours_per_week: Maybe<Scalars['Int']['output']>;
  preferred_job_types: Maybe<Scalars['String']['output']>;
  professional_assignment_favorites: Maybe<Array<Maybe<ProfessionalAssignmentFavorite>>>;
  professional_assignment_id: Maybe<Scalars['Int']['output']>;
  professional_positions: Maybe<Array<Maybe<ProfessionalPosition>>>;
  professional_qualifications: Maybe<Array<Maybe<ProfessionalQualification>>>;
  professional_saas_details: Maybe<Array<Maybe<ProfessionalSaasDetail>>>;
  profile_completed: Scalars['Boolean']['output'];
  profile_strength: Scalars['Int']['output'];
  publishable_key: Maybe<Scalars['String']['output']>;
  quick_note: Maybe<Scalars['String']['output']>;
  recruiter: Maybe<Administrator>;
  recruiter_id: Maybe<Scalars['Int']['output']>;
  referral_source: Maybe<ReferralSource>;
  referral_source_id: Maybe<Scalars['Int']['output']>;
  reject_reason: Maybe<Scalars['String']['output']>;
  requested_for_job_id: Scalars['Boolean']['output'];
  required_item_image: Maybe<Scalars['Boolean']['output']>;
  resume: Maybe<Scalars['AWSFile']['output']>;
  rfm: Maybe<Scalars['String']['output']>;
  rfmf: Maybe<Scalars['Int']['output']>;
  rfmr: Maybe<Scalars['Int']['output']>;
  satisfied_condition_ids: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  screening_recruiter: Maybe<Administrator>;
  screening_recruiter_id: Maybe<Scalars['Int']['output']>;
  shifts_completed: Maybe<Scalars['Int']['output']>;
  shifts_completed_here: Maybe<Scalars['Int']['output']>;
  signup_assignment_id: Maybe<Scalars['Int']['output']>;
  specialties: Maybe<Array<Maybe<Specialty>>>;
  status: Scalars['String']['output'];
  stripe_accounts: Maybe<Array<Maybe<StripeAccount>>>;
  stripe_bank_account_token: Maybe<Scalars['String']['output']>;
  stripe_external_account_id: Maybe<Scalars['String']['output']>;
  tax_classification_id: Maybe<Scalars['Int']['output']>;
  travel_email_notification: Maybe<Scalars['Boolean']['output']>;
  travel_email_preferences: Scalars['String']['output'];
  travel_state_names: Maybe<Scalars['String']['output']>;
  travel_states: Maybe<Array<Maybe<State>>>;
  universal_background_checks: Maybe<Array<Maybe<UniversalBackgroundCheck>>>;
  unsubscribe_token: Maybe<Scalars['String']['output']>;
  updated_at: Scalars['DateTime']['output'];
  w2_eligible: Scalars['Boolean']['output'];
  w2_enabled: Scalars['Boolean']['output'];
  w2_onboarding_complete: Maybe<Scalars['Boolean']['output']>;
  welcome_box_sent: Maybe<Scalars['Boolean']['output']>;
  work_gaps: Maybe<Array<Maybe<WorkGap>>>;
  work_histories: Maybe<Array<Maybe<WorkHistory>>>;
  years_experience: Maybe<Scalars['Int']['output']>;
};


export type ProfessionalAvailableArgs = {
  gte_starts_time: Scalars['DateTime']['input'];
  location_id: InputMaybe<Scalars['Int']['input']>;
  lte_starts_time: Scalars['DateTime']['input'];
};


export type ProfessionalCan_Accept_Assignment_OfferArgs = {
  assignment_id: Scalars['Int']['input'];
};


export type ProfessionalCan_Book_JobArgs = {
  job_id: Scalars['Int']['input'];
};


export type ProfessionalHas_Active_Jobs_HereArgs = {
  location_ids: Array<Scalars['Int']['input']>;
};


export type ProfessionalIs_BlockedArgs = {
  location_ids: Array<InputMaybe<Scalars['Int']['input']>>;
};


export type ProfessionalIs_FavoriteArgs = {
  location_ids: Array<InputMaybe<Scalars['Int']['input']>>;
};


export type ProfessionalMost_Recent_ShiftArgs = {
  account_id?: InputMaybe<Scalars['Int']['input']>;
  location_ids: Array<Scalars['Int']['input']>;
};


export type ProfessionalRequested_For_Job_IdArgs = {
  job_id: Scalars['Int']['input'];
};


export type ProfessionalShifts_Completed_HereArgs = {
  location_ids: Array<Scalars['Int']['input']>;
};

export type ProfessionalAssignmentFavorite = {
  __typename?: 'ProfessionalAssignmentFavorite';
  assignment: Assignment;
  assignment_id: Scalars['Int']['output'];
  created_at: Scalars['DateTime']['output'];
  id: Scalars['Int']['output'];
  professional: Maybe<Professional>;
  professional_id: Scalars['Int']['output'];
  updated_at: Scalars['DateTime']['output'];
};

export type ProfessionalAssignmentFavoriteOrderInput = {
  assignment_id: InputMaybe<Scalars['Boolean']['input']>;
  created_at: InputMaybe<Scalars['Boolean']['input']>;
  id: InputMaybe<Scalars['Boolean']['input']>;
  professional_id: InputMaybe<Scalars['Boolean']['input']>;
  updated_at: InputMaybe<Scalars['Boolean']['input']>;
};

export type ProfessionalAssignmentFavoriteQueryInput = {
  filter: InputMaybe<ProfessionalAssignmentFavoriteWhereInput>;
  orderBy: InputMaybe<ProfessionalAssignmentFavoriteOrderInput>;
  page: InputMaybe<Scalars['Int']['input']>;
  perPage: InputMaybe<Scalars['Int']['input']>;
  search: InputMaybe<ProfessionalAssignmentFavoriteSearchInput>;
};

export type ProfessionalAssignmentFavoriteSearchInput = {
  assignment_starts_date: InputMaybe<Scalars['Date']['input']>;
  assignment_statuses: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  last_assignment_request_statuses: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  professional_account_id: InputMaybe<Scalars['Int']['input']>;
  /**
   * *Constraints:*
   * * Maximal length: `150`
   *
   */
  q: InputMaybe<Scalars['String']['input']>;
};

export type ProfessionalAssignmentFavoriteWhereInput = {
  assignment_id: InputMaybe<Scalars['Int']['input']>;
  created_at: InputMaybe<Scalars['DateTime']['input']>;
  id: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  professional_account_id: InputMaybe<Scalars['Int']['input']>;
  professional_id: InputMaybe<Scalars['Int']['input']>;
  updated_at: InputMaybe<Scalars['DateTime']['input']>;
};

export type ProfessionalBlockReason = {
  __typename?: 'ProfessionalBlockReason';
  created_at: Scalars['DateTime']['output'];
  id: Scalars['Int']['output'];
  kind: Scalars['String']['output'];
  label: Maybe<Scalars['String']['output']>;
  relationships: Maybe<Array<Maybe<Relationship>>>;
  updated_at: Scalars['DateTime']['output'];
};

export type ProfessionalBlockReasonOrderInput = {
  created_at: InputMaybe<Scalars['Boolean']['input']>;
  id: InputMaybe<Scalars['Boolean']['input']>;
  kind: InputMaybe<Scalars['Boolean']['input']>;
  label: InputMaybe<Scalars['Boolean']['input']>;
  updated_at: InputMaybe<Scalars['Boolean']['input']>;
};

export type ProfessionalBlockReasonQueryInput = {
  filter: InputMaybe<ProfessionalBlockReasonWhereInput>;
  orderBy: InputMaybe<ProfessionalBlockReasonOrderInput>;
  page: InputMaybe<Scalars['Int']['input']>;
  perPage: InputMaybe<Scalars['Int']['input']>;
  search: InputMaybe<DefaultSearchInput>;
};

export type ProfessionalBlockReasonWhereInput = {
  created_at: InputMaybe<Scalars['DateTime']['input']>;
  id: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  kind: InputMaybe<Scalars['String']['input']>;
  label: InputMaybe<Scalars['String']['input']>;
  updated_at: InputMaybe<Scalars['DateTime']['input']>;
};

export type ProfessionalDistanceCheckInput = {
  coordinates: InputMaybe<Scalars['String']['input']>;
  distance: InputMaybe<Scalars['Int']['input']>;
};

export type ProfessionalJobs = {
  __typename?: 'ProfessionalJobs';
  favorite: Maybe<Scalars['Boolean']['output']>;
  id: Maybe<Scalars['Int']['output']>;
  name: Maybe<Scalars['String']['output']>;
  positions: Maybe<Scalars['String']['output']>;
  total_hours: Maybe<Scalars['Float']['output']>;
};

export type ProfessionalOrderInput = {
  account_id: InputMaybe<Scalars['Boolean']['input']>;
  adp_file_number: InputMaybe<Scalars['Boolean']['input']>;
  application_status: InputMaybe<Scalars['Boolean']['input']>;
  background_check_authorized: InputMaybe<Scalars['Boolean']['input']>;
  balance_cents: InputMaybe<Scalars['Boolean']['input']>;
  balance_currency: InputMaybe<Scalars['Boolean']['input']>;
  bank_last: InputMaybe<Scalars['Boolean']['input']>;
  bookability: InputMaybe<Bookability>;
  business_tax_id: InputMaybe<Scalars['Boolean']['input']>;
  completed_video: InputMaybe<Scalars['Boolean']['input']>;
  created_at: InputMaybe<Scalars['Boolean']['input']>;
  credentials_status: InputMaybe<Scalars['Boolean']['input']>;
  detailed_notes: InputMaybe<Scalars['Boolean']['input']>;
  dob: InputMaybe<Scalars['Boolean']['input']>;
  drug_screening_completed: InputMaybe<Scalars['Boolean']['input']>;
  has_item: InputMaybe<Scalars['Boolean']['input']>;
  hours_need_updating: InputMaybe<Scalars['Boolean']['input']>;
  id: InputMaybe<Scalars['Boolean']['input']>;
  invite_code: InputMaybe<Scalars['Boolean']['input']>;
  kind: InputMaybe<Scalars['Boolean']['input']>;
  last_updated_preferred_hours_at: InputMaybe<Scalars['Boolean']['input']>;
  migrated_lead_id: InputMaybe<Scalars['Boolean']['input']>;
  migrated_staff_id: InputMaybe<Scalars['Boolean']['input']>;
  nickname: InputMaybe<Scalars['Boolean']['input']>;
  paylocity_external_id: InputMaybe<Scalars['Boolean']['input']>;
  phone_screen_date_and_time: InputMaybe<Scalars['Boolean']['input']>;
  plaid_token: InputMaybe<Scalars['Boolean']['input']>;
  preferred_hours_per_week: InputMaybe<Scalars['Boolean']['input']>;
  preferred_job_types: InputMaybe<Scalars['Boolean']['input']>;
  professional_assignment_id: InputMaybe<Scalars['Boolean']['input']>;
  profile_completed: InputMaybe<Scalars['Boolean']['input']>;
  profile_strength: InputMaybe<Scalars['Boolean']['input']>;
  publishable_key: InputMaybe<Scalars['Boolean']['input']>;
  recruiter_id: InputMaybe<Scalars['Boolean']['input']>;
  rfm: InputMaybe<Scalars['Boolean']['input']>;
  rfmf: InputMaybe<Scalars['Boolean']['input']>;
  rfmr: InputMaybe<Scalars['Boolean']['input']>;
  status: InputMaybe<Scalars['Boolean']['input']>;
  stripe_bank_account_token: InputMaybe<Scalars['Boolean']['input']>;
  stripe_external_account_id: InputMaybe<Scalars['Boolean']['input']>;
  tax_classification_id: InputMaybe<Scalars['Boolean']['input']>;
  travel_email_notification: InputMaybe<Scalars['Boolean']['input']>;
  travel_email_preferences: InputMaybe<Scalars['Boolean']['input']>;
  tsv: InputMaybe<Scalars['Boolean']['input']>;
  uid: InputMaybe<Scalars['Boolean']['input']>;
  unsubscribe_token: InputMaybe<Scalars['Boolean']['input']>;
  updated_at: InputMaybe<Scalars['Boolean']['input']>;
  w2_enabled: InputMaybe<Scalars['Boolean']['input']>;
  w2_onboarding_complete: InputMaybe<Scalars['Boolean']['input']>;
  welcome_box_sent: InputMaybe<Scalars['Boolean']['input']>;
};

export type ProfessionalPoolQueryInput = {
  filter: InputMaybe<ProfessionalWhereInput>;
  orderBy: InputMaybe<ProfessionalOrderInput>;
  page: InputMaybe<Scalars['Int']['input']>;
  perPage: InputMaybe<Scalars['Int']['input']>;
  search: InputMaybe<ProfessionalPoolSearchInput>;
};

export type ProfessionalPoolSearchInput = {
  active: InputMaybe<Scalars['Boolean']['input']>;
  adp_file_number: InputMaybe<Scalars['String']['input']>;
  all_positions_onboarded: InputMaybe<Scalars['Boolean']['input']>;
  applied_to_assignment: InputMaybe<Scalars['Int']['input']>;
  created_at: InputMaybe<Scalars['Date']['input']>;
  created_at_from: InputMaybe<Scalars['Date']['input']>;
  created_at_to: InputMaybe<Scalars['Date']['input']>;
  credential_kind: InputMaybe<Scalars['String']['input']>;
  credential_required: InputMaybe<Scalars['Boolean']['input']>;
  credential_status: InputMaybe<Scalars['Int']['input']>;
  credential_types: InputMaybe<Array<Scalars['Int']['input']>>;
  credentials_status: InputMaybe<Scalars['String']['input']>;
  distance_check: InputMaybe<ProfessionalDistanceCheckInput>;
  ehr_system_ids: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  has_recent_shift: InputMaybe<Scalars['Boolean']['input']>;
  kinds: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  location_id: Scalars['Int']['input'];
  market_id: InputMaybe<Scalars['Int']['input']>;
  market_ids: InputMaybe<Array<Scalars['Int']['input']>>;
  position_ids: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  position_ids_all: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  professional_type: InputMaybe<Scalars['String']['input']>;
  /**
   * *Constraints:*
   * * Maximal length: `150`
   *
   */
  q: InputMaybe<Scalars['String']['input']>;
  relationships: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  specialty_ids: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  status: InputMaybe<Scalars['String']['input']>;
};

export type ProfessionalPosition = {
  __typename?: 'ProfessionalPosition';
  completed_onboarding_at: Maybe<Scalars['DateTime']['output']>;
  created_at: Maybe<Scalars['DateTime']['output']>;
  has_recent_experience: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
  position: Maybe<Position>;
  position_id: Maybe<Scalars['Int']['output']>;
  professional: Maybe<Professional>;
  professional_id: Maybe<Scalars['Int']['output']>;
  updated_at: Maybe<Scalars['DateTime']['output']>;
  years_of_experience: Maybe<Scalars['Int']['output']>;
};


export type ProfessionalPositionHas_Recent_ExperienceArgs = {
  within_past_years?: Scalars['Int']['input'];
};

export type ProfessionalPositionOrderInput = {
  created_at: InputMaybe<Scalars['Boolean']['input']>;
  id: InputMaybe<Scalars['Boolean']['input']>;
  position_id: InputMaybe<Scalars['Boolean']['input']>;
  professional_id: InputMaybe<Scalars['Boolean']['input']>;
  updated_at: InputMaybe<Scalars['Boolean']['input']>;
};

export type ProfessionalPositionQueryInput = {
  filter: InputMaybe<ProfessionalPositionWhereInput>;
  orderBy: InputMaybe<ProfessionalPositionOrderInput>;
  page: InputMaybe<Scalars['Int']['input']>;
  perPage: InputMaybe<Scalars['Int']['input']>;
  search: InputMaybe<ProfessionalPositionSearchInput>;
};

export type ProfessionalPositionSearchInput = {
  /**
   * *Constraints:*
   * * Maximal length: `150`
   *
   */
  q: InputMaybe<Scalars['String']['input']>;
};

export type ProfessionalPositionWhereInput = {
  created_at: InputMaybe<Scalars['DateTime']['input']>;
  id: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  position_id: InputMaybe<Scalars['Int']['input']>;
  professional_id: InputMaybe<Scalars['Int']['input']>;
  updated_at: InputMaybe<Scalars['DateTime']['input']>;
};

export type ProfessionalProfile = {
  __typename?: 'ProfessionalProfile';
  custom_professional_profile_ehr_systems: Maybe<Array<Maybe<CustomProfessionalProfileEhrSystem>>>;
  educations: Maybe<Array<Maybe<Education>>>;
  ehr_systems: Maybe<Array<Maybe<EhrSystem>>>;
  id: Scalars['Int']['output'];
  professional: Maybe<Professional>;
  professional_profile_ehr_systems: Maybe<Array<Maybe<ProfessionalProfileEhrSystem>>>;
  professional_references: Maybe<Array<Maybe<ProfessionalReference>>>;
  work_gaps: Maybe<Array<Maybe<WorkGap>>>;
  work_histories: Maybe<Array<Maybe<WorkHistory>>>;
};

export type ProfessionalProfileEhrSystem = {
  __typename?: 'ProfessionalProfileEhrSystem';
  created_at: Scalars['DateTime']['output'];
  ehr_system: Maybe<EhrSystem>;
  ehr_system_id: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  professional_id: Maybe<Scalars['Int']['output']>;
  professional_profile: Maybe<ProfessionalProfile>;
  professional_profile_id: Maybe<Scalars['Int']['output']>;
  updated_at: Scalars['DateTime']['output'];
};

export type ProfessionalProfileEhrSystemOrderInput = {
  id: InputMaybe<Scalars['Boolean']['input']>;
  professional_profile_id: InputMaybe<Scalars['Boolean']['input']>;
};

export type ProfessionalProfileEhrSystemQueryInput = {
  filter: InputMaybe<ProfessionalProfileEhrSystemWhereInput>;
  orderBy: InputMaybe<ProfessionalOrderInput>;
  page: InputMaybe<Scalars['Int']['input']>;
  perPage: InputMaybe<Scalars['Int']['input']>;
  search: InputMaybe<DefaultSearchInput>;
};

export type ProfessionalProfileEhrSystemWhereInput = {
  created_at: InputMaybe<Scalars['DateTime']['input']>;
  ehr_system_id: InputMaybe<Scalars['Int']['input']>;
  id: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  professional_id: InputMaybe<Scalars['Int']['input']>;
  professional_profile_id: InputMaybe<Scalars['Int']['input']>;
  updated_at: InputMaybe<Scalars['DateTime']['input']>;
};

export type ProfessionalProfileOrderInput = {
  id: InputMaybe<Scalars['Boolean']['input']>;
  professional_id: InputMaybe<Scalars['Boolean']['input']>;
};

export type ProfessionalProfileQueryInput = {
  filter: InputMaybe<ProfessionalProfileWhereInput>;
  orderBy: InputMaybe<ProfessionalOrderInput>;
  page: InputMaybe<Scalars['Int']['input']>;
  perPage: InputMaybe<Scalars['Int']['input']>;
  search: InputMaybe<DefaultSearchInput>;
};

export type ProfessionalProfileWhereInput = {
  id: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  professional_id: InputMaybe<Scalars['Int']['input']>;
  professional_type: InputMaybe<Scalars['String']['input']>;
};

export type ProfessionalQualification = {
  __typename?: 'ProfessionalQualification';
  admin_professional_qualification_attributes: Maybe<Array<Maybe<ProfessionalQualificationAttribute>>>;
  created_at: Scalars['DateTime']['output'];
  credential_rejected_reason: Maybe<CredentialRejectedReason>;
  credential_rejected_reason_id: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  last_updated_by_admin: Maybe<Account>;
  last_updated_by_admin_id: Maybe<Scalars['Int']['output']>;
  metadata: Maybe<Scalars['JSON']['output']>;
  professional: Professional;
  professional_id: Scalars['Int']['output'];
  professional_qualification_attributes: Maybe<Array<Maybe<ProfessionalQualificationAttribute>>>;
  qualification: Qualification;
  qualification_id: Scalars['Int']['output'];
  status: Scalars['String']['output'];
  updated_at: Scalars['DateTime']['output'];
};

export type ProfessionalQualificationAttribute = {
  __typename?: 'ProfessionalQualificationAttribute';
  created_at: Scalars['DateTime']['output'];
  id: Scalars['Int']['output'];
  metadata: Maybe<Scalars['JSON']['output']>;
  professional_qualification: ProfessionalQualification;
  professional_qualification_id: Scalars['Int']['output'];
  qualification_attribute: Maybe<QualificationAttribute>;
  qualification_attribute_id: Maybe<Scalars['Int']['output']>;
  state: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
  updated_at: Scalars['DateTime']['output'];
  value: Scalars['ProfessionalQualificationAttributeValue']['output'];
};

export type ProfessionalQualificationAttributeOrderInput = {
  created_at: InputMaybe<Scalars['Boolean']['input']>;
  id: InputMaybe<Scalars['Boolean']['input']>;
  type: InputMaybe<Scalars['Boolean']['input']>;
  updated_at: InputMaybe<Scalars['Boolean']['input']>;
};

export type ProfessionalQualificationAttributeQueryInput = {
  filter: InputMaybe<ProfessionalQualificationAttributeWhereInput>;
  orderBy: InputMaybe<ProfessionalQualificationAttributeOrderInput>;
  page: InputMaybe<Scalars['Int']['input']>;
  perPage: InputMaybe<Scalars['Int']['input']>;
  search: InputMaybe<ProfessionalQualificationAttributeSearchInput>;
};

export type ProfessionalQualificationAttributeSearchInput = {
  qa_active: InputMaybe<Scalars['Boolean']['input']>;
  qa_input_sources: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ProfessionalQualificationAttributeWhereInput = {
  id: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  professional_qualification_id: InputMaybe<Scalars['Int']['input']>;
  qualification_attribute_id: InputMaybe<Scalars['Int']['input']>;
  type: InputMaybe<Scalars['String']['input']>;
};

export type ProfessionalQualificationOrderInput = {
  created_at: InputMaybe<Scalars['Boolean']['input']>;
  credential_rejected_reason_id: InputMaybe<Scalars['Boolean']['input']>;
  id: InputMaybe<Scalars['Boolean']['input']>;
  last_updated_by_admin_id: InputMaybe<Scalars['Boolean']['input']>;
  license_id: InputMaybe<Scalars['Boolean']['input']>;
  license_status: InputMaybe<Scalars['Boolean']['input']>;
  professional_id: InputMaybe<Scalars['Boolean']['input']>;
  status: InputMaybe<Scalars['Boolean']['input']>;
  updated_at: InputMaybe<Scalars['Boolean']['input']>;
};

export type ProfessionalQualificationQueryInput = {
  filter: InputMaybe<ProfessionalQualificationWhereInput>;
  orderBy: InputMaybe<ProfessionalQualificationOrderInput>;
  page: InputMaybe<Scalars['Int']['input']>;
  perPage: InputMaybe<Scalars['Int']['input']>;
  search: InputMaybe<ProfessionalQualificationSearchInput>;
};

export type ProfessionalQualificationSearchInput = {
  condition_ids: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  expiring_professional_qualifications: InputMaybe<Scalars['Int']['input']>;
  kind: InputMaybe<Scalars['Int']['input']>;
  location_ids: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  not_archived: InputMaybe<Scalars['Boolean']['input']>;
  not_uploaded_in_error: InputMaybe<Scalars['Boolean']['input']>;
  professional_account_id: InputMaybe<Scalars['Int']['input']>;
  professional_status: InputMaybe<Scalars['String']['input']>;
  qualification_ids: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  qualification_positions: InputMaybe<QualificationPositionInput>;
  qualification_type: InputMaybe<Scalars['String']['input']>;
  qualification_types: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  required: InputMaybe<Scalars['Boolean']['input']>;
  statuses: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  uploaded_by_saas_professional: InputMaybe<Scalars['Boolean']['input']>;
};

export type ProfessionalQualificationWhereInput = {
  created_at: InputMaybe<Scalars['DateTime']['input']>;
  credential_rejected_reason_id: InputMaybe<Scalars['Int']['input']>;
  id: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  kind: InputMaybe<Scalars['Int']['input']>;
  last_updated_by_admin_id: InputMaybe<Scalars['Int']['input']>;
  license_id: InputMaybe<Scalars['Int']['input']>;
  license_status: InputMaybe<Scalars['String']['input']>;
  professional_id: InputMaybe<Scalars['Int']['input']>;
  status: InputMaybe<Scalars['String']['input']>;
  updated_at: InputMaybe<Scalars['DateTime']['input']>;
};

export type ProfessionalQueryInput = {
  filter: InputMaybe<ProfessionalWhereInput>;
  orderBy: InputMaybe<ProfessionalOrderInput>;
  page: InputMaybe<Scalars['Int']['input']>;
  perPage: InputMaybe<Scalars['Int']['input']>;
  search: InputMaybe<ProfessionalSearchInput>;
};

export type ProfessionalRecentExperience = {
  __typename?: 'ProfessionalRecentExperience';
  has_experience: Maybe<Scalars['Boolean']['output']>;
  position_id: Maybe<Scalars['Int']['output']>;
};

export type ProfessionalReference = {
  __typename?: 'ProfessionalReference';
  comments: Maybe<Scalars['String']['output']>;
  contact_me: Scalars['Boolean']['output'];
  created_at: Scalars['DateTime']['output'];
  current_position: Maybe<Scalars['Boolean']['output']>;
  date_obtained: Maybe<Scalars['Date']['output']>;
  department: Maybe<Scalars['String']['output']>;
  email: Maybe<Scalars['String']['output']>;
  end_date: Maybe<Scalars['DateTime']['output']>;
  first_name: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  is_valid: Scalars['Boolean']['output'];
  last_name: Maybe<Scalars['String']['output']>;
  location: Maybe<Scalars['String']['output']>;
  name: Maybe<Scalars['String']['output']>;
  phone_number: Maybe<Scalars['String']['output']>;
  professional: Maybe<Professional>;
  professional_id: Maybe<Scalars['Int']['output']>;
  professional_profile: Maybe<ProfessionalProfile>;
  professional_profile_id: Maybe<Scalars['Int']['output']>;
  questions: Maybe<Array<Maybe<ReferenceQuestion>>>;
  receive_emails: Scalars['Boolean']['output'];
  rehire_eligibility: Maybe<Scalars['Boolean']['output']>;
  sent_times: Maybe<Array<Maybe<Scalars['DateTime']['output']>>>;
  start_date: Maybe<Scalars['DateTime']['output']>;
  status: Maybe<Scalars['String']['output']>;
  title: Maybe<Scalars['String']['output']>;
  updated_at: Scalars['DateTime']['output'];
  uuid: Maybe<Scalars['String']['output']>;
  work_history: Maybe<WorkHistory>;
  work_history_id: Maybe<Scalars['Int']['output']>;
};

export type ProfessionalReferenceOrderInput = {
  end_date: InputMaybe<Scalars['Boolean']['input']>;
  id: InputMaybe<Scalars['Boolean']['input']>;
  professional_id: InputMaybe<Scalars['Boolean']['input']>;
  professional_profile_id: InputMaybe<Scalars['Boolean']['input']>;
  work_history_id: InputMaybe<Scalars['Boolean']['input']>;
};

export type ProfessionalReferenceQueryInput = {
  filter: InputMaybe<ProfessionalReferenceWhereInput>;
  orderBy: InputMaybe<ProfessionalReferenceOrderInput>;
  page: InputMaybe<Scalars['Int']['input']>;
  perPage: InputMaybe<Scalars['Int']['input']>;
  search: InputMaybe<ProfessionalReferenceSearchInput>;
};

export type ProfessionalReferenceSearchInput = {
  assignment_request_id: InputMaybe<Scalars['Int']['input']>;
  id: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  position_id: InputMaybe<Scalars['Int']['input']>;
  professional_account_id: InputMaybe<Scalars['Int']['input']>;
  professional_id: InputMaybe<Scalars['Int']['input']>;
  /**
   * *Constraints:*
   * * Maximal length: `150`
   *
   */
  q: InputMaybe<Scalars['String']['input']>;
};

export type ProfessionalReferenceWhereInput = {
  assignment_request_id: InputMaybe<Scalars['Int']['input']>;
  contact_me: InputMaybe<Scalars['Boolean']['input']>;
  created_at: InputMaybe<Scalars['DateTime']['input']>;
  date_obtained: InputMaybe<Scalars['Date']['input']>;
  department: InputMaybe<Scalars['String']['input']>;
  email: InputMaybe<Scalars['String']['input']>;
  end_date: InputMaybe<Scalars['DateTime']['input']>;
  first_name: InputMaybe<Scalars['String']['input']>;
  id: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  is_valid: InputMaybe<Scalars['Boolean']['input']>;
  last_name: InputMaybe<Scalars['String']['input']>;
  location: InputMaybe<Scalars['String']['input']>;
  phone_number: InputMaybe<Scalars['String']['input']>;
  position_id: InputMaybe<Scalars['Int']['input']>;
  professional_id: InputMaybe<Scalars['Int']['input']>;
  professional_profile_id: InputMaybe<Scalars['Int']['input']>;
  rehire_eligibility: InputMaybe<Scalars['Boolean']['input']>;
  start_date: InputMaybe<Scalars['DateTime']['input']>;
  status: InputMaybe<Scalars['String']['input']>;
  title: InputMaybe<Scalars['String']['input']>;
  updated_at: InputMaybe<Scalars['DateTime']['input']>;
  uuid: InputMaybe<Scalars['String']['input']>;
  work_history_id: InputMaybe<Scalars['Int']['input']>;
};

export type ProfessionalSaasDetail = {
  __typename?: 'ProfessionalSaasDetail';
  company: Maybe<Company>;
  company_id: Maybe<Scalars['Int']['output']>;
  employment_type: Scalars['String']['output'];
  hourly_rate_cents: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  joined_at: Maybe<Scalars['DateTime']['output']>;
  max_weekly_hours: Maybe<Scalars['Float']['output']>;
  offboarded_at: Maybe<Scalars['DateTime']['output']>;
  offboarded_reason: Maybe<Scalars['String']['output']>;
  professional: Maybe<Professional>;
  professional_id: Scalars['Int']['output'];
  shift_types: Maybe<Scalars['JSON']['output']>;
};

export type ProfessionalSaasDetailOrderInput = {
  id: InputMaybe<Scalars['Boolean']['input']>;
  professional_id: InputMaybe<Scalars['Boolean']['input']>;
};

export type ProfessionalSaasDetailQueryInput = {
  filter: InputMaybe<ProfessionalSaasDetailWhereInput>;
  orderBy: InputMaybe<ProfessionalSaasDetailOrderInput>;
  page: InputMaybe<Scalars['Int']['input']>;
  perPage: InputMaybe<Scalars['Int']['input']>;
  search: InputMaybe<DefaultSearchInput>;
};

export type ProfessionalSaasDetailWhereInput = {
  id: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  professional_id: InputMaybe<Scalars['Int']['input']>;
};

export type ProfessionalSearchInput = {
  active: InputMaybe<Scalars['Boolean']['input']>;
  adp_file_number: InputMaybe<Scalars['String']['input']>;
  agency_id: InputMaybe<Scalars['Int']['input']>;
  all_positions_onboarded: InputMaybe<Scalars['Boolean']['input']>;
  applied_to_assignment: InputMaybe<Scalars['Int']['input']>;
  archive_reason: InputMaybe<Scalars['String']['input']>;
  assignment_request_status: InputMaybe<Scalars['String']['input']>;
  awaiting_caps: InputMaybe<Scalars['Boolean']['input']>;
  background_check_status: InputMaybe<Scalars['String']['input']>;
  blocked_by_location_ids: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  contract_range: InputMaybe<ContractRangeInput>;
  created_at: InputMaybe<Scalars['Date']['input']>;
  created_at_from: InputMaybe<Scalars['Date']['input']>;
  created_at_to: InputMaybe<Scalars['Date']['input']>;
  credential_kind: InputMaybe<Scalars['String']['input']>;
  credential_required: InputMaybe<Scalars['Boolean']['input']>;
  credential_status: InputMaybe<Scalars['Int']['input']>;
  credential_types: InputMaybe<Array<Scalars['Int']['input']>>;
  credentials_status: InputMaybe<Scalars['String']['input']>;
  ehr_system_ids: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  email: InputMaybe<Scalars['String']['input']>;
  expiring_credentials: InputMaybe<Scalars['Int']['input']>;
  favorited_by_location_ids: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  favorited_or_blocked_by_location_ids: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  has_balance: InputMaybe<Scalars['Boolean']['input']>;
  has_booked_jobs: InputMaybe<Scalars['Boolean']['input']>;
  has_compact_license: InputMaybe<Scalars['Boolean']['input']>;
  has_onboarded_positions: InputMaybe<Scalars['Boolean']['input']>;
  has_recent_shift: InputMaybe<Scalars['Boolean']['input']>;
  has_rn_state_license: InputMaybe<Scalars['Int']['input']>;
  ignore_dl: InputMaybe<Scalars['Boolean']['input']>;
  in_pool_for_location: InputMaybe<Scalars['Int']['input']>;
  in_range_favorited_by_location_ids: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  in_workforce_for_location_ids: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  is_agency_staff: InputMaybe<Scalars['Boolean']['input']>;
  is_agency_staff_for_location_id: InputMaybe<Scalars['Int']['input']>;
  is_medely_internal: InputMaybe<Scalars['Boolean']['input']>;
  is_saas_for_location_ids: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  is_saas_professional: InputMaybe<Scalars['Boolean']['input']>;
  kinds: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  location_ids: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  market_id: InputMaybe<Scalars['Int']['input']>;
  market_ids: InputMaybe<Array<Scalars['Int']['input']>>;
  market_state_id: InputMaybe<Scalars['Int']['input']>;
  no_recruiter: InputMaybe<Scalars['Boolean']['input']>;
  not_favorited_or_blocked_by_location_ids: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  on_1099_assignment: InputMaybe<Scalars['Boolean']['input']>;
  on_w2_assignment: InputMaybe<Scalars['Boolean']['input']>;
  paylocity_external_id: InputMaybe<Scalars['String']['input']>;
  phone_interviewed: InputMaybe<Scalars['Boolean']['input']>;
  phone_number: InputMaybe<Scalars['String']['input']>;
  position_ids: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  position_ids_all: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  professional_type: InputMaybe<Scalars['String']['input']>;
  profile_approved: InputMaybe<Scalars['Boolean']['input']>;
  profile_approved_since: InputMaybe<Scalars['Date']['input']>;
  profile_strength: InputMaybe<Scalars['Int']['input']>;
  /**
   * *Constraints:*
   * * Maximal length: `150`
   *
   */
  q: InputMaybe<Scalars['String']['input']>;
  qualification_status: InputMaybe<Scalars['String']['input']>;
  recruiter_id: InputMaybe<Scalars['Int']['input']>;
  referral_source_id: InputMaybe<Scalars['Int']['input']>;
  reject_reason: InputMaybe<Scalars['String']['input']>;
  relationships: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  requested_for_job_id: InputMaybe<Scalars['Int']['input']>;
  required_qualifications: InputMaybe<Scalars['Boolean']['input']>;
  screening_recruiter_id: InputMaybe<Scalars['Int']['input']>;
  signup_assignment: InputMaybe<Scalars['Int']['input']>;
  signup_assignment_id: InputMaybe<Scalars['Int']['input']>;
  sms_notification: InputMaybe<Scalars['Boolean']['input']>;
  specialty_ids: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  state_id: InputMaybe<Scalars['Int']['input']>;
  status: InputMaybe<Scalars['String']['input']>;
  stripe_state_id: InputMaybe<Scalars['Int']['input']>;
  travel_position_ids: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  travel_state_id: InputMaybe<Scalars['Int']['input']>;
  utm_campaign: InputMaybe<Scalars['String']['input']>;
  utm_source: InputMaybe<Scalars['String']['input']>;
  welcome_box_sent: InputMaybe<Scalars['Boolean']['input']>;
};

export type ProfessionalSkillsAssessmentsAnswer = {
  __typename?: 'ProfessionalSkillsAssessmentsAnswer';
  id: Maybe<Scalars['Int']['output']>;
  professional: Maybe<Professional>;
  professional_id: Maybe<Scalars['Int']['output']>;
  skills_question: Maybe<SkillsQuestion>;
  skills_question_id: Maybe<Scalars['Int']['output']>;
  type: Maybe<Scalars['String']['output']>;
  value: Maybe<Scalars['String']['output']>;
};

export type ProfessionalSkillsAssessmentsAnswerOrderInput = {
  id: InputMaybe<Scalars['Boolean']['input']>;
};

export type ProfessionalSkillsAssessmentsAnswerQueryInput = {
  filter: InputMaybe<ProfessionalSkillsAssessmentsAnswerWhereInput>;
  orderBy: InputMaybe<ProfessionalSkillsAssessmentsAnswerOrderInput>;
  page: InputMaybe<Scalars['Int']['input']>;
  perPage: InputMaybe<Scalars['Int']['input']>;
  search: InputMaybe<ProfessionalSkillsAssessmentsAnswerSearchInput>;
};

export type ProfessionalSkillsAssessmentsAnswerSearchInput = {
  id: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  skills_assessment_id: InputMaybe<Scalars['Int']['input']>;
};

export type ProfessionalSkillsAssessmentsAnswerWhereInput = {
  id: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};

export type ProfessionalSpecialty = {
  __typename?: 'ProfessionalSpecialty';
  created_at: Scalars['DateTime']['output'];
  id: Scalars['Int']['output'];
  professional: Maybe<Professional>;
  professional_id: Maybe<Scalars['Int']['output']>;
  specialty: Maybe<Specialty>;
  specialty_id: Maybe<Scalars['Int']['output']>;
  updated_at: Scalars['DateTime']['output'];
};

export type ProfessionalSpecialtyOrderInput = {
  created_at: InputMaybe<Scalars['Boolean']['input']>;
  id: InputMaybe<Scalars['Boolean']['input']>;
  professional_id: InputMaybe<Scalars['Boolean']['input']>;
  specialty_id: InputMaybe<Scalars['Boolean']['input']>;
  updated_at: InputMaybe<Scalars['Boolean']['input']>;
};

export type ProfessionalSpecialtyQueryInput = {
  filter: InputMaybe<ProfessionalSpecialtyWhereInput>;
  orderBy: InputMaybe<ProfessionalSpecialtyOrderInput>;
  page: InputMaybe<Scalars['Int']['input']>;
  perPage: InputMaybe<Scalars['Int']['input']>;
  search: InputMaybe<DefaultSearchInput>;
};

export type ProfessionalSpecialtyWhereInput = {
  created_at: InputMaybe<Scalars['DateTime']['input']>;
  id: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  professional_id: InputMaybe<Scalars['Int']['input']>;
  specialty_id: InputMaybe<Scalars['Int']['input']>;
  updated_at: InputMaybe<Scalars['DateTime']['input']>;
};

export type ProfessionalTodos = {
  __typename?: 'ProfessionalTodos';
  active_jobs_requesting_to_work_facility_ids: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  active_jobs_requesting_to_work_ids: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  assignment_offers: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  assignments_missing_conditions: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  available_for_extensions: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  booked_jobs_count: Maybe<Scalars['Int']['output']>;
  campaigns_status: Array<Maybe<Scalars['JSON']['output']>>;
  days_until_debit_card_expires: Maybe<Scalars['Int']['output']>;
  disputes_waiting_on_professional: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  expired_or_missing_credentials_count: Maybe<Scalars['Int']['output']>;
  extension_offers: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  finished_jobs_count: Maybe<Scalars['Int']['output']>;
  has_invalid_credentials: Maybe<Scalars['Boolean']['output']>;
  has_position_with_completed_onboarding: Maybe<Scalars['Boolean']['output']>;
  incomplete_skill_assessments_count: Maybe<Scalars['Int']['output']>;
  missing_direct_deposit: Maybe<Scalars['Boolean']['output']>;
  missing_premier_credentials: Maybe<Scalars['Boolean']['output']>;
  missing_ssn_for_assignment: Maybe<Scalars['Boolean']['output']>;
  missing_w2_per_diem_onboarding: Maybe<Scalars['Boolean']['output']>;
  needs_emergency_contact: Maybe<Scalars['Boolean']['output']>;
  needs_payment_info: Maybe<Scalars['Boolean']['output']>;
  next_shift: Maybe<Scalars['JSON']['output']>;
  notifications_turned_on: Maybe<Scalars['Boolean']['output']>;
  offers_count: Maybe<Scalars['Int']['output']>;
  professional_account_id: Maybe<Scalars['Int']['output']>;
  profile_completeness: Maybe<Scalars['String']['output']>;
  sms_turned_on: Maybe<Scalars['Boolean']['output']>;
  unsigned_addendum_assignment_ids: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  unsigned_timesheet_ids: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
};

export type ProfessionalTravelAssignmentState = {
  __typename?: 'ProfessionalTravelAssignmentState';
  created_at: Scalars['DateTime']['output'];
  id: Scalars['Int']['output'];
  professional: Maybe<Professional>;
  professional_id: Maybe<Scalars['Int']['output']>;
  state: Maybe<State>;
  state_id: Maybe<Scalars['Int']['output']>;
  updated_at: Scalars['DateTime']['output'];
};

export type ProfessionalTravelAssignmentStateOrderInput = {
  created_at: InputMaybe<Scalars['Boolean']['input']>;
  id: InputMaybe<Scalars['Boolean']['input']>;
  professional_id: InputMaybe<Scalars['Boolean']['input']>;
  state_id: InputMaybe<Scalars['Boolean']['input']>;
  updated_at: InputMaybe<Scalars['Boolean']['input']>;
};

export type ProfessionalTravelAssignmentStateQueryInput = {
  filter: InputMaybe<ProfessionalTravelAssignmentStateWhereInput>;
  orderBy: InputMaybe<ProfessionalTravelAssignmentStateOrderInput>;
  page: InputMaybe<Scalars['Int']['input']>;
  perPage: InputMaybe<Scalars['Int']['input']>;
  search: InputMaybe<DefaultSearchInput>;
};

export type ProfessionalTravelAssignmentStateWhereInput = {
  created_at: InputMaybe<Scalars['DateTime']['input']>;
  id: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  professional_id: InputMaybe<Scalars['Int']['input']>;
  state_id: InputMaybe<Scalars['Int']['input']>;
  updated_at: InputMaybe<Scalars['DateTime']['input']>;
};

export type ProfessionalTravelPosition = {
  __typename?: 'ProfessionalTravelPosition';
  created_at: Scalars['DateTime']['output'];
  id: Scalars['Int']['output'];
  position: Maybe<Position>;
  position_id: Maybe<Scalars['Int']['output']>;
  professional: Maybe<Professional>;
  professional_id: Maybe<Scalars['Int']['output']>;
  updated_at: Scalars['DateTime']['output'];
};

export type ProfessionalTravelPositionOrderInput = {
  created_at: InputMaybe<Scalars['Boolean']['input']>;
  id: InputMaybe<Scalars['Boolean']['input']>;
  position_id: InputMaybe<Scalars['Boolean']['input']>;
  professional_id: InputMaybe<Scalars['Boolean']['input']>;
  updated_at: InputMaybe<Scalars['Boolean']['input']>;
};

export type ProfessionalTravelPositionQueryInput = {
  filter: InputMaybe<ProfessionalTravelPositionWhereInput>;
  orderBy: InputMaybe<ProfessionalTravelPositionOrderInput>;
  page: InputMaybe<Scalars['Int']['input']>;
  perPage: InputMaybe<Scalars['Int']['input']>;
  search: InputMaybe<DefaultSearchInput>;
};

export type ProfessionalTravelPositionWhereInput = {
  created_at: InputMaybe<Scalars['DateTime']['input']>;
  id: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  position_id: InputMaybe<Scalars['Int']['input']>;
  professional_id: InputMaybe<Scalars['Int']['input']>;
  updated_at: InputMaybe<Scalars['DateTime']['input']>;
};

export type ProfessionalWhereInput = {
  account_id: InputMaybe<Scalars['Int']['input']>;
  adp_file_number: InputMaybe<Scalars['String']['input']>;
  agency_id: InputMaybe<Scalars['Int']['input']>;
  application_status: InputMaybe<Scalars['String']['input']>;
  background_check_authorized: InputMaybe<Scalars['Boolean']['input']>;
  balance_cents: InputMaybe<Scalars['Int']['input']>;
  balance_currency: InputMaybe<Scalars['String']['input']>;
  bank_last: InputMaybe<Scalars['String']['input']>;
  business_tax_id: InputMaybe<Scalars['String']['input']>;
  completed_video: InputMaybe<Scalars['Boolean']['input']>;
  created_at: InputMaybe<Scalars['DateTime']['input']>;
  credentials_status: InputMaybe<Scalars['String']['input']>;
  detailed_notes: InputMaybe<Scalars['String']['input']>;
  dob: InputMaybe<Scalars['String']['input']>;
  drug_screening_completed: InputMaybe<Scalars['Boolean']['input']>;
  has_item: InputMaybe<Scalars['Boolean']['input']>;
  hours_need_updating: InputMaybe<Scalars['Boolean']['input']>;
  id: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  invite_code: InputMaybe<Scalars['String']['input']>;
  is_agency_staff: InputMaybe<Scalars['Boolean']['input']>;
  is_medely_internal: InputMaybe<Scalars['Boolean']['input']>;
  kind: InputMaybe<Scalars['String']['input']>;
  last_updated_preferred_hours_at: InputMaybe<Scalars['DateTime']['input']>;
  migrated_lead_id: InputMaybe<Scalars['Int']['input']>;
  migrated_staff_id: InputMaybe<Scalars['Int']['input']>;
  nickname: InputMaybe<Scalars['String']['input']>;
  paylocity_external_id: InputMaybe<Scalars['String']['input']>;
  phone_interviewed: InputMaybe<Scalars['Boolean']['input']>;
  plaid_token: InputMaybe<Scalars['String']['input']>;
  possible_duplicate: InputMaybe<Scalars['Boolean']['input']>;
  preferred_hours_per_week: InputMaybe<Scalars['Int']['input']>;
  preferred_job_types: InputMaybe<Scalars['String']['input']>;
  professional_assignment_id: InputMaybe<Scalars['Int']['input']>;
  profile_completed: InputMaybe<Scalars['Boolean']['input']>;
  profile_strength: InputMaybe<Scalars['Int']['input']>;
  publishable_key: InputMaybe<Scalars['String']['input']>;
  recruiter_id: InputMaybe<Scalars['Int']['input']>;
  rfm: InputMaybe<Scalars['String']['input']>;
  rfmf: InputMaybe<Scalars['Int']['input']>;
  rfmr: InputMaybe<Scalars['Int']['input']>;
  status: InputMaybe<Scalars['String']['input']>;
  stripe_bank_account_token: InputMaybe<Scalars['String']['input']>;
  stripe_external_account_id: InputMaybe<Scalars['String']['input']>;
  tax_classification_id: InputMaybe<Scalars['Int']['input']>;
  travel_email_notification: InputMaybe<Scalars['Boolean']['input']>;
  travel_email_preferences: InputMaybe<Scalars['String']['input']>;
  unsubscribe_token: InputMaybe<Scalars['String']['input']>;
  updated_at: InputMaybe<Scalars['DateTime']['input']>;
  w2_enabled: InputMaybe<Scalars['Boolean']['input']>;
  w2_onboarding_complete: InputMaybe<Scalars['Boolean']['input']>;
  welcome_box_sent: InputMaybe<Scalars['Boolean']['input']>;
};

export type ProfessionalsJobsInput = {
  ends_date: Scalars['Date']['input'];
  location_ids: Array<InputMaybe<Scalars['Int']['input']>>;
  starts_date: Scalars['Date']['input'];
};

export type ProfileStats = {
  __typename?: 'ProfileStats';
  do_not_sends_count: Maybe<Scalars['Int']['output']>;
  favorites_count: Maybe<Scalars['Int']['output']>;
  jobs_completed_count: Maybe<Scalars['Int']['output']>;
  late_cancellations_count: Maybe<Scalars['Int']['output']>;
  no_shows_count: Maybe<Scalars['Int']['output']>;
  status: Maybe<Scalars['String']['output']>;
};

export type Qualification = {
  __typename?: 'Qualification';
  admin_view_only: Scalars['Boolean']['output'];
  conditions: Maybe<Array<Maybe<Condition>>>;
  default_verification_title: Maybe<Scalars['String']['output']>;
  display_category: Maybe<Scalars['String']['output']>;
  display_description: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  input_source: Scalars['String']['output'];
  instructions: Maybe<Scalars['JSON']['output']>;
  long_name: Scalars['String']['output'];
  qualification_attributes: Maybe<Array<Maybe<QualificationAttribute>>>;
  qualification_automations: Maybe<Array<Maybe<QualificationAutomation>>>;
  qualification_type: Scalars['String']['output'];
  short_name: Scalars['String']['output'];
  slug: Scalars['String']['output'];
  status: Scalars['String']['output'];
  targets: Array<Maybe<Scalars['String']['output']>>;
};

export type QualificationAttribute = {
  __typename?: 'QualificationAttribute';
  active: Scalars['Boolean']['output'];
  data: Scalars['JSON']['output'];
  field_type: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  input_source: Scalars['String']['output'];
  label: Maybe<Scalars['String']['output']>;
  name: Maybe<Scalars['String']['output']>;
  qualification: Maybe<Qualification>;
  qualification_automation_attributes: Maybe<Array<Maybe<QualificationAutomationAttribute>>>;
  required: Scalars['Boolean']['output'];
  slug: Maybe<Scalars['String']['output']>;
};

export type QualificationAttributeOrderInput = {
  id: InputMaybe<Scalars['Boolean']['input']>;
  name: InputMaybe<Scalars['Boolean']['input']>;
};

export type QualificationAttributeQueryInput = {
  filter: InputMaybe<QualificationAttributeWhereInput>;
  orderBy: InputMaybe<QualificationAttributeOrderInput>;
  page: InputMaybe<Scalars['Int']['input']>;
  perPage: InputMaybe<Scalars['Int']['input']>;
  search: InputMaybe<QualificationAttributeSearchInput>;
};

export type QualificationAttributeSearchInput = {
  input_sources: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /**
   * *Constraints:*
   * * Maximal length: `150`
   *
   */
  q: InputMaybe<Scalars['String']['input']>;
};

export type QualificationAttributeWhereInput = {
  active: InputMaybe<Scalars['Boolean']['input']>;
  id: InputMaybe<Scalars['Int']['input']>;
  qualification_id: InputMaybe<Scalars['Int']['input']>;
  slug: InputMaybe<Scalars['String']['input']>;
};

export type QualificationAutomation = {
  __typename?: 'QualificationAutomation';
  backend_only: Scalars['Boolean']['output'];
  created_at: Scalars['DateTime']['output'];
  description: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  is_active: Maybe<Scalars['Boolean']['output']>;
  loading_text: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  qualification: Maybe<Qualification>;
  qualification_automation_attributes: Maybe<Array<Maybe<QualificationAutomationAttribute>>>;
  service_class: Scalars['String']['output'];
  updated_at: Scalars['DateTime']['output'];
};

export type QualificationAutomationAttribute = {
  __typename?: 'QualificationAutomationAttribute';
  created_at: Scalars['DateTime']['output'];
  id: Scalars['Int']['output'];
  qualification_attribute: Maybe<QualificationAttribute>;
  qualification_automation: Maybe<QualificationAutomation>;
  required: Maybe<Scalars['Boolean']['output']>;
  updated_at: Scalars['DateTime']['output'];
};

export type QualificationAutomationAttributeOrderInput = {
  created_at: InputMaybe<Scalars['Boolean']['input']>;
  id: InputMaybe<Scalars['Boolean']['input']>;
  qualification_attribute_id: InputMaybe<Scalars['Boolean']['input']>;
  qualification_automation_id: InputMaybe<Scalars['Boolean']['input']>;
  required: InputMaybe<Scalars['Boolean']['input']>;
  updated_at: InputMaybe<Scalars['Boolean']['input']>;
};

export type QualificationAutomationAttributeQueryInput = {
  filter: InputMaybe<QualificationAutomationAttributeWhereInput>;
  orderBy: InputMaybe<QualificationAutomationAttributeOrderInput>;
  page: InputMaybe<Scalars['Int']['input']>;
  perPage: InputMaybe<Scalars['Int']['input']>;
  search: InputMaybe<QualificationAutomationAttributeSearchInput>;
};

export type QualificationAutomationAttributeSearchInput = {
  /**
   * *Constraints:*
   * * Maximal length: `150`
   *
   */
  q: InputMaybe<Scalars['String']['input']>;
};

export type QualificationAutomationAttributeWhereInput = {
  created_at: InputMaybe<Scalars['DateTime']['input']>;
  id: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  qualification_attribute_id: InputMaybe<Scalars['Int']['input']>;
  qualification_automation_id: InputMaybe<Scalars['Int']['input']>;
  required: InputMaybe<Scalars['Boolean']['input']>;
  updated_at: InputMaybe<Scalars['DateTime']['input']>;
};

export type QualificationAutomationOrderInput = {
  backend_only: InputMaybe<Scalars['Boolean']['input']>;
  created_at: InputMaybe<Scalars['Boolean']['input']>;
  description: InputMaybe<Scalars['Boolean']['input']>;
  id: InputMaybe<Scalars['Boolean']['input']>;
  is_active: InputMaybe<Scalars['Boolean']['input']>;
  name: InputMaybe<Scalars['Boolean']['input']>;
  qualification_id: InputMaybe<Scalars['Boolean']['input']>;
  service_class: InputMaybe<Scalars['Boolean']['input']>;
  updated_at: InputMaybe<Scalars['Boolean']['input']>;
};

export type QualificationAutomationQueryInput = {
  filter: InputMaybe<QualificationAutomationWhereInput>;
  orderBy: InputMaybe<QualificationAutomationOrderInput>;
  page: InputMaybe<Scalars['Int']['input']>;
  perPage: InputMaybe<Scalars['Int']['input']>;
  search: InputMaybe<QualificationAutomationSearchInput>;
};

export type QualificationAutomationSearchInput = {
  /**
   * *Constraints:*
   * * Maximal length: `150`
   *
   */
  q: InputMaybe<Scalars['String']['input']>;
};

export type QualificationAutomationWhereInput = {
  backend_only: InputMaybe<Scalars['Boolean']['input']>;
  created_at: InputMaybe<Scalars['DateTime']['input']>;
  description: InputMaybe<Scalars['String']['input']>;
  id: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  is_active: InputMaybe<Scalars['Boolean']['input']>;
  name: InputMaybe<Scalars['String']['input']>;
  qualification_id: InputMaybe<Scalars['Int']['input']>;
  service_class: InputMaybe<Scalars['String']['input']>;
  updated_at: InputMaybe<Scalars['DateTime']['input']>;
};

export type QualificationOrderInput = {
  id: InputMaybe<Scalars['Boolean']['input']>;
  long_name: InputMaybe<Scalars['Boolean']['input']>;
  qualification_type: InputMaybe<Scalars['String']['input']>;
};

export type QualificationPositionInput = {
  for_application: Scalars['Boolean']['input'];
  for_on_boarding: Scalars['Boolean']['input'];
  position_ids: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  specialty_ids: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};

export type QualificationQueryInput = {
  filter: InputMaybe<QualificationWhereInput>;
  orderBy: InputMaybe<QualificationOrderInput>;
  page: InputMaybe<Scalars['Int']['input']>;
  perPage: InputMaybe<Scalars['Int']['input']>;
  search: InputMaybe<QualificationSearchInput>;
};

export type QualificationSearchInput = {
  available_to_agency: InputMaybe<Scalars['Int']['input']>;
  available_to_professional: InputMaybe<Scalars['Int']['input']>;
  condition_ids: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  condition_types: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  exclude_slugs: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  missing_conditions: InputMaybe<Missing_Conditions_Input>;
  /**
   * *Constraints:*
   * * Maximal length: `150`
   *
   */
  q: InputMaybe<Scalars['String']['input']>;
  qualification_types: InputMaybe<Array<Scalars['String']['input']>>;
  required_conditions: InputMaybe<Required_Conditions_Input>;
  targets: InputMaybe<Array<Scalars['String']['input']>>;
};

export type QualificationWhereInput = {
  admin_view_only: InputMaybe<Scalars['Boolean']['input']>;
  id: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  input_source: InputMaybe<Scalars['String']['input']>;
  qualification_type: InputMaybe<Scalars['String']['input']>;
  slug: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Scalars['String']['input']>;
};

export type QualificationsGroup = {
  __typename?: 'QualificationsGroup';
  created_at: Scalars['DateTime']['output'];
  id: Scalars['Int']['output'];
  name: Maybe<Scalars['String']['output']>;
  updated_at: Scalars['DateTime']['output'];
};

export type QualificationsGroupOrderInput = {
  created_at: InputMaybe<Scalars['Boolean']['input']>;
  id: InputMaybe<Scalars['Boolean']['input']>;
  name: InputMaybe<Scalars['Boolean']['input']>;
  updated_at: InputMaybe<Scalars['Boolean']['input']>;
};

export type QualificationsGroupQueryInput = {
  filter: InputMaybe<QualificationsGroupWhereInput>;
  orderBy: InputMaybe<QualificationsGroupOrderInput>;
  page: InputMaybe<Scalars['Int']['input']>;
  perPage: InputMaybe<Scalars['Int']['input']>;
  search: InputMaybe<DefaultSearchInput>;
};

export type QualificationsGroupWhereInput = {
  created_at: InputMaybe<Scalars['DateTime']['input']>;
  id: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  name: InputMaybe<Scalars['String']['input']>;
  updated_at: InputMaybe<Scalars['DateTime']['input']>;
};

export type Query = {
  __typename?: 'Query';
  _accountBillingGroupsMeta: Maybe<ListMeta>;
  _accountLocationsMeta: Maybe<ListMeta>;
  _accountsMeta: Maybe<ListMeta>;
  _administratorsMeta: Maybe<ListMeta>;
  _agenciesMeta: Maybe<ListMeta>;
  _agencyChargeOverridesMeta: Maybe<ListMeta>;
  _agencyLocationPositionRateSettingsMeta: Maybe<ListMeta>;
  _agencyLocationRateSettingsMeta: Maybe<ListMeta>;
  _agencyLocationsMeta: Maybe<ListMeta>;
  _agencyQualificationAttributesMeta: Maybe<ListMeta>;
  _agencyQualificationsMeta: Maybe<ListMeta>;
  _applicationRequirementsMeta: Maybe<ListMeta>;
  _approvalGroupsMeta: Maybe<ListMeta>;
  _approvalsMeta: Maybe<ListMeta>;
  _assignmentBillingGroupsMeta: Maybe<ListMeta>;
  _assignmentLocationsMeta: Maybe<ListMeta>;
  _assignmentMeta: Maybe<AssignmentMeta>;
  _assignmentRequestsMeta: Maybe<ListMeta>;
  _assignmentsMeta: Maybe<ListMeta>;
  _assignmentsPreviewsMeta: Maybe<ListMeta>;
  _auditsMeta: Maybe<ListMeta>;
  _availableAssignmentsMeta: Maybe<AvailableAssignmentsMeta>;
  _availableJobsMeta: Maybe<ListMeta>;
  _backgroundChecksMeta: Maybe<ListMeta>;
  _balanceSheetsMeta: Maybe<ListMeta>;
  _billingActivitiesMeta: Maybe<ListMeta>;
  _billingContactsMeta: Maybe<ListMeta>;
  _billingGroupCreditLimitCalculationsMeta: Maybe<ListMeta>;
  _billingGroupManagementCompaniesMeta: Maybe<ListMeta>;
  _billingGroupParentsMeta: Maybe<ListMeta>;
  _billingGroupsMeta: Maybe<ListMeta>;
  _breaksMeta: Maybe<ListMeta>;
  _cancellationReasonsMeta: Maybe<ListMeta>;
  _cancellationsMeta: Maybe<ListMeta>;
  _capsReportsMeta: Maybe<ListMeta>;
  _checkInsMeta: Maybe<ListMeta>;
  _checkOutsMeta: Maybe<ListMeta>;
  _checksMeta: Maybe<ListMeta>;
  _clinicalContactsMeta: Maybe<ListMeta>;
  _companiesMeta: Maybe<ListMeta>;
  _conditionDocumentsMeta: Maybe<ListMeta>;
  _conditionsMeta: Maybe<ListMeta>;
  _contractsMeta: Maybe<ListMeta>;
  _credentialRejectedReasonsMeta: Maybe<ListMeta>;
  _creditNotesMeta: Maybe<ListMeta>;
  _customProfessionalProfileEhrSystemsMeta: Maybe<ListMeta>;
  _deprecatedInvoicesMeta: Maybe<ListMeta>;
  _disabledReasonsMeta: Maybe<ListMeta>;
  _disputeShiftWitnessesMeta: Maybe<ListMeta>;
  _disputesMeta: Maybe<ListMeta>;
  _educationsMeta: Maybe<ListMeta>;
  _ehrSystemsMeta: Maybe<ListMeta>;
  _emergencyContactsMeta: Maybe<ListMeta>;
  _expenseAdjustmentsMeta: Maybe<ListMeta>;
  _externalAccountsMeta: Maybe<ListMeta>;
  _facilityConnectionsMeta: Maybe<ListMeta>;
  _financialTransactionsMeta: Maybe<ListMeta>;
  _fundingSourcesMeta: Maybe<ListMeta>;
  _gatewayInvoicesMeta: Maybe<ListMeta>;
  _gatewayStatementsMeta: Maybe<ListMeta>;
  _healthSystemsMeta: Maybe<ListMeta>;
  _interviewAvailabilitiesMeta: Maybe<ListMeta>;
  _invoicesMeta: Maybe<ListMeta>;
  _itemizedTransactionsMeta: Maybe<ListMeta>;
  _jobBillingsMeta: Maybe<ListMeta>;
  _jobIrregularitiesMeta: Maybe<ListMeta>;
  _jobPriceDifferentialsMeta: Maybe<ListMeta>;
  _jobProfilesMeta: Maybe<ListMeta>;
  /** @deprecated use JobProfile */
  _jobPublishingGroupsMeta: Maybe<ListMeta>;
  _jobRateTrackedEventsMeta: Maybe<ListMeta>;
  _jobSurgeryTypesMeta: Maybe<ListMeta>;
  _jobTemplatesMeta: Maybe<ListMeta>;
  _jobTracksMeta: Maybe<ListMeta>;
  _jobsBoardPositionsMeta: Maybe<ListMeta>;
  _jobsBoardsMeta: Maybe<ListMeta>;
  _jobsMeta: Maybe<ListMeta>;
  _lineOfCreditsMeta: Maybe<ListMeta>;
  _localRateRulesMeta: Maybe<ListMeta>;
  _locationBillingGroupsMeta: Maybe<ListMeta>;
  _locationBlockReasonsMeta: Maybe<ListMeta>;
  _locationGroupsMeta: Maybe<ListMeta>;
  _locationPositionRateSettingsMeta: Maybe<ListMeta>;
  _locationPositionsMeta: Maybe<ListMeta>;
  _locationRateSettingsMeta: Maybe<ListMeta>;
  _locationTypePositionsMeta: Maybe<ListMeta>;
  _locationTypesMeta: Maybe<ListMeta>;
  _locationsMeta: Maybe<ListMeta>;
  _marketLocationsMeta: Maybe<ListMeta>;
  _marketPositionRateSettingsMeta: Maybe<ListMeta>;
  _marketRateSettingsMeta: Maybe<ListMeta>;
  _marketsMeta: Maybe<ListMeta>;
  _marketsProfessionalsMeta: Maybe<ListMeta>;
  _mspsMeta: Maybe<ListMeta>;
  _netTermsMeta: Maybe<ListMeta>;
  _notesMeta: Maybe<ListMeta>;
  _nursysEnrollmentsMeta: Maybe<ListMeta>;
  _paymentsMeta: Maybe<ListMeta>;
  _payoutsMeta: Maybe<ListMeta>;
  _peopleMeta: Maybe<ListMeta>;
  _permissionGroupsMeta: Maybe<ListMeta>;
  _personDisabledReasonsMeta: Maybe<ListMeta>;
  _phoneScreeningRequestsMeta: Maybe<ListMeta>;
  _poolProfessionalsMeta: Maybe<ListMeta>;
  _positionPostingFieldsMeta: Maybe<ListMeta>;
  _positionSpecialtiesMeta: Maybe<ListMeta>;
  _positionsMeta: Maybe<ListMeta>;
  _postingFieldsMeta: Maybe<ListMeta>;
  _professionalAssignmentFavoritesMeta: Maybe<ListMeta>;
  _professionalBlockReasonsMeta: Maybe<ListMeta>;
  _professionalPositionsMeta: Maybe<ListMeta>;
  _professionalProfileEhrSystemsMeta: Maybe<ListMeta>;
  _professionalProfilesMeta: Maybe<ListMeta>;
  _professionalQualificationAttributesMeta: Maybe<ListMeta>;
  _professionalQualificationsMeta: Maybe<ListMeta>;
  _professionalReferencesMeta: Maybe<ListMeta>;
  _professionalSaasDetailsMeta: Maybe<ListMeta>;
  _professionalSkillsAssessmentsAnswersMeta: Maybe<ListMeta>;
  _professionalSpecialtiesMeta: Maybe<ListMeta>;
  _professionalTravelAssignmentStatesMeta: Maybe<ListMeta>;
  _professionalTravelPositionsMeta: Maybe<ListMeta>;
  _professionalsMeta: Maybe<ListMeta>;
  _qualificationAttributesMeta: Maybe<ListMeta>;
  _qualificationAutomationAttributesMeta: Maybe<ListMeta>;
  _qualificationAutomationsMeta: Maybe<ListMeta>;
  _qualificationsGroupsMeta: Maybe<ListMeta>;
  _qualificationsMeta: Maybe<ListMeta>;
  _questionnaireResponsesMeta: Maybe<ListMeta>;
  _questionnairesMeta: Maybe<ListMeta>;
  _rateCalculatorsMeta: Maybe<ListMeta>;
  _rateSettingsMeta: Maybe<ListMeta>;
  _referralSourcesMeta: Maybe<ListMeta>;
  _refundsMeta: Maybe<ListMeta>;
  _relationshipsMeta: Maybe<ListMeta>;
  _requirementsMeta: Maybe<ListMeta>;
  _revenueAdjustmentsMeta: Maybe<ListMeta>;
  _reviewsMeta: Maybe<ListMeta>;
  _skillsAssessmentBaksMeta: Maybe<ListMeta>;
  _skillsAssessmentResponseBaksMeta: Maybe<ListMeta>;
  _skillsAssessmentSkillsQuestionsMeta: Maybe<ListMeta>;
  _skillsAssessmentsMeta: Maybe<ListMeta>;
  _skillsQuestionsMeta: Maybe<ListMeta>;
  _specialtiesMeta: Maybe<ListMeta>;
  _staffBlockReasonsMeta: Maybe<ListMeta>;
  _statePositionRateSettingsMeta: Maybe<ListMeta>;
  _stateRateSettingsMeta: Maybe<ListMeta>;
  _statementsMeta: Maybe<ListMeta>;
  _statesMeta: Maybe<ListMeta>;
  _stripeAccountsMeta: Maybe<ListMeta>;
  _stripePaymentIntentsMeta: Maybe<ListMeta>;
  _stripeRepresentativesMeta: Maybe<ListMeta>;
  _surgeryTypesMeta: Maybe<ListMeta>;
  _taxClassificationsMeta: Maybe<ListMeta>;
  _taxFormsMeta: Maybe<ListMeta>;
  _timecardsMeta: Maybe<ListMeta>;
  _transferReversalsMeta: Maybe<ListMeta>;
  _uniqueAgencyChargeOverridesMeta: Maybe<ListMeta>;
  _universalBackgroundChecksMeta: Maybe<ListMeta>;
  _userPositionRateSettingsMeta: Maybe<ListMeta>;
  _userPositionsMeta: Maybe<ListMeta>;
  _userRateSettingsMeta: Maybe<ListMeta>;
  _usersMeta: Maybe<ListMeta>;
  _vmsAssignmentsMeta: Maybe<ListMeta>;
  _vmsPositionsMeta: Maybe<ListMeta>;
  _vmsTypesMeta: Maybe<ListMeta>;
  _vmsUsersMeta: Maybe<ListMeta>;
  _wageLogsMeta: Maybe<ListMeta>;
  _workGapsMeta: Maybe<ListMeta>;
  _workHistoriesMeta: Maybe<ListMeta>;
  account: Maybe<Account>;
  accountBillingGroup: Maybe<AccountBillingGroup>;
  accountBillingGroups: Maybe<Array<Maybe<AccountBillingGroup>>>;
  accountLocation: Maybe<AccountLocation>;
  accountLocations: Maybe<Array<Maybe<AccountLocation>>>;
  accountRequestPermissions: Maybe<Scalars['JSON']['output']>;
  accounts: Maybe<Array<Maybe<Account>>>;
  administrator: Maybe<Administrator>;
  administrators: Maybe<Array<Maybe<Administrator>>>;
  agencies: Maybe<Array<Maybe<Agency>>>;
  agency: Maybe<Agency>;
  agencyChargeOverrides: Array<AgencyChargeOverrides>;
  agencyLocation: Maybe<AgencyLocation>;
  agencyLocationPositionRateSetting: Maybe<AgencyLocationPositionRateSetting>;
  agencyLocationPositionRateSettings: Maybe<Array<Maybe<AgencyLocationPositionRateSetting>>>;
  agencyLocationRateSetting: Maybe<AgencyLocationRateSetting>;
  agencyLocationRateSettings: Maybe<Array<Maybe<AgencyLocationRateSetting>>>;
  agencyLocations: Maybe<Array<Maybe<AgencyLocation>>>;
  agencyQualification: Maybe<AgencyQualification>;
  agencyQualificationAttribute: Maybe<AgencyQualificationAttribute>;
  agencyQualificationAttributes: Maybe<Array<Maybe<AgencyQualificationAttribute>>>;
  agencyQualifications: Maybe<Array<Maybe<AgencyQualification>>>;
  appVersion: Maybe<AppVersion>;
  appVersions: Array<AppVersion>;
  applicationRequirement: Maybe<ApplicationRequirement>;
  applicationRequirements: Maybe<Array<Maybe<ApplicationRequirement>>>;
  approval: Maybe<Approval>;
  approvalGroup: Maybe<ApprovalGroup>;
  approvalGroups: Array<ApprovalGroup>;
  approvals: Array<Approval>;
  assignment: Maybe<Assignment>;
  assignmentBillingGroup: Maybe<AssignmentBillingGroup>;
  assignmentBillingGroups: Maybe<Array<Maybe<AssignmentBillingGroup>>>;
  assignmentCancellationReasons: Maybe<AssignmentCancellationReasons>;
  assignmentCancellationReasonsV2: Maybe<AssignmentCancellationReasonsV2>;
  assignmentLocation: Maybe<AssignmentLocation>;
  assignmentLocations: Maybe<Array<Maybe<AssignmentLocation>>>;
  assignmentPreview: Maybe<Assignment>;
  assignmentRequest: Maybe<AssignmentRequest>;
  assignmentRequests: Maybe<Array<Maybe<AssignmentRequest>>>;
  assignments: Maybe<Array<Maybe<Assignment>>>;
  assignmentsEndingSoon: Maybe<Array<AssignmentPanelCount>>;
  assignmentsPreviews: Maybe<Array<Maybe<Assignment>>>;
  assignmentsStartingSoon: Maybe<Array<AssignmentPanelCount>>;
  audit: Maybe<Audit>;
  audits: Array<Audit>;
  availableAssignment: Maybe<Assignment>;
  availableAssignments: Maybe<Array<Maybe<Assignment>>>;
  availableJob: Maybe<Job>;
  availableJobs: Maybe<Array<Job>>;
  backgroundCheck: Maybe<BackgroundCheck>;
  backgroundChecks: Maybe<Array<Maybe<BackgroundCheck>>>;
  balanceSheet: Maybe<BalanceSheet>;
  balanceSheets: Maybe<Array<Maybe<BalanceSheet>>>;
  billingActivities: Maybe<Array<Maybe<BillingActivity>>>;
  billingContact: Maybe<BillingContact>;
  billingContacts: Maybe<Array<Maybe<BillingContact>>>;
  billingGroup: Maybe<BillingGroup>;
  billingGroupCreditLimitCalculation: Maybe<BillingGroupCreditLimitCalculation>;
  billingGroupCreditLimitCalculations: Maybe<Array<Maybe<BillingGroupCreditLimitCalculation>>>;
  billingGroupManagementCompanies: Maybe<Array<Maybe<BillingGroupManagementCompany>>>;
  billingGroupManagementCompany: Maybe<BillingGroupManagementCompany>;
  billingGroupParent: Maybe<BillingGroupParent>;
  billingGroupParents: Maybe<Array<Maybe<BillingGroupParent>>>;
  billingGroups: Maybe<Array<Maybe<BillingGroup>>>;
  blockedJobs: Maybe<Array<Maybe<Job>>>;
  break: Maybe<Break>;
  breaks: Maybe<Array<Maybe<Break>>>;
  cancellation: Maybe<Cancellation>;
  cancellationReason: Maybe<CancellationReason>;
  cancellationReasons: Maybe<Array<Maybe<CancellationReason>>>;
  cancellations: Maybe<Array<Maybe<Cancellation>>>;
  capsReport: Maybe<CapsReport>;
  capsReports: Maybe<Array<Maybe<CapsReport>>>;
  check: Maybe<Check>;
  checkIn: Maybe<CheckIn>;
  checkIns: Maybe<Array<Maybe<CheckIn>>>;
  checkOut: Maybe<CheckOut>;
  checkOuts: Maybe<Array<Maybe<CheckOut>>>;
  checks: Maybe<Array<Maybe<Check>>>;
  clinicalContact: Maybe<ClinicalContact>;
  clinicalContacts: Maybe<Array<Maybe<ClinicalContact>>>;
  clockEventAttachment: Maybe<ClockEventAttachment>;
  clockEventAttachments: Maybe<Array<Maybe<ClockEventAttachment>>>;
  companies: Maybe<Array<Maybe<Company>>>;
  company: Maybe<Company>;
  condition: Maybe<Condition>;
  conditionDocument: Maybe<ConditionDocument>;
  conditionDocuments: Maybe<Array<Maybe<ConditionDocument>>>;
  conditions: Maybe<Array<Maybe<Condition>>>;
  contract: Maybe<Contract>;
  contracts: Maybe<Array<Maybe<Contract>>>;
  credentialRejectedReason: Maybe<CredentialRejectedReason>;
  credentialRejectedReasons: Maybe<Array<Maybe<CredentialRejectedReason>>>;
  creditNote: Maybe<CreditNote>;
  creditNotes: Maybe<Array<Maybe<CreditNote>>>;
  customProfessionalProfileEhrSystem: Maybe<CustomProfessionalProfileEhrSystem>;
  customProfessionalProfileEhrSystems: Maybe<Array<Maybe<CustomProfessionalProfileEhrSystem>>>;
  dashboardStats: Maybe<DashboardStats>;
  deprecatedInvoice: Maybe<DeprecatedInvoice>;
  deprecatedInvoices: Maybe<Array<Maybe<DeprecatedInvoice>>>;
  disabledReason: Maybe<DisabledReason>;
  disabledReasons: Maybe<Array<Maybe<DisabledReason>>>;
  dispute: Maybe<Dispute>;
  disputeShiftWitness: Maybe<DisputeShiftWitness>;
  disputeShiftWitnesses: Maybe<Array<Maybe<DisputeShiftWitness>>>;
  disputes: Maybe<Array<Maybe<Dispute>>>;
  education: Maybe<Education>;
  educations: Maybe<Array<Maybe<Education>>>;
  ehrSystem: Maybe<EhrSystem>;
  ehrSystems: Maybe<Array<Maybe<EhrSystem>>>;
  emergencyContact: Maybe<EmergencyContact>;
  emergencyContacts: Maybe<Array<Maybe<EmergencyContact>>>;
  expenseAdjustment: Maybe<ExpenseAdjustment>;
  expenseAdjustments: Maybe<Array<Maybe<ExpenseAdjustment>>>;
  externalAccount: Maybe<ExternalAccount>;
  externalAccounts: Maybe<Array<Maybe<ExternalAccount>>>;
  facilityConnection: Maybe<FacilityConnection>;
  facilityConnections: Maybe<Array<Maybe<FacilityConnection>>>;
  favoritesPanelRows: Array<FavoritesPanelRow>;
  financialTransaction: Maybe<FinancialTransaction>;
  financialTransactions: Maybe<Array<Maybe<FinancialTransaction>>>;
  fundingSource: Maybe<FundingSource>;
  fundingSources: Maybe<Array<Maybe<FundingSource>>>;
  gatewayBillingGroup: Maybe<BillingGroup>;
  gatewayBillingGroupCreditLimitCalculation: Maybe<BillingGroupCreditLimitCalculation>;
  gatewayConditionDocuments: Maybe<Array<Maybe<ConditionDocument>>>;
  gatewayInvoice: Maybe<Invoice>;
  gatewayInvoices: Maybe<Array<Maybe<Invoice>>>;
  gatewayProfessionalReferences: Maybe<Array<Maybe<ProfessionalReference>>>;
  gatewayStatement: Maybe<Statement>;
  gatewayStatements: Maybe<Array<Maybe<Statement>>>;
  getBlockedTimes: Maybe<Array<Maybe<BlockedTimes>>>;
  healthSystem: Maybe<HealthSystem>;
  healthSystems: Maybe<Array<Maybe<HealthSystem>>>;
  interviewAvailabilities: Maybe<Array<Maybe<InterviewAvailability>>>;
  interviewAvailability: Maybe<InterviewAvailability>;
  invoice: Maybe<Invoice>;
  invoiceStatusBillingGroupCounts: Array<InvoiceStatusBillingGroupCountsResult>;
  invoices: Maybe<Array<Maybe<Invoice>>>;
  invoicesTotals: Maybe<InvoicesTotals>;
  itemizedTransaction: Maybe<ItemizedTransaction>;
  itemizedTransactions: Maybe<Array<Maybe<ItemizedTransaction>>>;
  job: Maybe<Job>;
  jobBilling: Maybe<JobBilling>;
  jobBillings: Maybe<Array<Maybe<JobBilling>>>;
  jobCount: Maybe<ListMeta>;
  jobIrregularities: Maybe<Array<Maybe<JobIrregularity>>>;
  jobIrregularity: Maybe<JobIrregularity>;
  jobPriceDifferential: Maybe<JobPriceDifferential>;
  jobPriceDifferentials: Maybe<Array<Maybe<JobPriceDifferential>>>;
  jobProfile: Maybe<JobProfile>;
  jobProfiles: Maybe<Array<Maybe<JobProfile>>>;
  /** @deprecated use JobProfile */
  jobPublishingGroup: Maybe<JobPublishingGroup>;
  /** @deprecated use JobProfile */
  jobPublishingGroups: Maybe<Array<Maybe<JobPublishingGroup>>>;
  jobRateTrackedEvent: Maybe<JobRateTrackedEvent>;
  jobRateTrackedEvents: Maybe<Array<Maybe<JobRateTrackedEvent>>>;
  jobStatusLocationCounts: Array<JobStatusLocationCountsResult>;
  jobSurgeryType: Maybe<JobSurgeryType>;
  jobSurgeryTypes: Maybe<Array<Maybe<JobSurgeryType>>>;
  jobTemplate: Maybe<JobTemplate>;
  jobTemplates: Maybe<Array<Maybe<JobTemplate>>>;
  jobTrack: Maybe<JobTrack>;
  jobTracks: Maybe<Array<Maybe<JobTrack>>>;
  jobs: Maybe<Array<Job>>;
  jobsAwaitingApproval: Maybe<Array<Maybe<Job>>>;
  jobsBoard: Maybe<JobsBoard>;
  jobsBoardPosition: Maybe<JobsBoardPosition>;
  jobsBoardPositions: Maybe<Array<Maybe<JobsBoardPosition>>>;
  jobsBoards: Maybe<Array<Maybe<JobsBoard>>>;
  jobsByPosition: Maybe<Array<Maybe<Position>>>;
  jobsTotals: Maybe<JobsTotals>;
  jobsWithoutPayout: Maybe<Array<Maybe<Job>>>;
  lastWeekJobsDetails: Maybe<LastWeekJobDetails>;
  lineOfCredit: Maybe<LineOfCredit>;
  lineOfCredits: Maybe<Array<Maybe<LineOfCredit>>>;
  localRateRule: Maybe<LocalRateRule>;
  localRateRules: Maybe<Array<Maybe<LocalRateRule>>>;
  location: Maybe<Location>;
  locationAssignmentIssueCounts: Array<AssignmentPanelCount>;
  locationBillingGroup: Maybe<LocationBillingGroup>;
  locationBillingGroups: Maybe<Array<Maybe<LocationBillingGroup>>>;
  locationBlockReason: Maybe<LocationBlockReason>;
  locationBlockReasons: Maybe<Array<Maybe<LocationBlockReason>>>;
  locationGroup: Maybe<LocationGroup>;
  locationGroups: Maybe<Array<LocationGroup>>;
  locationPosition: Maybe<LocationPosition>;
  locationPositionRateSetting: Maybe<LocationPositionRateSetting>;
  locationPositionRateSettings: Maybe<Array<Maybe<LocationPositionRateSetting>>>;
  locationPositions: Maybe<Array<Maybe<LocationPosition>>>;
  locationRateSetting: Maybe<LocationRateSetting>;
  locationRateSettings: Maybe<Array<Maybe<LocationRateSetting>>>;
  locationType: Maybe<LocationType>;
  locationTypePosition: Maybe<LocationTypePosition>;
  locationTypePositions: Maybe<Array<Maybe<LocationTypePosition>>>;
  locationTypes: Maybe<Array<Maybe<LocationType>>>;
  locations: Maybe<Array<Maybe<Location>>>;
  market: Maybe<Market>;
  marketLocation: Maybe<MarketLocation>;
  marketLocations: Maybe<Array<Maybe<MarketLocation>>>;
  marketPositionRateSetting: Maybe<MarketPositionRateSetting>;
  marketPositionRateSettings: Maybe<Array<Maybe<MarketPositionRateSetting>>>;
  marketRateSetting: Maybe<MarketRateSetting>;
  marketRateSettings: Maybe<Array<Maybe<MarketRateSetting>>>;
  markets: Maybe<Array<Maybe<Market>>>;
  marketsProfessional: Maybe<MarketsProfessional>;
  marketsProfessionals: Maybe<Array<Maybe<MarketsProfessional>>>;
  me: Maybe<Account>;
  metabaseEmbedUrl: Maybe<MetabaseEmbed>;
  msp: Maybe<Msp>;
  msps: Maybe<Array<Maybe<Msp>>>;
  netTerm: Maybe<NetTerm>;
  netTerms: Maybe<Array<Maybe<NetTerm>>>;
  newApplicantCount: Maybe<Array<AssignmentPanelCount>>;
  note: Maybe<Note>;
  notes: Maybe<Array<Maybe<Note>>>;
  nursysEnrollment: Maybe<NursysEnrollment>;
  nursysEnrollments: Maybe<Array<Maybe<NursysEnrollment>>>;
  onboardingFlowDecision: OnboardingFlowDecision;
  payment: Maybe<Payment>;
  payments: Maybe<Array<Maybe<Payment>>>;
  payout: Maybe<Payout>;
  payouts: Maybe<Array<Maybe<Payout>>>;
  people: Maybe<Array<Maybe<Person>>>;
  permissionGroup: Maybe<PermissionGroup>;
  permissionGroups: Maybe<Array<Maybe<PermissionGroup>>>;
  person: Maybe<Person>;
  personDisabledReason: Maybe<PersonDisabledReason>;
  personDisabledReasons: Maybe<Array<Maybe<PersonDisabledReason>>>;
  phoneScreeningRequest: Maybe<PhoneScreeningRequest>;
  phoneScreeningRequests: Maybe<Array<Maybe<PhoneScreeningRequest>>>;
  poolProfessional: Maybe<Professional>;
  poolProfessionals: Maybe<Array<Maybe<Professional>>>;
  position: Maybe<Position>;
  positionPostingField: Maybe<PositionPostingField>;
  positionPostingFields: Maybe<Array<Maybe<PositionPostingField>>>;
  positionSpecialties: Maybe<Array<Maybe<PositionSpecialty>>>;
  positionSpecialty: Maybe<PositionSpecialty>;
  positions: Maybe<Array<Maybe<Position>>>;
  postingField: Maybe<PostingField>;
  postingFields: Maybe<Array<Maybe<PostingField>>>;
  professional: Maybe<Professional>;
  professionalAssignmentFavorite: Maybe<ProfessionalAssignmentFavorite>;
  professionalAssignmentFavorites: Maybe<Array<Maybe<ProfessionalAssignmentFavorite>>>;
  professionalBlockReason: Maybe<ProfessionalBlockReason>;
  professionalBlockReasons: Maybe<Array<Maybe<ProfessionalBlockReason>>>;
  professionalPosition: Maybe<ProfessionalPosition>;
  professionalPositions: Maybe<Array<Maybe<ProfessionalPosition>>>;
  professionalProfile: Maybe<ProfessionalProfile>;
  professionalProfileEhrSystem: Maybe<ProfessionalProfileEhrSystem>;
  professionalProfileEhrSystems: Maybe<Array<Maybe<ProfessionalProfileEhrSystem>>>;
  professionalProfiles: Maybe<Array<Maybe<ProfessionalProfile>>>;
  professionalQualification: Maybe<ProfessionalQualification>;
  professionalQualificationAttribute: Maybe<ProfessionalQualificationAttribute>;
  professionalQualificationAttributes: Maybe<Array<Maybe<ProfessionalQualificationAttribute>>>;
  professionalQualifications: Maybe<Array<Maybe<ProfessionalQualification>>>;
  professionalReference: Maybe<ProfessionalReference>;
  professionalReferences: Maybe<Array<Maybe<ProfessionalReference>>>;
  professionalSaasDetail: Maybe<ProfessionalSaasDetail>;
  professionalSaasDetails: Maybe<Array<Maybe<ProfessionalSaasDetail>>>;
  professionalSkillsAssessmentsAnswer: Maybe<ProfessionalSkillsAssessmentsAnswer>;
  professionalSkillsAssessmentsAnswers: Maybe<Array<Maybe<ProfessionalSkillsAssessmentsAnswer>>>;
  professionalSpecialties: Maybe<Array<Maybe<ProfessionalSpecialty>>>;
  professionalSpecialty: Maybe<ProfessionalSpecialty>;
  professionalTodos: Maybe<ProfessionalTodos>;
  professionalTravelAssignmentState: Maybe<ProfessionalTravelAssignmentState>;
  professionalTravelAssignmentStates: Maybe<Array<Maybe<ProfessionalTravelAssignmentState>>>;
  professionalTravelPosition: Maybe<ProfessionalTravelPosition>;
  professionalTravelPositions: Maybe<Array<Maybe<ProfessionalTravelPosition>>>;
  professionals: Maybe<Array<Maybe<Professional>>>;
  professionalsJobs: Maybe<Array<Maybe<ProfessionalJobs>>>;
  profileStats: Maybe<ProfileStats>;
  qualification: Maybe<Qualification>;
  qualificationAttribute: Maybe<QualificationAttribute>;
  qualificationAttributes: Maybe<Array<Maybe<QualificationAttribute>>>;
  qualificationAutomation: Maybe<QualificationAutomation>;
  qualificationAutomationAttribute: Maybe<QualificationAutomationAttribute>;
  qualificationAutomationAttributes: Maybe<Array<Maybe<QualificationAutomationAttribute>>>;
  qualificationAutomations: Maybe<Array<Maybe<QualificationAutomation>>>;
  qualifications: Maybe<Array<Maybe<Qualification>>>;
  qualificationsGroup: Maybe<QualificationsGroup>;
  qualificationsGroups: Maybe<Array<Maybe<QualificationsGroup>>>;
  questionnaire: Maybe<Questionnaire>;
  questionnaireResponse: Maybe<QuestionnaireResponse>;
  questionnaireResponses: Maybe<Array<Maybe<QuestionnaireResponse>>>;
  questionnaires: Maybe<Array<Maybe<Questionnaire>>>;
  rateCalculator: Maybe<RateCalculator>;
  rateCalculators: Maybe<Array<Maybe<RateCalculator>>>;
  rateSetting: Maybe<RateSetting>;
  rateSettings: Maybe<Array<Maybe<RateSetting>>>;
  referralSource: Maybe<ReferralSource>;
  referralSources: Maybe<Array<Maybe<ReferralSource>>>;
  refund: Maybe<Refund>;
  refunds: Maybe<Array<Maybe<Refund>>>;
  relationship: Maybe<Relationship>;
  relationships: Maybe<Array<Maybe<Relationship>>>;
  requirement: Maybe<Requirement>;
  requirements: Maybe<Array<Maybe<Requirement>>>;
  revenueAdjustment: Maybe<RevenueAdjustment>;
  revenueAdjustments: Maybe<Array<Maybe<RevenueAdjustment>>>;
  review: Maybe<Review>;
  reviews: Maybe<Array<Maybe<Review>>>;
  skillsAssessment: Maybe<SkillsAssessment>;
  skillsAssessmentBak: Maybe<SkillsAssessmentBak>;
  skillsAssessmentBaks: Maybe<Array<Maybe<SkillsAssessmentBak>>>;
  skillsAssessmentResponseBak: Maybe<SkillsAssessmentResponseBak>;
  skillsAssessmentResponseBaks: Maybe<Array<Maybe<SkillsAssessmentResponseBak>>>;
  skillsAssessmentSkillsQuestion: Maybe<SkillsAssessmentSkillsQuestion>;
  skillsAssessmentSkillsQuestions: Maybe<Array<Maybe<SkillsAssessmentSkillsQuestion>>>;
  skillsAssessments: Maybe<Array<Maybe<SkillsAssessment>>>;
  skillsQuestion: Maybe<SkillsQuestion>;
  skillsQuestions: Maybe<Array<Maybe<SkillsQuestion>>>;
  specialties: Maybe<Array<Maybe<Specialty>>>;
  specialty: Maybe<Specialty>;
  staffBlockReason: Maybe<StaffBlockReason>;
  staffBlockReasons: Maybe<Array<Maybe<StaffBlockReason>>>;
  state: Maybe<State>;
  statePositionRateSetting: Maybe<StatePositionRateSetting>;
  statePositionRateSettings: Maybe<Array<Maybe<StatePositionRateSetting>>>;
  stateRateSetting: Maybe<StateRateSetting>;
  stateRateSettings: Maybe<Array<Maybe<StateRateSetting>>>;
  statement: Maybe<Statement>;
  statements: Maybe<Array<Maybe<Statement>>>;
  states: Maybe<Array<Maybe<State>>>;
  stripeAccount: Maybe<StripeAccount>;
  stripeAccounts: Maybe<Array<Maybe<StripeAccount>>>;
  stripePaymentIntent: Maybe<StripePaymentIntent>;
  stripePaymentIntents: Maybe<Array<Maybe<StripePaymentIntent>>>;
  stripeRepresentative: Maybe<StripeRepresentative>;
  stripeRepresentatives: Maybe<Array<Maybe<StripeRepresentative>>>;
  surgeryType: Maybe<SurgeryType>;
  surgeryTypes: Maybe<Array<Maybe<SurgeryType>>>;
  taxClassification: Maybe<TaxClassification>;
  taxClassifications: Maybe<Array<Maybe<TaxClassification>>>;
  taxForm: Maybe<TaxForm>;
  taxForms: Maybe<Array<Maybe<TaxForm>>>;
  timecard: Maybe<Timecard>;
  timecards: Maybe<Array<Maybe<Timecard>>>;
  timecardsTotals: Maybe<TimecardsTotals>;
  transferReversal: Maybe<TransferReversal>;
  transferReversals: Maybe<Array<Maybe<TransferReversal>>>;
  unexplainedWorkGaps: Array<UnexplainedWorkGap>;
  uniqueAgencyChargeOverrides: Array<UniqueAgencyChargeOverrides>;
  universalBackgroundCheck: Maybe<UniversalBackgroundCheck>;
  universalBackgroundChecks: Maybe<Array<Maybe<UniversalBackgroundCheck>>>;
  unpaidTimecardAdjustments: Maybe<Array<Maybe<ExpenseAdjustment>>>;
  user: Maybe<User>;
  userPosition: Maybe<UserPosition>;
  userPositionRateSetting: Maybe<UserPositionRateSetting>;
  userPositionRateSettings: Maybe<Array<Maybe<UserPositionRateSetting>>>;
  userPositions: Maybe<Array<Maybe<UserPosition>>>;
  userRateSetting: Maybe<UserRateSetting>;
  userRateSettings: Maybe<Array<Maybe<UserRateSetting>>>;
  users: Maybe<Array<Maybe<User>>>;
  validateJobTimes: Maybe<Array<Maybe<Scalars['DateTime']['output']>>>;
  vmsAssignment: Maybe<VmsAssignment>;
  vmsAssignments: Maybe<Array<Maybe<VmsAssignment>>>;
  vmsPosition: Maybe<VmsPosition>;
  vmsPositions: Maybe<Array<Maybe<VmsPosition>>>;
  vmsType: Maybe<VmsType>;
  vmsTypes: Maybe<Array<Maybe<VmsType>>>;
  vmsUser: Maybe<VmsUser>;
  vmsUsers: Maybe<Array<Maybe<VmsUser>>>;
  wageLog: Maybe<WageLog>;
  wageLogs: Array<WageLog>;
  weeklyTimecardsTotals: Array<WeeklyTimecardsTotals>;
  workGap: Maybe<WorkGap>;
  workGaps: Maybe<Array<Maybe<WorkGap>>>;
  workHistories: Maybe<Array<Maybe<WorkHistory>>>;
  workHistory: Maybe<WorkHistory>;
};


export type Query_AccountBillingGroupsMetaArgs = {
  input: InputMaybe<AccountBillingGroupQueryInput>;
};


export type Query_AccountLocationsMetaArgs = {
  input: InputMaybe<AccountLocationQueryInput>;
};


export type Query_AccountsMetaArgs = {
  input: InputMaybe<AccountQueryInput>;
};


export type Query_AdministratorsMetaArgs = {
  input: InputMaybe<AdministratorQueryInput>;
};


export type Query_AgenciesMetaArgs = {
  input: InputMaybe<AgencyQueryInput>;
};


export type Query_AgencyChargeOverridesMetaArgs = {
  input: InputMaybe<AgencyChargeOverridesQueryInput>;
};


export type Query_AgencyLocationPositionRateSettingsMetaArgs = {
  input: InputMaybe<AgencyLocationPositionRateSettingQueryInput>;
};


export type Query_AgencyLocationRateSettingsMetaArgs = {
  input: InputMaybe<AgencyLocationRateSettingQueryInput>;
};


export type Query_AgencyLocationsMetaArgs = {
  input: InputMaybe<AgencyLocationQueryInput>;
};


export type Query_AgencyQualificationAttributesMetaArgs = {
  input: InputMaybe<AgencyQualificationAttributeQueryInput>;
};


export type Query_AgencyQualificationsMetaArgs = {
  input: InputMaybe<AgencyQualificationQueryInput>;
};


export type Query_ApplicationRequirementsMetaArgs = {
  input: InputMaybe<ApplicationRequirementQueryInput>;
};


export type Query_ApprovalGroupsMetaArgs = {
  input: InputMaybe<ApprovalGroupQueryInput>;
};


export type Query_ApprovalsMetaArgs = {
  input: InputMaybe<ApprovalQueryInput>;
};


export type Query_AssignmentBillingGroupsMetaArgs = {
  input: InputMaybe<AssignmentBillingGroupQueryInput>;
};


export type Query_AssignmentLocationsMetaArgs = {
  input: InputMaybe<AssignmentLocationQueryInput>;
};


export type Query_AssignmentMetaArgs = {
  id: Scalars['Int']['input'];
};


export type Query_AssignmentRequestsMetaArgs = {
  input: InputMaybe<AssignmentRequestQueryInput>;
};


export type Query_AssignmentsMetaArgs = {
  input: InputMaybe<AssignmentQueryInput>;
};


export type Query_AssignmentsPreviewsMetaArgs = {
  input: InputMaybe<AssignmentQueryInput>;
};


export type Query_AuditsMetaArgs = {
  input: InputMaybe<AuditQueryInput>;
};


export type Query_AvailableAssignmentsMetaArgs = {
  input: InputMaybe<AssignmentQueryInput>;
};


export type Query_AvailableJobsMetaArgs = {
  input: InputMaybe<JobQueryInput>;
};


export type Query_BackgroundChecksMetaArgs = {
  input: InputMaybe<BackgroundCheckQueryInput>;
};


export type Query_BalanceSheetsMetaArgs = {
  input: InputMaybe<BalanceSheetQueryInput>;
};


export type Query_BillingActivitiesMetaArgs = {
  input: InputMaybe<BillingActivityQueryInput>;
};


export type Query_BillingContactsMetaArgs = {
  input: InputMaybe<BillingContactQueryInput>;
};


export type Query_BillingGroupCreditLimitCalculationsMetaArgs = {
  input: InputMaybe<BillingGroupCreditLimitCalculationQueryInput>;
};


export type Query_BillingGroupManagementCompaniesMetaArgs = {
  input: InputMaybe<BillingGroupManagementCompanyQueryInput>;
};


export type Query_BillingGroupParentsMetaArgs = {
  input: InputMaybe<BillingGroupParentQueryInput>;
};


export type Query_BillingGroupsMetaArgs = {
  input: InputMaybe<BillingGroupQueryInput>;
};


export type Query_BreaksMetaArgs = {
  input: InputMaybe<BreakQueryInput>;
};


export type Query_CancellationReasonsMetaArgs = {
  input: InputMaybe<CancellationReasonQueryInput>;
};


export type Query_CancellationsMetaArgs = {
  input: InputMaybe<CancellationQueryInput>;
};


export type Query_CapsReportsMetaArgs = {
  input: InputMaybe<CapsReportQueryInput>;
};


export type Query_CheckInsMetaArgs = {
  input: InputMaybe<CheckInQueryInput>;
};


export type Query_CheckOutsMetaArgs = {
  input: InputMaybe<CheckOutQueryInput>;
};


export type Query_ChecksMetaArgs = {
  input: InputMaybe<CheckQueryInput>;
};


export type Query_ClinicalContactsMetaArgs = {
  input: InputMaybe<ClinicalContactQueryInput>;
};


export type Query_CompaniesMetaArgs = {
  input: InputMaybe<CompanyQueryInput>;
};


export type Query_ConditionDocumentsMetaArgs = {
  input: InputMaybe<ConditionDocumentQueryInput>;
};


export type Query_ConditionsMetaArgs = {
  input: InputMaybe<ConditionQueryInput>;
};


export type Query_ContractsMetaArgs = {
  input: InputMaybe<CreditNoteQueryInput>;
};


export type Query_CredentialRejectedReasonsMetaArgs = {
  input: InputMaybe<CredentialRejectedReasonQueryInput>;
};


export type Query_CreditNotesMetaArgs = {
  input: InputMaybe<CreditNoteQueryInput>;
};


export type Query_CustomProfessionalProfileEhrSystemsMetaArgs = {
  input: InputMaybe<CustomProfessionalProfileEhrSystemQueryInput>;
};


export type Query_DeprecatedInvoicesMetaArgs = {
  input: InputMaybe<DeprecatedInvoiceQueryInput>;
};


export type Query_DisabledReasonsMetaArgs = {
  input: InputMaybe<DisabledReasonQueryInput>;
};


export type Query_DisputeShiftWitnessesMetaArgs = {
  input: InputMaybe<DisputeShiftWitnessQueryInput>;
};


export type Query_DisputesMetaArgs = {
  input: InputMaybe<DisputeQueryInput>;
};


export type Query_EducationsMetaArgs = {
  input: InputMaybe<EducationQueryInput>;
};


export type Query_EhrSystemsMetaArgs = {
  input: InputMaybe<EhrSystemQueryInput>;
};


export type Query_EmergencyContactsMetaArgs = {
  input: InputMaybe<EmergencyContactQueryInput>;
};


export type Query_ExpenseAdjustmentsMetaArgs = {
  input: InputMaybe<ExpenseAdjustmentQueryInput>;
};


export type Query_ExternalAccountsMetaArgs = {
  input: InputMaybe<ExternalAccountQueryInput>;
};


export type Query_FacilityConnectionsMetaArgs = {
  input: InputMaybe<FacilityConnectionQueryInput>;
};


export type Query_FinancialTransactionsMetaArgs = {
  input: InputMaybe<FinancialTransactionQueryInput>;
};


export type Query_FundingSourcesMetaArgs = {
  input: InputMaybe<FundingSourceQueryInput>;
};


export type Query_GatewayInvoicesMetaArgs = {
  input: InputMaybe<InvoiceQueryInput>;
};


export type Query_GatewayStatementsMetaArgs = {
  input: InputMaybe<StatementQueryInput>;
};


export type Query_HealthSystemsMetaArgs = {
  input: InputMaybe<HealthSystemQueryInput>;
};


export type Query_InterviewAvailabilitiesMetaArgs = {
  input: InputMaybe<InterviewAvailabilityQueryInput>;
};


export type Query_InvoicesMetaArgs = {
  input: InputMaybe<InvoiceQueryInput>;
};


export type Query_ItemizedTransactionsMetaArgs = {
  input: InputMaybe<ItemizedTransactionQueryInput>;
};


export type Query_JobBillingsMetaArgs = {
  input: InputMaybe<JobBillingQueryInput>;
};


export type Query_JobIrregularitiesMetaArgs = {
  input: InputMaybe<JobIrregularityQueryInput>;
};


export type Query_JobPriceDifferentialsMetaArgs = {
  input: InputMaybe<JobPriceDifferentialQueryInput>;
};


export type Query_JobProfilesMetaArgs = {
  input: InputMaybe<JobProfileQueryInput>;
};


export type Query_JobPublishingGroupsMetaArgs = {
  input: InputMaybe<JobPublishingGroupQueryInput>;
};


export type Query_JobRateTrackedEventsMetaArgs = {
  input: InputMaybe<JobRateTrackedEventQueryInput>;
};


export type Query_JobSurgeryTypesMetaArgs = {
  input: InputMaybe<JobSurgeryTypeQueryInput>;
};


export type Query_JobTemplatesMetaArgs = {
  input: InputMaybe<JobTemplateQueryInput>;
};


export type Query_JobTracksMetaArgs = {
  input: InputMaybe<JobTrackQueryInput>;
};


export type Query_JobsBoardPositionsMetaArgs = {
  input: InputMaybe<JobsBoardPositionQueryInput>;
};


export type Query_JobsBoardsMetaArgs = {
  input: InputMaybe<JobsBoardQueryInput>;
};


export type Query_JobsMetaArgs = {
  input: InputMaybe<JobQueryInput>;
};


export type Query_LineOfCreditsMetaArgs = {
  input: InputMaybe<LineOfCreditQueryInput>;
};


export type Query_LocalRateRulesMetaArgs = {
  input: InputMaybe<LocalRateRuleQueryInput>;
};


export type Query_LocationBillingGroupsMetaArgs = {
  input: InputMaybe<LocationBillingGroupQueryInput>;
};


export type Query_LocationBlockReasonsMetaArgs = {
  input: InputMaybe<LocationBlockReasonQueryInput>;
};


export type Query_LocationGroupsMetaArgs = {
  input: InputMaybe<LocationGroupQueryInput>;
};


export type Query_LocationPositionRateSettingsMetaArgs = {
  input: InputMaybe<LocationPositionRateSettingQueryInput>;
};


export type Query_LocationPositionsMetaArgs = {
  input: InputMaybe<LocationPositionQueryInput>;
};


export type Query_LocationRateSettingsMetaArgs = {
  input: InputMaybe<LocationRateSettingQueryInput>;
};


export type Query_LocationTypePositionsMetaArgs = {
  input: InputMaybe<LocationTypePositionQueryInput>;
};


export type Query_LocationTypesMetaArgs = {
  input: InputMaybe<LocationTypeQueryInput>;
};


export type Query_LocationsMetaArgs = {
  input: InputMaybe<LocationQueryInput>;
};


export type Query_MarketLocationsMetaArgs = {
  input: InputMaybe<MarketLocationQueryInput>;
};


export type Query_MarketPositionRateSettingsMetaArgs = {
  input: InputMaybe<MarketPositionRateSettingQueryInput>;
};


export type Query_MarketRateSettingsMetaArgs = {
  input: InputMaybe<MarketRateSettingQueryInput>;
};


export type Query_MarketsMetaArgs = {
  input: InputMaybe<MarketQueryInput>;
};


export type Query_MarketsProfessionalsMetaArgs = {
  input: InputMaybe<MarketsProfessionalQueryInput>;
};


export type Query_MspsMetaArgs = {
  input: InputMaybe<MspQueryInput>;
};


export type Query_NetTermsMetaArgs = {
  input: InputMaybe<NetTermQueryInput>;
};


export type Query_NotesMetaArgs = {
  input: InputMaybe<NoteQueryInput>;
};


export type Query_NursysEnrollmentsMetaArgs = {
  input: InputMaybe<NursysEnrollmentQueryInput>;
};


export type Query_PaymentsMetaArgs = {
  input: InputMaybe<PaymentQueryInput>;
};


export type Query_PayoutsMetaArgs = {
  input: InputMaybe<PayoutQueryInput>;
};


export type Query_PeopleMetaArgs = {
  input: InputMaybe<PersonQueryInput>;
};


export type Query_PermissionGroupsMetaArgs = {
  input: InputMaybe<PermissionGroupQueryInput>;
};


export type Query_PersonDisabledReasonsMetaArgs = {
  input: InputMaybe<PersonDisabledReasonQueryInput>;
};


export type Query_PhoneScreeningRequestsMetaArgs = {
  input: InputMaybe<PhoneScreeningRequestQueryInput>;
};


export type Query_PoolProfessionalsMetaArgs = {
  input: InputMaybe<ProfessionalPoolQueryInput>;
};


export type Query_PositionPostingFieldsMetaArgs = {
  input: InputMaybe<PositionPostingFieldQueryInput>;
};


export type Query_PositionSpecialtiesMetaArgs = {
  input: InputMaybe<PositionSpecialtyQueryInput>;
};


export type Query_PositionsMetaArgs = {
  input: InputMaybe<PositionQueryInput>;
};


export type Query_PostingFieldsMetaArgs = {
  input: InputMaybe<PostingFieldQueryInput>;
};


export type Query_ProfessionalAssignmentFavoritesMetaArgs = {
  input: InputMaybe<ProfessionalAssignmentFavoriteQueryInput>;
};


export type Query_ProfessionalBlockReasonsMetaArgs = {
  input: InputMaybe<ProfessionalBlockReasonQueryInput>;
};


export type Query_ProfessionalPositionsMetaArgs = {
  input: InputMaybe<ProfessionalPositionQueryInput>;
};


export type Query_ProfessionalProfileEhrSystemsMetaArgs = {
  input: InputMaybe<ProfessionalProfileEhrSystemQueryInput>;
};


export type Query_ProfessionalProfilesMetaArgs = {
  input: InputMaybe<ProfessionalProfileQueryInput>;
};


export type Query_ProfessionalQualificationAttributesMetaArgs = {
  input: InputMaybe<ProfessionalQualificationAttributeQueryInput>;
};


export type Query_ProfessionalQualificationsMetaArgs = {
  input: InputMaybe<ProfessionalQualificationQueryInput>;
};


export type Query_ProfessionalReferencesMetaArgs = {
  input: InputMaybe<ProfessionalReferenceQueryInput>;
};


export type Query_ProfessionalSaasDetailsMetaArgs = {
  input: InputMaybe<ProfessionalSaasDetailQueryInput>;
};


export type Query_ProfessionalSkillsAssessmentsAnswersMetaArgs = {
  input: InputMaybe<ProfessionalSkillsAssessmentsAnswerQueryInput>;
};


export type Query_ProfessionalSpecialtiesMetaArgs = {
  input: InputMaybe<ProfessionalSpecialtyQueryInput>;
};


export type Query_ProfessionalTravelAssignmentStatesMetaArgs = {
  input: InputMaybe<ProfessionalTravelAssignmentStateQueryInput>;
};


export type Query_ProfessionalTravelPositionsMetaArgs = {
  input: InputMaybe<ProfessionalTravelPositionQueryInput>;
};


export type Query_ProfessionalsMetaArgs = {
  input: InputMaybe<ProfessionalQueryInput>;
};


export type Query_QualificationAttributesMetaArgs = {
  input: InputMaybe<QualificationAttributeQueryInput>;
};


export type Query_QualificationAutomationAttributesMetaArgs = {
  input: InputMaybe<QualificationAutomationAttributeQueryInput>;
};


export type Query_QualificationAutomationsMetaArgs = {
  input: InputMaybe<QualificationAutomationQueryInput>;
};


export type Query_QualificationsGroupsMetaArgs = {
  input: InputMaybe<QualificationsGroupQueryInput>;
};


export type Query_QualificationsMetaArgs = {
  input: InputMaybe<QualificationQueryInput>;
};


export type Query_QuestionnaireResponsesMetaArgs = {
  input: InputMaybe<QuestionnaireResponseQueryInput>;
};


export type Query_QuestionnairesMetaArgs = {
  input: InputMaybe<QuestionnaireQueryInput>;
};


export type Query_RateCalculatorsMetaArgs = {
  input: InputMaybe<RateCalculatorQueryInput>;
};


export type Query_RateSettingsMetaArgs = {
  input: InputMaybe<RateSettingQueryInput>;
};


export type Query_ReferralSourcesMetaArgs = {
  input: InputMaybe<ReferralSourceQueryInput>;
};


export type Query_RefundsMetaArgs = {
  input: InputMaybe<RefundQueryInput>;
};


export type Query_RelationshipsMetaArgs = {
  input: InputMaybe<RelationshipQueryInput>;
};


export type Query_RequirementsMetaArgs = {
  input: InputMaybe<RequirementQueryInput>;
};


export type Query_RevenueAdjustmentsMetaArgs = {
  input: InputMaybe<RevenueAdjustmentQueryInput>;
};


export type Query_ReviewsMetaArgs = {
  input: InputMaybe<ReviewQueryInput>;
};


export type Query_SkillsAssessmentBaksMetaArgs = {
  input: InputMaybe<SkillsAssessmentBakQueryInput>;
};


export type Query_SkillsAssessmentResponseBaksMetaArgs = {
  input: InputMaybe<SkillsAssessmentResponseBakQueryInput>;
};


export type Query_SkillsAssessmentSkillsQuestionsMetaArgs = {
  input: InputMaybe<SkillsAssessmentSkillsQuestionQueryInput>;
};


export type Query_SkillsAssessmentsMetaArgs = {
  input: InputMaybe<SkillsAssessmentQueryInput>;
};


export type Query_SkillsQuestionsMetaArgs = {
  input: InputMaybe<SkillsQuestionQueryInput>;
};


export type Query_SpecialtiesMetaArgs = {
  input: InputMaybe<SpecialtyQueryInput>;
};


export type Query_StaffBlockReasonsMetaArgs = {
  input: InputMaybe<StaffBlockReasonQueryInput>;
};


export type Query_StatePositionRateSettingsMetaArgs = {
  input: InputMaybe<StatePositionRateSettingQueryInput>;
};


export type Query_StateRateSettingsMetaArgs = {
  input: InputMaybe<StateRateSettingQueryInput>;
};


export type Query_StatementsMetaArgs = {
  input: InputMaybe<StatementQueryInput>;
};


export type Query_StatesMetaArgs = {
  input: InputMaybe<StateQueryInput>;
};


export type Query_StripeAccountsMetaArgs = {
  input: InputMaybe<StripeAccountQueryInput>;
};


export type Query_StripePaymentIntentsMetaArgs = {
  input: InputMaybe<StripePaymentIntentQueryInput>;
};


export type Query_StripeRepresentativesMetaArgs = {
  input: InputMaybe<StripeRepresentativeQueryInput>;
};


export type Query_SurgeryTypesMetaArgs = {
  input: InputMaybe<SurgeryTypeQueryInput>;
};


export type Query_TaxClassificationsMetaArgs = {
  input: InputMaybe<TaxClassificationQueryInput>;
};


export type Query_TaxFormsMetaArgs = {
  input: InputMaybe<TaxFormQueryInput>;
};


export type Query_TimecardsMetaArgs = {
  input: InputMaybe<TimecardQueryInput>;
};


export type Query_TransferReversalsMetaArgs = {
  input: InputMaybe<TransferReversalQueryInput>;
};


export type Query_UniqueAgencyChargeOverridesMetaArgs = {
  input: InputMaybe<AgencyChargeOverridesQueryInput>;
};


export type Query_UniversalBackgroundChecksMetaArgs = {
  input: InputMaybe<UniversalBackgroundCheckQueryInput>;
};


export type Query_UserPositionRateSettingsMetaArgs = {
  input: InputMaybe<UserPositionRateSettingQueryInput>;
};


export type Query_UserPositionsMetaArgs = {
  input: InputMaybe<UserPositionQueryInput>;
};


export type Query_UserRateSettingsMetaArgs = {
  input: InputMaybe<UserRateSettingQueryInput>;
};


export type Query_UsersMetaArgs = {
  input: InputMaybe<UserQueryInput>;
};


export type Query_VmsAssignmentsMetaArgs = {
  input: InputMaybe<VmsAssignmentQueryInput>;
};


export type Query_VmsPositionsMetaArgs = {
  input: InputMaybe<VmsPositionQueryInput>;
};


export type Query_VmsTypesMetaArgs = {
  input: InputMaybe<VmsTypeQueryInput>;
};


export type Query_VmsUsersMetaArgs = {
  input: InputMaybe<VmsUserQueryInput>;
};


export type Query_WageLogsMetaArgs = {
  input: InputMaybe<WageLogQueryInput>;
};


export type Query_WorkGapsMetaArgs = {
  input: InputMaybe<WorkGapQueryInput>;
};


export type Query_WorkHistoriesMetaArgs = {
  input: InputMaybe<WorkHistoryQueryInput>;
};


export type QueryAccountArgs = {
  id: InputMaybe<Scalars['Int']['input']>;
};


export type QueryAccountBillingGroupArgs = {
  id: Scalars['Int']['input'];
};


export type QueryAccountBillingGroupsArgs = {
  input: InputMaybe<AccountBillingGroupQueryInput>;
};


export type QueryAccountLocationArgs = {
  id: Scalars['Int']['input'];
};


export type QueryAccountLocationsArgs = {
  input: InputMaybe<AccountLocationQueryInput>;
};


export type QueryAccountsArgs = {
  input: InputMaybe<AccountQueryInput>;
};


export type QueryAdministratorArgs = {
  id: Scalars['Int']['input'];
};


export type QueryAdministratorsArgs = {
  input: InputMaybe<AdministratorQueryInput>;
};


export type QueryAgenciesArgs = {
  input: InputMaybe<AgencyQueryInput>;
};


export type QueryAgencyArgs = {
  id: Scalars['Int']['input'];
};


export type QueryAgencyChargeOverridesArgs = {
  input: InputMaybe<AgencyChargeOverridesQueryInput>;
};


export type QueryAgencyLocationArgs = {
  id: Scalars['Int']['input'];
};


export type QueryAgencyLocationPositionRateSettingArgs = {
  id: Scalars['Int']['input'];
  include_parents: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryAgencyLocationPositionRateSettingsArgs = {
  input: InputMaybe<AgencyLocationPositionRateSettingQueryInput>;
};


export type QueryAgencyLocationRateSettingArgs = {
  id: Scalars['Int']['input'];
  include_parents: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryAgencyLocationRateSettingsArgs = {
  input: InputMaybe<AgencyLocationRateSettingQueryInput>;
};


export type QueryAgencyLocationsArgs = {
  input: InputMaybe<AgencyLocationQueryInput>;
};


export type QueryAgencyQualificationArgs = {
  id: Scalars['Int']['input'];
};


export type QueryAgencyQualificationAttributeArgs = {
  id: Scalars['Int']['input'];
};


export type QueryAgencyQualificationAttributesArgs = {
  input: InputMaybe<AgencyQualificationAttributeQueryInput>;
};


export type QueryAgencyQualificationsArgs = {
  input: InputMaybe<AgencyQualificationQueryInput>;
};


export type QueryAppVersionArgs = {
  appName: Scalars['String']['input'];
};


export type QueryApplicationRequirementArgs = {
  id: Scalars['Int']['input'];
};


export type QueryApplicationRequirementsArgs = {
  input: InputMaybe<ApplicationRequirementQueryInput>;
};


export type QueryApprovalArgs = {
  id: Scalars['Int']['input'];
};


export type QueryApprovalGroupArgs = {
  id: Scalars['Int']['input'];
};


export type QueryApprovalGroupsArgs = {
  input: InputMaybe<ApprovalGroupQueryInput>;
};


export type QueryApprovalsArgs = {
  input: InputMaybe<ApprovalQueryInput>;
};


export type QueryAssignmentArgs = {
  id: Scalars['Int']['input'];
};


export type QueryAssignmentBillingGroupArgs = {
  id: Scalars['Int']['input'];
};


export type QueryAssignmentBillingGroupsArgs = {
  input: InputMaybe<AssignmentBillingGroupQueryInput>;
};


export type QueryAssignmentCancellationReasonsArgs = {
  location_id: Scalars['Int']['input'];
};


export type QueryAssignmentCancellationReasonsV2Args = {
  location_id: Scalars['Int']['input'];
};


export type QueryAssignmentLocationArgs = {
  id: Scalars['Int']['input'];
};


export type QueryAssignmentLocationsArgs = {
  input: InputMaybe<AssignmentLocationQueryInput>;
};


export type QueryAssignmentPreviewArgs = {
  id: Scalars['Int']['input'];
};


export type QueryAssignmentRequestArgs = {
  id: Scalars['Int']['input'];
};


export type QueryAssignmentRequestsArgs = {
  input: InputMaybe<AssignmentRequestQueryInput>;
};


export type QueryAssignmentsArgs = {
  input: InputMaybe<AssignmentQueryInput>;
};


export type QueryAssignmentsPreviewsArgs = {
  input: InputMaybe<AssignmentQueryInput>;
};


export type QueryAuditArgs = {
  id: Scalars['Int']['input'];
};


export type QueryAuditsArgs = {
  input: InputMaybe<AuditQueryInput>;
};


export type QueryAvailableAssignmentArgs = {
  id: Scalars['Int']['input'];
};


export type QueryAvailableAssignmentsArgs = {
  input: InputMaybe<AssignmentQueryInput>;
};


export type QueryAvailableJobArgs = {
  id: Scalars['Int']['input'];
};


export type QueryAvailableJobsArgs = {
  input: InputMaybe<JobQueryInput>;
};


export type QueryBackgroundCheckArgs = {
  id: Scalars['Int']['input'];
};


export type QueryBackgroundChecksArgs = {
  input: InputMaybe<BackgroundCheckQueryInput>;
};


export type QueryBalanceSheetArgs = {
  id: Scalars['Int']['input'];
};


export type QueryBalanceSheetsArgs = {
  input: InputMaybe<BalanceSheetQueryInput>;
};


export type QueryBillingActivitiesArgs = {
  input: InputMaybe<BillingActivityQueryInput>;
};


export type QueryBillingContactArgs = {
  id: Scalars['Int']['input'];
};


export type QueryBillingContactsArgs = {
  input: InputMaybe<BillingContactQueryInput>;
};


export type QueryBillingGroupArgs = {
  id: Scalars['Int']['input'];
};


export type QueryBillingGroupCreditLimitCalculationArgs = {
  input: InputMaybe<BillingGroupCreditLimitCalculationQueryInput>;
};


export type QueryBillingGroupCreditLimitCalculationsArgs = {
  input: InputMaybe<BillingGroupCreditLimitCalculationQueryInput>;
};


export type QueryBillingGroupManagementCompaniesArgs = {
  input: InputMaybe<BillingGroupManagementCompanyQueryInput>;
};


export type QueryBillingGroupManagementCompanyArgs = {
  id: Scalars['Int']['input'];
};


export type QueryBillingGroupParentArgs = {
  id: Scalars['Int']['input'];
};


export type QueryBillingGroupParentsArgs = {
  input: InputMaybe<BillingGroupParentQueryInput>;
};


export type QueryBillingGroupsArgs = {
  input: InputMaybe<BillingGroupQueryInput>;
};


export type QueryBlockedJobsArgs = {
  input: InputMaybe<JobQueryInput>;
};


export type QueryBreakArgs = {
  id: Scalars['Int']['input'];
};


export type QueryBreaksArgs = {
  input: InputMaybe<BreakQueryInput>;
};


export type QueryCancellationArgs = {
  id: Scalars['Int']['input'];
};


export type QueryCancellationReasonArgs = {
  id: Scalars['Int']['input'];
};


export type QueryCancellationReasonsArgs = {
  input: InputMaybe<CancellationReasonQueryInput>;
};


export type QueryCancellationsArgs = {
  input: InputMaybe<CancellationQueryInput>;
};


export type QueryCapsReportArgs = {
  id: Scalars['Int']['input'];
};


export type QueryCapsReportsArgs = {
  input: InputMaybe<CapsReportQueryInput>;
};


export type QueryCheckArgs = {
  id: Scalars['Int']['input'];
};


export type QueryCheckInArgs = {
  id: Scalars['Int']['input'];
};


export type QueryCheckInsArgs = {
  input: InputMaybe<CheckInQueryInput>;
};


export type QueryCheckOutArgs = {
  id: Scalars['Int']['input'];
};


export type QueryCheckOutsArgs = {
  input: InputMaybe<CheckOutQueryInput>;
};


export type QueryChecksArgs = {
  input: InputMaybe<CheckQueryInput>;
};


export type QueryClinicalContactArgs = {
  id: Scalars['Int']['input'];
};


export type QueryClinicalContactsArgs = {
  input: InputMaybe<ClinicalContactQueryInput>;
};


export type QueryClockEventAttachmentArgs = {
  id: Scalars['Int']['input'];
};


export type QueryClockEventAttachmentsArgs = {
  input: InputMaybe<ClockEventAttachmentQueryInput>;
};


export type QueryCompaniesArgs = {
  input: InputMaybe<CompanyQueryInput>;
};


export type QueryCompanyArgs = {
  id: Scalars['Int']['input'];
};


export type QueryConditionArgs = {
  id: Scalars['Int']['input'];
};


export type QueryConditionDocumentArgs = {
  id: Scalars['Int']['input'];
};


export type QueryConditionDocumentsArgs = {
  input: InputMaybe<ConditionDocumentQueryInput>;
};


export type QueryConditionsArgs = {
  input: InputMaybe<ConditionQueryInput>;
};


export type QueryContractArgs = {
  id: Scalars['Int']['input'];
};


export type QueryContractsArgs = {
  input: InputMaybe<ContractQueryInput>;
};


export type QueryCredentialRejectedReasonArgs = {
  id: Scalars['Int']['input'];
};


export type QueryCredentialRejectedReasonsArgs = {
  input: InputMaybe<CredentialRejectedReasonQueryInput>;
};


export type QueryCreditNoteArgs = {
  id: Scalars['Int']['input'];
};


export type QueryCreditNotesArgs = {
  input: InputMaybe<CreditNoteQueryInput>;
};


export type QueryCustomProfessionalProfileEhrSystemArgs = {
  id: Scalars['Int']['input'];
};


export type QueryCustomProfessionalProfileEhrSystemsArgs = {
  input: InputMaybe<CustomProfessionalProfileEhrSystemQueryInput>;
};


export type QueryDeprecatedInvoiceArgs = {
  id: Scalars['Int']['input'];
};


export type QueryDeprecatedInvoicesArgs = {
  input: InputMaybe<DeprecatedInvoiceQueryInput>;
};


export type QueryDisabledReasonArgs = {
  id: Scalars['Int']['input'];
};


export type QueryDisabledReasonsArgs = {
  input: InputMaybe<DisabledReasonQueryInput>;
};


export type QueryDisputeArgs = {
  id: Scalars['Int']['input'];
};


export type QueryDisputeShiftWitnessArgs = {
  id: Scalars['Int']['input'];
};


export type QueryDisputeShiftWitnessesArgs = {
  input: InputMaybe<DisputeShiftWitnessQueryInput>;
};


export type QueryDisputesArgs = {
  input: InputMaybe<DisputeQueryInput>;
};


export type QueryEducationArgs = {
  id: Scalars['Int']['input'];
};


export type QueryEducationsArgs = {
  input: InputMaybe<EducationQueryInput>;
};


export type QueryEhrSystemArgs = {
  id: Scalars['Int']['input'];
};


export type QueryEhrSystemsArgs = {
  input: InputMaybe<EhrSystemQueryInput>;
};


export type QueryEmergencyContactArgs = {
  id: Scalars['Int']['input'];
};


export type QueryEmergencyContactsArgs = {
  input: InputMaybe<EmergencyContactQueryInput>;
};


export type QueryExpenseAdjustmentArgs = {
  id: Scalars['Int']['input'];
};


export type QueryExpenseAdjustmentsArgs = {
  input: InputMaybe<ExpenseAdjustmentQueryInput>;
};


export type QueryExternalAccountArgs = {
  id: Scalars['Int']['input'];
};


export type QueryExternalAccountsArgs = {
  input: InputMaybe<ExternalAccountQueryInput>;
};


export type QueryFacilityConnectionArgs = {
  id: Scalars['Int']['input'];
};


export type QueryFacilityConnectionsArgs = {
  input: InputMaybe<FacilityConnectionQueryInput>;
};


export type QueryFinancialTransactionArgs = {
  id: Scalars['Int']['input'];
};


export type QueryFinancialTransactionsArgs = {
  input: InputMaybe<FinancialTransactionQueryInput>;
};


export type QueryFundingSourceArgs = {
  id: Scalars['Int']['input'];
};


export type QueryFundingSourcesArgs = {
  input: InputMaybe<FundingSourceQueryInput>;
};


export type QueryGatewayBillingGroupArgs = {
  uid: Scalars['String']['input'];
};


export type QueryGatewayBillingGroupCreditLimitCalculationArgs = {
  uid: Scalars['UUID']['input'];
};


export type QueryGatewayConditionDocumentsArgs = {
  input: InputMaybe<ConditionDocumentQueryInput>;
};


export type QueryGatewayInvoiceArgs = {
  billing_id: Scalars['String']['input'];
};


export type QueryGatewayInvoicesArgs = {
  input: InputMaybe<InvoiceQueryInput>;
};


export type QueryGatewayProfessionalReferencesArgs = {
  input: InputMaybe<ProfessionalReferenceQueryInput>;
};


export type QueryGatewayStatementArgs = {
  billing_id: Scalars['String']['input'];
};


export type QueryGatewayStatementsArgs = {
  input: InputMaybe<StatementQueryInput>;
};


export type QueryGetBlockedTimesArgs = {
  input: GetBlockedTimesInput;
};


export type QueryHealthSystemArgs = {
  id: Scalars['Int']['input'];
};


export type QueryHealthSystemsArgs = {
  input: InputMaybe<HealthSystemQueryInput>;
};


export type QueryInterviewAvailabilitiesArgs = {
  input: InputMaybe<InterviewAvailabilityQueryInput>;
};


export type QueryInterviewAvailabilityArgs = {
  id: Scalars['Int']['input'];
};


export type QueryInvoiceArgs = {
  id: Scalars['Int']['input'];
};


export type QueryInvoiceStatusBillingGroupCountsArgs = {
  input: InvoiceStatusBillingGroupCountsInput;
};


export type QueryInvoicesArgs = {
  input: InputMaybe<InvoiceQueryInput>;
};


export type QueryInvoicesTotalsArgs = {
  input: InputMaybe<InvoiceQueryInput>;
};


export type QueryItemizedTransactionArgs = {
  id: Scalars['Int']['input'];
};


export type QueryItemizedTransactionsArgs = {
  input: InputMaybe<ItemizedTransactionQueryInput>;
};


export type QueryJobArgs = {
  id: Scalars['Int']['input'];
};


export type QueryJobBillingArgs = {
  id: Scalars['Int']['input'];
};


export type QueryJobBillingsArgs = {
  input: InputMaybe<JobBillingQueryInput>;
};


export type QueryJobCountArgs = {
  input: InputMaybe<JobQueryInput>;
};


export type QueryJobIrregularitiesArgs = {
  input: InputMaybe<JobIrregularityQueryInput>;
};


export type QueryJobIrregularityArgs = {
  id: Scalars['Int']['input'];
};


export type QueryJobPriceDifferentialArgs = {
  id: Scalars['Int']['input'];
};


export type QueryJobPriceDifferentialsArgs = {
  input: InputMaybe<JobPriceDifferentialQueryInput>;
};


export type QueryJobProfileArgs = {
  id: Scalars['Int']['input'];
};


export type QueryJobProfilesArgs = {
  input: InputMaybe<JobProfileQueryInput>;
};


export type QueryJobPublishingGroupArgs = {
  id: Scalars['Int']['input'];
};


export type QueryJobPublishingGroupsArgs = {
  input: InputMaybe<JobPublishingGroupQueryInput>;
};


export type QueryJobRateTrackedEventArgs = {
  id: Scalars['Int']['input'];
};


export type QueryJobRateTrackedEventsArgs = {
  input: InputMaybe<JobRateTrackedEventQueryInput>;
};


export type QueryJobStatusLocationCountsArgs = {
  input: JobStatusLocationCountsInput;
};


export type QueryJobSurgeryTypeArgs = {
  id: Scalars['Int']['input'];
};


export type QueryJobSurgeryTypesArgs = {
  input: InputMaybe<JobSurgeryTypeQueryInput>;
};


export type QueryJobTemplateArgs = {
  id: Scalars['Int']['input'];
};


export type QueryJobTemplatesArgs = {
  input: InputMaybe<JobTemplateQueryInput>;
};


export type QueryJobTrackArgs = {
  id: Scalars['Int']['input'];
};


export type QueryJobTracksArgs = {
  input: InputMaybe<JobTrackQueryInput>;
};


export type QueryJobsArgs = {
  input: InputMaybe<JobQueryInput>;
};


export type QueryJobsAwaitingApprovalArgs = {
  input: InputMaybe<JobQueryInput>;
};


export type QueryJobsBoardArgs = {
  id: Scalars['Int']['input'];
};


export type QueryJobsBoardPositionArgs = {
  id: Scalars['Int']['input'];
};


export type QueryJobsBoardPositionsArgs = {
  input: InputMaybe<JobsBoardPositionQueryInput>;
};


export type QueryJobsBoardsArgs = {
  input: InputMaybe<JobsBoardQueryInput>;
};


export type QueryJobsByPositionArgs = {
  input: InputMaybe<JobQueryInput>;
};


export type QueryJobsTotalsArgs = {
  input: InputMaybe<JobQueryInput>;
};


export type QueryJobsWithoutPayoutArgs = {
  input: InputMaybe<JobQueryInput>;
};


export type QueryLineOfCreditArgs = {
  id: Scalars['Int']['input'];
};


export type QueryLineOfCreditsArgs = {
  input: InputMaybe<LineOfCreditQueryInput>;
};


export type QueryLocalRateRuleArgs = {
  id: Scalars['Int']['input'];
};


export type QueryLocalRateRulesArgs = {
  input: InputMaybe<LocalRateRuleQueryInput>;
};


export type QueryLocationArgs = {
  id: Scalars['Int']['input'];
};


export type QueryLocationAssignmentIssueCountsArgs = {
  input: LocationAssignmentIssueCountsInput;
};


export type QueryLocationBillingGroupArgs = {
  id: Scalars['Int']['input'];
};


export type QueryLocationBillingGroupsArgs = {
  input: InputMaybe<LocationBillingGroupQueryInput>;
};


export type QueryLocationBlockReasonArgs = {
  id: Scalars['Int']['input'];
};


export type QueryLocationBlockReasonsArgs = {
  input: InputMaybe<LocationBlockReasonQueryInput>;
};


export type QueryLocationGroupArgs = {
  id: Scalars['Int']['input'];
};


export type QueryLocationGroupsArgs = {
  input: InputMaybe<LocationGroupQueryInput>;
};


export type QueryLocationPositionArgs = {
  id: Scalars['Int']['input'];
};


export type QueryLocationPositionRateSettingArgs = {
  id: Scalars['Int']['input'];
  include_parents: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryLocationPositionRateSettingsArgs = {
  input: InputMaybe<LocationPositionRateSettingQueryInput>;
};


export type QueryLocationPositionsArgs = {
  input: InputMaybe<LocationPositionQueryInput>;
};


export type QueryLocationRateSettingArgs = {
  id: Scalars['Int']['input'];
  include_parents: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryLocationRateSettingsArgs = {
  input: InputMaybe<LocationRateSettingQueryInput>;
};


export type QueryLocationTypeArgs = {
  id: Scalars['Int']['input'];
};


export type QueryLocationTypePositionArgs = {
  id: Scalars['Int']['input'];
};


export type QueryLocationTypePositionsArgs = {
  input: InputMaybe<LocationTypePositionQueryInput>;
};


export type QueryLocationTypesArgs = {
  input: InputMaybe<LocationTypeQueryInput>;
};


export type QueryLocationsArgs = {
  input: InputMaybe<LocationQueryInput>;
};


export type QueryMarketArgs = {
  id: Scalars['Int']['input'];
};


export type QueryMarketLocationArgs = {
  id: Scalars['Int']['input'];
};


export type QueryMarketLocationsArgs = {
  input: InputMaybe<MarketLocationQueryInput>;
};


export type QueryMarketPositionRateSettingArgs = {
  id: Scalars['Int']['input'];
  include_parents: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryMarketPositionRateSettingsArgs = {
  input: InputMaybe<MarketPositionRateSettingQueryInput>;
};


export type QueryMarketRateSettingArgs = {
  id: Scalars['Int']['input'];
  include_parents: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryMarketRateSettingsArgs = {
  input: InputMaybe<MarketRateSettingQueryInput>;
};


export type QueryMarketsArgs = {
  input: InputMaybe<MarketQueryInput>;
};


export type QueryMarketsProfessionalArgs = {
  id: Scalars['Int']['input'];
};


export type QueryMarketsProfessionalsArgs = {
  input: InputMaybe<MarketsProfessionalQueryInput>;
};


export type QueryMetabaseEmbedUrlArgs = {
  input: InputMaybe<MetabaseEmbedQueryInput>;
};


export type QueryMspArgs = {
  id: Scalars['Int']['input'];
};


export type QueryMspsArgs = {
  input: InputMaybe<MspQueryInput>;
};


export type QueryNetTermArgs = {
  id: Scalars['Int']['input'];
};


export type QueryNetTermsArgs = {
  input: InputMaybe<NetTermQueryInput>;
};


export type QueryNoteArgs = {
  id: Scalars['Int']['input'];
};


export type QueryNotesArgs = {
  input: InputMaybe<NoteQueryInput>;
};


export type QueryNursysEnrollmentArgs = {
  id: Scalars['Int']['input'];
};


export type QueryNursysEnrollmentsArgs = {
  input: InputMaybe<NursysEnrollmentQueryInput>;
};


export type QueryPaymentArgs = {
  id: Scalars['Int']['input'];
};


export type QueryPaymentsArgs = {
  input: InputMaybe<PaymentQueryInput>;
};


export type QueryPayoutArgs = {
  id: Scalars['Int']['input'];
};


export type QueryPayoutsArgs = {
  input: InputMaybe<PayoutQueryInput>;
};


export type QueryPeopleArgs = {
  input: InputMaybe<PersonQueryInput>;
};


export type QueryPermissionGroupArgs = {
  id: Scalars['Int']['input'];
};


export type QueryPermissionGroupsArgs = {
  input: InputMaybe<PermissionGroupQueryInput>;
};


export type QueryPersonArgs = {
  id: Scalars['Int']['input'];
};


export type QueryPersonDisabledReasonArgs = {
  id: Scalars['Int']['input'];
};


export type QueryPersonDisabledReasonsArgs = {
  input: InputMaybe<PersonDisabledReasonQueryInput>;
};


export type QueryPhoneScreeningRequestArgs = {
  id: Scalars['Int']['input'];
};


export type QueryPhoneScreeningRequestsArgs = {
  input: InputMaybe<PhoneScreeningRequestQueryInput>;
};


export type QueryPoolProfessionalArgs = {
  id: Scalars['Int']['input'];
  location_id: Scalars['Int']['input'];
};


export type QueryPoolProfessionalsArgs = {
  input: InputMaybe<ProfessionalPoolQueryInput>;
};


export type QueryPositionArgs = {
  id: Scalars['Int']['input'];
};


export type QueryPositionPostingFieldArgs = {
  id: Scalars['Int']['input'];
};


export type QueryPositionPostingFieldsArgs = {
  input: InputMaybe<PositionPostingFieldQueryInput>;
};


export type QueryPositionSpecialtiesArgs = {
  input: InputMaybe<PositionSpecialtyQueryInput>;
};


export type QueryPositionSpecialtyArgs = {
  id: Scalars['Int']['input'];
};


export type QueryPositionsArgs = {
  input: InputMaybe<PositionQueryInput>;
};


export type QueryPostingFieldArgs = {
  id: Scalars['Int']['input'];
};


export type QueryPostingFieldsArgs = {
  input: InputMaybe<PostingFieldQueryInput>;
};


export type QueryProfessionalArgs = {
  id: Scalars['Int']['input'];
};


export type QueryProfessionalAssignmentFavoriteArgs = {
  id: Scalars['Int']['input'];
};


export type QueryProfessionalAssignmentFavoritesArgs = {
  input: InputMaybe<ProfessionalAssignmentFavoriteQueryInput>;
};


export type QueryProfessionalBlockReasonArgs = {
  id: Scalars['Int']['input'];
};


export type QueryProfessionalBlockReasonsArgs = {
  input: InputMaybe<ProfessionalBlockReasonQueryInput>;
};


export type QueryProfessionalPositionArgs = {
  id: Scalars['Int']['input'];
};


export type QueryProfessionalPositionsArgs = {
  input: InputMaybe<ProfessionalPositionQueryInput>;
};


export type QueryProfessionalProfileArgs = {
  id: Scalars['Int']['input'];
};


export type QueryProfessionalProfileEhrSystemArgs = {
  id: Scalars['Int']['input'];
};


export type QueryProfessionalProfileEhrSystemsArgs = {
  input: InputMaybe<ProfessionalProfileEhrSystemQueryInput>;
};


export type QueryProfessionalProfilesArgs = {
  input: InputMaybe<ProfessionalProfileQueryInput>;
};


export type QueryProfessionalQualificationArgs = {
  id: Scalars['Int']['input'];
};


export type QueryProfessionalQualificationAttributeArgs = {
  id: Scalars['Int']['input'];
};


export type QueryProfessionalQualificationAttributesArgs = {
  input: InputMaybe<ProfessionalQualificationAttributeQueryInput>;
};


export type QueryProfessionalQualificationsArgs = {
  input: InputMaybe<ProfessionalQualificationQueryInput>;
};


export type QueryProfessionalReferenceArgs = {
  id: Scalars['Int']['input'];
};


export type QueryProfessionalReferencesArgs = {
  input: InputMaybe<ProfessionalReferenceQueryInput>;
};


export type QueryProfessionalSaasDetailArgs = {
  id: Scalars['Int']['input'];
};


export type QueryProfessionalSaasDetailsArgs = {
  input: InputMaybe<ProfessionalSaasDetailQueryInput>;
};


export type QueryProfessionalSkillsAssessmentsAnswerArgs = {
  id: Scalars['Int']['input'];
};


export type QueryProfessionalSkillsAssessmentsAnswersArgs = {
  input: InputMaybe<ProfessionalSkillsAssessmentsAnswerQueryInput>;
};


export type QueryProfessionalSpecialtiesArgs = {
  input: InputMaybe<ProfessionalSpecialtyQueryInput>;
};


export type QueryProfessionalSpecialtyArgs = {
  id: Scalars['Int']['input'];
};


export type QueryProfessionalTravelAssignmentStateArgs = {
  id: Scalars['Int']['input'];
};


export type QueryProfessionalTravelAssignmentStatesArgs = {
  input: InputMaybe<ProfessionalTravelAssignmentStateQueryInput>;
};


export type QueryProfessionalTravelPositionArgs = {
  id: Scalars['Int']['input'];
};


export type QueryProfessionalTravelPositionsArgs = {
  input: InputMaybe<ProfessionalTravelPositionQueryInput>;
};


export type QueryProfessionalsArgs = {
  input: InputMaybe<ProfessionalQueryInput>;
};


export type QueryProfessionalsJobsArgs = {
  input: ProfessionalsJobsInput;
};


export type QueryQualificationArgs = {
  id: Scalars['Int']['input'];
};


export type QueryQualificationAttributeArgs = {
  id: Scalars['Int']['input'];
};


export type QueryQualificationAttributesArgs = {
  input: InputMaybe<QualificationAttributeQueryInput>;
};


export type QueryQualificationAutomationArgs = {
  id: Scalars['Int']['input'];
};


export type QueryQualificationAutomationAttributeArgs = {
  id: Scalars['Int']['input'];
};


export type QueryQualificationAutomationAttributesArgs = {
  input: InputMaybe<QualificationAutomationAttributeQueryInput>;
};


export type QueryQualificationAutomationsArgs = {
  input: InputMaybe<QualificationAutomationQueryInput>;
};


export type QueryQualificationsArgs = {
  input: InputMaybe<QualificationQueryInput>;
};


export type QueryQualificationsGroupArgs = {
  id: Scalars['Int']['input'];
};


export type QueryQualificationsGroupsArgs = {
  input: InputMaybe<QualificationsGroupQueryInput>;
};


export type QueryQuestionnaireArgs = {
  id: Scalars['Int']['input'];
};


export type QueryQuestionnaireResponseArgs = {
  id: Scalars['Int']['input'];
};


export type QueryQuestionnaireResponsesArgs = {
  input: InputMaybe<QuestionnaireResponseQueryInput>;
};


export type QueryQuestionnairesArgs = {
  input: InputMaybe<QuestionnaireQueryInput>;
};


export type QueryRateCalculatorArgs = {
  id: Scalars['Int']['input'];
};


export type QueryRateCalculatorsArgs = {
  input: InputMaybe<RateCalculatorQueryInput>;
};


export type QueryRateSettingArgs = {
  id: Scalars['Int']['input'];
};


export type QueryRateSettingsArgs = {
  input: InputMaybe<RateSettingQueryInput>;
};


export type QueryReferralSourceArgs = {
  id: Scalars['Int']['input'];
};


export type QueryReferralSourcesArgs = {
  input: InputMaybe<ReferralSourceQueryInput>;
};


export type QueryRefundArgs = {
  id: Scalars['Int']['input'];
};


export type QueryRefundsArgs = {
  input: InputMaybe<RefundQueryInput>;
};


export type QueryRelationshipArgs = {
  id: Scalars['Int']['input'];
};


export type QueryRelationshipsArgs = {
  input: InputMaybe<RelationshipQueryInput>;
};


export type QueryRequirementArgs = {
  id: Scalars['Int']['input'];
};


export type QueryRequirementsArgs = {
  input: InputMaybe<RequirementQueryInput>;
};


export type QueryRevenueAdjustmentArgs = {
  id: Scalars['Int']['input'];
};


export type QueryRevenueAdjustmentsArgs = {
  input: InputMaybe<RevenueAdjustmentQueryInput>;
};


export type QueryReviewArgs = {
  id: Scalars['Int']['input'];
};


export type QueryReviewsArgs = {
  input: InputMaybe<ReviewQueryInput>;
};


export type QuerySkillsAssessmentArgs = {
  id: Scalars['Int']['input'];
};


export type QuerySkillsAssessmentBakArgs = {
  id: Scalars['Int']['input'];
};


export type QuerySkillsAssessmentBaksArgs = {
  input: InputMaybe<SkillsAssessmentBakQueryInput>;
};


export type QuerySkillsAssessmentResponseBakArgs = {
  id: Scalars['Int']['input'];
};


export type QuerySkillsAssessmentResponseBaksArgs = {
  input: InputMaybe<SkillsAssessmentResponseBakQueryInput>;
};


export type QuerySkillsAssessmentSkillsQuestionArgs = {
  id: Scalars['Int']['input'];
};


export type QuerySkillsAssessmentSkillsQuestionsArgs = {
  input: InputMaybe<SkillsAssessmentSkillsQuestionQueryInput>;
};


export type QuerySkillsAssessmentsArgs = {
  input: InputMaybe<SkillsAssessmentQueryInput>;
};


export type QuerySkillsQuestionArgs = {
  id: Scalars['Int']['input'];
};


export type QuerySkillsQuestionsArgs = {
  input: InputMaybe<SkillsQuestionQueryInput>;
};


export type QuerySpecialtiesArgs = {
  input: InputMaybe<SpecialtyQueryInput>;
};


export type QuerySpecialtyArgs = {
  id: Scalars['Int']['input'];
};


export type QueryStaffBlockReasonArgs = {
  id: Scalars['Int']['input'];
};


export type QueryStaffBlockReasonsArgs = {
  input: InputMaybe<StaffBlockReasonQueryInput>;
};


export type QueryStateArgs = {
  id: Scalars['Int']['input'];
};


export type QueryStatePositionRateSettingArgs = {
  id: Scalars['Int']['input'];
  include_parents: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryStatePositionRateSettingsArgs = {
  input: InputMaybe<StatePositionRateSettingQueryInput>;
};


export type QueryStateRateSettingArgs = {
  id: Scalars['Int']['input'];
};


export type QueryStateRateSettingsArgs = {
  input: InputMaybe<StateRateSettingQueryInput>;
};


export type QueryStatementArgs = {
  id: Scalars['Int']['input'];
};


export type QueryStatementsArgs = {
  input: InputMaybe<StatementQueryInput>;
};


export type QueryStatesArgs = {
  input: InputMaybe<StateQueryInput>;
};


export type QueryStripeAccountArgs = {
  id: Scalars['Int']['input'];
};


export type QueryStripeAccountsArgs = {
  input: InputMaybe<StripeAccountQueryInput>;
};


export type QueryStripePaymentIntentArgs = {
  id: Scalars['Int']['input'];
};


export type QueryStripePaymentIntentsArgs = {
  input: InputMaybe<StripePaymentIntentQueryInput>;
};


export type QueryStripeRepresentativeArgs = {
  id: Scalars['Int']['input'];
};


export type QueryStripeRepresentativesArgs = {
  input: InputMaybe<StripeRepresentativeQueryInput>;
};


export type QuerySurgeryTypeArgs = {
  id: Scalars['Int']['input'];
};


export type QuerySurgeryTypesArgs = {
  input: InputMaybe<SurgeryTypeQueryInput>;
};


export type QueryTaxClassificationArgs = {
  id: Scalars['Int']['input'];
};


export type QueryTaxClassificationsArgs = {
  input: InputMaybe<TaxClassificationQueryInput>;
};


export type QueryTaxFormArgs = {
  id: Scalars['Int']['input'];
};


export type QueryTaxFormsArgs = {
  input: InputMaybe<TaxFormQueryInput>;
};


export type QueryTimecardArgs = {
  id: Scalars['Int']['input'];
};


export type QueryTimecardsArgs = {
  input: InputMaybe<TimecardQueryInput>;
};


export type QueryTimecardsTotalsArgs = {
  input: InputMaybe<TimecardQueryInput>;
};


export type QueryTransferReversalArgs = {
  id: Scalars['Int']['input'];
};


export type QueryTransferReversalsArgs = {
  input: InputMaybe<TransferReversalQueryInput>;
};


export type QueryUniqueAgencyChargeOverridesArgs = {
  input: InputMaybe<AgencyChargeOverridesQueryInput>;
};


export type QueryUniversalBackgroundCheckArgs = {
  id: Scalars['Int']['input'];
};


export type QueryUniversalBackgroundChecksArgs = {
  input: InputMaybe<UniversalBackgroundCheckQueryInput>;
};


export type QueryUnpaidTimecardAdjustmentsArgs = {
  input: InputMaybe<ExpenseAdjustmentQueryInput>;
};


export type QueryUserArgs = {
  id: Scalars['Int']['input'];
};


export type QueryUserPositionArgs = {
  id: Scalars['Int']['input'];
};


export type QueryUserPositionRateSettingArgs = {
  id: Scalars['Int']['input'];
  include_parents: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryUserPositionRateSettingsArgs = {
  input: InputMaybe<UserPositionRateSettingQueryInput>;
};


export type QueryUserPositionsArgs = {
  input: InputMaybe<UserPositionQueryInput>;
};


export type QueryUserRateSettingArgs = {
  id: Scalars['Int']['input'];
  include_parents: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryUserRateSettingsArgs = {
  input: InputMaybe<UserRateSettingQueryInput>;
};


export type QueryUsersArgs = {
  input: InputMaybe<UserQueryInput>;
};


export type QueryValidateJobTimesArgs = {
  input: ValidateJobTimesInput;
};


export type QueryVmsAssignmentArgs = {
  id: Scalars['Int']['input'];
};


export type QueryVmsAssignmentsArgs = {
  input: InputMaybe<VmsAssignmentQueryInput>;
};


export type QueryVmsPositionArgs = {
  id: Scalars['Int']['input'];
};


export type QueryVmsPositionsArgs = {
  input: InputMaybe<VmsPositionQueryInput>;
};


export type QueryVmsTypeArgs = {
  id: Scalars['Int']['input'];
};


export type QueryVmsTypesArgs = {
  input: InputMaybe<VmsTypeQueryInput>;
};


export type QueryVmsUserArgs = {
  id: Scalars['Int']['input'];
};


export type QueryVmsUsersArgs = {
  input: InputMaybe<VmsUserQueryInput>;
};


export type QueryWageLogArgs = {
  id: Scalars['Int']['input'];
};


export type QueryWageLogsArgs = {
  input: InputMaybe<WageLogQueryInput>;
};


export type QueryWeeklyTimecardsTotalsArgs = {
  input: InputMaybe<WeeklyTimecardsTotalsInput>;
};


export type QueryWorkGapArgs = {
  id: Scalars['Int']['input'];
};


export type QueryWorkGapsArgs = {
  input: InputMaybe<WorkGapQueryInput>;
};


export type QueryWorkHistoriesArgs = {
  input: InputMaybe<WorkHistoryQueryInput>;
};


export type QueryWorkHistoryArgs = {
  id: Scalars['Int']['input'];
};

export type Questionnaire = {
  __typename?: 'Questionnaire';
  created_at: Scalars['DateTime']['output'];
  id: Scalars['Int']['output'];
  label: Maybe<Scalars['String']['output']>;
  questions: Maybe<Scalars['JSON']['output']>;
  updated_at: Scalars['DateTime']['output'];
};

export type QuestionnaireOrderInput = {
  id: InputMaybe<Scalars['Boolean']['input']>;
  license_id: InputMaybe<Scalars['Boolean']['input']>;
};

export type QuestionnaireQueryInput = {
  filter: InputMaybe<QuestionnaireWhereInput>;
  orderBy: InputMaybe<QuestionnaireOrderInput>;
  page: InputMaybe<Scalars['Int']['input']>;
  perPage: InputMaybe<Scalars['Int']['input']>;
  search: InputMaybe<DefaultSearchInput>;
};

export type QuestionnaireResponse = {
  __typename?: 'QuestionnaireResponse';
  created_at: Scalars['DateTime']['output'];
  id: Scalars['Int']['output'];
  professional: Maybe<Professional>;
  professional_id: Maybe<Scalars['Int']['output']>;
  questionnaire: Maybe<Questionnaire>;
  questionnaire_id: Maybe<Scalars['Int']['output']>;
  questions: Maybe<Scalars['JSON']['output']>;
  updated_at: Scalars['DateTime']['output'];
};

export type QuestionnaireResponseOrderInput = {
  id: InputMaybe<Scalars['Boolean']['input']>;
  professional_id: InputMaybe<Scalars['Boolean']['input']>;
  status: InputMaybe<Scalars['Boolean']['input']>;
};

export type QuestionnaireResponseQueryInput = {
  filter: InputMaybe<QuestionnaireResponseWhereInput>;
  orderBy: InputMaybe<QuestionnaireResponseOrderInput>;
  page: InputMaybe<Scalars['Int']['input']>;
  perPage: InputMaybe<Scalars['Int']['input']>;
  search: InputMaybe<QuestionnaireResponseSearchInput>;
};

export type QuestionnaireResponseSearchInput = {
  credential_id: InputMaybe<Scalars['Int']['input']>;
  id: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  license_id: InputMaybe<Scalars['Int']['input']>;
  professional_id: InputMaybe<Scalars['Int']['input']>;
  /**
   * *Constraints:*
   * * Maximal length: `150`
   *
   */
  q: InputMaybe<Scalars['String']['input']>;
  questionnaire_id: InputMaybe<Scalars['Int']['input']>;
};

export type QuestionnaireResponseWhereInput = {
  credential_id: InputMaybe<Scalars['Int']['input']>;
  id: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  professional_id: InputMaybe<Scalars['Int']['input']>;
  questionnaire_id: InputMaybe<Scalars['Int']['input']>;
};

export type QuestionnaireWhereInput = {
  id: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  license_id: InputMaybe<Scalars['Int']['input']>;
};

export type RateCalculator = {
  __typename?: 'RateCalculator';
  base_rate_cents: Maybe<Scalars['Int']['output']>;
  base_rate_facility_cents: Maybe<Scalars['Int']['output']>;
  charge_rate_cents: Maybe<Scalars['Int']['output']>;
  created_at: Scalars['DateTime']['output'];
  fee_percent: Maybe<Scalars['Float']['output']>;
  id: Scalars['Int']['output'];
  payout_rate_cents: Maybe<Scalars['Int']['output']>;
  rate_differential: Scalars['Float']['output'];
  updated_at: Scalars['DateTime']['output'];
};

export type RateCalculatorOrderInput = {
  base_rate: InputMaybe<Scalars['Boolean']['input']>;
  base_rate_facility: InputMaybe<Scalars['Boolean']['input']>;
  charge_rate_cents: InputMaybe<Scalars['Boolean']['input']>;
  created_at: InputMaybe<Scalars['Boolean']['input']>;
  fee_percent: InputMaybe<Scalars['Boolean']['input']>;
  id: InputMaybe<Scalars['Boolean']['input']>;
  rate: InputMaybe<Scalars['Boolean']['input']>;
  rate_differential: InputMaybe<Scalars['Boolean']['input']>;
  updated_at: InputMaybe<Scalars['Boolean']['input']>;
};

export type RateCalculatorQueryInput = {
  filter: InputMaybe<RateCalculatorWhereInput>;
  orderBy: InputMaybe<RateCalculatorOrderInput>;
  page: InputMaybe<Scalars['Int']['input']>;
  perPage: InputMaybe<Scalars['Int']['input']>;
  search: InputMaybe<DefaultSearchInput>;
};

export type RateCalculatorWhereInput = {
  base_rate: InputMaybe<Scalars['Int']['input']>;
  base_rate_facility: InputMaybe<Scalars['Int']['input']>;
  charge_rate_cents: InputMaybe<Scalars['Int']['input']>;
  created_at: InputMaybe<Scalars['DateTime']['input']>;
  fee_percent: InputMaybe<Scalars['Float']['input']>;
  id: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  rate: InputMaybe<Scalars['Int']['input']>;
  rate_differential: InputMaybe<Scalars['Float']['input']>;
  updated_at: InputMaybe<Scalars['DateTime']['input']>;
};

export type RateSetting = {
  __typename?: 'RateSetting';
  active: Scalars['Boolean']['output'];
  charge_on_call_hourly_rate_cents: Scalars['Int']['output'];
  charge_on_call_hourly_rate_currency: Scalars['String']['output'];
  charge_overtime_frequency: Maybe<Scalars['String']['output']>;
  charge_overtime_multiplier: Maybe<Scalars['Float']['output']>;
  charge_rate_cents: Scalars['Int']['output'];
  charge_rate_minimum_cents: Maybe<Scalars['Int']['output']>;
  compliance_burden_cents: Scalars['Int']['output'];
  created_at: Scalars['DateTime']['output'];
  federal_unemployment_max_burden_cents: Scalars['Int']['output'];
  federal_unemployment_percent_burden_multiplier: Scalars['Float']['output'];
  fee_percent: Maybe<Scalars['Float']['output']>;
  id: Scalars['Int']['output'];
  market: Maybe<Market>;
  market_name: Maybe<Scalars['String']['output']>;
  medicare_burden_multiplier: Scalars['Float']['output'];
  on_call_fee_percent: Maybe<Scalars['Float']['output']>;
  on_call_hourly_rate_cents: Maybe<Scalars['Int']['output']>;
  other_burden_multiplier: Scalars['Float']['output'];
  payout_on_call_hourly_rate_cents: Scalars['Int']['output'];
  payout_on_call_hourly_rate_currency: Scalars['String']['output'];
  payout_overtime_frequency: Maybe<Scalars['String']['output']>;
  payout_overtime_multiplier: Maybe<Scalars['Float']['output']>;
  position: Maybe<Position>;
  position_name: Maybe<Scalars['String']['output']>;
  rate_double: Maybe<Scalars['Int']['output']>;
  rate_time_half: Maybe<Scalars['Float']['output']>;
  social_security_burden_multiplier: Scalars['Float']['output'];
  specialty: Maybe<Specialty>;
  state: Maybe<State>;
  state_unemployment_max_burden_cents: Scalars['Int']['output'];
  state_unemployment_percent_burden_multiplier: Scalars['Float']['output'];
  updated_at: Scalars['DateTime']['output'];
  user: Maybe<User>;
  w2_fee_percent: Scalars['Float']['output'];
};

export type RateSettingOrderInput = {
  active: InputMaybe<Scalars['Boolean']['input']>;
  charge_rate_cents: InputMaybe<Scalars['Boolean']['input']>;
  created_at: InputMaybe<Scalars['Boolean']['input']>;
  facility_rate: InputMaybe<Scalars['Boolean']['input']>;
  fee_percent: InputMaybe<Scalars['Boolean']['input']>;
  id: InputMaybe<Scalars['Boolean']['input']>;
  location_id: InputMaybe<Scalars['Int']['input']>;
  market_id: InputMaybe<Scalars['Boolean']['input']>;
  market_name: InputMaybe<Scalars['Boolean']['input']>;
  on_call_hourly_rate_cents: InputMaybe<Scalars['Boolean']['input']>;
  payout_rate_cents: InputMaybe<Scalars['Boolean']['input']>;
  position_id: InputMaybe<Scalars['Boolean']['input']>;
  position_name: InputMaybe<Scalars['Boolean']['input']>;
  rate: InputMaybe<Scalars['Boolean']['input']>;
  rate_double: InputMaybe<Scalars['Boolean']['input']>;
  rate_time_half: InputMaybe<Scalars['Boolean']['input']>;
  specialty_id: InputMaybe<Scalars['Int']['input']>;
  updated_at: InputMaybe<Scalars['Boolean']['input']>;
};

export type RateSettingQueryInput = {
  filter: InputMaybe<RateSettingWhereInput>;
  orderBy: InputMaybe<RateSettingOrderInput>;
  page: InputMaybe<Scalars['Int']['input']>;
  perPage: InputMaybe<Scalars['Int']['input']>;
  search: InputMaybe<RateSettingSearchInput>;
};

export type RateSettingSearchInput = {
  location_id: InputMaybe<Scalars['Int']['input']>;
  market_id: InputMaybe<Scalars['Int']['input']>;
  position_id: InputMaybe<Scalars['Int']['input']>;
  specialty_id: InputMaybe<Scalars['Int']['input']>;
  state_id: InputMaybe<Scalars['Int']['input']>;
  user_id: InputMaybe<Scalars['Int']['input']>;
};

export type RateSettingWhereInput = {
  active: InputMaybe<Scalars['Boolean']['input']>;
  charge_rate_cents: InputMaybe<Scalars['Int']['input']>;
  created_at: InputMaybe<Scalars['DateTime']['input']>;
  facility_rate: InputMaybe<Scalars['Int']['input']>;
  fee_percent: InputMaybe<Scalars['Float']['input']>;
  id: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  location_id: InputMaybe<Scalars['Int']['input']>;
  market_id: InputMaybe<Scalars['Int']['input']>;
  market_name: InputMaybe<Scalars['String']['input']>;
  on_call_hourly_rate_cents: InputMaybe<Scalars['Int']['input']>;
  payout_rate_cents: InputMaybe<Scalars['Int']['input']>;
  position_id: InputMaybe<Scalars['Int']['input']>;
  position_name: InputMaybe<Scalars['String']['input']>;
  rate: InputMaybe<Scalars['Int']['input']>;
  rate_double: InputMaybe<Scalars['Int']['input']>;
  rate_time_half: InputMaybe<Scalars['Int']['input']>;
  specialty_id: InputMaybe<Scalars['Int']['input']>;
  state_id: InputMaybe<Scalars['Int']['input']>;
  updated_at: InputMaybe<Scalars['DateTime']['input']>;
  user_id: InputMaybe<Scalars['Int']['input']>;
  w2_fee_percent: InputMaybe<Scalars['Float']['input']>;
};

export type Reason = LocationBlockReason | ProfessionalBlockReason;

export type RecentShift = {
  __typename?: 'RecentShift';
  id: Scalars['Int']['output'];
  starts_date: Scalars['Date']['output'];
};

export type Recipient = BillingGroup | FinancialTransaction | Location | Professional;

export type RecommendedAssignmentInput = {
  id: InputMaybe<Scalars['Int']['input']>;
  professional_id: InputMaybe<Scalars['Int']['input']>;
};

export type ReferenceQuestion = {
  __typename?: 'ReferenceQuestion';
  answer: Maybe<Scalars['Int']['output']>;
  question: Maybe<Scalars['String']['output']>;
};

export type ReferralSource = {
  __typename?: 'ReferralSource';
  admin_only: Scalars['Boolean']['output'];
  applies_to_facilities: Scalars['Boolean']['output'];
  applies_to_professionals: Scalars['Boolean']['output'];
  created_at: Scalars['DateTime']['output'];
  id: Scalars['Int']['output'];
  label: Maybe<Scalars['String']['output']>;
  name: Maybe<Scalars['String']['output']>;
  professionals: Maybe<Array<Maybe<Professional>>>;
  updated_at: Scalars['DateTime']['output'];
};

export type ReferralSourceOrderInput = {
  admin_only: InputMaybe<Scalars['Boolean']['input']>;
  applies_to_facilities: InputMaybe<Scalars['Boolean']['input']>;
  applies_to_professionals: InputMaybe<Scalars['Boolean']['input']>;
  created_at: InputMaybe<Scalars['Boolean']['input']>;
  id: InputMaybe<Scalars['Boolean']['input']>;
  label: InputMaybe<Scalars['Boolean']['input']>;
  name: InputMaybe<Scalars['Boolean']['input']>;
  updated_at: InputMaybe<Scalars['Boolean']['input']>;
};

export type ReferralSourceQueryInput = {
  filter: InputMaybe<ReferralSourceWhereInput>;
  orderBy: InputMaybe<ReferralSourceOrderInput>;
  page: InputMaybe<Scalars['Int']['input']>;
  perPage: InputMaybe<Scalars['Int']['input']>;
  search: InputMaybe<DefaultSearchInput>;
};

export type ReferralSourceWhereInput = {
  admin_only: InputMaybe<Scalars['Boolean']['input']>;
  applies_to_facilities: InputMaybe<Scalars['Boolean']['input']>;
  applies_to_professionals: InputMaybe<Scalars['Boolean']['input']>;
  created_at: InputMaybe<Scalars['DateTime']['input']>;
  id: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  label: InputMaybe<Scalars['String']['input']>;
  name: InputMaybe<Scalars['String']['input']>;
  updated_at: InputMaybe<Scalars['DateTime']['input']>;
  without_admin_only: InputMaybe<Scalars['Boolean']['input']>;
};

export type Refund = {
  __typename?: 'Refund';
  amount_cents: Scalars['Int']['output'];
  amount_currency: Scalars['String']['output'];
  created_at: Scalars['DateTime']['output'];
  id: Scalars['Int']['output'];
  invoice: Maybe<Invoice>;
  kind: Maybe<Scalars['String']['output']>;
  reason: Maybe<Scalars['String']['output']>;
  status: Maybe<Scalars['String']['output']>;
  stripe_id: Maybe<Scalars['String']['output']>;
  updated_at: Scalars['DateTime']['output'];
  user: Maybe<User>;
};

export type RefundOrderInput = {
  amount_cents: InputMaybe<Scalars['Boolean']['input']>;
  amount_currency: InputMaybe<Scalars['Boolean']['input']>;
  created_at: InputMaybe<Scalars['Boolean']['input']>;
  id: InputMaybe<Scalars['Boolean']['input']>;
  invoice_id: InputMaybe<Scalars['Boolean']['input']>;
  kind: InputMaybe<Scalars['Boolean']['input']>;
  reason: InputMaybe<Scalars['Boolean']['input']>;
  status: InputMaybe<Scalars['Boolean']['input']>;
  stripe_id: InputMaybe<Scalars['Boolean']['input']>;
  updated_at: InputMaybe<Scalars['Boolean']['input']>;
  user_id: InputMaybe<Scalars['Boolean']['input']>;
};

export type RefundQueryInput = {
  filter: InputMaybe<RefundWhereInput>;
  orderBy: InputMaybe<RefundOrderInput>;
  page: InputMaybe<Scalars['Int']['input']>;
  perPage: InputMaybe<Scalars['Int']['input']>;
  search: InputMaybe<DefaultSearchInput>;
};

export type RefundWhereInput = {
  amount_cents: InputMaybe<Scalars['Int']['input']>;
  amount_currency: InputMaybe<Scalars['String']['input']>;
  created_at: InputMaybe<Scalars['DateTime']['input']>;
  id: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  invoice_id: InputMaybe<Scalars['Int']['input']>;
  kind: InputMaybe<Scalars['String']['input']>;
  reason: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Scalars['String']['input']>;
  stripe_id: InputMaybe<Scalars['String']['input']>;
  updated_at: InputMaybe<Scalars['DateTime']['input']>;
  user_id: InputMaybe<Scalars['Int']['input']>;
};

export type RelatedToFacilityAccountInput = {
  billing_group_ids: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  location_ids: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};

export type Relationship = {
  __typename?: 'Relationship';
  comments: Maybe<Scalars['String']['output']>;
  created_at: Scalars['DateTime']['output'];
  id: Scalars['Int']['output'];
  kind: Scalars['String']['output'];
  location: Maybe<Location>;
  locationBlockReason: Maybe<LocationBlockReason>;
  professional: Maybe<Professional>;
  professionalBlockReason: Maybe<ProfessionalBlockReason>;
  reason: Maybe<Reason>;
  reason_id: Maybe<Scalars['Int']['output']>;
  reason_type: Maybe<Scalars['String']['output']>;
  requestee: Maybe<Requestee>;
  requestee_id: Maybe<Scalars['Int']['output']>;
  requestee_type: Maybe<Scalars['String']['output']>;
  requester: Maybe<Requester>;
  requester_id: Maybe<Scalars['Int']['output']>;
  requester_type: Maybe<Scalars['String']['output']>;
  updated_at: Scalars['DateTime']['output'];
};

export type RelationshipOrderInput = {
  comments: InputMaybe<Scalars['Boolean']['input']>;
  created_at: InputMaybe<Scalars['Boolean']['input']>;
  id: InputMaybe<Scalars['Boolean']['input']>;
  kind: InputMaybe<Scalars['Boolean']['input']>;
  reason_id: InputMaybe<Scalars['Boolean']['input']>;
  reason_type: InputMaybe<Scalars['Boolean']['input']>;
  requestee_id: InputMaybe<Scalars['Boolean']['input']>;
  requestee_type: InputMaybe<Scalars['Boolean']['input']>;
  requester_id: InputMaybe<Scalars['Boolean']['input']>;
  requester_type: InputMaybe<Scalars['Boolean']['input']>;
  updated_at: InputMaybe<Scalars['Boolean']['input']>;
};

export type RelationshipQueryInput = {
  filter: InputMaybe<RelationshipWhereInput>;
  orderBy: InputMaybe<RelationshipOrderInput>;
  page: InputMaybe<Scalars['Int']['input']>;
  perPage: InputMaybe<Scalars['Int']['input']>;
  search: InputMaybe<RelationshipSearchInput>;
};

export type RelationshipSearchInput = {
  comments: InputMaybe<Scalars['String']['input']>;
  created_at: InputMaybe<Scalars['DateTime']['input']>;
  exclude_deactivated: InputMaybe<Scalars['Boolean']['input']>;
  exclude_soft_deleted: InputMaybe<Scalars['Boolean']['input']>;
  from_date: InputMaybe<Scalars['Date']['input']>;
  id: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  kind: InputMaybe<Scalars['String']['input']>;
  location_block_reason_id: InputMaybe<Scalars['Int']['input']>;
  professional_block_reason_id: InputMaybe<Scalars['Int']['input']>;
  reason_id: InputMaybe<Scalars['Int']['input']>;
  reason_type: InputMaybe<Scalars['String']['input']>;
  requestee_id: InputMaybe<Scalars['Int']['input']>;
  requestee_type: InputMaybe<Scalars['String']['input']>;
  requester_id: InputMaybe<Scalars['Int']['input']>;
  requester_type: InputMaybe<Scalars['String']['input']>;
  to_date: InputMaybe<Scalars['Date']['input']>;
  updated_at: InputMaybe<Scalars['DateTime']['input']>;
};

export type RelationshipWhereInput = {
  comments: InputMaybe<Scalars['String']['input']>;
  created_at: InputMaybe<Scalars['DateTime']['input']>;
  id: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  kind: InputMaybe<Scalars['String']['input']>;
  reason_id: InputMaybe<Scalars['Int']['input']>;
  reason_type: InputMaybe<Scalars['String']['input']>;
  requestee_id: InputMaybe<Scalars['Int']['input']>;
  requestee_type: InputMaybe<Scalars['String']['input']>;
  requester_id: InputMaybe<Scalars['Int']['input']>;
  requester_type: InputMaybe<Scalars['String']['input']>;
  updated_at: InputMaybe<Scalars['DateTime']['input']>;
};

export type Requestee = Location | Professional;

export type Requester = Location | Professional;

export type Requirement = {
  __typename?: 'Requirement';
  add_to_booked_jobs: Scalars['Boolean']['output'];
  base: Maybe<Scalars['Boolean']['output']>;
  cohort_eligibility: Scalars['String']['output'];
  company: Maybe<Company>;
  company_id: Maybe<Scalars['Int']['output']>;
  condition: Condition;
  condition_id: Scalars['Int']['output'];
  created_at: Scalars['DateTime']['output'];
  id: Scalars['Int']['output'];
  job_type: Maybe<Scalars['String']['output']>;
  kind: Maybe<Scalars['String']['output']>;
  location: Maybe<Location>;
  location_id: Maybe<Scalars['Int']['output']>;
  medely: Scalars['Boolean']['output'];
  position: Maybe<Position>;
  position_id: Maybe<Scalars['Int']['output']>;
  required: Scalars['Boolean']['output'];
  specialty: Maybe<Specialty>;
  specialty_id: Maybe<Scalars['Int']['output']>;
  state: Maybe<State>;
  state_id: Maybe<Scalars['Int']['output']>;
  updated_at: Scalars['DateTime']['output'];
  vms_type: Maybe<VmsType>;
  vms_type_id: Maybe<Scalars['Int']['output']>;
};

export type RequirementOrderInput = {
  id: InputMaybe<Scalars['Boolean']['input']>;
  position_id: InputMaybe<Scalars['Boolean']['input']>;
};

export type RequirementQueryInput = {
  filter: InputMaybe<RequirementWhereInput>;
  orderBy: InputMaybe<RequirementOrderInput>;
  page: InputMaybe<Scalars['Int']['input']>;
  perPage: InputMaybe<Scalars['Int']['input']>;
  search: InputMaybe<RequirementSearchInput>;
};

export type RequirementSearchInput = {
  company_ids: InputMaybe<Array<Scalars['Int']['input']>>;
  company_medely_requirements: InputMaybe<CompanyMedelyRequirements>;
  company_requirements: InputMaybe<Scalars['Boolean']['input']>;
  include_company_only: InputMaybe<Scalars['Boolean']['input']>;
  kind_requirements: InputMaybe<Scalars['Boolean']['input']>;
  location_ids: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  location_requirements: InputMaybe<Scalars['Boolean']['input']>;
  medely_requirements: InputMaybe<Scalars['Boolean']['input']>;
  position_requirements: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * *Constraints:*
   * * Maximal length: `150`
   *
   */
  q: InputMaybe<Scalars['String']['input']>;
  specialty_requirements: InputMaybe<Scalars['Boolean']['input']>;
  state_requirements: InputMaybe<Scalars['Boolean']['input']>;
  vms_requirements: InputMaybe<Scalars['Boolean']['input']>;
};

export type RequirementWhereInput = {
  cohort_eligibility: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  company_id: InputMaybe<Scalars['Int']['input']>;
  condition_id: InputMaybe<Scalars['Int']['input']>;
  id: InputMaybe<Scalars['Int']['input']>;
  job_type: InputMaybe<Scalars['String']['input']>;
  kind: InputMaybe<Scalars['String']['input']>;
  location_id: InputMaybe<Scalars['Int']['input']>;
  medely: InputMaybe<Scalars['Boolean']['input']>;
  position_id: InputMaybe<Scalars['Int']['input']>;
  specialty_id: InputMaybe<Scalars['Int']['input']>;
  state_id: InputMaybe<Scalars['Int']['input']>;
  vms_type_id: InputMaybe<Scalars['Int']['input']>;
};

export type RevenueAdjustment = {
  __typename?: 'RevenueAdjustment';
  adjustment_type: Maybe<Scalars['String']['output']>;
  amount_cents: Scalars['Int']['output'];
  amount_currency: Scalars['String']['output'];
  balance_sheet: Maybe<BalanceSheet>;
  created_at: Scalars['DateTime']['output'];
  description: Maybe<Scalars['String']['output']>;
  dispute: Maybe<Dispute>;
  dispute_id: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  invoice: Maybe<Invoice>;
  job: Maybe<Job>;
  job_id: Maybe<Scalars['Int']['output']>;
  notes: Maybe<Scalars['String']['output']>;
  past_month_adjustment: Scalars['Boolean']['output'];
  primary_adjustment: Scalars['Boolean']['output'];
  timecard: Maybe<Timecard>;
  updated_at: Scalars['DateTime']['output'];
  user: Maybe<User>;
};

export type RevenueAdjustmentOrderInput = {
  adjustment_type: InputMaybe<Scalars['Boolean']['input']>;
  amount_cents: InputMaybe<Scalars['Boolean']['input']>;
  amount_currency: InputMaybe<Scalars['Boolean']['input']>;
  balance_sheet_id: InputMaybe<Scalars['Boolean']['input']>;
  created_at: InputMaybe<Scalars['Boolean']['input']>;
  id: InputMaybe<Scalars['Boolean']['input']>;
  invoice_id: InputMaybe<Scalars['Boolean']['input']>;
  job_id: InputMaybe<Scalars['Boolean']['input']>;
  past_month_adjustment: InputMaybe<Scalars['Boolean']['input']>;
  primary_adjustment: InputMaybe<Scalars['Boolean']['input']>;
  user_id: InputMaybe<Scalars['Boolean']['input']>;
};

export type RevenueAdjustmentQueryInput = {
  filter: InputMaybe<RevenueAdjustmentWhereInput>;
  orderBy: InputMaybe<RevenueAdjustmentOrderInput>;
  page: InputMaybe<Scalars['Int']['input']>;
  perPage: InputMaybe<Scalars['Int']['input']>;
  search: InputMaybe<RevenueAdjustmentSearchInput>;
};

export type RevenueAdjustmentSearchInput = {
  adjustment_type: InputMaybe<Scalars['String']['input']>;
  amount_cents: InputMaybe<Scalars['Int']['input']>;
  amount_currency: InputMaybe<Scalars['String']['input']>;
  balance_sheet_id: InputMaybe<Scalars['Int']['input']>;
  created_at: InputMaybe<Scalars['DateTime']['input']>;
  dispute_id: InputMaybe<Scalars['Int']['input']>;
  id: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  invoice_id: InputMaybe<Scalars['Int']['input']>;
  job_id: InputMaybe<Scalars['Int']['input']>;
  past_month_adjustment: InputMaybe<Scalars['Boolean']['input']>;
  professional_id: InputMaybe<Scalars['Int']['input']>;
  /**
   * *Constraints:*
   * * Maximal length: `150`
   *
   */
  q: InputMaybe<Scalars['String']['input']>;
  user_id: InputMaybe<Scalars['Int']['input']>;
};

export type RevenueAdjustmentWhereInput = {
  adjustment_type: InputMaybe<Scalars['String']['input']>;
  amount_cents: InputMaybe<Scalars['Int']['input']>;
  amount_currency: InputMaybe<Scalars['String']['input']>;
  balance_sheet_id: InputMaybe<Scalars['Int']['input']>;
  created_at: InputMaybe<Scalars['DateTime']['input']>;
  dispute_id: InputMaybe<Scalars['Int']['input']>;
  id: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  invoice_id: InputMaybe<Scalars['Int']['input']>;
  job_id: InputMaybe<Scalars['Int']['input']>;
  past_month_adjustment: InputMaybe<Scalars['Boolean']['input']>;
  timecard_id: InputMaybe<Scalars['Int']['input']>;
  user_id: InputMaybe<Scalars['Int']['input']>;
};

export type Review = {
  __typename?: 'Review';
  blocked: Scalars['Boolean']['output'];
  comments: Maybe<Scalars['String']['output']>;
  comments_: Maybe<Scalars['String']['output']>;
  created_at: Scalars['DateTime']['output'];
  id: Scalars['Int']['output'];
  job: Maybe<Job>;
  rating: Maybe<Scalars['Float']['output']>;
  reviewee: Maybe<Account>;
  reviewee_id: Maybe<Scalars['Int']['output']>;
  reviewer: Maybe<Account>;
  reviewer_id: Maybe<Scalars['Int']['output']>;
  updated_at: Scalars['DateTime']['output'];
};

export type ReviewOrderInput = {
  blocked: InputMaybe<Scalars['Boolean']['input']>;
  comments: InputMaybe<Scalars['Boolean']['input']>;
  comments_: InputMaybe<Scalars['Boolean']['input']>;
  created_at: InputMaybe<Scalars['Boolean']['input']>;
  id: InputMaybe<Scalars['Boolean']['input']>;
  job_id: InputMaybe<Scalars['Boolean']['input']>;
  rating: InputMaybe<Scalars['Boolean']['input']>;
  reviewee_id: InputMaybe<Scalars['Boolean']['input']>;
  reviewee_role: InputMaybe<Scalars['Boolean']['input']>;
  reviewer_id: InputMaybe<Scalars['Boolean']['input']>;
  reviewer_role: InputMaybe<Scalars['Boolean']['input']>;
  updated_at: InputMaybe<Scalars['Boolean']['input']>;
};

export type ReviewQueryInput = {
  filter: InputMaybe<ReviewWhereInput>;
  orderBy: InputMaybe<ReviewOrderInput>;
  page: InputMaybe<Scalars['Int']['input']>;
  perPage: InputMaybe<Scalars['Int']['input']>;
  search: InputMaybe<ReviewSearchInput>;
};

export type ReviewSearchInput = {
  company_id: InputMaybe<Scalars['Int']['input']>;
  id: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  job_id: InputMaybe<Scalars['Int']['input']>;
  professional_id: InputMaybe<Scalars['Int']['input']>;
  rating: InputMaybe<Scalars['Int']['input']>;
  reviews_for_type: InputMaybe<Scalars['String']['input']>;
};

export type ReviewWhereInput = {
  blocked: InputMaybe<Scalars['Boolean']['input']>;
  comments: InputMaybe<Scalars['String']['input']>;
  comments_: InputMaybe<Scalars['String']['input']>;
  created_at: InputMaybe<Scalars['DateTime']['input']>;
  id: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  job_id: InputMaybe<Scalars['Int']['input']>;
  professional_reviewee_id: InputMaybe<Scalars['Int']['input']>;
  professional_reviewer_id: InputMaybe<Scalars['Int']['input']>;
  rating: InputMaybe<Scalars['Float']['input']>;
  reviewee_id: InputMaybe<Scalars['Int']['input']>;
  reviewee_role: InputMaybe<Scalars['String']['input']>;
  reviewer_id: InputMaybe<Scalars['Int']['input']>;
  reviewer_role: InputMaybe<Scalars['String']['input']>;
  updated_at: InputMaybe<Scalars['DateTime']['input']>;
};

export enum Role {
  AccountManager = 'account_manager',
  Admin = 'admin',
  Credentialist = 'credentialist',
  Recruiter = 'recruiter',
  SalesAdmin = 'sales_admin',
  SalesAssociate = 'sales_associate',
  SalesRecruiter = 'sales_recruiter',
  SupportAdmin = 'support_admin',
  SupportAgent = 'support_agent'
}

export type SaasCheckInput = {
  is_saas_professional: InputMaybe<Scalars['Boolean']['input']>;
  professional_id: InputMaybe<Scalars['Int']['input']>;
};

export type ShiftLengthInput = {
  max: Scalars['Int']['input'];
  min: Scalars['Int']['input'];
};

export type SkillsAssessment = {
  __typename?: 'SkillsAssessment';
  id: Scalars['Int']['output'];
  skills_questions: Maybe<Array<Maybe<SkillsQuestion>>>;
  title: Maybe<Scalars['String']['output']>;
};

export type SkillsAssessmentBak = {
  __typename?: 'SkillsAssessmentBak';
  created_at: Scalars['DateTime']['output'];
  id: Scalars['Int']['output'];
  position: Maybe<Position>;
  position_id: Maybe<Scalars['Int']['output']>;
  required: Maybe<Scalars['Boolean']['output']>;
  specialty: Maybe<Specialty>;
  typeform_id: Maybe<Scalars['String']['output']>;
  updated_at: Scalars['DateTime']['output'];
};

export type SkillsAssessmentBakOrderInput = {
  created_at: InputMaybe<Scalars['Boolean']['input']>;
  id: InputMaybe<Scalars['Boolean']['input']>;
  position_id: InputMaybe<Scalars['Boolean']['input']>;
  required: InputMaybe<Scalars['Boolean']['input']>;
  specialty_id: InputMaybe<Scalars['Boolean']['input']>;
  typeform_id: InputMaybe<Scalars['Boolean']['input']>;
  updated_at: InputMaybe<Scalars['Boolean']['input']>;
};

export type SkillsAssessmentBakQueryInput = {
  filter: InputMaybe<SkillsAssessmentBakWhereInput>;
  orderBy: InputMaybe<SkillsAssessmentBakOrderInput>;
  page: InputMaybe<Scalars['Int']['input']>;
  perPage: InputMaybe<Scalars['Int']['input']>;
  search: InputMaybe<DefaultSearchInput>;
};

export type SkillsAssessmentBakWhereInput = {
  created_at: InputMaybe<Scalars['DateTime']['input']>;
  id: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  position_id: InputMaybe<Scalars['Int']['input']>;
  required: InputMaybe<Scalars['Boolean']['input']>;
  specialty_id: InputMaybe<Scalars['Int']['input']>;
  typeform_id: InputMaybe<Scalars['String']['input']>;
  updated_at: InputMaybe<Scalars['DateTime']['input']>;
};

export type SkillsAssessmentOrderInput = {
  id: InputMaybe<Scalars['Boolean']['input']>;
};

export type SkillsAssessmentQueryInput = {
  filter: InputMaybe<SkillsAssessmentWhereInput>;
  orderBy: InputMaybe<SkillsAssessmentOrderInput>;
  page: InputMaybe<Scalars['Int']['input']>;
  perPage: InputMaybe<Scalars['Int']['input']>;
  search: InputMaybe<DefaultSearchInput>;
};

export type SkillsAssessmentResponseBak = {
  __typename?: 'SkillsAssessmentResponseBak';
  answers: Maybe<Scalars['JSON']['output']>;
  created_at: Maybe<Scalars['DateTime']['output']>;
  expiration_date: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['Int']['output'];
  last_completed_at: Maybe<Scalars['DateTime']['output']>;
  professioanl_id: Maybe<Scalars['Int']['output']>;
  professional: Maybe<Professional>;
  questions: Maybe<Scalars['JSON']['output']>;
  skills_assessment_bak: Maybe<SkillsAssessmentBak>;
  updated_at: Maybe<Scalars['DateTime']['output']>;
  webhook_pending: Maybe<Scalars['Boolean']['output']>;
};

export type SkillsAssessmentResponseBakOrderInput = {
  answers: InputMaybe<Scalars['Boolean']['input']>;
  created_at: InputMaybe<Scalars['Boolean']['input']>;
  expiration_date: InputMaybe<Scalars['Boolean']['input']>;
  id: InputMaybe<Scalars['Boolean']['input']>;
  last_completed_at: InputMaybe<Scalars['Boolean']['input']>;
  professional_id: InputMaybe<Scalars['Boolean']['input']>;
  questions: InputMaybe<Scalars['Boolean']['input']>;
  skills_assessment_bak_id: InputMaybe<Scalars['Boolean']['input']>;
  updated_at: InputMaybe<Scalars['Boolean']['input']>;
  webhook_pending: InputMaybe<Scalars['Boolean']['input']>;
};

export type SkillsAssessmentResponseBakQueryInput = {
  filter: InputMaybe<SkillsAssessmentResponseBakWhereInput>;
  orderBy: InputMaybe<SkillsAssessmentResponseBakOrderInput>;
  page: InputMaybe<Scalars['Int']['input']>;
  perPage: InputMaybe<Scalars['Int']['input']>;
  search: InputMaybe<DefaultSearchInput>;
};

export type SkillsAssessmentResponseBakWhereInput = {
  answers: InputMaybe<Scalars['String']['input']>;
  created_at: InputMaybe<Scalars['DateTime']['input']>;
  expiration_date: InputMaybe<Scalars['DateTime']['input']>;
  id: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  last_completed_at: InputMaybe<Scalars['DateTime']['input']>;
  professional_account_id: InputMaybe<Scalars['Int']['input']>;
  professional_id: InputMaybe<Scalars['Int']['input']>;
  questions: InputMaybe<Scalars['String']['input']>;
  skills_assessment_id: InputMaybe<Scalars['Int']['input']>;
  updated_at: InputMaybe<Scalars['DateTime']['input']>;
  webhook_pending: InputMaybe<Scalars['Boolean']['input']>;
};

export type SkillsAssessmentSkillsQuestion = {
  __typename?: 'SkillsAssessmentSkillsQuestion';
  id: Scalars['Int']['output'];
  skills_assessment: Maybe<SkillsAssessment>;
  skills_assessment_id: Maybe<Scalars['Int']['output']>;
  skills_question: Maybe<SkillsQuestion>;
  skills_question_id: Maybe<Scalars['Int']['output']>;
};

export type SkillsAssessmentSkillsQuestionOrderInput = {
  id: InputMaybe<Scalars['Boolean']['input']>;
};

export type SkillsAssessmentSkillsQuestionQueryInput = {
  filter: InputMaybe<SkillsAssessmentSkillsQuestionWhereInput>;
  orderBy: InputMaybe<SkillsAssessmentSkillsQuestionOrderInput>;
  page: InputMaybe<Scalars['Int']['input']>;
  perPage: InputMaybe<Scalars['Int']['input']>;
  search: InputMaybe<DefaultSearchInput>;
};

export type SkillsAssessmentSkillsQuestionWhereInput = {
  id: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};

export type SkillsAssessmentWhereInput = {
  id: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};

export type SkillsQuestion = {
  __typename?: 'SkillsQuestion';
  category: Maybe<Scalars['String']['output']>;
  data: Maybe<Scalars['JSON']['output']>;
  field_type: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  label: Maybe<Scalars['String']['output']>;
  slug: Maybe<Scalars['String']['output']>;
};

export type SkillsQuestionOrderInput = {
  id: InputMaybe<Scalars['Boolean']['input']>;
};

export type SkillsQuestionQueryInput = {
  filter: InputMaybe<SkillsQuestionWhereInput>;
  orderBy: InputMaybe<SkillsQuestionOrderInput>;
  page: InputMaybe<Scalars['Int']['input']>;
  perPage: InputMaybe<Scalars['Int']['input']>;
  search: InputMaybe<DefaultSearchInput>;
};

export type SkillsQuestionWhereInput = {
  id: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};

export type Specialty = {
  __typename?: 'Specialty';
  active: Scalars['Boolean']['output'];
  assignments: Maybe<Array<Maybe<Assignment>>>;
  created_at: Scalars['DateTime']['output'];
  id: Scalars['Int']['output'];
  job_templates: Maybe<Array<Maybe<JobTemplate>>>;
  jobs: Maybe<Array<Maybe<Job>>>;
  label: Maybe<Scalars['String']['output']>;
  name: Maybe<Scalars['String']['output']>;
  position_list: Maybe<Scalars['String']['output']>;
  positions: Maybe<Array<Maybe<Position>>>;
  rate_differential: Maybe<Scalars['Float']['output']>;
  updated_at: Scalars['DateTime']['output'];
};

export type SpecialtyOrderInput = {
  active: InputMaybe<Scalars['Boolean']['input']>;
  created_at: InputMaybe<Scalars['Boolean']['input']>;
  id: InputMaybe<Scalars['Boolean']['input']>;
  label: InputMaybe<Scalars['Boolean']['input']>;
  name: InputMaybe<Scalars['Boolean']['input']>;
  position_list: InputMaybe<Scalars['Boolean']['input']>;
  position_name: InputMaybe<Scalars['Boolean']['input']>;
  rate_differential: InputMaybe<Scalars['Boolean']['input']>;
  updated_at: InputMaybe<Scalars['Boolean']['input']>;
};

export type SpecialtyQueryInput = {
  filter: InputMaybe<SpecialtyWhereInput>;
  orderBy: InputMaybe<SpecialtyOrderInput>;
  page: InputMaybe<Scalars['Int']['input']>;
  perPage: InputMaybe<Scalars['Int']['input']>;
  search: InputMaybe<SpecialtySearchInput>;
};

export type SpecialtySearchInput = {
  active: InputMaybe<Scalars['Boolean']['input']>;
  exclude_ids: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  for_locations: InputMaybe<ForPositionLocations>;
  id: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  label: InputMaybe<Scalars['String']['input']>;
  name: InputMaybe<Scalars['String']['input']>;
  position_ids: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  /**
   * *Constraints:*
   * * Maximal length: `150`
   *
   */
  q: InputMaybe<Scalars['String']['input']>;
};

export type SpecialtyWhereInput = {
  active: InputMaybe<Scalars['Boolean']['input']>;
  created_at: InputMaybe<Scalars['DateTime']['input']>;
  id: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  label: InputMaybe<Scalars['String']['input']>;
  location_ids: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  name: InputMaybe<Scalars['String']['input']>;
  position_ids: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  position_list: InputMaybe<Scalars['String']['input']>;
  rate_differential: InputMaybe<Scalars['Float']['input']>;
  updated_at: InputMaybe<Scalars['DateTime']['input']>;
};

export type StaffBlockReason = {
  __typename?: 'StaffBlockReason';
  created_at: Maybe<Scalars['DateTime']['output']>;
  id: Maybe<Scalars['Int']['output']>;
  kind: Maybe<Scalars['String']['output']>;
  label: Maybe<Scalars['String']['output']>;
  relationships: Maybe<Array<Maybe<Relationship>>>;
  updated_at: Maybe<Scalars['DateTime']['output']>;
};

export type StaffBlockReasonOrderInput = {
  created_at: InputMaybe<Scalars['Boolean']['input']>;
  id: InputMaybe<Scalars['Boolean']['input']>;
  kind: InputMaybe<Scalars['Boolean']['input']>;
  label: InputMaybe<Scalars['Boolean']['input']>;
  updated_at: InputMaybe<Scalars['Boolean']['input']>;
};

export type StaffBlockReasonQueryInput = {
  filter: InputMaybe<StaffBlockReasonWhereInput>;
  orderBy: InputMaybe<StaffBlockReasonOrderInput>;
  page: InputMaybe<Scalars['Int']['input']>;
  perPage: InputMaybe<Scalars['Int']['input']>;
  search: InputMaybe<DefaultSearchInput>;
};

export type StaffBlockReasonWhereInput = {
  created_at: InputMaybe<Scalars['DateTime']['input']>;
  id: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  kind: InputMaybe<Scalars['String']['input']>;
  label: InputMaybe<Scalars['String']['input']>;
  updated_at: InputMaybe<Scalars['DateTime']['input']>;
};

export type State = {
  __typename?: 'State';
  abbreviation: Maybe<Scalars['String']['output']>;
  accounts: Maybe<Array<Maybe<Account>>>;
  active: Scalars['Boolean']['output'];
  covid_requirement: Maybe<Scalars['String']['output']>;
  created_at: Maybe<Scalars['DateTime']['output']>;
  display_by_hourly: Scalars['Boolean']['output'];
  google_place_id: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  market_names: Maybe<Scalars['String']['output']>;
  markets: Maybe<Array<Maybe<Market>>>;
  minimum_rate_cents: Scalars['Int']['output'];
  name: Maybe<Scalars['String']['output']>;
  nlc: Scalars['Boolean']['output'];
  overtime_hours_frequency: Maybe<Scalars['String']['output']>;
  overtime_hours_threshold: Scalars['Int']['output'];
  popular_travel_state: Scalars['Boolean']['output'];
  rectangle_image: Maybe<Scalars['AWSFile']['output']>;
  square_image: Maybe<Scalars['AWSFile']['output']>;
  states: Maybe<Array<Maybe<State>>>;
  updated_at: Maybe<Scalars['DateTime']['output']>;
};

export type StateOrderInput = {
  abbreviation: InputMaybe<Scalars['Boolean']['input']>;
  active: InputMaybe<Scalars['Boolean']['input']>;
  covid_requirement: InputMaybe<Scalars['Boolean']['input']>;
  created_at: InputMaybe<Scalars['Boolean']['input']>;
  display_by_hourly: InputMaybe<Scalars['Boolean']['input']>;
  id: InputMaybe<Scalars['Boolean']['input']>;
  market_names: InputMaybe<Scalars['Boolean']['input']>;
  minimum_rate_cents: InputMaybe<Scalars['Boolean']['input']>;
  name: InputMaybe<Scalars['Boolean']['input']>;
  nlc: InputMaybe<Scalars['Boolean']['input']>;
  overtime_hours_frequency: InputMaybe<Scalars['Boolean']['input']>;
  overtime_hours_threshold: InputMaybe<Scalars['Boolean']['input']>;
  updated_at: InputMaybe<Scalars['Boolean']['input']>;
};

export type StatePositionRateSetting = {
  __typename?: 'StatePositionRateSetting';
  active: Maybe<Scalars['Boolean']['output']>;
  audits: Maybe<Array<Maybe<Audit>>>;
  created_at: Maybe<Scalars['DateTime']['output']>;
  id: Maybe<Scalars['String']['output']>;
  position: Maybe<Position>;
  position_id: Maybe<Scalars['Int']['output']>;
  settings: Maybe<PositionSettings>;
  specialty: Maybe<Specialty>;
  specialty_id: Maybe<Scalars['Int']['output']>;
  state: Maybe<State>;
  state_id: Maybe<Scalars['Int']['output']>;
  state_position_rate_setting: Maybe<PositionSettings>;
  state_position_rate_setting_active: Maybe<Scalars['Boolean']['output']>;
  state_position_rate_setting_id: Maybe<Scalars['Int']['output']>;
  updated_at: Maybe<Scalars['DateTime']['output']>;
};

export type StatePositionRateSettingOrderInput = {
  active: InputMaybe<Scalars['Boolean']['input']>;
  created_at: InputMaybe<Scalars['DateTime']['input']>;
  id: InputMaybe<Scalars['Boolean']['input']>;
  position_id: InputMaybe<Scalars['Int']['input']>;
  specialty_id: InputMaybe<Scalars['Int']['input']>;
  state_id: InputMaybe<Scalars['Int']['input']>;
  updated_at: InputMaybe<Scalars['Boolean']['input']>;
};

export type StatePositionRateSettingQueryInput = {
  filter: InputMaybe<StatePositionRateSettingWhereInput>;
  orderBy: InputMaybe<StatePositionRateSettingOrderInput>;
  page: InputMaybe<Scalars['Int']['input']>;
  perPage: InputMaybe<Scalars['Int']['input']>;
  search: InputMaybe<StatePositionRateSettingSearchInput>;
};

export type StatePositionRateSettingSearchInput = {
  position_id: InputMaybe<Scalars['Int']['input']>;
  position_ids: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  specialty_id: InputMaybe<Scalars['Int']['input']>;
  specialty_ids: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  state_id: InputMaybe<Scalars['Int']['input']>;
  updated_at_from: InputMaybe<Scalars['DateTime']['input']>;
};

export type StatePositionRateSettingWhereInput = {
  active: InputMaybe<Scalars['Boolean']['input']>;
  created_at: InputMaybe<Scalars['DateTime']['input']>;
  for_assignment: InputMaybe<Scalars['Boolean']['input']>;
  for_job: InputMaybe<Scalars['Boolean']['input']>;
  id: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  include_parents: InputMaybe<Scalars['Boolean']['input']>;
  position_id: InputMaybe<Scalars['Int']['input']>;
  specialty_id: InputMaybe<Scalars['Int']['input']>;
  state_id: InputMaybe<Scalars['Int']['input']>;
  updated_at: InputMaybe<Scalars['DateTime']['input']>;
};

export type StateQueryInput = {
  filter: InputMaybe<StateWhereInput>;
  orderBy: InputMaybe<StateOrderInput>;
  page: InputMaybe<Scalars['Int']['input']>;
  perPage: InputMaybe<Scalars['Int']['input']>;
  search: InputMaybe<DefaultSearchInput>;
};

export type StateRateSetting = {
  __typename?: 'StateRateSetting';
  active: Maybe<Scalars['Boolean']['output']>;
  created_at: Maybe<Scalars['DateTime']['output']>;
  id: Maybe<Scalars['Int']['output']>;
  settings: Maybe<Scalars['JSON']['output']>;
  state: Maybe<State>;
  state_id: Maybe<Scalars['Int']['output']>;
  updated_at: Maybe<Scalars['DateTime']['output']>;
};

export type StateRateSettingOrderInput = {
  active: InputMaybe<Scalars['Boolean']['input']>;
  created_at: InputMaybe<Scalars['Boolean']['input']>;
  id: InputMaybe<Scalars['Boolean']['input']>;
  state_id: InputMaybe<Scalars['Int']['input']>;
  updated_at: InputMaybe<Scalars['Boolean']['input']>;
};

export type StateRateSettingQueryInput = {
  filter: InputMaybe<StateRateSettingWhereInput>;
  orderBy: InputMaybe<StateRateSettingOrderInput>;
  page: InputMaybe<Scalars['Int']['input']>;
  perPage: InputMaybe<Scalars['Int']['input']>;
  search: InputMaybe<StateRateSettingSearchInput>;
};

export type StateRateSettingSearchInput = {
  state_id: InputMaybe<Scalars['Int']['input']>;
  updated_at_from: InputMaybe<Scalars['DateTime']['input']>;
};

export type StateRateSettingWhereInput = {
  active: InputMaybe<Scalars['Boolean']['input']>;
  id: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  state_id: InputMaybe<Scalars['Int']['input']>;
};

export type StateWhereInput = {
  abbreviation: InputMaybe<Scalars['String']['input']>;
  active: InputMaybe<Scalars['Boolean']['input']>;
  active_states: InputMaybe<Scalars['Boolean']['input']>;
  covid_requirement: InputMaybe<Scalars['String']['input']>;
  created_at: InputMaybe<Scalars['DateTime']['input']>;
  display_by_hourly: InputMaybe<Scalars['Boolean']['input']>;
  id: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  market_names: InputMaybe<Scalars['String']['input']>;
  minimum_rate_cents: InputMaybe<Scalars['Int']['input']>;
  name: InputMaybe<Scalars['String']['input']>;
  nlc: InputMaybe<Scalars['Boolean']['input']>;
  overtime_hours_frequency: InputMaybe<Scalars['String']['input']>;
  overtime_hours_threshold: InputMaybe<Scalars['Int']['input']>;
  popular_travel_state: InputMaybe<Scalars['Boolean']['input']>;
  updated_at: InputMaybe<Scalars['DateTime']['input']>;
};

export type Statement = {
  __typename?: 'Statement';
  amount_due_cents: Scalars['Int']['output'];
  amount_due_currency: Scalars['String']['output'];
  billing_group: Maybe<BillingGroup>;
  billing_group_id: Maybe<Scalars['Int']['output']>;
  billing_id: Maybe<Scalars['String']['output']>;
  close_time: Maybe<Scalars['DateTime']['output']>;
  created_at: Scalars['DateTime']['output'];
  due_date: Maybe<Scalars['Date']['output']>;
  id: Scalars['Int']['output'];
  invoices: Maybe<Array<Maybe<Invoice>>>;
  paid_date: Maybe<Scalars['DateTime']['output']>;
  pay_period_end: Maybe<Scalars['DateTime']['output']>;
  pay_period_start: Maybe<Scalars['DateTime']['output']>;
  status: Maybe<Scalars['String']['output']>;
  total_cents: Scalars['Int']['output'];
  total_currency: Scalars['String']['output'];
  updated_at: Scalars['DateTime']['output'];
};

export type StatementOrderInput = {
  amount_due_cents: InputMaybe<Scalars['Boolean']['input']>;
  amount_due_currency: InputMaybe<Scalars['Boolean']['input']>;
  created_at: InputMaybe<Scalars['Boolean']['input']>;
  due_date: InputMaybe<Scalars['Boolean']['input']>;
  id: InputMaybe<Scalars['Boolean']['input']>;
  paid_date: InputMaybe<Scalars['Boolean']['input']>;
  pay_period_end: InputMaybe<Scalars['Boolean']['input']>;
  pay_period_start: InputMaybe<Scalars['Boolean']['input']>;
  status: InputMaybe<Scalars['Boolean']['input']>;
  total_cents: InputMaybe<Scalars['Boolean']['input']>;
  total_currency: InputMaybe<Scalars['Boolean']['input']>;
  updated_at: InputMaybe<Scalars['Boolean']['input']>;
};

export type StatementQueryInput = {
  filter: InputMaybe<StatementWhereInput>;
  orderBy: InputMaybe<StatementOrderInput>;
  page: InputMaybe<Scalars['Int']['input']>;
  perPage: InputMaybe<Scalars['Int']['input']>;
  search: InputMaybe<StatementSearchInput>;
};

export enum StatementSearchByInput {
  Statements = 'statements',
  Users = 'users'
}

export type StatementSearchInput = {
  account_manager_id: InputMaybe<Scalars['Int']['input']>;
  billing_group_ids: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  billing_group_uid: InputMaybe<Scalars['String']['input']>;
  billing_id: InputMaybe<Scalars['String']['input']>;
  created_at: InputMaybe<Scalars['DateTime']['input']>;
  due_date: InputMaybe<Scalars['Date']['input']>;
  id: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  open_payment_gateway: InputMaybe<Scalars['Boolean']['input']>;
  paid: InputMaybe<Scalars['Boolean']['input']>;
  paid_date: InputMaybe<Scalars['DateTime']['input']>;
  past_due: InputMaybe<Scalars['Boolean']['input']>;
  pay_period_end: InputMaybe<Scalars['Date']['input']>;
  pay_period_start: InputMaybe<Scalars['Date']['input']>;
  /**
   * *Constraints:*
   * * Maximal length: `150`
   *
   */
  q: InputMaybe<Scalars['String']['input']>;
  search_by: InputMaybe<StatementSearchByInput>;
  status: InputMaybe<Scalars['String']['input']>;
  statuses: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  total_cents: InputMaybe<Scalars['Int']['input']>;
  total_currency: InputMaybe<Scalars['String']['input']>;
  updated_at: InputMaybe<Scalars['DateTime']['input']>;
};

export type StatementWhereInput = {
  amount_due_cents: InputMaybe<Scalars['Int']['input']>;
  amount_due_currency: InputMaybe<Scalars['String']['input']>;
  billing_group_id: InputMaybe<Scalars['Int']['input']>;
  billing_id: InputMaybe<Scalars['String']['input']>;
  created_at: InputMaybe<Scalars['DateTime']['input']>;
  due_date: InputMaybe<Scalars['Date']['input']>;
  id: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  paid_date: InputMaybe<Scalars['DateTime']['input']>;
  past_due: InputMaybe<Scalars['Boolean']['input']>;
  pay_period_end: InputMaybe<Scalars['Date']['input']>;
  pay_period_start: InputMaybe<Scalars['Date']['input']>;
  status: InputMaybe<Scalars['String']['input']>;
  total_cents: InputMaybe<Scalars['Int']['input']>;
  total_currency: InputMaybe<Scalars['String']['input']>;
  updated_at: InputMaybe<Scalars['DateTime']['input']>;
};

export type StripeAccount = {
  __typename?: 'StripeAccount';
  active: Maybe<Scalars['Boolean']['output']>;
  address_city: Maybe<Scalars['String']['output']>;
  address_first: Maybe<Scalars['String']['output']>;
  address_second: Maybe<Scalars['String']['output']>;
  address_zip: Maybe<Scalars['String']['output']>;
  agency_id: Maybe<Scalars['Int']['output']>;
  company_name: Maybe<Scalars['String']['output']>;
  coordinates: Maybe<Coordinates>;
  created_at: Scalars['DateTime']['output'];
  external_accounts: Maybe<Array<Maybe<ExternalAccount>>>;
  first_name: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  last_name: Maybe<Scalars['String']['output']>;
  phone_number: Maybe<Scalars['String']['output']>;
  professional: Maybe<Professional>;
  professional_id: Maybe<Scalars['Int']['output']>;
  representative: Maybe<StripeRepresentative>;
  state: Maybe<State>;
  state_id: Maybe<Scalars['Int']['output']>;
  stripe_id: Scalars['String']['output'];
  tax_classification: TaxClassification;
  tax_classification_id: Scalars['Int']['output'];
  tax_form_preference: Maybe<Scalars['String']['output']>;
  updated_at: Scalars['DateTime']['output'];
  verified: Scalars['Boolean']['output'];
};

export type StripeAccountOrderInput = {
  active: InputMaybe<Scalars['Boolean']['input']>;
  address_city: InputMaybe<Scalars['Boolean']['input']>;
  address_first: InputMaybe<Scalars['Boolean']['input']>;
  address_second: InputMaybe<Scalars['Boolean']['input']>;
  address_zip: InputMaybe<Scalars['Boolean']['input']>;
  company_name: InputMaybe<Scalars['Boolean']['input']>;
  created_at: InputMaybe<Scalars['Boolean']['input']>;
  first_name: InputMaybe<Scalars['Boolean']['input']>;
  id: InputMaybe<Scalars['Boolean']['input']>;
  last_name: InputMaybe<Scalars['Boolean']['input']>;
  phone_number: InputMaybe<Scalars['Boolean']['input']>;
  professional_id: InputMaybe<Scalars['Boolean']['input']>;
  state_id: InputMaybe<Scalars['Boolean']['input']>;
  stripe_id: InputMaybe<Scalars['Boolean']['input']>;
  tax_classification_id: InputMaybe<Scalars['Boolean']['input']>;
  tax_form_preference: InputMaybe<Scalars['String']['input']>;
  updated_at: InputMaybe<Scalars['Boolean']['input']>;
  verified: InputMaybe<Scalars['Boolean']['input']>;
};

export type StripeAccountQueryInput = {
  filter: InputMaybe<StripeAccountWhereInput>;
  orderBy: InputMaybe<StripeAccountOrderInput>;
  page: InputMaybe<Scalars['Int']['input']>;
  perPage: InputMaybe<Scalars['Int']['input']>;
  search: InputMaybe<StripeAccountSearchInput>;
};

export type StripeAccountSearchInput = {
  account_id: InputMaybe<Scalars['Int']['input']>;
  active: InputMaybe<Scalars['Boolean']['input']>;
  address_city: InputMaybe<Scalars['String']['input']>;
  address_first: InputMaybe<Scalars['String']['input']>;
  address_second: InputMaybe<Scalars['String']['input']>;
  address_zip: InputMaybe<Scalars['String']['input']>;
  agency_id: InputMaybe<Scalars['Int']['input']>;
  company_name: InputMaybe<Scalars['String']['input']>;
  created_at: InputMaybe<Scalars['DateTime']['input']>;
  first_name: InputMaybe<Scalars['String']['input']>;
  id: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  last_name: InputMaybe<Scalars['String']['input']>;
  phone_number: InputMaybe<Scalars['String']['input']>;
  professional_account_id: InputMaybe<Scalars['Int']['input']>;
  professional_id: InputMaybe<Scalars['Int']['input']>;
  stateId: InputMaybe<Scalars['Int']['input']>;
  stripe_id: InputMaybe<Scalars['String']['input']>;
  tax_classification_id: InputMaybe<Scalars['Int']['input']>;
  tax_form_preference: InputMaybe<Scalars['String']['input']>;
  updated_at: InputMaybe<Scalars['DateTime']['input']>;
  verified: InputMaybe<Scalars['Boolean']['input']>;
};

export type StripeAccountWhereInput = {
  active: InputMaybe<Scalars['Boolean']['input']>;
  address_city: InputMaybe<Scalars['String']['input']>;
  address_first: InputMaybe<Scalars['String']['input']>;
  address_second: InputMaybe<Scalars['String']['input']>;
  address_zip: InputMaybe<Scalars['String']['input']>;
  agency_id: InputMaybe<Scalars['Int']['input']>;
  company_name: InputMaybe<Scalars['String']['input']>;
  created_at: InputMaybe<Scalars['DateTime']['input']>;
  first_name: InputMaybe<Scalars['String']['input']>;
  id: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  last_name: InputMaybe<Scalars['String']['input']>;
  phone_number: InputMaybe<Scalars['String']['input']>;
  professional_id: InputMaybe<Scalars['Int']['input']>;
  state_id: InputMaybe<Scalars['Int']['input']>;
  stripe_id: InputMaybe<Scalars['String']['input']>;
  tax_classification_id: InputMaybe<Scalars['Int']['input']>;
  tax_form_preference: InputMaybe<Scalars['String']['input']>;
  updated_at: InputMaybe<Scalars['DateTime']['input']>;
  verified: InputMaybe<Scalars['Boolean']['input']>;
};

export type StripePaymentIntent = {
  __typename?: 'StripePaymentIntent';
  amount_cents: Maybe<Scalars['Int']['output']>;
  completed_at: Maybe<Scalars['String']['output']>;
  created_at: Scalars['String']['output'];
  failed_at: Maybe<Scalars['String']['output']>;
  failure_reason: Maybe<Scalars['String']['output']>;
  funding_source: Maybe<FundingSource>;
  id: Scalars['Int']['output'];
  processing_at: Maybe<Scalars['String']['output']>;
  status: Maybe<Scalars['String']['output']>;
  stripe_id: Maybe<Scalars['String']['output']>;
  updated_at: Scalars['String']['output'];
};

export type StripePaymentIntentOrderInput = {
  id: InputMaybe<Scalars['Boolean']['input']>;
};

export type StripePaymentIntentQueryInput = {
  filter: InputMaybe<StripePaymentIntentWhereInput>;
  orderBy: InputMaybe<StripePaymentIntentOrderInput>;
  page: InputMaybe<Scalars['Int']['input']>;
  perPage: InputMaybe<Scalars['Int']['input']>;
  search: InputMaybe<StripePaymentIntentSearchInput>;
};

export type StripePaymentIntentSearchInput = {
  id: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};

export type StripePaymentIntentWhereInput = {
  id: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};

export type StripeRepresentative = {
  __typename?: 'StripeRepresentative';
  address_city: Scalars['String']['output'];
  address_first: Scalars['String']['output'];
  address_second: Maybe<Scalars['String']['output']>;
  address_zip: Scalars['String']['output'];
  dob: Scalars['DateTime']['output'];
  email: Scalars['String']['output'];
  first_name: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  last_name: Scalars['String']['output'];
  phone: Scalars['String']['output'];
  ssn_last_4: Scalars['String']['output'];
  state: State;
  state_id: Scalars['Int']['output'];
  title: Scalars['String']['output'];
};

export type StripeRepresentativeOrderInput = {
  id: InputMaybe<Scalars['Boolean']['input']>;
};

export type StripeRepresentativeQueryInput = {
  filter: InputMaybe<StripeRepresentativeWhereInput>;
  orderBy: InputMaybe<StripeRepresentativeOrderInput>;
  page: InputMaybe<Scalars['Int']['input']>;
  perPage: InputMaybe<Scalars['Int']['input']>;
  search: InputMaybe<StripeRepresentativeSearchInput>;
};

export type StripeRepresentativeSearchInput = {
  id: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};

export type StripeRepresentativeWhereInput = {
  id: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};

export type SurgeryType = {
  __typename?: 'SurgeryType';
  active: Scalars['Boolean']['output'];
  assignments: Maybe<Array<Maybe<Assignment>>>;
  created_at: Scalars['DateTime']['output'];
  display_name: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  job_surgery_types: Maybe<Array<Maybe<JobSurgeryType>>>;
  job_templates: Maybe<Array<Maybe<JobTemplate>>>;
  jobs: Maybe<Array<Maybe<Job>>>;
  name: Maybe<Scalars['String']['output']>;
  sequence: Maybe<Scalars['Int']['output']>;
  updated_at: Scalars['DateTime']['output'];
};

export type SurgeryTypeOrderInput = {
  active: InputMaybe<Scalars['Boolean']['input']>;
  created_at: InputMaybe<Scalars['Boolean']['input']>;
  display_name: InputMaybe<Scalars['Boolean']['input']>;
  id: InputMaybe<Scalars['Boolean']['input']>;
  name: InputMaybe<Scalars['Boolean']['input']>;
  sequence: InputMaybe<Scalars['Boolean']['input']>;
  updated_at: InputMaybe<Scalars['Boolean']['input']>;
};

export type SurgeryTypeQueryInput = {
  filter: InputMaybe<SurgeryTypeWhereInput>;
  orderBy: InputMaybe<SurgeryTypeOrderInput>;
  page: InputMaybe<Scalars['Int']['input']>;
  perPage: InputMaybe<Scalars['Int']['input']>;
  search: InputMaybe<DefaultSearchInput>;
};

export type SurgeryTypeWhereInput = {
  active: InputMaybe<Scalars['Boolean']['input']>;
  created_at: InputMaybe<Scalars['DateTime']['input']>;
  display_name: InputMaybe<Scalars['String']['input']>;
  id: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  name: InputMaybe<Scalars['String']['input']>;
  sequence: InputMaybe<Scalars['Int']['input']>;
  updated_at: InputMaybe<Scalars['DateTime']['input']>;
};

export type TaxClassification = {
  __typename?: 'TaxClassification';
  created_at: Scalars['DateTime']['output'];
  id: Scalars['Int']['output'];
  label: Maybe<Scalars['String']['output']>;
  name: Maybe<Scalars['String']['output']>;
  sequence: Maybe<Scalars['Int']['output']>;
  updated_at: Scalars['DateTime']['output'];
};

export type TaxClassificationOrderInput = {
  created_at: InputMaybe<Scalars['Boolean']['input']>;
  id: InputMaybe<Scalars['Boolean']['input']>;
  label: InputMaybe<Scalars['Boolean']['input']>;
  name: InputMaybe<Scalars['Boolean']['input']>;
  sequence: InputMaybe<Scalars['Boolean']['input']>;
  updated_at: InputMaybe<Scalars['Boolean']['input']>;
};

export type TaxClassificationQueryInput = {
  filter: InputMaybe<TaxClassificationWhereInput>;
  orderBy: InputMaybe<TaxClassificationOrderInput>;
  page: InputMaybe<Scalars['Int']['input']>;
  perPage: InputMaybe<Scalars['Int']['input']>;
  search: InputMaybe<DefaultSearchInput>;
};

export type TaxClassificationWhereInput = {
  created_at: InputMaybe<Scalars['DateTime']['input']>;
  id: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  label: InputMaybe<Scalars['String']['input']>;
  name: InputMaybe<Scalars['String']['input']>;
  sequence: InputMaybe<Scalars['Int']['input']>;
  updated_at: InputMaybe<Scalars['DateTime']['input']>;
};

export type TaxForm = {
  __typename?: 'TaxForm';
  created_at: Scalars['DateTime']['output'];
  id: Scalars['Int']['output'];
  stripe_account: StripeAccount;
  stripe_account_id: Scalars['Int']['output'];
  tax_form: Maybe<Scalars['AWSFile']['output']>;
  updated_at: Scalars['DateTime']['output'];
  year: Scalars['Int']['output'];
};

export type TaxFormOrderInput = {
  created_at: InputMaybe<Scalars['Boolean']['input']>;
  id: InputMaybe<Scalars['Boolean']['input']>;
  updated_at: InputMaybe<Scalars['Boolean']['input']>;
  year: InputMaybe<Scalars['Boolean']['input']>;
};

export type TaxFormQueryInput = {
  filter: InputMaybe<TaxFormWhereInput>;
  orderBy: InputMaybe<TaxFormOrderInput>;
  page: InputMaybe<Scalars['Int']['input']>;
  perPage: InputMaybe<Scalars['Int']['input']>;
  search: InputMaybe<TaxFormSearchInput>;
};

export type TaxFormSearchInput = {
  created_at: InputMaybe<Scalars['DateTime']['input']>;
  id: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  professional_account_id: InputMaybe<Scalars['Int']['input']>;
  updated_at: InputMaybe<Scalars['DateTime']['input']>;
  year: InputMaybe<Scalars['Int']['input']>;
};

export type TaxFormWhereInput = {
  created_at: InputMaybe<Scalars['DateTime']['input']>;
  id: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  professional_account_id: InputMaybe<Scalars['Int']['input']>;
  updated_at: InputMaybe<Scalars['DateTime']['input']>;
  year: InputMaybe<Scalars['Int']['input']>;
};

export type Timecard = {
  __typename?: 'Timecard';
  approve_by: Scalars['DateTime']['output'];
  assignment: Maybe<Assignment>;
  assignment_id: Maybe<Scalars['Int']['output']>;
  availableJobs: Array<Job>;
  aws_signature_url: Maybe<Scalars['AWSFile']['output']>;
  created_at: Scalars['DateTime']['output'];
  ends_time: Scalars['DateTime']['output'];
  expense_adjustments: Maybe<Array<Maybe<ExpenseAdjustment>>>;
  id: Scalars['Int']['output'];
  internal: Maybe<Scalars['Boolean']['output']>;
  invoice_ids: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  job_count: Maybe<Scalars['Int']['output']>;
  jobs: Maybe<Array<Maybe<Job>>>;
  payout_ids: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  payout_kind: Maybe<Scalars['String']['output']>;
  primary_payout_id: Maybe<Scalars['Int']['output']>;
  professional: Professional;
  professional_id: Scalars['Int']['output'];
  saas_company_id: Maybe<Scalars['Int']['output']>;
  signature_url: Maybe<Scalars['String']['output']>;
  starts_time: Scalars['DateTime']['output'];
  status: Scalars['String']['output'];
  submit_by: Scalars['DateTime']['output'];
  total_breaks_hours: Maybe<Scalars['Float']['output']>;
  total_callback_hours: Maybe<Scalars['Float']['output']>;
  total_double_hours: Maybe<Scalars['Float']['output']>;
  total_hours: Maybe<Scalars['Float']['output']>;
  total_on_call_hours: Maybe<Scalars['Float']['output']>;
  total_overtime_hours: Maybe<Scalars['Float']['output']>;
  total_regular_hours: Maybe<Scalars['Float']['output']>;
  updated_at: Scalars['DateTime']['output'];
};

export type TimecardOrderInput = {
  approve_by: InputMaybe<Scalars['Boolean']['input']>;
  assignment_id: InputMaybe<Scalars['Boolean']['input']>;
  created_at: InputMaybe<Scalars['Boolean']['input']>;
  ends_time: InputMaybe<Scalars['Boolean']['input']>;
  id: InputMaybe<Scalars['Boolean']['input']>;
  professional_id: InputMaybe<Scalars['Boolean']['input']>;
  starts_time: InputMaybe<Scalars['Boolean']['input']>;
  submit_by: InputMaybe<Scalars['Boolean']['input']>;
  updated_at: InputMaybe<Scalars['Boolean']['input']>;
};

export type TimecardQueryInput = {
  filter: InputMaybe<TimecardWhereInput>;
  orderBy: InputMaybe<TimecardOrderInput>;
  page: InputMaybe<Scalars['Int']['input']>;
  perPage: InputMaybe<Scalars['Int']['input']>;
  search: InputMaybe<TimecardSearchInput>;
};

export type TimecardSearchInput = {
  ends_time_from: InputMaybe<Scalars['Date']['input']>;
  ends_time_to: InputMaybe<Scalars['Date']['input']>;
  for_assignment: InputMaybe<Scalars['Boolean']['input']>;
  job_statuses: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  kinds: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  location_id: InputMaybe<Scalars['Int']['input']>;
  location_ids: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  no_breaks: InputMaybe<Scalars['Boolean']['input']>;
  primary_payout_id: InputMaybe<Scalars['Int']['input']>;
  professional_account_id: InputMaybe<Scalars['Int']['input']>;
  /**
   * *Constraints:*
   * * Maximal length: `150`
   *
   */
  q: InputMaybe<Scalars['String']['input']>;
  saas_only: InputMaybe<Scalars['Boolean']['input']>;
  starts_time_from: InputMaybe<Scalars['Date']['input']>;
  starts_time_to: InputMaybe<Scalars['DateTime']['input']>;
  status: InputMaybe<Scalars['String']['input']>;
  statuses: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type TimecardWhereInput = {
  assignment_id: InputMaybe<Scalars['Int']['input']>;
  created_at: InputMaybe<Scalars['DateTime']['input']>;
  ends_time: InputMaybe<Scalars['DateTime']['input']>;
  id: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  invoice_id: InputMaybe<Scalars['Int']['input']>;
  primary_payout_id: InputMaybe<Scalars['Int']['input']>;
  professional_id: InputMaybe<Scalars['Int']['input']>;
  starts_time: InputMaybe<Scalars['DateTime']['input']>;
  status: InputMaybe<Scalars['String']['input']>;
  submit_by: InputMaybe<Scalars['DateTime']['input']>;
  updated_at: InputMaybe<Scalars['DateTime']['input']>;
};

export type TimecardsTotals = {
  __typename?: 'TimecardsTotals';
  filtered_breaks_hours: Maybe<Scalars['Float']['output']>;
  filtered_callback_hours: Maybe<Scalars['Float']['output']>;
  filtered_double_hours: Maybe<Scalars['Float']['output']>;
  filtered_on_call_hours: Maybe<Scalars['Float']['output']>;
  filtered_overtime_hours: Maybe<Scalars['Float']['output']>;
  filtered_regular_hours: Maybe<Scalars['Float']['output']>;
  filtered_total_hours: Maybe<Scalars['Float']['output']>;
};

export type TransferReversal = {
  __typename?: 'TransferReversal';
  amount_cents: Scalars['Int']['output'];
  amount_currency: Scalars['String']['output'];
  created_at: Scalars['DateTime']['output'];
  id: Scalars['Int']['output'];
  invoice: Maybe<Invoice>;
  kind: Maybe<Scalars['String']['output']>;
  payout: Maybe<Payout>;
  professional: Maybe<Professional>;
  reason: Maybe<Scalars['String']['output']>;
  stripe_id: Maybe<Scalars['String']['output']>;
  updated_at: Scalars['DateTime']['output'];
};

export type TransferReversalOrderInput = {
  amount_cents: InputMaybe<Scalars['Boolean']['input']>;
  amount_currency: InputMaybe<Scalars['Boolean']['input']>;
  created_at: InputMaybe<Scalars['Boolean']['input']>;
  id: InputMaybe<Scalars['Boolean']['input']>;
  invoice_id: InputMaybe<Scalars['Boolean']['input']>;
  kind: InputMaybe<Scalars['Boolean']['input']>;
  payout_id: InputMaybe<Scalars['Boolean']['input']>;
  professional_id: InputMaybe<Scalars['Boolean']['input']>;
  reason: InputMaybe<Scalars['Boolean']['input']>;
  stripe_id: InputMaybe<Scalars['Boolean']['input']>;
  updated_at: InputMaybe<Scalars['Boolean']['input']>;
};

export type TransferReversalQueryInput = {
  filter: InputMaybe<TransferReversalWhereInput>;
  orderBy: InputMaybe<TransferReversalOrderInput>;
  page: InputMaybe<Scalars['Int']['input']>;
  perPage: InputMaybe<Scalars['Int']['input']>;
  search: InputMaybe<DefaultSearchInput>;
};

export type TransferReversalWhereInput = {
  amount_cents: InputMaybe<Scalars['Int']['input']>;
  amount_currency: InputMaybe<Scalars['String']['input']>;
  created_at: InputMaybe<Scalars['DateTime']['input']>;
  id: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  invoice_id: InputMaybe<Scalars['Int']['input']>;
  kind: InputMaybe<Scalars['String']['input']>;
  payout_id: InputMaybe<Scalars['Int']['input']>;
  professional_id: InputMaybe<Scalars['Int']['input']>;
  reason: InputMaybe<Scalars['String']['input']>;
  stripe_id: InputMaybe<Scalars['String']['input']>;
  updated_at: InputMaybe<Scalars['DateTime']['input']>;
};

export type UnexplainedWorkGap = {
  __typename?: 'UnexplainedWorkGap';
  earlier_end_date: Scalars['Date']['output'];
  earlier_experience_id: Scalars['Int']['output'];
  earlier_experience_type: Scalars['String']['output'];
  later_experience_id: Scalars['Int']['output'];
  later_experience_type: Scalars['String']['output'];
  later_start_date: Scalars['Date']['output'];
  professional_id: Scalars['Int']['output'];
};

export type UniqueAgencyChargeOverrides = {
  __typename?: 'UniqueAgencyChargeOverrides';
  position: Maybe<Scalars['JSON']['output']>;
  position_id: Maybe<Scalars['Int']['output']>;
  specialty: Maybe<Scalars['JSON']['output']>;
  specialty_id: Maybe<Scalars['Int']['output']>;
};

export type UniversalBackgroundCheck = {
  __typename?: 'UniversalBackgroundCheck';
  created_at: Scalars['DateTime']['output'];
  id: Scalars['Int']['output'];
  order_number: Maybe<Scalars['String']['output']>;
  order_status: Maybe<Scalars['String']['output']>;
  order_url: Maybe<Scalars['String']['output']>;
  professional: Maybe<Professional>;
  professional_id: Maybe<Scalars['Int']['output']>;
  updated_at: Scalars['DateTime']['output'];
};

export type UniversalBackgroundCheckOrderInput = {
  id: InputMaybe<Scalars['Boolean']['input']>;
  order_number: InputMaybe<Scalars['Boolean']['input']>;
  order_status: InputMaybe<Scalars['Boolean']['input']>;
  order_url: InputMaybe<Scalars['Boolean']['input']>;
  professional_id: InputMaybe<Scalars['Boolean']['input']>;
};

export type UniversalBackgroundCheckQueryInput = {
  filter: InputMaybe<UniversalBackgroundCheckWhereInput>;
  orderBy: InputMaybe<UniversalBackgroundCheckOrderInput>;
  page: InputMaybe<Scalars['Int']['input']>;
  perPage: InputMaybe<Scalars['Int']['input']>;
  search: InputMaybe<DefaultSearchInput>;
};

export type UniversalBackgroundCheckWhereInput = {
  id: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  order_number: InputMaybe<Scalars['String']['input']>;
  order_status: InputMaybe<Scalars['String']['input']>;
  order_url: InputMaybe<Scalars['String']['input']>;
  professional_id: InputMaybe<Scalars['Int']['input']>;
};

export type User = {
  __typename?: 'User';
  about: Maybe<Scalars['String']['output']>;
  account_manager: Maybe<Administrator>;
  account_summary_emails: Maybe<Scalars['Boolean']['output']>;
  allow_assignments: Maybe<Scalars['Boolean']['output']>;
  allow_per_diem_jobs: Maybe<Scalars['Boolean']['output']>;
  auto_pay: Maybe<Scalars['Boolean']['output']>;
  balance_cents: Maybe<Scalars['Int']['output']>;
  balance_currency: Maybe<Scalars['String']['output']>;
  billable_orientation_hours: Maybe<Scalars['Float']['output']>;
  billing: Maybe<Scalars['String']['output']>;
  billing_contacts: Maybe<Array<Maybe<BillingContact>>>;
  billing_email: Maybe<Scalars['String']['output']>;
  billing_id: Maybe<Scalars['String']['output']>;
  blocked_by_list: Maybe<Scalars['String']['output']>;
  blocks_list: Maybe<Scalars['String']['output']>;
  business_name: Maybe<Scalars['String']['output']>;
  business_phone_number: Maybe<Scalars['String']['output']>;
  business_tax_id: Maybe<Scalars['String']['output']>;
  cancellation_fee_charge_hours: Maybe<Scalars['Int']['output']>;
  cancellation_fee_window: Maybe<Scalars['Int']['output']>;
  cancellations: Maybe<Array<Maybe<Cancellation>>>;
  charge_on_call_hourly_rate_cents: Maybe<Scalars['Int']['output']>;
  charge_on_call_hourly_rate_currency: Maybe<Scalars['String']['output']>;
  check_line_of_credit: Maybe<Scalars['Boolean']['output']>;
  clinical_contacts: Maybe<Array<Maybe<ClinicalContact>>>;
  company: Maybe<Scalars['String']['output']>;
  covid_requirement: Maybe<Scalars['String']['output']>;
  created_at: Maybe<Scalars['DateTime']['output']>;
  detailed_notes: Maybe<Scalars['String']['output']>;
  disabled_at: Maybe<Scalars['DateTime']['output']>;
  disabled_reason_names: Maybe<Scalars['String']['output']>;
  disabled_reasons: Maybe<Array<Maybe<DisabledReason>>>;
  drug_screening_required: Maybe<Scalars['Boolean']['output']>;
  facility_cancellation_hours: Maybe<Scalars['Int']['output']>;
  facility_group: Maybe<Scalars['String']['output']>;
  favorites: Maybe<Array<Maybe<Professional>>>;
  fill_rate_ratio: Maybe<Scalars['Int']['output']>;
  fill_ratio: Maybe<Scalars['String']['output']>;
  guaranteed_minimum_hours: Maybe<Scalars['Int']['output']>;
  health_system: Maybe<HealthSystem>;
  health_system_id: Maybe<Scalars['Int']['output']>;
  id: Maybe<Scalars['Int']['output']>;
  interview_availabilities: Maybe<Array<Maybe<InterviewAvailability>>>;
  invite_last_sent_at: Maybe<Scalars['DateTime']['output']>;
  invoice_emails: Maybe<Scalars['Boolean']['output']>;
  invoices: Maybe<Array<Maybe<Invoice>>>;
  itemized_transactions: Maybe<Array<Maybe<ItemizedTransaction>>>;
  job_count: Maybe<Scalars['Int']['output']>;
  jobs: Maybe<Array<Maybe<Job>>>;
  last_time_job_posted: Maybe<Scalars['DateTime']['output']>;
  latitude: Maybe<Scalars['Float']['output']>;
  line_of_credit_cents: Maybe<Scalars['Int']['output']>;
  location_type: Maybe<LocationType>;
  longitude: Maybe<Scalars['Float']['output']>;
  main_rate_setting: Maybe<RateSetting>;
  manage_facilities: Maybe<Array<Maybe<User>>>;
  manage_facilities_list: Maybe<Scalars['String']['output']>;
  managed_by_facilities: Maybe<Array<Maybe<User>>>;
  market: Maybe<Market>;
  msp: Maybe<Msp>;
  msp_id: Maybe<Scalars['Int']['output']>;
  name: Maybe<Scalars['String']['output']>;
  net_term: Maybe<Scalars['Int']['output']>;
  non_billable_orientation_burden_hours: Maybe<Scalars['Float']['output']>;
  onboarding_complete: Maybe<Scalars['Boolean']['output']>;
  overtime_hours_frequency: Maybe<Scalars['Int']['output']>;
  overtime_hours_threshold: Maybe<Scalars['Int']['output']>;
  parking_cost_cents: Maybe<Scalars['Int']['output']>;
  parking_free: Maybe<Scalars['Boolean']['output']>;
  parking_instructions: Maybe<Scalars['String']['output']>;
  parking_reimbursed: Maybe<Scalars['Boolean']['output']>;
  parking_reimbursement_cents: Maybe<Scalars['Int']['output']>;
  parking_validated: Maybe<Scalars['Boolean']['output']>;
  payment_gateway: Maybe<Scalars['Boolean']['output']>;
  person: Maybe<Person>;
  plan: Maybe<Scalars['String']['output']>;
  position_display_names: Maybe<Scalars['String']['output']>;
  positions: Maybe<Array<Maybe<Position>>>;
  primary_first_name: Maybe<Scalars['String']['output']>;
  primary_last_name: Maybe<Scalars['String']['output']>;
  primary_phone_number: Maybe<Scalars['String']['output']>;
  primary_phone_sms: Maybe<Scalars['Boolean']['output']>;
  professionals: Maybe<Array<Maybe<Professional>>>;
  provider: Maybe<Scalars['String']['output']>;
  referral: Maybe<Scalars['String']['output']>;
  relationships: Maybe<Array<Maybe<Relationship>>>;
  require_physical_signature: Maybe<Scalars['Boolean']['output']>;
  revenue_adjustments: Maybe<Array<Maybe<RevenueAdjustment>>>;
  rfm: Maybe<Scalars['String']['output']>;
  rfmf: Maybe<Scalars['Int']['output']>;
  rfmm: Maybe<Scalars['Int']['output']>;
  rfmr: Maybe<Scalars['Int']['output']>;
  sales_associate: Maybe<Administrator>;
  scrubs_provided: Maybe<Scalars['Boolean']['output']>;
  secondary_email: Maybe<Scalars['String']['output']>;
  secondary_first_name: Maybe<Scalars['String']['output']>;
  secondary_last_name: Maybe<Scalars['String']['output']>;
  secondary_phone_number: Maybe<Scalars['String']['output']>;
  secondary_phone_sms: Maybe<Scalars['Boolean']['output']>;
  source: Maybe<Scalars['String']['output']>;
  source_other: Maybe<Scalars['String']['output']>;
  ssn_last_4: Maybe<Scalars['String']['output']>;
  statement_fee_percent: Maybe<Scalars['Float']['output']>;
  stripe_ach_credit_transfer_id: Maybe<Scalars['String']['output']>;
  stripe_bank_account_token: Maybe<Scalars['String']['output']>;
  stripe_customer_id: Maybe<Scalars['String']['output']>;
  timezone_lookup: Maybe<Scalars['TZ']['output']>;
  token: Maybe<Scalars['String']['output']>;
  uid: Maybe<Scalars['String']['output']>;
  unsubscribe: Maybe<Scalars['Boolean']['output']>;
  unsubscribe_token: Maybe<Scalars['String']['output']>;
  updated_at: Maybe<Scalars['DateTime']['output']>;
  user_positions: Maybe<UserPosition>;
  verified: Maybe<Scalars['Boolean']['output']>;
  vms_facility_name: Maybe<Scalars['String']['output']>;
  vms_fee_percent: Maybe<Scalars['Float']['output']>;
  vms_type: Maybe<VmsType>;
  vms_type_id: Maybe<Scalars['Int']['output']>;
  vms_user: Maybe<VmsUser>;
};

export type UserOrderInput = {
  about: InputMaybe<Scalars['Boolean']['input']>;
  account_manager_id: InputMaybe<Scalars['Boolean']['input']>;
  allow_assignments: InputMaybe<Scalars['Boolean']['input']>;
  allow_per_diem_jobs: InputMaybe<Scalars['Boolean']['input']>;
  auto_pay: InputMaybe<Scalars['Boolean']['input']>;
  billing: InputMaybe<Scalars['Boolean']['input']>;
  blocked_by_list: InputMaybe<Scalars['Boolean']['input']>;
  blocks_list: InputMaybe<Scalars['Boolean']['input']>;
  business_name: InputMaybe<Scalars['Boolean']['input']>;
  business_phone_number: InputMaybe<Scalars['Boolean']['input']>;
  business_tax_id: InputMaybe<Scalars['Boolean']['input']>;
  check_line_of_credit: InputMaybe<Scalars['Boolean']['input']>;
  company: InputMaybe<Scalars['Boolean']['input']>;
  covid_requirement: InputMaybe<Scalars['Boolean']['input']>;
  created_at: InputMaybe<Scalars['Boolean']['input']>;
  detailed_notes: InputMaybe<Scalars['Boolean']['input']>;
  disabled_at: InputMaybe<Scalars['Boolean']['input']>;
  disabled_reason_names: InputMaybe<Scalars['Boolean']['input']>;
  drug_screening_required: InputMaybe<Scalars['Boolean']['input']>;
  facility_group: InputMaybe<Scalars['Boolean']['input']>;
  facility_type_id: InputMaybe<Scalars['Boolean']['input']>;
  fill_rate_ratio: InputMaybe<Scalars['Boolean']['input']>;
  funding_source_id: InputMaybe<Scalars['Boolean']['input']>;
  health_system_id: InputMaybe<Scalars['Boolean']['input']>;
  id: InputMaybe<Scalars['Boolean']['input']>;
  invite_last_sent_at: InputMaybe<Scalars['Boolean']['input']>;
  last_time_job_posted: InputMaybe<Scalars['Boolean']['input']>;
  latitude: InputMaybe<Scalars['Boolean']['input']>;
  line_of_credit_id: InputMaybe<Scalars['Boolean']['input']>;
  longitude: InputMaybe<Scalars['Boolean']['input']>;
  manage_facilities_list: InputMaybe<Scalars['Boolean']['input']>;
  market_id: InputMaybe<Scalars['Boolean']['input']>;
  msp_id: InputMaybe<Scalars['Boolean']['input']>;
  net_term_id: InputMaybe<Scalars['Boolean']['input']>;
  onboarding_complete: InputMaybe<Scalars['Boolean']['input']>;
  overtime_hours_frequency: InputMaybe<Scalars['Boolean']['input']>;
  overtime_hours_threshold: InputMaybe<Scalars['Boolean']['input']>;
  parking_cost_cents: InputMaybe<Scalars['Boolean']['input']>;
  parking_instructions: InputMaybe<Scalars['Boolean']['input']>;
  parking_reimbursement_cents: InputMaybe<Scalars['Boolean']['input']>;
  person_id: InputMaybe<Scalars['Boolean']['input']>;
  plan: InputMaybe<Scalars['Boolean']['input']>;
  position_display_names: InputMaybe<Scalars['Boolean']['input']>;
  primary_first_name: InputMaybe<Scalars['Boolean']['input']>;
  primary_last_name: InputMaybe<Scalars['Boolean']['input']>;
  primary_phone_number: InputMaybe<Scalars['Boolean']['input']>;
  primary_phone_sms: InputMaybe<Scalars['Boolean']['input']>;
  provider: InputMaybe<Scalars['Boolean']['input']>;
  referral: InputMaybe<Scalars['Boolean']['input']>;
  sales_associate_id: InputMaybe<Scalars['Boolean']['input']>;
  secondary_email: InputMaybe<Scalars['Boolean']['input']>;
  secondary_first_name: InputMaybe<Scalars['Boolean']['input']>;
  secondary_last_name: InputMaybe<Scalars['Boolean']['input']>;
  secondary_phone_number: InputMaybe<Scalars['Boolean']['input']>;
  secondary_phone_sms: InputMaybe<Scalars['Boolean']['input']>;
  source: InputMaybe<Scalars['Boolean']['input']>;
  source_other: InputMaybe<Scalars['Boolean']['input']>;
  ssn_last_4: InputMaybe<Scalars['Boolean']['input']>;
  statement_fee_percent: InputMaybe<Scalars['Boolean']['input']>;
  stripe_bank_account_token: InputMaybe<Scalars['Boolean']['input']>;
  stripe_customer_id: InputMaybe<Scalars['Boolean']['input']>;
  timezone: InputMaybe<Scalars['Boolean']['input']>;
  token: InputMaybe<Scalars['Boolean']['input']>;
  uid: InputMaybe<Scalars['Boolean']['input']>;
  unsubscribe: InputMaybe<Scalars['Boolean']['input']>;
  unsubscribe_token: InputMaybe<Scalars['Boolean']['input']>;
  updated_at: InputMaybe<Scalars['Boolean']['input']>;
  verified: InputMaybe<Scalars['Boolean']['input']>;
  vms_type_id: InputMaybe<Scalars['Boolean']['input']>;
};

export type UserPosition = {
  __typename?: 'UserPosition';
  created_at: Scalars['DateTime']['output'];
  id: Scalars['Int']['output'];
  position: Maybe<Position>;
  position_id: Maybe<Scalars['Int']['output']>;
  updated_at: Scalars['DateTime']['output'];
  user: Maybe<User>;
  user_id: Maybe<Scalars['Int']['output']>;
};

export type UserPositionOrderInput = {
  created_at: InputMaybe<Scalars['Boolean']['input']>;
  id: InputMaybe<Scalars['Boolean']['input']>;
  position_id: InputMaybe<Scalars['Boolean']['input']>;
  updated_at: InputMaybe<Scalars['Boolean']['input']>;
  user_id: InputMaybe<Scalars['Boolean']['input']>;
};

export type UserPositionQueryInput = {
  filter: InputMaybe<UserPositionWhereInput>;
  orderBy: InputMaybe<UserPositionOrderInput>;
  page: InputMaybe<Scalars['Int']['input']>;
  perPage: InputMaybe<Scalars['Int']['input']>;
  search: InputMaybe<DefaultSearchInput>;
};

export type UserPositionRateSetting = {
  __typename?: 'UserPositionRateSetting';
  active: Maybe<Scalars['Boolean']['output']>;
  created_at: Maybe<Scalars['DateTime']['output']>;
  id: Maybe<Scalars['String']['output']>;
  market_position_rate_setting_active: Maybe<Scalars['Boolean']['output']>;
  market_position_rate_setting_id: Maybe<Scalars['Int']['output']>;
  original_id: Maybe<Scalars['Int']['output']>;
  position: Maybe<Position>;
  position_id: Maybe<Scalars['Int']['output']>;
  settings: Maybe<Scalars['JSON']['output']>;
  specialty: Maybe<Specialty>;
  specialty_id: Maybe<Scalars['Int']['output']>;
  state_position_rate_setting_active: Maybe<Scalars['Boolean']['output']>;
  state_position_rate_setting_id: Maybe<Scalars['Int']['output']>;
  updated_at: Maybe<Scalars['DateTime']['output']>;
  user: Maybe<User>;
  user_id: Maybe<Scalars['Int']['output']>;
  user_position_rate_setting_active: Maybe<Scalars['Boolean']['output']>;
  user_position_rate_setting_id: Maybe<Scalars['Int']['output']>;
};

export type UserPositionRateSettingOrderInput = {
  active: InputMaybe<Scalars['Boolean']['input']>;
  created_at: InputMaybe<Scalars['Boolean']['input']>;
  id: InputMaybe<Scalars['Boolean']['input']>;
  position: InputMaybe<PositionOrderInput>;
  position_id: InputMaybe<Scalars['Boolean']['input']>;
  specialty_id: InputMaybe<Scalars['Int']['input']>;
  updated_at: InputMaybe<Scalars['Boolean']['input']>;
  user_id: InputMaybe<Scalars['Int']['input']>;
};

export type UserPositionRateSettingQueryInput = {
  filter: InputMaybe<UserPositionRateSettingWhereInput>;
  orderBy: InputMaybe<UserPositionRateSettingOrderInput>;
  page: InputMaybe<Scalars['Int']['input']>;
  perPage: InputMaybe<Scalars['Int']['input']>;
  search: InputMaybe<UserPositionRateSettingSearchInput>;
};

export type UserPositionRateSettingSearchInput = {
  below_market_rate: InputMaybe<Scalars['Boolean']['input']>;
  position_id: InputMaybe<Scalars['Int']['input']>;
  position_ids: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  specialty_id: InputMaybe<Scalars['Int']['input']>;
  specialty_ids: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  user_id: InputMaybe<Scalars['Int']['input']>;
};

export type UserPositionRateSettingWhereInput = {
  active: InputMaybe<Scalars['Boolean']['input']>;
  created_at: InputMaybe<Scalars['DateTime']['input']>;
  for_assignment: InputMaybe<Scalars['Boolean']['input']>;
  for_job: InputMaybe<Scalars['Boolean']['input']>;
  id: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  include_parents: InputMaybe<Scalars['Boolean']['input']>;
  position_id: InputMaybe<Scalars['Int']['input']>;
  specialty_id: InputMaybe<Scalars['Int']['input']>;
  updated_at: InputMaybe<Scalars['DateTime']['input']>;
  user_id: InputMaybe<Scalars['Int']['input']>;
};

export type UserPositionWhereInput = {
  created_at: InputMaybe<Scalars['DateTime']['input']>;
  id: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  position_id: InputMaybe<Scalars['Int']['input']>;
  updated_at: InputMaybe<Scalars['DateTime']['input']>;
  user_id: InputMaybe<Scalars['Int']['input']>;
};

export type UserQueryInput = {
  filter: InputMaybe<UserWhereInput>;
  orderBy: InputMaybe<UserOrderInput>;
  page: InputMaybe<Scalars['Int']['input']>;
  perPage: InputMaybe<Scalars['Int']['input']>;
  search: InputMaybe<UserSearchInput>;
};

export type UserRateSetting = {
  __typename?: 'UserRateSetting';
  active: Maybe<Scalars['Boolean']['output']>;
  created_at: Maybe<Scalars['DateTime']['output']>;
  id: Maybe<Scalars['Int']['output']>;
  settings: Maybe<Scalars['JSON']['output']>;
  updated_at: Maybe<Scalars['DateTime']['output']>;
  user: Maybe<User>;
  user_id: Maybe<Scalars['Int']['output']>;
};

export type UserRateSettingOrderInput = {
  active: InputMaybe<Scalars['Boolean']['input']>;
  created_at: InputMaybe<Scalars['Boolean']['input']>;
  id: InputMaybe<Scalars['Boolean']['input']>;
  updated_at: InputMaybe<Scalars['Boolean']['input']>;
  user_id: InputMaybe<Scalars['Int']['input']>;
};

export type UserRateSettingQueryInput = {
  filter: InputMaybe<UserRateSettingWhereInput>;
  orderBy: InputMaybe<UserRateSettingOrderInput>;
  page: InputMaybe<Scalars['Int']['input']>;
  perPage: InputMaybe<Scalars['Int']['input']>;
  search: InputMaybe<UserRateSettingSearchInput>;
};

export type UserRateSettingSearchInput = {
  user_id: InputMaybe<Scalars['Int']['input']>;
};

export type UserRateSettingWhereInput = {
  active: InputMaybe<Scalars['Boolean']['input']>;
  id: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  include_parents: InputMaybe<Scalars['Boolean']['input']>;
  user_id: InputMaybe<Scalars['Int']['input']>;
};

export type UserSearchInput = {
  account_manager_id: InputMaybe<Scalars['Int']['input']>;
  facility_type_id: InputMaybe<Scalars['Int']['input']>;
  fill_ratio: InputMaybe<Scalars['Int']['input']>;
  has_user_balance: InputMaybe<Scalars['Boolean']['input']>;
  health_sytem_id: InputMaybe<Scalars['String']['input']>;
  market_id: InputMaybe<Scalars['Int']['input']>;
  market_ids: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  msp_id: InputMaybe<Scalars['String']['input']>;
  no_vms_user: InputMaybe<Scalars['Boolean']['input']>;
  onboarding_complete: InputMaybe<Scalars['Boolean']['input']>;
  phone_number: InputMaybe<Scalars['String']['input']>;
  plan: InputMaybe<Scalars['Int']['input']>;
  /**
   * *Constraints:*
   * * Maximal length: `150`
   *
   */
  q: InputMaybe<Scalars['String']['input']>;
  sales_associate_id: InputMaybe<Scalars['Int']['input']>;
  state_id: InputMaybe<Scalars['Int']['input']>;
  utm_campaign: InputMaybe<Scalars['String']['input']>;
  utm_source: InputMaybe<Scalars['String']['input']>;
  verified: InputMaybe<Scalars['Boolean']['input']>;
  vms_type_id: InputMaybe<Scalars['String']['input']>;
};

export type UserWhereInput = {
  about: InputMaybe<Scalars['String']['input']>;
  account_manager_id: InputMaybe<Scalars['Int']['input']>;
  allow_assignments: InputMaybe<Scalars['Boolean']['input']>;
  allow_per_diem_jobs: InputMaybe<Scalars['Boolean']['input']>;
  auto_pay: InputMaybe<Scalars['Boolean']['input']>;
  billing: InputMaybe<Scalars['String']['input']>;
  blocked_by_list: InputMaybe<Scalars['String']['input']>;
  blocks_list: InputMaybe<Scalars['String']['input']>;
  business_name: InputMaybe<Scalars['String']['input']>;
  business_phone_number: InputMaybe<Scalars['String']['input']>;
  business_tax_id: InputMaybe<Scalars['String']['input']>;
  check_line_of_credit: InputMaybe<Scalars['Boolean']['input']>;
  company: InputMaybe<Scalars['String']['input']>;
  covid_requirement: InputMaybe<Scalars['String']['input']>;
  created_at: InputMaybe<Scalars['DateTime']['input']>;
  detailed_notes: InputMaybe<Scalars['String']['input']>;
  disabled_at: InputMaybe<Scalars['DateTime']['input']>;
  disabled_reason_names: InputMaybe<Scalars['String']['input']>;
  drug_screening_required: InputMaybe<Scalars['Boolean']['input']>;
  facility_group: InputMaybe<Scalars['String']['input']>;
  facility_type_id: InputMaybe<Scalars['Int']['input']>;
  fill_rate_ratio: InputMaybe<Scalars['Int']['input']>;
  funding_source_id: InputMaybe<Scalars['Int']['input']>;
  health_system_id: InputMaybe<Scalars['Int']['input']>;
  id: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  invite_last_sent_at: InputMaybe<Scalars['DateTime']['input']>;
  last_time_job_posted: InputMaybe<Scalars['DateTime']['input']>;
  latitude: InputMaybe<Scalars['Float']['input']>;
  line_of_credit_id: InputMaybe<Scalars['Int']['input']>;
  longitude: InputMaybe<Scalars['Float']['input']>;
  manage_facilities_list: InputMaybe<Scalars['String']['input']>;
  market_id: InputMaybe<Scalars['Int']['input']>;
  msp_id: InputMaybe<Scalars['Int']['input']>;
  net_term_id: InputMaybe<Scalars['Int']['input']>;
  onboarding_complete: InputMaybe<Scalars['Boolean']['input']>;
  overtime_hours_frequency: InputMaybe<Scalars['String']['input']>;
  overtime_hours_threshold: InputMaybe<Scalars['Int']['input']>;
  parking_cost_cents: InputMaybe<Scalars['Int']['input']>;
  parking_free: InputMaybe<Scalars['Boolean']['input']>;
  parking_instructions: InputMaybe<Scalars['String']['input']>;
  parking_reimbursed: InputMaybe<Scalars['Boolean']['input']>;
  parking_reimbursement_cents: InputMaybe<Scalars['Int']['input']>;
  parking_validated: InputMaybe<Scalars['Boolean']['input']>;
  person_id: InputMaybe<Scalars['Int']['input']>;
  plan: InputMaybe<Scalars['Int']['input']>;
  position_display_names: InputMaybe<Scalars['String']['input']>;
  primary_first_name: InputMaybe<Scalars['String']['input']>;
  primary_last_name: InputMaybe<Scalars['String']['input']>;
  primary_phone_number: InputMaybe<Scalars['String']['input']>;
  primary_phone_sms: InputMaybe<Scalars['Boolean']['input']>;
  provider: InputMaybe<Scalars['String']['input']>;
  referral: InputMaybe<Scalars['String']['input']>;
  sales_associate_id: InputMaybe<Scalars['Int']['input']>;
  secondary_email: InputMaybe<Scalars['String']['input']>;
  secondary_first_name: InputMaybe<Scalars['String']['input']>;
  secondary_last_name: InputMaybe<Scalars['String']['input']>;
  secondary_phone_number: InputMaybe<Scalars['String']['input']>;
  secondary_phone_sms: InputMaybe<Scalars['Boolean']['input']>;
  source: InputMaybe<Scalars['String']['input']>;
  source_other: InputMaybe<Scalars['String']['input']>;
  ssn_last_4: InputMaybe<Scalars['String']['input']>;
  statement_fee_percent: InputMaybe<Scalars['Float']['input']>;
  stripe_bank_account_token: InputMaybe<Scalars['String']['input']>;
  stripe_customer_id: InputMaybe<Scalars['String']['input']>;
  timezone_lookup: InputMaybe<Scalars['TZ']['input']>;
  token: InputMaybe<Scalars['String']['input']>;
  uid: InputMaybe<Scalars['String']['input']>;
  unsubscribe: InputMaybe<Scalars['Boolean']['input']>;
  unsubscribe_token: InputMaybe<Scalars['String']['input']>;
  updated_at: InputMaybe<Scalars['DateTime']['input']>;
  verified: InputMaybe<Scalars['Boolean']['input']>;
  vms_type_id: InputMaybe<Scalars['Int']['input']>;
  vms_user_id: InputMaybe<Scalars['Int']['input']>;
};

export type ValidateJobTimesInput = {
  is_w2: InputMaybe<Scalars['Int']['input']>;
  job_id: InputMaybe<Scalars['Int']['input']>;
  job_times: Array<InputMaybe<Job_Time_Ranges>>;
  professional_id: Scalars['Int']['input'];
};

export type VmsAssignment = {
  __typename?: 'VmsAssignment';
  assignments: Maybe<Array<Maybe<Assignment>>>;
  bullhorn_client_id: Maybe<Scalars['String']['output']>;
  bullhorn_id: Maybe<Scalars['Int']['output']>;
  created_at: Scalars['DateTime']['output'];
  current_data: Maybe<Scalars['JSON']['output']>;
  current_hash: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  manual_data: Scalars['JSON']['output'];
  new_data: Maybe<Scalars['JSON']['output']>;
  new_hash: Maybe<Scalars['String']['output']>;
  reason_assignment_not_created: Maybe<Scalars['String']['output']>;
  updated: Maybe<Scalars['Boolean']['output']>;
  updated_at: Scalars['DateTime']['output'];
  valid_data: Maybe<Scalars['JSON']['output']>;
  vms_external_id: Maybe<Scalars['String']['output']>;
  vms_user: Maybe<VmsUser>;
};

export type VmsAssignmentOrderInput = {
  created_at: InputMaybe<Scalars['Boolean']['input']>;
  current_data: InputMaybe<CurrentDataOrderInput>;
  id: InputMaybe<Scalars['Boolean']['input']>;
  reason_assignment_not_created: InputMaybe<Scalars['Boolean']['input']>;
  updated_at: InputMaybe<Scalars['Boolean']['input']>;
  vms_external_id: InputMaybe<Scalars['Boolean']['input']>;
};

export type VmsAssignmentQueryInput = {
  filter: InputMaybe<VmsAssignmentWhereInput>;
  orderBy: InputMaybe<VmsAssignmentOrderInput>;
  page: InputMaybe<Scalars['Int']['input']>;
  perPage: InputMaybe<Scalars['Int']['input']>;
  search: InputMaybe<VmsAssignmentSearchInput>;
};

export type VmsAssignmentSearchInput = {
  assignments: InputMaybe<Scalars['String']['input']>;
  bullhorn_client_id: InputMaybe<Scalars['String']['input']>;
  bullhorn_id: InputMaybe<Scalars['String']['input']>;
  created_at: InputMaybe<Scalars['DateTime']['input']>;
  id: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  start_date: InputMaybe<Scalars['Date']['input']>;
  updated: InputMaybe<Scalars['Boolean']['input']>;
  updated_at: InputMaybe<Scalars['DateTime']['input']>;
  vms_external_id: InputMaybe<Scalars['String']['input']>;
  vms_type_id: InputMaybe<Scalars['Int']['input']>;
};

export type VmsAssignmentWhereInput = {
  created_at: InputMaybe<Scalars['DateTime']['input']>;
  id: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  reason_assignment_not_created: InputMaybe<Scalars['String']['input']>;
  updated_at: InputMaybe<Scalars['DateTime']['input']>;
  vms_external_id: InputMaybe<Scalars['String']['input']>;
};

export type VmsPosition = {
  __typename?: 'VmsPosition';
  active: Scalars['Boolean']['output'];
  created_at: Scalars['DateTime']['output'];
  id: Scalars['Int']['output'];
  label: Maybe<Scalars['String']['output']>;
  position: Maybe<Position>;
  position_id: Maybe<Scalars['Int']['output']>;
  updated_at: Scalars['DateTime']['output'];
  vms_category_id: Maybe<Scalars['String']['output']>;
  vms_source_id: Maybe<Scalars['String']['output']>;
  vms_type: Maybe<VmsType>;
  vms_type_id: Maybe<Scalars['Int']['output']>;
};

export type VmsPositionOrderInput = {
  created_at: InputMaybe<Scalars['Boolean']['input']>;
  id: InputMaybe<Scalars['Boolean']['input']>;
  label: InputMaybe<Scalars['Boolean']['input']>;
  position_id: InputMaybe<Scalars['Boolean']['input']>;
  updated_at: InputMaybe<Scalars['Boolean']['input']>;
  vms_category_id: InputMaybe<Scalars['Boolean']['input']>;
  vms_source_id: InputMaybe<Scalars['Boolean']['input']>;
  vms_type_id: InputMaybe<Scalars['Boolean']['input']>;
};

export type VmsPositionQueryInput = {
  filter: InputMaybe<VmsPositionWhereInput>;
  orderBy: InputMaybe<VmsPositionOrderInput>;
  page: InputMaybe<Scalars['Int']['input']>;
  perPage: InputMaybe<Scalars['Int']['input']>;
  search: InputMaybe<DefaultSearchInput>;
};

export type VmsPositionWhereInput = {
  active: InputMaybe<Scalars['Boolean']['input']>;
  created_at: InputMaybe<Scalars['DateTime']['input']>;
  id: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  label: InputMaybe<Scalars['String']['input']>;
  position_id: InputMaybe<Scalars['Int']['input']>;
  updated_at: InputMaybe<Scalars['DateTime']['input']>;
  vms_category_id: InputMaybe<Scalars['String']['input']>;
  vms_source_id: InputMaybe<Scalars['String']['input']>;
  vms_type_id: InputMaybe<Scalars['Int']['input']>;
};

export type VmsType = {
  __typename?: 'VmsType';
  billable_orientation_hours: Maybe<Scalars['Float']['output']>;
  bullhorn_id: Maybe<Scalars['String']['output']>;
  companies: Maybe<Array<Maybe<Company>>>;
  created_at: Scalars['DateTime']['output'];
  fee_percent: Scalars['Float']['output'];
  id: Scalars['Int']['output'];
  label: Maybe<Scalars['String']['output']>;
  name: Maybe<Scalars['String']['output']>;
  non_billable_orientation_burden_hours: Maybe<Scalars['Float']['output']>;
  updated_at: Scalars['DateTime']['output'];
  users: Maybe<Array<Maybe<User>>>;
  vms_assgignments: Maybe<Array<Maybe<VmsAssignment>>>;
  vms_positions: Maybe<Array<Maybe<VmsPosition>>>;
};

export type VmsTypeOrderInput = {
  created_at: InputMaybe<Scalars['Boolean']['input']>;
  id: InputMaybe<Scalars['Boolean']['input']>;
  label: InputMaybe<Scalars['Boolean']['input']>;
  name: InputMaybe<Scalars['Boolean']['input']>;
  updated_at: InputMaybe<Scalars['Boolean']['input']>;
};

export type VmsTypeQueryInput = {
  filter: InputMaybe<VmsTypeWhereInput>;
  orderBy: InputMaybe<VmsTypeOrderInput>;
  page: InputMaybe<Scalars['Int']['input']>;
  perPage: InputMaybe<Scalars['Int']['input']>;
  search: InputMaybe<DefaultSearchInput>;
};

export type VmsTypeWhereInput = {
  bullhorn_id: InputMaybe<Scalars['String']['input']>;
  created_at: InputMaybe<Scalars['DateTime']['input']>;
  id: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  label: InputMaybe<Scalars['String']['input']>;
  name: InputMaybe<Scalars['String']['input']>;
  updated_at: InputMaybe<Scalars['DateTime']['input']>;
};

export type VmsUser = {
  __typename?: 'VmsUser';
  bullhorn_id: Maybe<Scalars['String']['output']>;
  created_at: Scalars['DateTime']['output'];
  current_data: Maybe<Scalars['JSON']['output']>;
  current_hash: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  locations: Maybe<Array<Maybe<Location>>>;
  manual_data: Maybe<Scalars['JSON']['output']>;
  new_data: Maybe<Scalars['JSON']['output']>;
  new_hash: Maybe<Scalars['String']['output']>;
  updated: Maybe<Scalars['Boolean']['output']>;
  updated_at: Scalars['DateTime']['output'];
  users: Maybe<Array<Maybe<User>>>;
  valid_data: Maybe<Scalars['JSON']['output']>;
  vms_external_id: Maybe<Scalars['String']['output']>;
  vms_type: Maybe<VmsType>;
  vms_type_id: Maybe<Scalars['Int']['output']>;
};

export type VmsUserOrderInput = {
  created_at: InputMaybe<Scalars['Boolean']['input']>;
  id: InputMaybe<Scalars['Boolean']['input']>;
  updated_at: InputMaybe<Scalars['Boolean']['input']>;
  vms_external_id: InputMaybe<Scalars['Boolean']['input']>;
  vms_type_id: InputMaybe<Scalars['Boolean']['input']>;
};

export type VmsUserQueryInput = {
  filter: InputMaybe<VmsUserWhereInput>;
  orderBy: InputMaybe<VmsUserOrderInput>;
  page: InputMaybe<Scalars['Int']['input']>;
  perPage: InputMaybe<Scalars['Int']['input']>;
  search: InputMaybe<VmsUserSearchInput>;
};

export type VmsUserSearchInput = {
  bullhorn_id: InputMaybe<Scalars['String']['input']>;
  created_at: InputMaybe<Scalars['DateTime']['input']>;
  id: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  start_date: InputMaybe<Scalars['Date']['input']>;
  updated: InputMaybe<Scalars['Boolean']['input']>;
  updated_at: InputMaybe<Scalars['DateTime']['input']>;
  vms_external_id: InputMaybe<Scalars['String']['input']>;
  vms_position: InputMaybe<Scalars['String']['input']>;
  vms_status: InputMaybe<Scalars['String']['input']>;
  vms_type_id: InputMaybe<Scalars['Int']['input']>;
};

export type VmsUserWhereInput = {
  bullhorn_id: InputMaybe<Scalars['String']['input']>;
  created_at: InputMaybe<Scalars['DateTime']['input']>;
  id: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  updated_at: InputMaybe<Scalars['DateTime']['input']>;
  vms_external_id: InputMaybe<Scalars['String']['input']>;
  vms_type_id: InputMaybe<Scalars['Int']['input']>;
};

export type WageLog = {
  __typename?: 'WageLog';
  city: Maybe<Scalars['String']['output']>;
  created_at: Scalars['DateTime']['output'];
  hourly_rate_cents: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  market: Maybe<Market>;
  market_id: Maybe<Scalars['Int']['output']>;
  position: Maybe<Position>;
  position_id: Maybe<Scalars['Int']['output']>;
  professional: Professional;
  professional_id: Scalars['Int']['output'];
  state: Maybe<State>;
  state_id: Maybe<Scalars['Int']['output']>;
  updated_at: Scalars['DateTime']['output'];
  work_history: Maybe<WorkHistory>;
  work_history_id: Maybe<Scalars['Int']['output']>;
  zip_code: Scalars['String']['output'];
};

export type WageLogOrderInput = {
  city: InputMaybe<Scalars['Boolean']['input']>;
  created_at: InputMaybe<Scalars['Boolean']['input']>;
  hourly_rate_cents: InputMaybe<Scalars['Boolean']['input']>;
  id: InputMaybe<Scalars['Boolean']['input']>;
  market_id: InputMaybe<Scalars['Boolean']['input']>;
  position_id: InputMaybe<Scalars['Boolean']['input']>;
  professional_id: InputMaybe<Scalars['Boolean']['input']>;
  state_id: InputMaybe<Scalars['Boolean']['input']>;
  updated_at: InputMaybe<Scalars['Boolean']['input']>;
  work_history_id: InputMaybe<Scalars['Boolean']['input']>;
  zip_code: InputMaybe<Scalars['Boolean']['input']>;
};

export type WageLogQueryInput = {
  filter: InputMaybe<WageLogWhereInput>;
  orderBy: InputMaybe<WageLogOrderInput>;
  page: InputMaybe<Scalars['Int']['input']>;
  perPage: InputMaybe<Scalars['Int']['input']>;
  search: InputMaybe<WageLogSearchInput>;
};

export type WageLogSearchInput = {
  professional_account_id: InputMaybe<Scalars['Int']['input']>;
};

export type WageLogWhereInput = {
  city: InputMaybe<Scalars['String']['input']>;
  created_at: InputMaybe<Scalars['DateTime']['input']>;
  hourly_rate_cents: InputMaybe<Scalars['Int']['input']>;
  id: InputMaybe<Array<Scalars['Int']['input']>>;
  market_id: InputMaybe<Scalars['Int']['input']>;
  position_id: InputMaybe<Scalars['Int']['input']>;
  professional_id: InputMaybe<Scalars['Int']['input']>;
  state_id: InputMaybe<Scalars['Int']['input']>;
  updated_at: InputMaybe<Scalars['DateTime']['input']>;
  work_history_id: InputMaybe<Scalars['Int']['input']>;
  zip_code: InputMaybe<Scalars['String']['input']>;
};

export type WeeklyTimecardsTotals = {
  __typename?: 'WeeklyTimecardsTotals';
  breaks_hours: Maybe<Scalars['Int']['output']>;
  hours: Maybe<Scalars['Int']['output']>;
  start_of_week: Maybe<Scalars['DateTime']['output']>;
};

export type WeeklyTimecardsTotalsFilter = {
  ignored_job_id: InputMaybe<Scalars['Int']['input']>;
};

export type WeeklyTimecardsTotalsInput = {
  filter: InputMaybe<WeeklyTimecardsTotalsFilter>;
  search: InputMaybe<WeeklyTimecardsTotalsSearch>;
};

export type WeeklyTimecardsTotalsSearch = {
  professional_id: InputMaybe<Scalars['Int']['input']>;
  starts_time_from: InputMaybe<Scalars['DateTime']['input']>;
  starts_time_to: InputMaybe<Scalars['DateTime']['input']>;
};

export type WorkGap = {
  __typename?: 'WorkGap';
  created_at: Scalars['DateTime']['output'];
  end_date: Maybe<Scalars['Date']['output']>;
  explanation: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  include_in_work_histories: Scalars['Boolean']['output'];
  location: Maybe<Scalars['String']['output']>;
  professional_id: Maybe<Scalars['Int']['output']>;
  professional_profile: Maybe<ProfessionalProfile>;
  professional_profile_id: Maybe<Scalars['Int']['output']>;
  start_date: Maybe<Scalars['Date']['output']>;
  state: Maybe<State>;
  state_id: Maybe<Scalars['Int']['output']>;
  updated_at: Scalars['DateTime']['output'];
};

export type WorkGapOrderInput = {
  id: InputMaybe<Scalars['Boolean']['input']>;
  professional_profile_id: InputMaybe<Scalars['Boolean']['input']>;
  start_date: InputMaybe<Scalars['Boolean']['input']>;
};

export type WorkGapQueryInput = {
  filter: InputMaybe<WorkGapWhereInput>;
  orderBy: InputMaybe<WorkGapOrderInput>;
  page: InputMaybe<Scalars['Int']['input']>;
  perPage: InputMaybe<Scalars['Int']['input']>;
  search: InputMaybe<WorkGapSearchInput>;
};

export type WorkGapSearchInput = {
  location_ids: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  professional_account_id: InputMaybe<Scalars['Int']['input']>;
};

export type WorkGapWhereInput = {
  created_at: InputMaybe<Scalars['DateTime']['input']>;
  explanation: InputMaybe<Scalars['String']['input']>;
  id: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  professional_id: InputMaybe<Scalars['Int']['input']>;
  professional_profile_id: InputMaybe<Scalars['Int']['input']>;
  updated_at: InputMaybe<Scalars['DateTime']['input']>;
};

export type WorkHistory = {
  __typename?: 'WorkHistory';
  clinical: Scalars['Boolean']['output'];
  created_at: Scalars['DateTime']['output'];
  currently_work_here: Scalars['Boolean']['output'];
  description: Maybe<Scalars['String']['output']>;
  employment_type: Maybe<Scalars['Int']['output']>;
  end_date: Maybe<Scalars['Date']['output']>;
  floating: Maybe<Scalars['Boolean']['output']>;
  floating_details: Maybe<Scalars['String']['output']>;
  has_missing_information: Scalars['Boolean']['output'];
  hours_per_week: Maybe<Scalars['Float']['output']>;
  id: Scalars['Int']['output'];
  location: Maybe<Scalars['String']['output']>;
  location_is_teaching: Maybe<Scalars['Boolean']['output']>;
  location_name: Maybe<Scalars['String']['output']>;
  location_number_of_beds: Maybe<Scalars['Int']['output']>;
  location_trauma_level: Maybe<Scalars['String']['output']>;
  location_type: Maybe<LocationType>;
  location_type_id: Maybe<Scalars['Int']['output']>;
  missing_information_list: Array<Maybe<Scalars['String']['output']>>;
  organization_name: Maybe<Scalars['String']['output']>;
  position: Maybe<Position>;
  position_id: Maybe<Scalars['Int']['output']>;
  position_title: Maybe<Scalars['String']['output']>;
  professional_id: Maybe<Scalars['Int']['output']>;
  professional_profile: Maybe<ProfessionalProfile>;
  start_date: Maybe<Scalars['Date']['output']>;
  state: Maybe<State>;
  state_id: Maybe<Scalars['Int']['output']>;
  travel: Scalars['Boolean']['output'];
  travel_agency: Maybe<Scalars['String']['output']>;
  unit: Maybe<Scalars['String']['output']>;
  updated_at: Scalars['DateTime']['output'];
  wage_logs: Array<WageLog>;
};

export type WorkHistoryOrderInput = {
  created_at: InputMaybe<Scalars['Boolean']['input']>;
  currently_work_here: InputMaybe<Scalars['Boolean']['input']>;
  description: InputMaybe<Scalars['Boolean']['input']>;
  end_date: InputMaybe<Scalars['Boolean']['input']>;
  facility_type_id: InputMaybe<Scalars['Boolean']['input']>;
  id: InputMaybe<Scalars['Boolean']['input']>;
  location: InputMaybe<Scalars['Boolean']['input']>;
  organization_name: InputMaybe<Scalars['Boolean']['input']>;
  position_title: InputMaybe<Scalars['Boolean']['input']>;
  professional_profile_id: InputMaybe<Scalars['Boolean']['input']>;
  start_date: InputMaybe<Scalars['Boolean']['input']>;
  state_id: InputMaybe<Scalars['Boolean']['input']>;
  travel: InputMaybe<Scalars['Boolean']['input']>;
  unit: InputMaybe<Scalars['Boolean']['input']>;
  updated_at: InputMaybe<Scalars['Boolean']['input']>;
};

export type WorkHistoryQueryInput = {
  filter: InputMaybe<WorkHistoryWhereInput>;
  orderBy: InputMaybe<WorkHistoryOrderInput>;
  page: InputMaybe<Scalars['Int']['input']>;
  perPage: InputMaybe<Scalars['Int']['input']>;
  search: InputMaybe<WorkHistorySearchInput>;
};

export type WorkHistorySearchInput = {
  location_ids: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  professional_account_id: InputMaybe<Scalars['Int']['input']>;
};

export type WorkHistoryWhereInput = {
  created_at: InputMaybe<Scalars['DateTime']['input']>;
  currently_work_here: InputMaybe<Scalars['Boolean']['input']>;
  description: InputMaybe<Scalars['String']['input']>;
  end_date: InputMaybe<Scalars['Date']['input']>;
  facility_type_id: InputMaybe<Scalars['Int']['input']>;
  id: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  location: InputMaybe<Scalars['String']['input']>;
  organization_name: InputMaybe<Scalars['String']['input']>;
  position_title: InputMaybe<Scalars['String']['input']>;
  professional_id: InputMaybe<Scalars['Int']['input']>;
  professional_profile_id: InputMaybe<Scalars['Int']['input']>;
  start_date: InputMaybe<Scalars['Date']['input']>;
  state_id: InputMaybe<Scalars['Int']['input']>;
  travel: InputMaybe<Scalars['Boolean']['input']>;
  unit: InputMaybe<Scalars['String']['input']>;
  updated_at: InputMaybe<Scalars['DateTime']['input']>;
};

export type Expiring_Conditions_Input = {
  professional_id: Scalars['Int']['input'];
};

export type Job_Time_Ranges = {
  ends_time: Scalars['DateTime']['input'];
  starts_time: Scalars['DateTime']['input'];
};

export type Missing_Conditions_Input = {
  assignment_id: InputMaybe<Scalars['Int']['input']>;
  for_application: Scalars['Boolean']['input'];
  for_on_boarding: Scalars['Boolean']['input'];
  for_premier_only: InputMaybe<Scalars['Boolean']['input']>;
  is_w2: InputMaybe<Scalars['Boolean']['input']>;
  job_id: InputMaybe<Scalars['Int']['input']>;
  position_ids: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  professional_account_id: InputMaybe<Scalars['Int']['input']>;
  professional_id: Scalars['Int']['input'];
  specialty_ids: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};

export type Required_Conditions_Input = {
  for_application: Scalars['Boolean']['input'];
  for_on_boarding: Scalars['Boolean']['input'];
  is_w2: Scalars['Boolean']['input'];
  position_ids: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  professional_id: Scalars['Int']['input'];
  specialty_ids: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};

export type ApprovalActionsFragment = (
  { __typename?: 'Job', id: number, created_by: { __typename?: 'Account', name: string | null } | null }
  & { ' $fragmentRefs'?: { 'ApprovalMutationFragment': ApprovalMutationFragment } }
) & { ' $fragmentName'?: 'ApprovalActionsFragment' };

export type ApproversListFragment = { __typename?: 'Approval', approval_rule_id: number, rejection_reason: string | null, status: ApprovalStatus, tier: number, approval_groups: Array<{ __typename?: 'ApprovalGroup', accounts: Array<{ __typename?: 'Account', id: number, name: string | null }> }>, approver_account: { __typename?: 'Account', id: number, name: string | null } | null } & { ' $fragmentName'?: 'ApproversListFragment' };

export type DisputeFormFragment = (
  { __typename?: 'Job', approved_clock_in: string | null, approved_clock_out: string | null, id: number, track_unpaid_breaks: boolean, job_billing_sums: { __typename?: 'JobBillingSum', total_breaks_minutes: number | null } | null, location: { __typename?: 'Location', timezone_lookup: string | null } | null }
  & { ' $fragmentRefs'?: { 'DisputeFormContentFragment': DisputeFormContentFragment;'ValidateFormFragment': ValidateFormFragment } }
) & { ' $fragmentName'?: 'DisputeFormFragment' };

export type ClockOutHelperTextFragment = { __typename?: 'Job', approved_clock_out: string | null, ends_time: string | null, job_irregularities: Array<{ __typename?: 'JobIrregularity', irregularity_type: string }> } & { ' $fragmentName'?: 'ClockOutHelperTextFragment' };

export type DisputeFormContentFragment = (
  { __typename?: 'Job', approved_clock_in: string | null, ends_time: string | null, starts_date: any | null, starts_time: string | null, status: JobStatus | null, location: { __typename?: 'Location', timezone_lookup: string | null } | null, professional: { __typename?: 'Professional', name: string | null } | null }
  & { ' $fragmentRefs'?: { 'DisputeFormDisplayHelpersFragment': DisputeFormDisplayHelpersFragment;'ClockOutHelperTextFragment': ClockOutHelperTextFragment } }
) & { ' $fragmentName'?: 'DisputeFormContentFragment' };

export type DisputeFormDisplayHelpersFragment = { __typename?: 'Job', status: JobStatus | null, track_unpaid_breaks: boolean, job_irregularities: Array<{ __typename?: 'JobIrregularity', irregularity_type: string }> } & { ' $fragmentName'?: 'DisputeFormDisplayHelpersFragment' };

export type ValidateFormFragment = (
  { __typename?: 'Job', approved_clock_in: string | null, approved_clock_out: string | null, job_billing_sums: { __typename?: 'JobBillingSum', total_breaks_minutes: number | null } | null, location: { __typename?: 'Location', timezone_lookup: string | null } | null }
  & { ' $fragmentRefs'?: { 'DisputeFormDisplayHelpersFragment': DisputeFormDisplayHelpersFragment } }
) & { ' $fragmentName'?: 'ValidateFormFragment' };

export type CancelDisputeButtonContainerFragment = { __typename?: 'Job', id: number } & { ' $fragmentName'?: 'CancelDisputeButtonContainerFragment' };

export type DetailsTitleFragment = { __typename?: 'Job', approval_status: ApprovalStatus | null, status: JobStatus | null, professional: (
    { __typename?: 'Professional', kind: string, nickname: string | null, account: { __typename?: 'Account', first_name: string | null, last_name: string | null } | null }
    & { ' $fragmentRefs'?: { 'BlockFavoriteButtonsFragment': BlockFavoriteButtonsFragment;'BlockFavoriteMenuFragment': BlockFavoriteMenuFragment } }
  ) | null } & { ' $fragmentName'?: 'DetailsTitleFragment' };

export type DisputableDetailsSectionFragment = { __typename?: 'Job', status: JobStatus | null } & { ' $fragmentName'?: 'DisputableDetailsSectionFragment' };

export type DisputeButtonsContainerFragment = (
  { __typename?: 'Job', approved_clock_in: string | null, id: number, status: JobStatus | null, job_irregularities: Array<{ __typename?: 'JobIrregularity', approved_by_account_id: number | null, status: string }>, location: { __typename?: 'Location', company_id: number | null } | null }
  & { ' $fragmentRefs'?: { 'DisputeModalFragment': DisputeModalFragment } }
) & { ' $fragmentName'?: 'DisputeButtonsContainerFragment' };

export type DisputeModalFragment = (
  { __typename?: 'Job', id: number, status: JobStatus | null, job_irregularities: Array<{ __typename?: 'JobIrregularity', label: string }> }
  & { ' $fragmentRefs'?: { 'DisputeFormFragment': DisputeFormFragment } }
) & { ' $fragmentName'?: 'DisputeModalFragment' };

export type JobApprovalDetailsFragment = (
  { __typename?: 'Job', approval_requestee_notes: string | null, approval_status: ApprovalStatus | null, approval_violated_parameters: Record<string, any> | null, id: number, status: JobStatus | null, approvals: Array<(
    { __typename?: 'Approval', status: ApprovalStatus, approval_groups: Array<{ __typename?: 'ApprovalGroup', accounts: Array<{ __typename?: 'Account', id: number, name: string | null }> }> }
    & { ' $fragmentRefs'?: { 'ApproversListFragment': ApproversListFragment } }
  )>, marketplace_job_profile: { __typename?: 'JobProfile', charge_base_hourly_rate_cents: number } | null }
  & { ' $fragmentRefs'?: { 'ApprovalActionsFragment': ApprovalActionsFragment } }
) & { ' $fragmentName'?: 'JobApprovalDetailsFragment' };

export type JobDetailsFragment = (
  { __typename?: 'Job', approval_status: ApprovalStatus | null, approved_clock_in: string | null, assignment_id: number | null, bonus_one_time_cents: number | null, charge_base_hourly_rate_cents: number | null, charge_on_call_hourly_rate_cents: number | null, created_at: string, current_ends_time: string | null, current_starts_time: string | null, detail: string | null, id: number, location_id: number | null, marketplace_bonus_one_time_cents: number | null, marketplace_charge_base_hourly_rate_cents: number | null, professional_id: number | null, release_audience: string, shift_type: string | null, starts_date: any | null, starts_time: string | null, status: JobStatus | null, location: { __typename?: 'Location', name: string | null, timezone_lookup: string | null, agencies: Array<{ __typename?: 'Agency', id: number } | null> | null } | null, positions: Array<{ __typename?: 'Position', display_name: string | null, id: number } | null> | null, specialties: Array<{ __typename?: 'Specialty', label: string | null } | null> | null }
  & { ' $fragmentRefs'?: { 'CancelJobModalFragment': CancelJobModalFragment;'DetailsTitleFragment': DetailsTitleFragment;'JobStatusActionsFragment': JobStatusActionsFragment;'PostedBySectionFragment': PostedBySectionFragment } }
) & { ' $fragmentName'?: 'JobDetailsFragment' };

export type JobDetailsLayoutFragment = (
  { __typename?: 'Job', approval_status: ApprovalStatus | null, status: JobStatus | null, approvals: Array<{ __typename?: 'Approval', id: number }> }
  & { ' $fragmentRefs'?: { 'JobApprovalDetailsFragment': JobApprovalDetailsFragment;'JobDetailsFragment': JobDetailsFragment;'TimesheetDetailsFragment': TimesheetDetailsFragment } }
) & { ' $fragmentName'?: 'JobDetailsLayoutFragment' };

export type JobStatusActionsFragment = (
  { __typename?: 'Job', approval_status: ApprovalStatus | null, ends_time: string | null, id: number, shift_type: string | null, starts_time: string | null, status: JobStatus | null, location: { __typename?: 'Location', timezone_lookup: string | null } | null, professional: { __typename?: 'Professional', id: number } | null }
  & { ' $fragmentRefs'?: { 'AddClockInDialogFragment': AddClockInDialogFragment;'ContactButtonFragment': ContactButtonFragment;'EditShiftTimeDialogFragment': EditShiftTimeDialogFragment } }
) & { ' $fragmentName'?: 'JobStatusActionsFragment' };

export type PostedBySectionFragment = { __typename?: 'Job', status: JobStatus | null, created_by: { __typename?: 'Account', account_type: string, name: string | null } | null, job_irregularities: Array<{ __typename?: 'JobIrregularity', irregularity_type: string }> } & { ' $fragmentName'?: 'PostedBySectionFragment' };

export type RegularHoursSectionFragment = { __typename?: 'Job', charge_overtime_multiplier: number | null, job_price_differentials: Array<{ __typename?: 'JobPriceDifferential', recommendation_used: boolean, slug: string } | null> | null, job_billing_sums: { __typename?: 'JobBillingSum', charge_overtime_amount_cents: number | null, charge_overtime_hours: number | null, charge_regular_amount_cents: number | null, charge_regular_hours: number | null } | null } & { ' $fragmentName'?: 'RegularHoursSectionFragment' };

export type TimesheetDetailsClockEventAttachmentFragment = { __typename?: 'ClockEventAttachment', clock_event_id: number, clock_event_type: string, created_at: string, file: any | null, id: number, metadata: Record<string, any> | null, reasons: Record<string, any> | null, updated_at: string } & { ' $fragmentName'?: 'TimesheetDetailsClockEventAttachmentFragment' };

export type TimesheetDetailsFragment = (
  { __typename?: 'Job', approved_clock_in: string | null, approved_clock_out: string | null, assignment_id: number | null, attachment: any | null, ends_time: string | null, id: number, is_w2: boolean | null, starts_date: any | null, starts_time: string | null, status: JobStatus | null, track_unpaid_breaks: boolean, check_ins: Array<{ __typename?: 'CheckIn', clock_event_attachments: Array<(
      { __typename?: 'ClockEventAttachment', file: any | null, metadata: Record<string, any> | null, reasons: Record<string, any> | null }
      & { ' $fragmentRefs'?: { 'TimesheetDetailsClockEventAttachmentFragment': TimesheetDetailsClockEventAttachmentFragment } }
    ) | null> | null } | null> | null, check_outs: Array<{ __typename?: 'CheckOut', clock_event_attachments: Array<(
      { __typename?: 'ClockEventAttachment', file: any | null, metadata: Record<string, any> | null, reasons: Record<string, any> | null }
      & { ' $fragmentRefs'?: { 'TimesheetDetailsClockEventAttachmentFragment': TimesheetDetailsClockEventAttachmentFragment } }
    ) | null> | null } | null> | null, job_billing_sums: { __typename?: 'JobBillingSum', charge_callback_hours: number | null, charge_double_hours: number | null, charge_overtime_hours: number | null, charge_total_amount_cents: number | null, total_breaks_minutes: number | null, total_hours: number | null, total_on_call_hours: number | null } | null, job_irregularities: Array<{ __typename?: 'JobIrregularity', label: string }>, location: { __typename?: 'Location', enable_geo_fence: boolean, require_upload_on_clock_out: boolean, timezone_lookup: string | null } | null, positions: Array<{ __typename?: 'Position', display_name: string | null } | null> | null, specialties: Array<{ __typename?: 'Specialty', label: string | null } | null> | null }
  & { ' $fragmentRefs'?: { 'DetailsTitleFragment': DetailsTitleFragment;'DisputableDetailsSectionFragment': DisputableDetailsSectionFragment;'PostedBySectionFragment': PostedBySectionFragment;'RegularHoursSectionFragment': RegularHoursSectionFragment;'TimesheetDetailsButtonFragment': TimesheetDetailsButtonFragment } }
) & { ' $fragmentName'?: 'TimesheetDetailsFragment' };

export type TimesheetDetailsButtonFragment = (
  { __typename?: 'Job', status: JobStatus | null }
  & { ' $fragmentRefs'?: { 'CancelDisputeButtonContainerFragment': CancelDisputeButtonContainerFragment;'DisputeButtonsContainerFragment': DisputeButtonsContainerFragment } }
) & { ' $fragmentName'?: 'TimesheetDetailsButtonFragment' };

export type ExperienceFragment = { __typename?: 'Professional', dob: any | null, has_active_jobs_here: boolean | null, id: number, shifts_completed: number | null, shifts_completed_here: number | null, years_experience: number | null, account: { __typename?: 'Account', email: string, phone_number: string | null, ssn_last_4: string | null } | null, positions: Array<{ __typename?: 'Position', id: number, display_name: string | null } | null> | null, specialties: Array<{ __typename?: 'Specialty', active: boolean, label: string | null, positions: Array<{ __typename?: 'Position', id: number } | null> | null } | null> | null } & { ' $fragmentName'?: 'ExperienceFragment' };

export type GetJobForTopBarRightContentQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type GetJobForTopBarRightContentQuery = { __typename?: 'Query', job: { __typename?: 'Job', assignment_id: number | null, id: number, status: JobStatus | null } | null };

export type GetAssignmentForTopBarTitleBackQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type GetAssignmentForTopBarTitleBackQuery = { __typename?: 'Query', assignment: { __typename?: 'Assignment', ends_date: any | null, id: number, is_extension: boolean | null, professional: { __typename?: 'Professional', id: number, account: { __typename?: 'Account', name: string | null, id: number } | null } | null } | null };

export type GetJobForTopBarTitleBackQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type GetJobForTopBarTitleBackQuery = { __typename?: 'Query', job: { __typename?: 'Job', id: number, professional: { __typename?: 'Professional', account: { __typename?: 'Account', name: string | null } | null } | null } | null };

export type GetApplicationForTopBarTitleBackQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type GetApplicationForTopBarTitleBackQuery = { __typename?: 'Query', assignmentRequest: { __typename?: 'AssignmentRequest', id: number, professional: { __typename?: 'Professional', account: { __typename?: 'Account', name: string | null } | null } | null } | null };

export type StatsigSetupQueryVariables = Exact<{
  locationInput: InputMaybe<LocationQueryInput>;
  billingInput: InputMaybe<BillingGroupQueryInput>;
}>;


export type StatsigSetupQuery = { __typename?: 'Query', activeBillingGroups: Array<{ __typename?: 'BillingGroup', id: number } | null> | null, activeLocations: Array<{ __typename?: 'Location', id: number, location_type_id: number, market_id: number | null } | null> | null, me: { __typename?: 'Account', company_id: number | null, email: string, id: number } | null };

export type GetJobCountForStatsigQueryVariables = Exact<{
  input: InputMaybe<JobQueryInput>;
}>;


export type GetJobCountForStatsigQuery = { __typename?: 'Query', jobCount: { __typename?: 'ListMeta', count: number | null } | null };

export type GetSchemaPermissionsForRequestsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetSchemaPermissionsForRequestsQuery = { __typename?: 'Query', accountRequestPermissions: Record<string, any> | null };

export type ApprovalMutationFragment = { __typename?: 'Job', id: number, approvals: Array<{ __typename?: 'Approval', id: number, status: ApprovalStatus }> } & { ' $fragmentName'?: 'ApprovalMutationFragment' };

export type DashboardAssignmentsPanelEndingSoonQueryVariables = Exact<{ [key: string]: never; }>;


export type DashboardAssignmentsPanelEndingSoonQuery = { __typename?: 'Query', assignmentsEndingSoon: Array<{ __typename?: 'AssignmentPanelCount', count: number, location: { __typename?: 'Location', id: number, name: string | null } }> | null };

export type DashboardAssignmentsPanelStartingSoonQueryVariables = Exact<{ [key: string]: never; }>;


export type DashboardAssignmentsPanelStartingSoonQuery = { __typename?: 'Query', assignmentsStartingSoon: Array<{ __typename?: 'AssignmentPanelCount', count: number, location: { __typename?: 'Location', id: number, name: string | null } }> | null };

export type EhrSystemQueryVariables = Exact<{
  input: InputMaybe<EhrSystemQueryInput>;
}>;


export type EhrSystemQuery = { __typename?: 'Query', ehrSystems: Array<{ __typename?: 'EhrSystem', id: number, label: string | null } | null> | null };

export type FavoritesPanelRowsQueryVariables = Exact<{ [key: string]: never; }>;


export type FavoritesPanelRowsQuery = { __typename?: 'Query', favoritesPanelRows: Array<{ __typename?: 'FavoritesPanelRow', job_id: number, starts_date: any, starts_time: string, location_name: string, location_id: number, professional_id: number, professional_name: string, is_favorited: boolean, is_blocked: boolean, positions: Array<{ __typename?: 'Position', id: number, display_name: string | null }> }> };

export type JobLocationSyncFragment = { __typename?: 'Job', assignment_id: number | null, id: number, location_id: number | null, professional_id: number | null, shift_type: string | null, status: JobStatus | null, assignment: { __typename?: 'Assignment', id: number } | null, location: { __typename?: 'Location', id: number } | null, professional: { __typename?: 'Professional', id: number } | null } & { ' $fragmentName'?: 'JobLocationSyncFragment' };

export type MetabaseEmbedQueryVariables = Exact<{
  input: InputMaybe<MetabaseEmbedQueryInput>;
}>;


export type MetabaseEmbedQuery = { __typename?: 'Query', metabaseEmbedUrl: { __typename?: 'MetabaseEmbed', signed_token: string | null } | null };

export type DashboardQueryVariables = Exact<{ [key: string]: never; }>;


export type DashboardQuery = { __typename?: 'Query', newApplicantCount: Array<{ __typename?: 'AssignmentPanelCount', count: number, location: { __typename?: 'Location', id: number, name: string | null } }> | null };

export type ProfessionalQueryVariables = Exact<{
  id: Scalars['Int']['input'];
  location_id: Scalars['Int']['input'];
  location_ids: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
}>;


export type ProfessionalQuery = { __typename?: 'Query', poolProfessional: { __typename?: 'Professional', created_at: string, dob: any | null, has_active_jobs_here: boolean | null, id: number, is_blocked: boolean | null, is_favorite: boolean | null, kinds: Array<string>, shifts_completed: number | null, shifts_completed_here: number | null, status: string, years_experience: number | null, account: { __typename?: 'Account', company_id: number | null, email: string, first_name: string | null, id: number, last_name: string | null, name: string | null, phone_number: string | null, ssn_last_4: string | null, locations: Array<{ __typename?: 'Location', id: number, name: string | null } | null> | null, primary_locations: Array<{ __typename?: 'Location', id: number } | null> | null } | null, background_checks: Array<{ __typename?: 'BackgroundCheck', completed_on: string | null } | null> | null, emergency_contacts: Array<{ __typename?: 'EmergencyContact', id: number, first_name: string | null, last_name: string | null, phone_number: string | null } | null> | null, positions: Array<{ __typename?: 'Position', id: number, kind: string | null, display_name: string | null } | null> | null, professional_saas_details: Array<{ __typename?: 'ProfessionalSaasDetail', id: number, max_weekly_hours: number | null, hourly_rate_cents: number | null, shift_types: Record<string, any> | null, employment_type: string } | null> | null, professional_qualifications: Array<{ __typename?: 'ProfessionalQualification', id: number, status: string, professional_qualification_attributes: Array<{ __typename?: 'ProfessionalQualificationAttribute', value: any, qualification_attribute: { __typename?: 'QualificationAttribute', slug: string | null, name: string | null } | null } | null> | null } | null> | null, specialties: Array<{ __typename?: 'Specialty', id: number, active: boolean, name: string | null, label: string | null, positions: Array<{ __typename?: 'Position', id: number } | null> | null } | null> | null } | null };

export type OnboardingProfessionalsQueryVariables = Exact<{
  input: InputMaybe<ProfessionalPoolQueryInput>;
  location_ids: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
}>;


export type OnboardingProfessionalsQuery = { __typename?: 'Query', poolProfessionals: Array<{ __typename?: 'Professional', id: number, years_experience: number | null, account: { __typename?: 'Account', name: string | null } | null, positions: Array<{ __typename?: 'Position', display_name: string | null } | null> | null, professional_qualifications: Array<{ __typename?: 'ProfessionalQualification', status: string, professional_qualification_attributes: Array<{ __typename?: 'ProfessionalQualificationAttribute', value: any, qualification_attribute: { __typename?: 'QualificationAttribute', name: string | null, slug: string | null } | null } | null> | null } | null> | null } | null> | null, _poolProfessionalsMeta: { __typename?: 'ListMeta', count: number | null } | null };

export type WeeklyTimecardTotalsQueryVariables = Exact<{
  input: InputMaybe<WeeklyTimecardsTotalsInput>;
}>;


export type WeeklyTimecardTotalsQuery = { __typename?: 'Query', weeklyTimecardsTotals: Array<{ __typename?: 'WeeklyTimecardsTotals', hours: number | null, start_of_week: string | null }> };

export type GatewayBillingGroupQueryVariables = Exact<{
  uid: Scalars['String']['input'];
}>;


export type GatewayBillingGroupQuery = { __typename?: 'Query', gatewayBillingGroup: { __typename?: 'BillingGroup', id: number, name: string | null, balance_cents: number, total_due_cents: number | null, ach_source_detail: any | null, company: { __typename?: 'Company', name: string }, funding_sources: Array<{ __typename?: 'FundingSource', id: number, brand: string | null, last4: string | null, bank_name: string | null, active: boolean | null, status: string | null } | null> | null } | null };

export type GetGatewayInvoiceQueryVariables = Exact<{
  billing_id: Scalars['String']['input'];
}>;


export type GetGatewayInvoiceQuery = { __typename?: 'Query', gatewayInvoice: { __typename?: 'Invoice', id: number, billing_id: string | null, due_date: any | null, job_count: number | null, total_hours: number | null, total_cents: number, amount_due_cents: number | null, status: string | null, starts_time: string, ends_time: string | null, total_regular_hours: number | null, total_breaks_hours: number | null, total_overtime_hours: number | null, total_double_hours: number | null, total_on_call_hours: number | null, total_callback_hours: number | null, invoice_type: string | null, stripe_payment_intents: Array<{ __typename?: 'StripePaymentIntent', status: string | null, stripe_id: string | null, created_at: string, amount_cents: number | null, funding_source: { __typename?: 'FundingSource', last4: string | null } | null } | null> | null, parent_invoice_links: Array<{ __typename?: 'InvoicesLink', parent_invoice_id: number | null } | null> | null, assignment: { __typename?: 'Assignment', id: number, require_physical_signature: boolean, track_unpaid_breaks: boolean, professional: { __typename?: 'Professional', kind: string } | null, positions: Array<{ __typename?: 'Position', display_name: string | null } | null> | null } | null, billing_group: { __typename?: 'BillingGroup', uid: string, name: string | null, balance_cents: number, company: { __typename?: 'Company', name: string } } | null, jobs: Array<{ __typename?: 'Job', id: number, status: JobStatus | null, admin_notes: string | null, is_w2: boolean | null, current_starts_time: string | null, current_ends_time: string | null, canceled_by_location: boolean | null, professional: { __typename?: 'Professional', id: number, account: { __typename?: 'Account', first_name: string | null, last_name: string | null, name: string | null } | null } | null, location: { __typename?: 'Location', id: number, name: string | null } | null, positions: Array<{ __typename?: 'Position', display_name: string | null } | null> | null, job_billing_sums: { __typename?: 'JobBillingSum', total_hours: number | null, charge_regular_hours: number | null, charge_regular_amount_cents: number | null, charge_overtime_hours: number | null, charge_overtime_amount_cents: number | null, charge_double_hours: number | null, charge_double_amount_cents: number | null, total_on_call_hours: number | null, total_breaks_hours: number | null, charge_callback_hours: number | null, charge_callback_amount_cents: number | null, charge_total_amount_cents: number | null } | null } | null> | null, revenue_adjustments: Array<{ __typename?: 'RevenueAdjustment', id: number, created_at: string, job_id: number | null, description: string | null, amount_cents: number, adjustment_type: string | null } | null> | null } | null };

export type GatewayInvoicesQueryVariables = Exact<{
  input: InputMaybe<InvoiceQueryInput>;
}>;


export type GatewayInvoicesQuery = { __typename?: 'Query', gatewayInvoices: Array<{ __typename?: 'Invoice', id: number, billing_id: string | null, status: string | null, total_cents: number, amount_due_cents: number | null, job_count: number | null, due_date: any | null, starts_time: string, ends_time: string | null, total_hours: number | null, total_regular_hours: number | null, total_overtime_hours: number | null, total_double_hours: number | null, total_breaks_hours: number | null, total_on_call_hours: number | null, total_callback_hours: number | null, invoice_type: string | null, jobs: Array<{ __typename?: 'Job', id: number } | null> | null, stripe_payment_intents: Array<{ __typename?: 'StripePaymentIntent', status: string | null, stripe_id: string | null, created_at: string, amount_cents: number | null, funding_source: { __typename?: 'FundingSource', last4: string | null } | null } | null> | null } | null> | null, _gatewayInvoicesMeta: { __typename?: 'ListMeta', count: number | null } | null };

export type GatewayBillingGroupCreditLimitCalculationsQueryVariables = Exact<{
  uid: Scalars['UUID']['input'];
}>;


export type GatewayBillingGroupCreditLimitCalculationsQuery = { __typename?: 'Query', gatewayBillingGroupCreditLimitCalculation: { __typename?: 'BillingGroupCreditLimitCalculation', remaining_credit_cents: number | null } | null };

export type GetJobForJobRootQueryVariables = Exact<{
  id: Scalars['Int']['input'];
  location_ids: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
}>;


export type GetJobForJobRootQuery = { __typename?: 'Query', job: (
    { __typename?: 'Job', approval_status: ApprovalStatus | null, assignment_id: number | null, starts_time: string | null, status: JobStatus | null, timecard_id: number | null, professional: (
      { __typename?: 'Professional', id: number, status: string }
      & { ' $fragmentRefs'?: { 'ExperienceFragment': ExperienceFragment } }
    ) | null }
    & { ' $fragmentRefs'?: { 'JobDetailsLayoutFragment': JobDetailsLayoutFragment;'JobLocationSyncFragment': JobLocationSyncFragment;'PerDiemJobFormFragment': PerDiemJobFormFragment } }
  ) | null };

export type PerDiemJobFormFragment = { __typename?: 'Job', approval_status: ApprovalStatus | null, bonus_one_time_cents: number | null, charge_base_hourly_rate_cents: number | null, covid_care: boolean, detail: string | null, ends_date: any | null, ends_time: string | null, favorite_ids: Array<string>, id: number, location_id: number | null, marketplace_bonus_one_time_cents: number | null, marketplace_charge_base_hourly_rate_cents: number | null, override_rates: boolean | null, patient_population: string | null, position_ids: Array<number | null> | null, posting_field_contents: Record<string, any> | null, professional_id: number | null, release_audience: string, release_to_marketplace_strategy: string, release_to_platform: number, reserved_for_favorites_only: boolean, starts_date: any | null, starts_time: string | null, status: JobStatus | null, clinical_contact: { __typename?: 'Account', id: number } | null, location: { __typename?: 'Location', timezone_lookup: string | null } | null, positions: Array<{ __typename?: 'Position', display_name: string | null, id: number } | null> | null, professional: { __typename?: 'Professional', id: number } | null, specialties: Array<{ __typename?: 'Specialty', name: string | null, id: number } | null> | null, surgery_types: Array<{ __typename?: 'SurgeryType', id: number } | null> | null } & { ' $fragmentName'?: 'PerDiemJobFormFragment' };

export type GetProfessionalForHourSummaryQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type GetProfessionalForHourSummaryQuery = { __typename?: 'Query', professional: { __typename?: 'Professional', id: number, account: { __typename?: 'Account', name: string | null } | null, professional_saas_details: Array<{ __typename?: 'ProfessionalSaasDetail', max_weekly_hours: number | null } | null> | null } | null };

export type CancelJobModalFragment = (
  { __typename?: 'Job', assignment_id: number | null, cancellation_fee_window: number | null, created_at: string, id: number, location_id: number | null, starts_date: any | null, starts_time: string | null, status: JobStatus | null, assignment: { __typename?: 'Assignment', id: number } | null, location: { __typename?: 'Location', company_id: number | null } | null, positions: Array<{ __typename?: 'Position', display_name: string | null } | null> | null, professional: { __typename?: 'Professional', account: { __typename?: 'Account', first_name: string | null } | null } | null }
  & { ' $fragmentRefs'?: { 'CancelProInfoFragment': CancelProInfoFragment } }
) & { ' $fragmentName'?: 'CancelJobModalFragment' };

export type CancelProInfoFragment = { __typename?: 'Job', professional: { __typename?: 'Professional', id: number, is_any_favorite: boolean | null, kind: string, account: { __typename?: 'Account', name: string | null } | null } | null } & { ' $fragmentName'?: 'CancelProInfoFragment' };

export type ContactButtonFragment = { __typename?: 'Job', id: number, professional_number: string | null, professional: { __typename?: 'Professional', account: { __typename?: 'Account', name: string | null } | null } | null } & { ' $fragmentName'?: 'ContactButtonFragment' };

export type JobListDialogFragment = { __typename?: 'Job', approval_status: ApprovalStatus | null, assignment_id: number | null, current_ends_time: string | null, current_starts_time: string | null, ends_time: string | null, id: number, shift_type: string | null, starts_time: string | null, status: JobStatus | null, location: { __typename?: 'Location', timezone_lookup: string | null, unit: string | null } | null, positions: Array<{ __typename?: 'Position', display_name: string | null, id: number } | null> | null, professional: { __typename?: 'Professional', id: number, account: { __typename?: 'Account', agency_id: number | null, name: string | null } | null, professional_saas_details: Array<{ __typename?: 'ProfessionalSaasDetail', employment_type: string } | null> | null } | null } & { ' $fragmentName'?: 'JobListDialogFragment' };

export type QuickAddNoCardFragment = { __typename?: 'Job', assignment_id: number | null, id: number, location_id: number | null, starts_time: string | null, positions: Array<{ __typename?: 'Position', display_name: string | null, id: number } | null> | null } & { ' $fragmentName'?: 'QuickAddNoCardFragment' };

export type SchedulerCardFragment = (
  { __typename?: 'Job', approval_status: ApprovalStatus | null, current_ends_time: string | null, current_starts_time: string | null, id: number, professional_id: number | null, shift_type: string | null, starts_time: string | null, status: JobStatus | null, positions: Array<{ __typename?: 'Position', display_name: string | null, id: number } | null> | null }
  & { ' $fragmentRefs'?: { 'StatusIconJobFragment': StatusIconJobFragment } }
) & { ' $fragmentName'?: 'SchedulerCardFragment' };

export type SchedulerCardContainerJobFragment = (
  { __typename?: 'Job', id: number }
  & { ' $fragmentRefs'?: { 'SchedulerCardFragment': SchedulerCardFragment } }
) & { ' $fragmentName'?: 'SchedulerCardContainerJobFragment' };

export type SchedulerCardContainerDuplicateJobFragment = (
  { __typename?: 'Job' }
  & { ' $fragmentRefs'?: { 'JobListDialogFragment': JobListDialogFragment } }
) & { ' $fragmentName'?: 'SchedulerCardContainerDuplicateJobFragment' };

export type SchedulerDayJobFragment = { __typename?: 'Job', approval_status: ApprovalStatus | null, assignment_id: number | null, ends_time: string | null, id: number, starts_time: string | null, status: JobStatus | null, location: { __typename?: 'Location', unit: string | null } | null, positions: Array<{ __typename?: 'Position', display_name: string | null, id: number } | null> | null, professional: { __typename?: 'Professional', id: number, account: { __typename?: 'Account', agency_id: number | null, name: string | null } | null, professional_saas_details: Array<{ __typename?: 'ProfessionalSaasDetail', employment_type: string } | null> | null } | null } & { ' $fragmentName'?: 'SchedulerDayJobFragment' };

export type SchedulerMonthJobFragment = { __typename?: 'Job', approval_status: ApprovalStatus | null, id: number, starts_date: any | null, starts_time: string | null, status: JobStatus | null, location: { __typename?: 'Location', timezone_lookup: string | null } | null, positions: Array<{ __typename?: 'Position', display_name: string | null, id: number } | null> | null, professional: { __typename?: 'Professional', id: number, account: { __typename?: 'Account', name: string | null } | null } | null } & { ' $fragmentName'?: 'SchedulerMonthJobFragment' };

export type SchedulerWeekAssignmentFragment = { __typename?: 'Assignment', id: number, is_extension: boolean | null, positions: Array<{ __typename?: 'Position', display_name: string | null, id: number } | null> | null, professional: { __typename?: 'Professional', id: number, account: { __typename?: 'Account', agency_id: number | null, name: string | null } | null, professional_saas_details: Array<{ __typename?: 'ProfessionalSaasDetail', employment_type: string } | null> | null } | null } & { ' $fragmentName'?: 'SchedulerWeekAssignmentFragment' };

export type SchedulerWeekJobFragment = (
  { __typename?: 'Job', assignment_id: number | null, ends_time: string | null, id: number, location_id: number | null, shift_type: string | null, starts_date: any | null, starts_time: string | null, status: JobStatus | null, location: { __typename?: 'Location', timezone_lookup: string | null } | null, positions: Array<{ __typename?: 'Position', display_name: string | null, id: number } | null> | null, professional: { __typename?: 'Professional', id: number, account: { __typename?: 'Account', agency_id: number | null, name: string | null } | null, professional_saas_details: Array<{ __typename?: 'ProfessionalSaasDetail', employment_type: string } | null> | null } | null, specialties: Array<{ __typename?: 'Specialty', id: number } | null> | null, surgery_types: Array<{ __typename?: 'SurgeryType', id: number } | null> | null }
  & { ' $fragmentRefs'?: { 'SchedulerCardContainerJobFragment': SchedulerCardContainerJobFragment;'SchedulerCardContainerDuplicateJobFragment': SchedulerCardContainerDuplicateJobFragment;'QuickAddNoCardFragment': QuickAddNoCardFragment } }
) & { ' $fragmentName'?: 'SchedulerWeekJobFragment' };

export type AddClockInDialogFragment = { __typename?: 'Job', current_ends_time: string | null, current_starts_time: string | null, id: number, starts_time: string | null, location: { __typename?: 'Location', timezone_lookup: string | null } | null } & { ' $fragmentName'?: 'AddClockInDialogFragment' };

export type EditShiftTimeDialogFragment = { __typename?: 'Job', approved_clock_in: string | null, approval_status: ApprovalStatus | null, current_ends_time: string | null, current_starts_time: string | null, ends_time: string | null, id: number, shift_type: string | null, starts_time: string | null, status: JobStatus | null, location: { __typename?: 'Location', timezone_lookup: string | null } | null, professional: { __typename?: 'Professional', account: { __typename?: 'Account', first_name: string | null, last_name: string | null } | null } | null } & { ' $fragmentName'?: 'EditShiftTimeDialogFragment' };

export type StatusIconJobFragment = { __typename?: 'Job', approval_status: ApprovalStatus | null, current_ends_time: string | null, current_starts_time: string | null, id: number, professional_id: number | null, shift_type: string | null, starts_time: string | null, status: JobStatus | null, positions: Array<{ __typename?: 'Position', display_name: string | null, id: number } | null> | null } & { ' $fragmentName'?: 'StatusIconJobFragment' };

export type GetScheduleQueryVariables = Exact<{
  assignmentDateRange: DateRangeInput;
  assignmentInput: AssignmentQueryInput;
  assignmentJobsInput: JobQueryInput;
  getAssignmentJobs: Scalars['Boolean']['input'];
  getAssignments: Scalars['Boolean']['input'];
  getPerDiemJobs: Scalars['Boolean']['input'];
  isDayView: Scalars['Boolean']['input'];
  isWeekView: Scalars['Boolean']['input'];
  isMonthView: Scalars['Boolean']['input'];
  perDiemJobInput: JobQueryInput;
}>;


export type GetScheduleQuery = { __typename?: 'Query', assignmentJobs?: Array<(
    { __typename?: 'Job', approval_status: ApprovalStatus | null, assignment_id: number | null, current_ends_time: string | null, current_starts_time: string | null, ends_time: string | null, id: number, shift_type: string | null, starts_time: string | null, status: JobStatus | null, location: { __typename?: 'Location', timezone_lookup: string | null } | null, positions: Array<{ __typename?: 'Position', display_name: string | null, id: number } | null> | null }
    & { ' $fragmentRefs'?: { 'SchedulerDayJobFragment': SchedulerDayJobFragment;'SchedulerWeekJobFragment': SchedulerWeekJobFragment;'SchedulerMonthJobFragment': SchedulerMonthJobFragment } }
  )> | null, assignments?: Array<(
    { __typename?: 'Assignment', ends_date: any | null, ends_time: string | null, existing_job_hours: number, guaranteed_minimum_hours: number | null, id: number, number_of_shifts_per_week: number | null, starts_date: any | null, starts_time: string | null, positions: Array<{ __typename?: 'Position', id: number } | null> | null }
    & { ' $fragmentRefs'?: { 'SchedulerWeekAssignmentFragment': SchedulerWeekAssignmentFragment } }
  ) | null> | null, perDiemJobs?: Array<(
    { __typename?: 'Job', approval_status: ApprovalStatus | null, assignment_id: number | null, current_ends_time: string | null, current_starts_time: string | null, ends_time: string | null, id: number, shift_type: string | null, starts_time: string | null, status: JobStatus | null, location: { __typename?: 'Location', timezone_lookup: string | null } | null, positions: Array<{ __typename?: 'Position', display_name: string | null, id: number } | null> | null }
    & { ' $fragmentRefs'?: { 'SchedulerDayJobFragment': SchedulerDayJobFragment;'SchedulerWeekJobFragment': SchedulerWeekJobFragment;'SchedulerMonthJobFragment': SchedulerMonthJobFragment } }
  )> | null };

export type BlockFavoriteButtonsFragment = { __typename?: 'Professional', id: number, is_blocked: boolean | null, is_favorite: boolean | null, account: { __typename?: 'Account', name: string | null } | null } & { ' $fragmentName'?: 'BlockFavoriteButtonsFragment' };

export type BlockFavoriteMenuFragment = { __typename?: 'Professional', id: number, is_blocked: boolean | null, is_favorite: boolean | null, account: { __typename?: 'Account', name: string | null } | null } & { ' $fragmentName'?: 'BlockFavoriteMenuFragment' };

export const ApproversListFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ApproversList"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Approval"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"approval_groups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accounts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"approval_rule_id"}},{"kind":"Field","name":{"kind":"Name","value":"approver_account"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"rejection_reason"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"tier"}}]}}]} as unknown as DocumentNode<ApproversListFragment, unknown>;
export const ApprovalMutationFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ApprovalMutation"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Job"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"approvals"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]} as unknown as DocumentNode<ApprovalMutationFragment, unknown>;
export const ApprovalActionsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ApprovalActions"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Job"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"created_by"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ApprovalMutation"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ApprovalMutation"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Job"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"approvals"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]} as unknown as DocumentNode<ApprovalActionsFragment, unknown>;
export const JobApprovalDetailsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"JobApprovalDetails"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Job"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"approval_requestee_notes"}},{"kind":"Field","name":{"kind":"Name","value":"approval_status"}},{"kind":"Field","name":{"kind":"Name","value":"approval_violated_parameters"}},{"kind":"Field","name":{"kind":"Name","value":"approvals"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"approval_groups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accounts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ApproversList"}}]}},{"kind":"Field","name":{"kind":"Name","value":"marketplace_job_profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"charge_base_hourly_rate_cents"}}]}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ApprovalActions"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ApprovalMutation"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Job"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"approvals"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ApproversList"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Approval"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"approval_groups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accounts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"approval_rule_id"}},{"kind":"Field","name":{"kind":"Name","value":"approver_account"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"rejection_reason"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"tier"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ApprovalActions"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Job"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"created_by"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ApprovalMutation"}}]}}]} as unknown as DocumentNode<JobApprovalDetailsFragment, unknown>;
export const CancelProInfoFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CancelProInfo"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Job"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"professional"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"account"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"is_any_favorite"}},{"kind":"Field","name":{"kind":"Name","value":"kind"}}]}}]}}]} as unknown as DocumentNode<CancelProInfoFragment, unknown>;
export const CancelJobModalFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CancelJobModal"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Job"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"assignment_id"}},{"kind":"Field","name":{"kind":"Name","value":"assignment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"cancellation_fee_window"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"location_id"}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"company_id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"positions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"display_name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"professional"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"account"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"first_name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"starts_date"}},{"kind":"Field","name":{"kind":"Name","value":"starts_time"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"CancelProInfo"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CancelProInfo"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Job"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"professional"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"account"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"is_any_favorite"}},{"kind":"Field","name":{"kind":"Name","value":"kind"}}]}}]}}]} as unknown as DocumentNode<CancelJobModalFragment, unknown>;
export const BlockFavoriteButtonsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BlockFavoriteButtons"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Professional"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"account"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"is_blocked"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"location_ids"},"value":{"kind":"Variable","name":{"kind":"Name","value":"location_ids"}}}]},{"kind":"Field","name":{"kind":"Name","value":"is_favorite"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"location_ids"},"value":{"kind":"Variable","name":{"kind":"Name","value":"location_ids"}}}]}]}}]} as unknown as DocumentNode<BlockFavoriteButtonsFragment, unknown>;
export const BlockFavoriteMenuFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BlockFavoriteMenu"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Professional"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"account"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"is_blocked"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"location_ids"},"value":{"kind":"Variable","name":{"kind":"Name","value":"location_ids"}}}]},{"kind":"Field","name":{"kind":"Name","value":"is_favorite"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"location_ids"},"value":{"kind":"Variable","name":{"kind":"Name","value":"location_ids"}}}]}]}}]} as unknown as DocumentNode<BlockFavoriteMenuFragment, unknown>;
export const DetailsTitleFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DetailsTitle"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Job"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"approval_status"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"professional"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"account"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"kind"}},{"kind":"Field","name":{"kind":"Name","value":"nickname"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"BlockFavoriteButtons"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"BlockFavoriteMenu"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BlockFavoriteButtons"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Professional"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"account"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"is_blocked"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"location_ids"},"value":{"kind":"Variable","name":{"kind":"Name","value":"location_ids"}}}]},{"kind":"Field","name":{"kind":"Name","value":"is_favorite"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"location_ids"},"value":{"kind":"Variable","name":{"kind":"Name","value":"location_ids"}}}]}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BlockFavoriteMenu"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Professional"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"account"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"is_blocked"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"location_ids"},"value":{"kind":"Variable","name":{"kind":"Name","value":"location_ids"}}}]},{"kind":"Field","name":{"kind":"Name","value":"is_favorite"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"location_ids"},"value":{"kind":"Variable","name":{"kind":"Name","value":"location_ids"}}}]}]}}]} as unknown as DocumentNode<DetailsTitleFragment, unknown>;
export const AddClockInDialogFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AddClockInDialog"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Job"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"current_ends_time"}},{"kind":"Field","name":{"kind":"Name","value":"current_starts_time"}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"timezone_lookup"}}]}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"starts_time"}}]}}]} as unknown as DocumentNode<AddClockInDialogFragment, unknown>;
export const ContactButtonFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ContactButton"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Job"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"professional"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"account"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"professional_number"}}]}}]} as unknown as DocumentNode<ContactButtonFragment, unknown>;
export const EditShiftTimeDialogFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EditShiftTimeDialog"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Job"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"approved_clock_in"}},{"kind":"Field","name":{"kind":"Name","value":"approval_status"}},{"kind":"Field","name":{"kind":"Name","value":"current_ends_time"}},{"kind":"Field","name":{"kind":"Name","value":"current_starts_time"}},{"kind":"Field","name":{"kind":"Name","value":"ends_time"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"timezone_lookup"}}]}},{"kind":"Field","name":{"kind":"Name","value":"professional"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"account"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"shift_type"}},{"kind":"Field","name":{"kind":"Name","value":"starts_time"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]} as unknown as DocumentNode<EditShiftTimeDialogFragment, unknown>;
export const JobStatusActionsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"JobStatusActions"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Job"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"approval_status"}},{"kind":"Field","name":{"kind":"Name","value":"ends_time"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"shift_type"}},{"kind":"Field","name":{"kind":"Name","value":"starts_time"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"timezone_lookup"}}]}},{"kind":"Field","name":{"kind":"Name","value":"professional"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"AddClockInDialog"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ContactButton"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"EditShiftTimeDialog"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AddClockInDialog"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Job"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"current_ends_time"}},{"kind":"Field","name":{"kind":"Name","value":"current_starts_time"}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"timezone_lookup"}}]}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"starts_time"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ContactButton"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Job"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"professional"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"account"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"professional_number"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EditShiftTimeDialog"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Job"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"approved_clock_in"}},{"kind":"Field","name":{"kind":"Name","value":"approval_status"}},{"kind":"Field","name":{"kind":"Name","value":"current_ends_time"}},{"kind":"Field","name":{"kind":"Name","value":"current_starts_time"}},{"kind":"Field","name":{"kind":"Name","value":"ends_time"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"timezone_lookup"}}]}},{"kind":"Field","name":{"kind":"Name","value":"professional"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"account"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"shift_type"}},{"kind":"Field","name":{"kind":"Name","value":"starts_time"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]} as unknown as DocumentNode<JobStatusActionsFragment, unknown>;
export const PostedBySectionFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PostedBySection"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Job"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"created_by"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"account_type"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"job_irregularities"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"irregularity_type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]} as unknown as DocumentNode<PostedBySectionFragment, unknown>;
export const JobDetailsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"JobDetails"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Job"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"approval_status"}},{"kind":"Field","name":{"kind":"Name","value":"approved_clock_in"}},{"kind":"Field","name":{"kind":"Name","value":"assignment_id"}},{"kind":"Field","name":{"kind":"Name","value":"bonus_one_time_cents"}},{"kind":"Field","name":{"kind":"Name","value":"charge_base_hourly_rate_cents"}},{"kind":"Field","name":{"kind":"Name","value":"charge_on_call_hourly_rate_cents"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"current_ends_time"}},{"kind":"Field","name":{"kind":"Name","value":"current_starts_time"}},{"kind":"Field","name":{"kind":"Name","value":"detail"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"agencies"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"timezone_lookup"}}]}},{"kind":"Field","name":{"kind":"Name","value":"location_id"}},{"kind":"Field","name":{"kind":"Name","value":"marketplace_bonus_one_time_cents"}},{"kind":"Field","name":{"kind":"Name","value":"marketplace_charge_base_hourly_rate_cents"}},{"kind":"Field","name":{"kind":"Name","value":"positions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"display_name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"professional_id"}},{"kind":"Field","name":{"kind":"Name","value":"release_audience"}},{"kind":"Field","name":{"kind":"Name","value":"shift_type"}},{"kind":"Field","name":{"kind":"Name","value":"specialties"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"label"}}]}},{"kind":"Field","name":{"kind":"Name","value":"starts_date"}},{"kind":"Field","name":{"kind":"Name","value":"starts_time"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"CancelJobModal"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"DetailsTitle"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"JobStatusActions"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PostedBySection"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CancelProInfo"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Job"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"professional"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"account"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"is_any_favorite"}},{"kind":"Field","name":{"kind":"Name","value":"kind"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BlockFavoriteButtons"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Professional"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"account"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"is_blocked"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"location_ids"},"value":{"kind":"Variable","name":{"kind":"Name","value":"location_ids"}}}]},{"kind":"Field","name":{"kind":"Name","value":"is_favorite"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"location_ids"},"value":{"kind":"Variable","name":{"kind":"Name","value":"location_ids"}}}]}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BlockFavoriteMenu"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Professional"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"account"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"is_blocked"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"location_ids"},"value":{"kind":"Variable","name":{"kind":"Name","value":"location_ids"}}}]},{"kind":"Field","name":{"kind":"Name","value":"is_favorite"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"location_ids"},"value":{"kind":"Variable","name":{"kind":"Name","value":"location_ids"}}}]}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AddClockInDialog"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Job"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"current_ends_time"}},{"kind":"Field","name":{"kind":"Name","value":"current_starts_time"}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"timezone_lookup"}}]}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"starts_time"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ContactButton"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Job"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"professional"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"account"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"professional_number"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EditShiftTimeDialog"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Job"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"approved_clock_in"}},{"kind":"Field","name":{"kind":"Name","value":"approval_status"}},{"kind":"Field","name":{"kind":"Name","value":"current_ends_time"}},{"kind":"Field","name":{"kind":"Name","value":"current_starts_time"}},{"kind":"Field","name":{"kind":"Name","value":"ends_time"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"timezone_lookup"}}]}},{"kind":"Field","name":{"kind":"Name","value":"professional"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"account"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"shift_type"}},{"kind":"Field","name":{"kind":"Name","value":"starts_time"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CancelJobModal"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Job"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"assignment_id"}},{"kind":"Field","name":{"kind":"Name","value":"assignment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"cancellation_fee_window"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"location_id"}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"company_id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"positions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"display_name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"professional"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"account"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"first_name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"starts_date"}},{"kind":"Field","name":{"kind":"Name","value":"starts_time"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"CancelProInfo"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DetailsTitle"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Job"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"approval_status"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"professional"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"account"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"kind"}},{"kind":"Field","name":{"kind":"Name","value":"nickname"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"BlockFavoriteButtons"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"BlockFavoriteMenu"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"JobStatusActions"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Job"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"approval_status"}},{"kind":"Field","name":{"kind":"Name","value":"ends_time"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"shift_type"}},{"kind":"Field","name":{"kind":"Name","value":"starts_time"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"timezone_lookup"}}]}},{"kind":"Field","name":{"kind":"Name","value":"professional"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"AddClockInDialog"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ContactButton"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"EditShiftTimeDialog"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PostedBySection"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Job"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"created_by"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"account_type"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"job_irregularities"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"irregularity_type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]} as unknown as DocumentNode<JobDetailsFragment, unknown>;
export const TimesheetDetailsClockEventAttachmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TimesheetDetailsClockEventAttachment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ClockEventAttachment"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"clock_event_id"}},{"kind":"Field","name":{"kind":"Name","value":"clock_event_type"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"file"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"}},{"kind":"Field","name":{"kind":"Name","value":"reasons"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}}]}}]} as unknown as DocumentNode<TimesheetDetailsClockEventAttachmentFragment, unknown>;
export const DisputableDetailsSectionFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DisputableDetailsSection"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Job"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]} as unknown as DocumentNode<DisputableDetailsSectionFragment, unknown>;
export const RegularHoursSectionFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RegularHoursSection"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Job"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"charge_overtime_multiplier"}},{"kind":"Field","name":{"kind":"Name","value":"job_price_differentials"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"recommendation_used"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"Field","name":{"kind":"Name","value":"job_billing_sums"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"charge_overtime_amount_cents"}},{"kind":"Field","name":{"kind":"Name","value":"charge_overtime_hours"}},{"kind":"Field","name":{"kind":"Name","value":"charge_regular_amount_cents"}},{"kind":"Field","name":{"kind":"Name","value":"charge_regular_hours"}}]}}]}}]} as unknown as DocumentNode<RegularHoursSectionFragment, unknown>;
export const CancelDisputeButtonContainerFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CancelDisputeButtonContainer"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Job"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]} as unknown as DocumentNode<CancelDisputeButtonContainerFragment, unknown>;
export const DisputeFormDisplayHelpersFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DisputeFormDisplayHelpers"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Job"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"job_irregularities"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"irregularity_type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"track_unpaid_breaks"}}]}}]} as unknown as DocumentNode<DisputeFormDisplayHelpersFragment, unknown>;
export const ClockOutHelperTextFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ClockOutHelperText"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Job"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"approved_clock_out"}},{"kind":"Field","name":{"kind":"Name","value":"ends_time"}},{"kind":"Field","name":{"kind":"Name","value":"job_irregularities"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"irregularity_type"}}]}}]}}]} as unknown as DocumentNode<ClockOutHelperTextFragment, unknown>;
export const DisputeFormContentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DisputeFormContent"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Job"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"approved_clock_in"}},{"kind":"Field","name":{"kind":"Name","value":"ends_time"}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"timezone_lookup"}}]}},{"kind":"Field","name":{"kind":"Name","value":"professional"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"starts_date"}},{"kind":"Field","name":{"kind":"Name","value":"starts_time"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"DisputeFormDisplayHelpers"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ClockOutHelperText"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DisputeFormDisplayHelpers"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Job"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"job_irregularities"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"irregularity_type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"track_unpaid_breaks"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ClockOutHelperText"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Job"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"approved_clock_out"}},{"kind":"Field","name":{"kind":"Name","value":"ends_time"}},{"kind":"Field","name":{"kind":"Name","value":"job_irregularities"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"irregularity_type"}}]}}]}}]} as unknown as DocumentNode<DisputeFormContentFragment, unknown>;
export const ValidateFormFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ValidateForm"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Job"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"approved_clock_in"}},{"kind":"Field","name":{"kind":"Name","value":"approved_clock_out"}},{"kind":"Field","name":{"kind":"Name","value":"job_billing_sums"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"total_breaks_minutes"}}]}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"timezone_lookup"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"DisputeFormDisplayHelpers"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DisputeFormDisplayHelpers"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Job"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"job_irregularities"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"irregularity_type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"track_unpaid_breaks"}}]}}]} as unknown as DocumentNode<ValidateFormFragment, unknown>;
export const DisputeFormFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DisputeForm"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Job"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"approved_clock_in"}},{"kind":"Field","name":{"kind":"Name","value":"approved_clock_out"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"track_unpaid_breaks"}},{"kind":"Field","name":{"kind":"Name","value":"job_billing_sums"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"total_breaks_minutes"}}]}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"timezone_lookup"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"DisputeFormContent"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ValidateForm"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DisputeFormDisplayHelpers"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Job"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"job_irregularities"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"irregularity_type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"track_unpaid_breaks"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ClockOutHelperText"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Job"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"approved_clock_out"}},{"kind":"Field","name":{"kind":"Name","value":"ends_time"}},{"kind":"Field","name":{"kind":"Name","value":"job_irregularities"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"irregularity_type"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DisputeFormContent"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Job"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"approved_clock_in"}},{"kind":"Field","name":{"kind":"Name","value":"ends_time"}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"timezone_lookup"}}]}},{"kind":"Field","name":{"kind":"Name","value":"professional"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"starts_date"}},{"kind":"Field","name":{"kind":"Name","value":"starts_time"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"DisputeFormDisplayHelpers"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ClockOutHelperText"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ValidateForm"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Job"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"approved_clock_in"}},{"kind":"Field","name":{"kind":"Name","value":"approved_clock_out"}},{"kind":"Field","name":{"kind":"Name","value":"job_billing_sums"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"total_breaks_minutes"}}]}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"timezone_lookup"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"DisputeFormDisplayHelpers"}}]}}]} as unknown as DocumentNode<DisputeFormFragment, unknown>;
export const DisputeModalFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DisputeModal"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Job"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"job_irregularities"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"label"}}]}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"DisputeForm"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DisputeFormDisplayHelpers"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Job"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"job_irregularities"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"irregularity_type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"track_unpaid_breaks"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ClockOutHelperText"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Job"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"approved_clock_out"}},{"kind":"Field","name":{"kind":"Name","value":"ends_time"}},{"kind":"Field","name":{"kind":"Name","value":"job_irregularities"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"irregularity_type"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DisputeFormContent"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Job"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"approved_clock_in"}},{"kind":"Field","name":{"kind":"Name","value":"ends_time"}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"timezone_lookup"}}]}},{"kind":"Field","name":{"kind":"Name","value":"professional"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"starts_date"}},{"kind":"Field","name":{"kind":"Name","value":"starts_time"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"DisputeFormDisplayHelpers"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ClockOutHelperText"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ValidateForm"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Job"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"approved_clock_in"}},{"kind":"Field","name":{"kind":"Name","value":"approved_clock_out"}},{"kind":"Field","name":{"kind":"Name","value":"job_billing_sums"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"total_breaks_minutes"}}]}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"timezone_lookup"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"DisputeFormDisplayHelpers"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DisputeForm"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Job"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"approved_clock_in"}},{"kind":"Field","name":{"kind":"Name","value":"approved_clock_out"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"track_unpaid_breaks"}},{"kind":"Field","name":{"kind":"Name","value":"job_billing_sums"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"total_breaks_minutes"}}]}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"timezone_lookup"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"DisputeFormContent"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ValidateForm"}}]}}]} as unknown as DocumentNode<DisputeModalFragment, unknown>;
export const DisputeButtonsContainerFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DisputeButtonsContainer"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Job"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"approved_clock_in"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"job_irregularities"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"approved_by_account_id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"company_id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"DisputeModal"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DisputeFormDisplayHelpers"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Job"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"job_irregularities"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"irregularity_type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"track_unpaid_breaks"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ClockOutHelperText"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Job"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"approved_clock_out"}},{"kind":"Field","name":{"kind":"Name","value":"ends_time"}},{"kind":"Field","name":{"kind":"Name","value":"job_irregularities"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"irregularity_type"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DisputeFormContent"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Job"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"approved_clock_in"}},{"kind":"Field","name":{"kind":"Name","value":"ends_time"}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"timezone_lookup"}}]}},{"kind":"Field","name":{"kind":"Name","value":"professional"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"starts_date"}},{"kind":"Field","name":{"kind":"Name","value":"starts_time"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"DisputeFormDisplayHelpers"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ClockOutHelperText"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ValidateForm"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Job"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"approved_clock_in"}},{"kind":"Field","name":{"kind":"Name","value":"approved_clock_out"}},{"kind":"Field","name":{"kind":"Name","value":"job_billing_sums"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"total_breaks_minutes"}}]}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"timezone_lookup"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"DisputeFormDisplayHelpers"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DisputeForm"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Job"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"approved_clock_in"}},{"kind":"Field","name":{"kind":"Name","value":"approved_clock_out"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"track_unpaid_breaks"}},{"kind":"Field","name":{"kind":"Name","value":"job_billing_sums"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"total_breaks_minutes"}}]}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"timezone_lookup"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"DisputeFormContent"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ValidateForm"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DisputeModal"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Job"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"job_irregularities"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"label"}}]}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"DisputeForm"}}]}}]} as unknown as DocumentNode<DisputeButtonsContainerFragment, unknown>;
export const TimesheetDetailsButtonFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TimesheetDetailsButton"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Job"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"CancelDisputeButtonContainer"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"DisputeButtonsContainer"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DisputeFormDisplayHelpers"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Job"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"job_irregularities"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"irregularity_type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"track_unpaid_breaks"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ClockOutHelperText"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Job"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"approved_clock_out"}},{"kind":"Field","name":{"kind":"Name","value":"ends_time"}},{"kind":"Field","name":{"kind":"Name","value":"job_irregularities"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"irregularity_type"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DisputeFormContent"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Job"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"approved_clock_in"}},{"kind":"Field","name":{"kind":"Name","value":"ends_time"}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"timezone_lookup"}}]}},{"kind":"Field","name":{"kind":"Name","value":"professional"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"starts_date"}},{"kind":"Field","name":{"kind":"Name","value":"starts_time"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"DisputeFormDisplayHelpers"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ClockOutHelperText"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ValidateForm"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Job"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"approved_clock_in"}},{"kind":"Field","name":{"kind":"Name","value":"approved_clock_out"}},{"kind":"Field","name":{"kind":"Name","value":"job_billing_sums"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"total_breaks_minutes"}}]}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"timezone_lookup"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"DisputeFormDisplayHelpers"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DisputeForm"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Job"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"approved_clock_in"}},{"kind":"Field","name":{"kind":"Name","value":"approved_clock_out"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"track_unpaid_breaks"}},{"kind":"Field","name":{"kind":"Name","value":"job_billing_sums"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"total_breaks_minutes"}}]}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"timezone_lookup"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"DisputeFormContent"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ValidateForm"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DisputeModal"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Job"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"job_irregularities"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"label"}}]}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"DisputeForm"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CancelDisputeButtonContainer"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Job"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DisputeButtonsContainer"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Job"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"approved_clock_in"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"job_irregularities"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"approved_by_account_id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"company_id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"DisputeModal"}}]}}]} as unknown as DocumentNode<TimesheetDetailsButtonFragment, unknown>;
export const TimesheetDetailsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TimesheetDetails"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Job"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"approved_clock_in"}},{"kind":"Field","name":{"kind":"Name","value":"approved_clock_out"}},{"kind":"Field","name":{"kind":"Name","value":"assignment_id"}},{"kind":"Field","name":{"kind":"Name","value":"attachment"}},{"kind":"Field","name":{"kind":"Name","value":"check_ins"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"clock_event_attachments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"file"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"}},{"kind":"Field","name":{"kind":"Name","value":"reasons"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"TimesheetDetailsClockEventAttachment"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"check_outs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"clock_event_attachments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"file"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"}},{"kind":"Field","name":{"kind":"Name","value":"reasons"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"TimesheetDetailsClockEventAttachment"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"ends_time"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"is_w2"}},{"kind":"Field","name":{"kind":"Name","value":"job_billing_sums"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"charge_callback_hours"}},{"kind":"Field","name":{"kind":"Name","value":"charge_double_hours"}},{"kind":"Field","name":{"kind":"Name","value":"charge_overtime_hours"}},{"kind":"Field","name":{"kind":"Name","value":"charge_total_amount_cents"}},{"kind":"Field","name":{"kind":"Name","value":"total_breaks_minutes"}},{"kind":"Field","name":{"kind":"Name","value":"total_hours"}},{"kind":"Field","name":{"kind":"Name","value":"total_on_call_hours"}}]}},{"kind":"Field","name":{"kind":"Name","value":"job_irregularities"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"label"}}]}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"enable_geo_fence"}},{"kind":"Field","name":{"kind":"Name","value":"require_upload_on_clock_out"}},{"kind":"Field","name":{"kind":"Name","value":"timezone_lookup"}}]}},{"kind":"Field","name":{"kind":"Name","value":"positions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"display_name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"specialties"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"label"}}]}},{"kind":"Field","name":{"kind":"Name","value":"starts_date"}},{"kind":"Field","name":{"kind":"Name","value":"starts_time"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"track_unpaid_breaks"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"DetailsTitle"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"DisputableDetailsSection"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PostedBySection"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"RegularHoursSection"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"TimesheetDetailsButton"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BlockFavoriteButtons"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Professional"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"account"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"is_blocked"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"location_ids"},"value":{"kind":"Variable","name":{"kind":"Name","value":"location_ids"}}}]},{"kind":"Field","name":{"kind":"Name","value":"is_favorite"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"location_ids"},"value":{"kind":"Variable","name":{"kind":"Name","value":"location_ids"}}}]}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BlockFavoriteMenu"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Professional"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"account"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"is_blocked"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"location_ids"},"value":{"kind":"Variable","name":{"kind":"Name","value":"location_ids"}}}]},{"kind":"Field","name":{"kind":"Name","value":"is_favorite"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"location_ids"},"value":{"kind":"Variable","name":{"kind":"Name","value":"location_ids"}}}]}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CancelDisputeButtonContainer"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Job"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DisputeFormDisplayHelpers"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Job"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"job_irregularities"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"irregularity_type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"track_unpaid_breaks"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ClockOutHelperText"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Job"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"approved_clock_out"}},{"kind":"Field","name":{"kind":"Name","value":"ends_time"}},{"kind":"Field","name":{"kind":"Name","value":"job_irregularities"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"irregularity_type"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DisputeFormContent"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Job"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"approved_clock_in"}},{"kind":"Field","name":{"kind":"Name","value":"ends_time"}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"timezone_lookup"}}]}},{"kind":"Field","name":{"kind":"Name","value":"professional"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"starts_date"}},{"kind":"Field","name":{"kind":"Name","value":"starts_time"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"DisputeFormDisplayHelpers"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ClockOutHelperText"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ValidateForm"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Job"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"approved_clock_in"}},{"kind":"Field","name":{"kind":"Name","value":"approved_clock_out"}},{"kind":"Field","name":{"kind":"Name","value":"job_billing_sums"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"total_breaks_minutes"}}]}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"timezone_lookup"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"DisputeFormDisplayHelpers"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DisputeForm"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Job"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"approved_clock_in"}},{"kind":"Field","name":{"kind":"Name","value":"approved_clock_out"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"track_unpaid_breaks"}},{"kind":"Field","name":{"kind":"Name","value":"job_billing_sums"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"total_breaks_minutes"}}]}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"timezone_lookup"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"DisputeFormContent"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ValidateForm"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DisputeModal"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Job"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"job_irregularities"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"label"}}]}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"DisputeForm"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DisputeButtonsContainer"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Job"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"approved_clock_in"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"job_irregularities"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"approved_by_account_id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"company_id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"DisputeModal"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TimesheetDetailsClockEventAttachment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ClockEventAttachment"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"clock_event_id"}},{"kind":"Field","name":{"kind":"Name","value":"clock_event_type"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"file"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"}},{"kind":"Field","name":{"kind":"Name","value":"reasons"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DetailsTitle"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Job"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"approval_status"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"professional"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"account"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"kind"}},{"kind":"Field","name":{"kind":"Name","value":"nickname"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"BlockFavoriteButtons"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"BlockFavoriteMenu"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DisputableDetailsSection"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Job"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"status"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PostedBySection"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Job"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"created_by"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"account_type"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"job_irregularities"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"irregularity_type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RegularHoursSection"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Job"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"charge_overtime_multiplier"}},{"kind":"Field","name":{"kind":"Name","value":"job_price_differentials"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"recommendation_used"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"Field","name":{"kind":"Name","value":"job_billing_sums"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"charge_overtime_amount_cents"}},{"kind":"Field","name":{"kind":"Name","value":"charge_overtime_hours"}},{"kind":"Field","name":{"kind":"Name","value":"charge_regular_amount_cents"}},{"kind":"Field","name":{"kind":"Name","value":"charge_regular_hours"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TimesheetDetailsButton"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Job"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"CancelDisputeButtonContainer"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"DisputeButtonsContainer"}}]}}]} as unknown as DocumentNode<TimesheetDetailsFragment, unknown>;
export const JobDetailsLayoutFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"JobDetailsLayout"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Job"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"approval_status"}},{"kind":"Field","name":{"kind":"Name","value":"approvals"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"JobApprovalDetails"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"JobDetails"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"TimesheetDetails"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ApproversList"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Approval"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"approval_groups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accounts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"approval_rule_id"}},{"kind":"Field","name":{"kind":"Name","value":"approver_account"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"rejection_reason"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"tier"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ApprovalMutation"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Job"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"approvals"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ApprovalActions"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Job"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"created_by"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ApprovalMutation"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CancelProInfo"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Job"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"professional"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"account"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"is_any_favorite"}},{"kind":"Field","name":{"kind":"Name","value":"kind"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CancelJobModal"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Job"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"assignment_id"}},{"kind":"Field","name":{"kind":"Name","value":"assignment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"cancellation_fee_window"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"location_id"}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"company_id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"positions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"display_name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"professional"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"account"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"first_name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"starts_date"}},{"kind":"Field","name":{"kind":"Name","value":"starts_time"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"CancelProInfo"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BlockFavoriteButtons"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Professional"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"account"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"is_blocked"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"location_ids"},"value":{"kind":"Variable","name":{"kind":"Name","value":"location_ids"}}}]},{"kind":"Field","name":{"kind":"Name","value":"is_favorite"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"location_ids"},"value":{"kind":"Variable","name":{"kind":"Name","value":"location_ids"}}}]}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BlockFavoriteMenu"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Professional"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"account"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"is_blocked"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"location_ids"},"value":{"kind":"Variable","name":{"kind":"Name","value":"location_ids"}}}]},{"kind":"Field","name":{"kind":"Name","value":"is_favorite"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"location_ids"},"value":{"kind":"Variable","name":{"kind":"Name","value":"location_ids"}}}]}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DetailsTitle"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Job"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"approval_status"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"professional"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"account"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"kind"}},{"kind":"Field","name":{"kind":"Name","value":"nickname"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"BlockFavoriteButtons"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"BlockFavoriteMenu"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AddClockInDialog"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Job"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"current_ends_time"}},{"kind":"Field","name":{"kind":"Name","value":"current_starts_time"}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"timezone_lookup"}}]}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"starts_time"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ContactButton"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Job"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"professional"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"account"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"professional_number"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EditShiftTimeDialog"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Job"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"approved_clock_in"}},{"kind":"Field","name":{"kind":"Name","value":"approval_status"}},{"kind":"Field","name":{"kind":"Name","value":"current_ends_time"}},{"kind":"Field","name":{"kind":"Name","value":"current_starts_time"}},{"kind":"Field","name":{"kind":"Name","value":"ends_time"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"timezone_lookup"}}]}},{"kind":"Field","name":{"kind":"Name","value":"professional"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"account"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"shift_type"}},{"kind":"Field","name":{"kind":"Name","value":"starts_time"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"JobStatusActions"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Job"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"approval_status"}},{"kind":"Field","name":{"kind":"Name","value":"ends_time"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"shift_type"}},{"kind":"Field","name":{"kind":"Name","value":"starts_time"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"timezone_lookup"}}]}},{"kind":"Field","name":{"kind":"Name","value":"professional"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"AddClockInDialog"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ContactButton"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"EditShiftTimeDialog"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PostedBySection"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Job"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"created_by"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"account_type"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"job_irregularities"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"irregularity_type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TimesheetDetailsClockEventAttachment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ClockEventAttachment"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"clock_event_id"}},{"kind":"Field","name":{"kind":"Name","value":"clock_event_type"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"file"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"}},{"kind":"Field","name":{"kind":"Name","value":"reasons"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DisputableDetailsSection"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Job"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"status"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RegularHoursSection"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Job"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"charge_overtime_multiplier"}},{"kind":"Field","name":{"kind":"Name","value":"job_price_differentials"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"recommendation_used"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"Field","name":{"kind":"Name","value":"job_billing_sums"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"charge_overtime_amount_cents"}},{"kind":"Field","name":{"kind":"Name","value":"charge_overtime_hours"}},{"kind":"Field","name":{"kind":"Name","value":"charge_regular_amount_cents"}},{"kind":"Field","name":{"kind":"Name","value":"charge_regular_hours"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CancelDisputeButtonContainer"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Job"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DisputeFormDisplayHelpers"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Job"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"job_irregularities"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"irregularity_type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"track_unpaid_breaks"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ClockOutHelperText"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Job"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"approved_clock_out"}},{"kind":"Field","name":{"kind":"Name","value":"ends_time"}},{"kind":"Field","name":{"kind":"Name","value":"job_irregularities"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"irregularity_type"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DisputeFormContent"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Job"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"approved_clock_in"}},{"kind":"Field","name":{"kind":"Name","value":"ends_time"}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"timezone_lookup"}}]}},{"kind":"Field","name":{"kind":"Name","value":"professional"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"starts_date"}},{"kind":"Field","name":{"kind":"Name","value":"starts_time"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"DisputeFormDisplayHelpers"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ClockOutHelperText"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ValidateForm"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Job"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"approved_clock_in"}},{"kind":"Field","name":{"kind":"Name","value":"approved_clock_out"}},{"kind":"Field","name":{"kind":"Name","value":"job_billing_sums"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"total_breaks_minutes"}}]}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"timezone_lookup"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"DisputeFormDisplayHelpers"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DisputeForm"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Job"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"approved_clock_in"}},{"kind":"Field","name":{"kind":"Name","value":"approved_clock_out"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"track_unpaid_breaks"}},{"kind":"Field","name":{"kind":"Name","value":"job_billing_sums"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"total_breaks_minutes"}}]}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"timezone_lookup"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"DisputeFormContent"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ValidateForm"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DisputeModal"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Job"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"job_irregularities"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"label"}}]}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"DisputeForm"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DisputeButtonsContainer"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Job"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"approved_clock_in"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"job_irregularities"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"approved_by_account_id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"company_id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"DisputeModal"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TimesheetDetailsButton"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Job"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"CancelDisputeButtonContainer"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"DisputeButtonsContainer"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"JobApprovalDetails"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Job"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"approval_requestee_notes"}},{"kind":"Field","name":{"kind":"Name","value":"approval_status"}},{"kind":"Field","name":{"kind":"Name","value":"approval_violated_parameters"}},{"kind":"Field","name":{"kind":"Name","value":"approvals"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"approval_groups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accounts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ApproversList"}}]}},{"kind":"Field","name":{"kind":"Name","value":"marketplace_job_profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"charge_base_hourly_rate_cents"}}]}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ApprovalActions"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"JobDetails"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Job"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"approval_status"}},{"kind":"Field","name":{"kind":"Name","value":"approved_clock_in"}},{"kind":"Field","name":{"kind":"Name","value":"assignment_id"}},{"kind":"Field","name":{"kind":"Name","value":"bonus_one_time_cents"}},{"kind":"Field","name":{"kind":"Name","value":"charge_base_hourly_rate_cents"}},{"kind":"Field","name":{"kind":"Name","value":"charge_on_call_hourly_rate_cents"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"current_ends_time"}},{"kind":"Field","name":{"kind":"Name","value":"current_starts_time"}},{"kind":"Field","name":{"kind":"Name","value":"detail"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"agencies"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"timezone_lookup"}}]}},{"kind":"Field","name":{"kind":"Name","value":"location_id"}},{"kind":"Field","name":{"kind":"Name","value":"marketplace_bonus_one_time_cents"}},{"kind":"Field","name":{"kind":"Name","value":"marketplace_charge_base_hourly_rate_cents"}},{"kind":"Field","name":{"kind":"Name","value":"positions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"display_name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"professional_id"}},{"kind":"Field","name":{"kind":"Name","value":"release_audience"}},{"kind":"Field","name":{"kind":"Name","value":"shift_type"}},{"kind":"Field","name":{"kind":"Name","value":"specialties"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"label"}}]}},{"kind":"Field","name":{"kind":"Name","value":"starts_date"}},{"kind":"Field","name":{"kind":"Name","value":"starts_time"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"CancelJobModal"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"DetailsTitle"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"JobStatusActions"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PostedBySection"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TimesheetDetails"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Job"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"approved_clock_in"}},{"kind":"Field","name":{"kind":"Name","value":"approved_clock_out"}},{"kind":"Field","name":{"kind":"Name","value":"assignment_id"}},{"kind":"Field","name":{"kind":"Name","value":"attachment"}},{"kind":"Field","name":{"kind":"Name","value":"check_ins"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"clock_event_attachments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"file"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"}},{"kind":"Field","name":{"kind":"Name","value":"reasons"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"TimesheetDetailsClockEventAttachment"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"check_outs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"clock_event_attachments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"file"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"}},{"kind":"Field","name":{"kind":"Name","value":"reasons"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"TimesheetDetailsClockEventAttachment"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"ends_time"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"is_w2"}},{"kind":"Field","name":{"kind":"Name","value":"job_billing_sums"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"charge_callback_hours"}},{"kind":"Field","name":{"kind":"Name","value":"charge_double_hours"}},{"kind":"Field","name":{"kind":"Name","value":"charge_overtime_hours"}},{"kind":"Field","name":{"kind":"Name","value":"charge_total_amount_cents"}},{"kind":"Field","name":{"kind":"Name","value":"total_breaks_minutes"}},{"kind":"Field","name":{"kind":"Name","value":"total_hours"}},{"kind":"Field","name":{"kind":"Name","value":"total_on_call_hours"}}]}},{"kind":"Field","name":{"kind":"Name","value":"job_irregularities"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"label"}}]}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"enable_geo_fence"}},{"kind":"Field","name":{"kind":"Name","value":"require_upload_on_clock_out"}},{"kind":"Field","name":{"kind":"Name","value":"timezone_lookup"}}]}},{"kind":"Field","name":{"kind":"Name","value":"positions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"display_name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"specialties"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"label"}}]}},{"kind":"Field","name":{"kind":"Name","value":"starts_date"}},{"kind":"Field","name":{"kind":"Name","value":"starts_time"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"track_unpaid_breaks"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"DetailsTitle"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"DisputableDetailsSection"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PostedBySection"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"RegularHoursSection"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"TimesheetDetailsButton"}}]}}]} as unknown as DocumentNode<JobDetailsLayoutFragment, unknown>;
export const ExperienceFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Experience"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Professional"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"account"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"phone_number"}},{"kind":"Field","name":{"kind":"Name","value":"ssn_last_4"}}]}},{"kind":"Field","name":{"kind":"Name","value":"dob"}},{"kind":"Field","name":{"kind":"Name","value":"has_active_jobs_here"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"location_ids"},"value":{"kind":"Variable","name":{"kind":"Name","value":"location_ids"}}}]},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"positions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"display_name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"specialties"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"positions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"shifts_completed"}},{"kind":"Field","name":{"kind":"Name","value":"shifts_completed_here"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"location_ids"},"value":{"kind":"Variable","name":{"kind":"Name","value":"location_ids"}}}]},{"kind":"Field","name":{"kind":"Name","value":"years_experience"}}]}}]} as unknown as DocumentNode<ExperienceFragment, unknown>;
export const JobLocationSyncFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"JobLocationSync"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Job"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"assignment_id"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"location_id"}},{"kind":"Field","name":{"kind":"Name","value":"professional_id"}},{"kind":"Field","name":{"kind":"Name","value":"shift_type"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"assignment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"professional"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<JobLocationSyncFragment, unknown>;
export const PerDiemJobFormFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PerDiemJobForm"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Job"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"approval_status"}},{"kind":"Field","name":{"kind":"Name","value":"bonus_one_time_cents"}},{"kind":"Field","name":{"kind":"Name","value":"charge_base_hourly_rate_cents"}},{"kind":"Field","name":{"kind":"Name","value":"clinical_contact"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"covid_care"}},{"kind":"Field","name":{"kind":"Name","value":"detail"}},{"kind":"Field","name":{"kind":"Name","value":"ends_date"}},{"kind":"Field","name":{"kind":"Name","value":"ends_time"}},{"kind":"Field","name":{"kind":"Name","value":"favorite_ids"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"timezone_lookup"}}]}},{"kind":"Field","name":{"kind":"Name","value":"location_id"}},{"kind":"Field","name":{"kind":"Name","value":"marketplace_bonus_one_time_cents"}},{"kind":"Field","name":{"kind":"Name","value":"marketplace_charge_base_hourly_rate_cents"}},{"kind":"Field","name":{"kind":"Name","value":"override_rates"}},{"kind":"Field","name":{"kind":"Name","value":"patient_population"}},{"kind":"Field","name":{"kind":"Name","value":"position_ids"}},{"kind":"Field","name":{"kind":"Name","value":"positions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"display_name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"posting_field_contents"}},{"kind":"Field","name":{"kind":"Name","value":"professional"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"professional_id"}},{"kind":"Field","name":{"kind":"Name","value":"release_audience"}},{"kind":"Field","name":{"kind":"Name","value":"release_to_marketplace_strategy"}},{"kind":"Field","name":{"kind":"Name","value":"release_to_platform"}},{"kind":"Field","name":{"kind":"Name","value":"reserved_for_favorites_only"}},{"kind":"Field","name":{"kind":"Name","value":"specialties"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"starts_date"}},{"kind":"Field","name":{"kind":"Name","value":"starts_time"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"surgery_types"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<PerDiemJobFormFragment, unknown>;
export const SchedulerDayJobFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SchedulerDayJob"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Job"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"approval_status"}},{"kind":"Field","name":{"kind":"Name","value":"assignment_id"}},{"kind":"Field","name":{"kind":"Name","value":"ends_time"}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"unit"}}]}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"positions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"display_name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"professional"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"account"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"agency_id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"professional_saas_details"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"employment_type"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"starts_time"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]} as unknown as DocumentNode<SchedulerDayJobFragment, unknown>;
export const SchedulerMonthJobFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SchedulerMonthJob"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Job"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"approval_status"}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"timezone_lookup"}}]}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"positions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"display_name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"professional"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"account"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"starts_date"}},{"kind":"Field","name":{"kind":"Name","value":"starts_time"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]} as unknown as DocumentNode<SchedulerMonthJobFragment, unknown>;
export const SchedulerWeekAssignmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SchedulerWeekAssignment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Assignment"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"is_extension"}},{"kind":"Field","name":{"kind":"Name","value":"positions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"display_name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"professional"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"account"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"agency_id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"professional_saas_details"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"employment_type"}}]}}]}}]}}]} as unknown as DocumentNode<SchedulerWeekAssignmentFragment, unknown>;
export const StatusIconJobFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"StatusIconJob"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Job"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"approval_status"}},{"kind":"Field","name":{"kind":"Name","value":"current_ends_time"}},{"kind":"Field","name":{"kind":"Name","value":"current_starts_time"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"positions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"display_name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"professional_id"}},{"kind":"Field","name":{"kind":"Name","value":"shift_type"}},{"kind":"Field","name":{"kind":"Name","value":"starts_time"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]} as unknown as DocumentNode<StatusIconJobFragment, unknown>;
export const SchedulerCardFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SchedulerCard"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Job"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"approval_status"}},{"kind":"Field","name":{"kind":"Name","value":"current_ends_time"}},{"kind":"Field","name":{"kind":"Name","value":"current_starts_time"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"positions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"display_name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"professional_id"}},{"kind":"Field","name":{"kind":"Name","value":"shift_type"}},{"kind":"Field","name":{"kind":"Name","value":"starts_time"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"StatusIconJob"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"StatusIconJob"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Job"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"approval_status"}},{"kind":"Field","name":{"kind":"Name","value":"current_ends_time"}},{"kind":"Field","name":{"kind":"Name","value":"current_starts_time"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"positions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"display_name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"professional_id"}},{"kind":"Field","name":{"kind":"Name","value":"shift_type"}},{"kind":"Field","name":{"kind":"Name","value":"starts_time"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]} as unknown as DocumentNode<SchedulerCardFragment, unknown>;
export const SchedulerCardContainerJobFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SchedulerCardContainerJob"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Job"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SchedulerCard"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"StatusIconJob"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Job"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"approval_status"}},{"kind":"Field","name":{"kind":"Name","value":"current_ends_time"}},{"kind":"Field","name":{"kind":"Name","value":"current_starts_time"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"positions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"display_name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"professional_id"}},{"kind":"Field","name":{"kind":"Name","value":"shift_type"}},{"kind":"Field","name":{"kind":"Name","value":"starts_time"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SchedulerCard"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Job"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"approval_status"}},{"kind":"Field","name":{"kind":"Name","value":"current_ends_time"}},{"kind":"Field","name":{"kind":"Name","value":"current_starts_time"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"positions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"display_name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"professional_id"}},{"kind":"Field","name":{"kind":"Name","value":"shift_type"}},{"kind":"Field","name":{"kind":"Name","value":"starts_time"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"StatusIconJob"}}]}}]} as unknown as DocumentNode<SchedulerCardContainerJobFragment, unknown>;
export const JobListDialogFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"JobListDialog"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Job"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"approval_status"}},{"kind":"Field","name":{"kind":"Name","value":"assignment_id"}},{"kind":"Field","name":{"kind":"Name","value":"current_ends_time"}},{"kind":"Field","name":{"kind":"Name","value":"current_starts_time"}},{"kind":"Field","name":{"kind":"Name","value":"ends_time"}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"timezone_lookup"}},{"kind":"Field","name":{"kind":"Name","value":"unit"}}]}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"positions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"display_name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"professional"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"account"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"agency_id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"professional_saas_details"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"employment_type"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"shift_type"}},{"kind":"Field","name":{"kind":"Name","value":"starts_time"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]} as unknown as DocumentNode<JobListDialogFragment, unknown>;
export const SchedulerCardContainerDuplicateJobFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SchedulerCardContainerDuplicateJob"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Job"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"JobListDialog"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"JobListDialog"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Job"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"approval_status"}},{"kind":"Field","name":{"kind":"Name","value":"assignment_id"}},{"kind":"Field","name":{"kind":"Name","value":"current_ends_time"}},{"kind":"Field","name":{"kind":"Name","value":"current_starts_time"}},{"kind":"Field","name":{"kind":"Name","value":"ends_time"}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"timezone_lookup"}},{"kind":"Field","name":{"kind":"Name","value":"unit"}}]}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"positions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"display_name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"professional"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"account"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"agency_id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"professional_saas_details"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"employment_type"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"shift_type"}},{"kind":"Field","name":{"kind":"Name","value":"starts_time"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]} as unknown as DocumentNode<SchedulerCardContainerDuplicateJobFragment, unknown>;
export const QuickAddNoCardFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"QuickAddNoCard"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Job"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"assignment_id"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"location_id"}},{"kind":"Field","name":{"kind":"Name","value":"positions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"display_name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"starts_time"}}]}}]} as unknown as DocumentNode<QuickAddNoCardFragment, unknown>;
export const SchedulerWeekJobFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SchedulerWeekJob"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Job"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"assignment_id"}},{"kind":"Field","name":{"kind":"Name","value":"ends_time"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"location_id"}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"timezone_lookup"}}]}},{"kind":"Field","name":{"kind":"Name","value":"positions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"display_name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"professional"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"account"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"agency_id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"professional_saas_details"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"employment_type"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"shift_type"}},{"kind":"Field","name":{"kind":"Name","value":"specialties"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"starts_date"}},{"kind":"Field","name":{"kind":"Name","value":"starts_time"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"surgery_types"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"SchedulerCardContainerJob"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"SchedulerCardContainerDuplicateJob"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"QuickAddNoCard"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"StatusIconJob"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Job"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"approval_status"}},{"kind":"Field","name":{"kind":"Name","value":"current_ends_time"}},{"kind":"Field","name":{"kind":"Name","value":"current_starts_time"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"positions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"display_name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"professional_id"}},{"kind":"Field","name":{"kind":"Name","value":"shift_type"}},{"kind":"Field","name":{"kind":"Name","value":"starts_time"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SchedulerCard"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Job"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"approval_status"}},{"kind":"Field","name":{"kind":"Name","value":"current_ends_time"}},{"kind":"Field","name":{"kind":"Name","value":"current_starts_time"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"positions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"display_name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"professional_id"}},{"kind":"Field","name":{"kind":"Name","value":"shift_type"}},{"kind":"Field","name":{"kind":"Name","value":"starts_time"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"StatusIconJob"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"JobListDialog"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Job"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"approval_status"}},{"kind":"Field","name":{"kind":"Name","value":"assignment_id"}},{"kind":"Field","name":{"kind":"Name","value":"current_ends_time"}},{"kind":"Field","name":{"kind":"Name","value":"current_starts_time"}},{"kind":"Field","name":{"kind":"Name","value":"ends_time"}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"timezone_lookup"}},{"kind":"Field","name":{"kind":"Name","value":"unit"}}]}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"positions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"display_name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"professional"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"account"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"agency_id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"professional_saas_details"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"employment_type"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"shift_type"}},{"kind":"Field","name":{"kind":"Name","value":"starts_time"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SchedulerCardContainerJob"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Job"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SchedulerCard"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SchedulerCardContainerDuplicateJob"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Job"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"JobListDialog"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"QuickAddNoCard"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Job"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"assignment_id"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"location_id"}},{"kind":"Field","name":{"kind":"Name","value":"positions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"display_name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"starts_time"}}]}}]} as unknown as DocumentNode<SchedulerWeekJobFragment, unknown>;
export const GetJobForTopBarRightContentDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetJobForTopBarRightContent"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"job"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"assignment_id"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]}}]} as unknown as DocumentNode<GetJobForTopBarRightContentQuery, GetJobForTopBarRightContentQueryVariables>;
export const GetAssignmentForTopBarTitleBackDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetAssignmentForTopBarTitleBack"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"assignment"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ends_date"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"is_extension"}},{"kind":"Field","name":{"kind":"Name","value":"professional"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"account"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<GetAssignmentForTopBarTitleBackQuery, GetAssignmentForTopBarTitleBackQueryVariables>;
export const GetJobForTopBarTitleBackDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetJobForTopBarTitleBack"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"job"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"professional"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"account"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetJobForTopBarTitleBackQuery, GetJobForTopBarTitleBackQueryVariables>;
export const GetApplicationForTopBarTitleBackDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetApplicationForTopBarTitleBack"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"assignmentRequest"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"professional"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"account"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetApplicationForTopBarTitleBackQuery, GetApplicationForTopBarTitleBackQueryVariables>;
export const StatsigSetupDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"StatsigSetup"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"locationInput"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"LocationQueryInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"billingInput"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"BillingGroupQueryInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"activeBillingGroups"},"name":{"kind":"Name","value":"billingGroups"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"billingInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"activeLocations"},"name":{"kind":"Name","value":"locations"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"locationInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"location_type_id"}},{"kind":"Field","name":{"kind":"Name","value":"market_id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"me"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"company_id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<StatsigSetupQuery, StatsigSetupQueryVariables>;
export const GetJobCountForStatsigDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetJobCountForStatsig"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"JobQueryInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"jobCount"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]} as unknown as DocumentNode<GetJobCountForStatsigQuery, GetJobCountForStatsigQueryVariables>;
export const GetSchemaPermissionsForRequestsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetSchemaPermissionsForRequests"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accountRequestPermissions"}}]}}]} as unknown as DocumentNode<GetSchemaPermissionsForRequestsQuery, GetSchemaPermissionsForRequestsQueryVariables>;
export const DashboardAssignmentsPanelEndingSoonDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"DashboardAssignmentsPanelEndingSoon"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"assignmentsEndingSoon"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]} as unknown as DocumentNode<DashboardAssignmentsPanelEndingSoonQuery, DashboardAssignmentsPanelEndingSoonQueryVariables>;
export const DashboardAssignmentsPanelStartingSoonDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"DashboardAssignmentsPanelStartingSoon"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"assignmentsStartingSoon"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]} as unknown as DocumentNode<DashboardAssignmentsPanelStartingSoonQuery, DashboardAssignmentsPanelStartingSoonQueryVariables>;
export const EhrSystemDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"EhrSystem"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"EhrSystemQueryInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ehrSystems"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}}]}}]} as unknown as DocumentNode<EhrSystemQuery, EhrSystemQueryVariables>;
export const FavoritesPanelRowsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FavoritesPanelRows"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"favoritesPanelRows"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"job_id"}},{"kind":"Field","name":{"kind":"Name","value":"starts_date"}},{"kind":"Field","name":{"kind":"Name","value":"starts_time"}},{"kind":"Field","name":{"kind":"Name","value":"location_name"}},{"kind":"Field","name":{"kind":"Name","value":"location_id"}},{"kind":"Field","name":{"kind":"Name","value":"professional_id"}},{"kind":"Field","name":{"kind":"Name","value":"professional_name"}},{"kind":"Field","name":{"kind":"Name","value":"positions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"display_name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"is_favorited"}},{"kind":"Field","name":{"kind":"Name","value":"is_blocked"}}]}}]}}]} as unknown as DocumentNode<FavoritesPanelRowsQuery, FavoritesPanelRowsQueryVariables>;
export const MetabaseEmbedDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"MetabaseEmbed"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"MetabaseEmbedQueryInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"metabaseEmbedUrl"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"signed_token"}}]}}]}}]} as unknown as DocumentNode<MetabaseEmbedQuery, MetabaseEmbedQueryVariables>;
export const DashboardDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Dashboard"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"newApplicantCount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]} as unknown as DocumentNode<DashboardQuery, DashboardQueryVariables>;
export const ProfessionalDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Professional"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"location_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"location_ids"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"poolProfessional"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"location_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"location_id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"account"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"company_id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"locations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"phone_number"}},{"kind":"Field","name":{"kind":"Name","value":"primary_locations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ssn_last_4"}}]}},{"kind":"Field","name":{"kind":"Name","value":"background_checks"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"completed_on"}}]}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"dob"}},{"kind":"Field","name":{"kind":"Name","value":"emergency_contacts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"phone_number"}}]}},{"kind":"Field","name":{"kind":"Name","value":"has_active_jobs_here"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"location_ids"},"value":{"kind":"Variable","name":{"kind":"Name","value":"location_ids"}}}]},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"is_blocked"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"location_ids"},"value":{"kind":"Variable","name":{"kind":"Name","value":"location_ids"}}}]},{"kind":"Field","name":{"kind":"Name","value":"is_favorite"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"location_ids"},"value":{"kind":"Variable","name":{"kind":"Name","value":"location_ids"}}}]},{"kind":"Field","name":{"kind":"Name","value":"kinds"}},{"kind":"Field","name":{"kind":"Name","value":"positions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"kind"}},{"kind":"Field","name":{"kind":"Name","value":"display_name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"professional_saas_details"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"max_weekly_hours"}},{"kind":"Field","name":{"kind":"Name","value":"hourly_rate_cents"}},{"kind":"Field","name":{"kind":"Name","value":"shift_types"}},{"kind":"Field","name":{"kind":"Name","value":"employment_type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"professional_qualifications"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"professional_qualification_attributes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"qualification_attribute"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"shifts_completed"}},{"kind":"Field","name":{"kind":"Name","value":"shifts_completed_here"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"location_ids"},"value":{"kind":"Variable","name":{"kind":"Name","value":"location_ids"}}}]},{"kind":"Field","name":{"kind":"Name","value":"specialties"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"positions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"years_experience"}}]}}]}}]} as unknown as DocumentNode<ProfessionalQuery, ProfessionalQueryVariables>;
export const OnboardingProfessionalsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"OnboardingProfessionals"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ProfessionalPoolQueryInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"location_ids"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"poolProfessionals"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"account"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"positions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"display_name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"professional_qualifications"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"professional_qualification_attributes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"qualification_attribute"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"years_experience"}}]}},{"kind":"Field","name":{"kind":"Name","value":"_poolProfessionalsMeta"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]} as unknown as DocumentNode<OnboardingProfessionalsQuery, OnboardingProfessionalsQueryVariables>;
export const WeeklyTimecardTotalsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"WeeklyTimecardTotals"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"WeeklyTimecardsTotalsInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"weeklyTimecardsTotals"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hours"}},{"kind":"Field","name":{"kind":"Name","value":"start_of_week"}}]}}]}}]} as unknown as DocumentNode<WeeklyTimecardTotalsQuery, WeeklyTimecardTotalsQueryVariables>;
export const GatewayBillingGroupDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GatewayBillingGroup"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"uid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"gatewayBillingGroup"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"uid"},"value":{"kind":"Variable","name":{"kind":"Name","value":"uid"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"balance_cents"}},{"kind":"Field","name":{"kind":"Name","value":"total_due_cents"}},{"kind":"Field","name":{"kind":"Name","value":"company"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ach_source_detail"}},{"kind":"Field","name":{"kind":"Name","value":"funding_sources"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"brand"}},{"kind":"Field","name":{"kind":"Name","value":"last4"}},{"kind":"Field","name":{"kind":"Name","value":"bank_name"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]}}]}}]} as unknown as DocumentNode<GatewayBillingGroupQuery, GatewayBillingGroupQueryVariables>;
export const GetGatewayInvoiceDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetGatewayInvoice"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"billing_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"gatewayInvoice"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"billing_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"billing_id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"billing_id"}},{"kind":"Field","name":{"kind":"Name","value":"due_date"}},{"kind":"Field","name":{"kind":"Name","value":"job_count"}},{"kind":"Field","name":{"kind":"Name","value":"total_hours"}},{"kind":"Field","name":{"kind":"Name","value":"total_cents"}},{"kind":"Field","name":{"kind":"Name","value":"amount_due_cents"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"starts_time"}},{"kind":"Field","name":{"kind":"Name","value":"ends_time"}},{"kind":"Field","name":{"kind":"Name","value":"total_hours"}},{"kind":"Field","name":{"kind":"Name","value":"total_regular_hours"}},{"kind":"Field","name":{"kind":"Name","value":"total_breaks_hours"}},{"kind":"Field","name":{"kind":"Name","value":"total_overtime_hours"}},{"kind":"Field","name":{"kind":"Name","value":"total_double_hours"}},{"kind":"Field","name":{"kind":"Name","value":"total_on_call_hours"}},{"kind":"Field","name":{"kind":"Name","value":"total_callback_hours"}},{"kind":"Field","name":{"kind":"Name","value":"invoice_type"}},{"kind":"Field","name":{"kind":"Name","value":"stripe_payment_intents"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"stripe_id"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"amount_cents"}},{"kind":"Field","name":{"kind":"Name","value":"funding_source"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"last4"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"parent_invoice_links"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"parent_invoice_id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"assignment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"require_physical_signature"}},{"kind":"Field","name":{"kind":"Name","value":"track_unpaid_breaks"}},{"kind":"Field","name":{"kind":"Name","value":"professional"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"kind"}}]}},{"kind":"Field","name":{"kind":"Name","value":"positions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"display_name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"billing_group"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uid"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"company"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"balance_cents"}}]}},{"kind":"Field","name":{"kind":"Name","value":"jobs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"admin_notes"}},{"kind":"Field","name":{"kind":"Name","value":"is_w2"}},{"kind":"Field","name":{"kind":"Name","value":"professional"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"account"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"positions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"display_name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"current_starts_time"}},{"kind":"Field","name":{"kind":"Name","value":"current_ends_time"}},{"kind":"Field","name":{"kind":"Name","value":"canceled_by_location"}},{"kind":"Field","name":{"kind":"Name","value":"job_billing_sums"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"billing_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"billing_id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"total_hours"}},{"kind":"Field","name":{"kind":"Name","value":"charge_regular_hours"}},{"kind":"Field","name":{"kind":"Name","value":"charge_regular_amount_cents"}},{"kind":"Field","name":{"kind":"Name","value":"charge_overtime_hours"}},{"kind":"Field","name":{"kind":"Name","value":"charge_overtime_amount_cents"}},{"kind":"Field","name":{"kind":"Name","value":"charge_double_hours"}},{"kind":"Field","name":{"kind":"Name","value":"charge_double_amount_cents"}},{"kind":"Field","name":{"kind":"Name","value":"total_on_call_hours"}},{"kind":"Field","name":{"kind":"Name","value":"total_breaks_hours"}},{"kind":"Field","name":{"kind":"Name","value":"charge_callback_hours"}},{"kind":"Field","name":{"kind":"Name","value":"charge_callback_amount_cents"}},{"kind":"Field","name":{"kind":"Name","value":"charge_total_amount_cents"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"revenue_adjustments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"job_id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"amount_cents"}},{"kind":"Field","name":{"kind":"Name","value":"adjustment_type"}}]}}]}}]}}]} as unknown as DocumentNode<GetGatewayInvoiceQuery, GetGatewayInvoiceQueryVariables>;
export const GatewayInvoicesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GatewayInvoices"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"InvoiceQueryInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"gatewayInvoices"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"billing_id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"jobs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"total_cents"}},{"kind":"Field","name":{"kind":"Name","value":"amount_due_cents"}},{"kind":"Field","name":{"kind":"Name","value":"job_count"}},{"kind":"Field","name":{"kind":"Name","value":"due_date"}},{"kind":"Field","name":{"kind":"Name","value":"starts_time"}},{"kind":"Field","name":{"kind":"Name","value":"ends_time"}},{"kind":"Field","name":{"kind":"Name","value":"total_hours"}},{"kind":"Field","name":{"kind":"Name","value":"total_regular_hours"}},{"kind":"Field","name":{"kind":"Name","value":"total_overtime_hours"}},{"kind":"Field","name":{"kind":"Name","value":"total_double_hours"}},{"kind":"Field","name":{"kind":"Name","value":"total_breaks_hours"}},{"kind":"Field","name":{"kind":"Name","value":"total_on_call_hours"}},{"kind":"Field","name":{"kind":"Name","value":"total_callback_hours"}},{"kind":"Field","name":{"kind":"Name","value":"invoice_type"}},{"kind":"Field","name":{"kind":"Name","value":"stripe_payment_intents"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"stripe_id"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"amount_cents"}},{"kind":"Field","name":{"kind":"Name","value":"funding_source"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"last4"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"_gatewayInvoicesMeta"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]} as unknown as DocumentNode<GatewayInvoicesQuery, GatewayInvoicesQueryVariables>;
export const GatewayBillingGroupCreditLimitCalculationsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GatewayBillingGroupCreditLimitCalculations"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"uid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"gatewayBillingGroupCreditLimitCalculation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"uid"},"value":{"kind":"Variable","name":{"kind":"Name","value":"uid"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"remaining_credit_cents"}}]}}]}}]} as unknown as DocumentNode<GatewayBillingGroupCreditLimitCalculationsQuery, GatewayBillingGroupCreditLimitCalculationsQueryVariables>;
export const GetJobForJobRootDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetJobForJobRoot"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"location_ids"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"job"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"approval_status"}},{"kind":"Field","name":{"kind":"Name","value":"assignment_id"}},{"kind":"Field","name":{"kind":"Name","value":"professional"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"Experience"}}]}},{"kind":"Field","name":{"kind":"Name","value":"starts_time"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"timecard_id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"JobDetailsLayout"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"JobLocationSync"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PerDiemJobForm"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ApproversList"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Approval"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"approval_groups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accounts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"approval_rule_id"}},{"kind":"Field","name":{"kind":"Name","value":"approver_account"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"rejection_reason"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"tier"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ApprovalMutation"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Job"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"approvals"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ApprovalActions"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Job"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"created_by"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ApprovalMutation"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"JobApprovalDetails"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Job"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"approval_requestee_notes"}},{"kind":"Field","name":{"kind":"Name","value":"approval_status"}},{"kind":"Field","name":{"kind":"Name","value":"approval_violated_parameters"}},{"kind":"Field","name":{"kind":"Name","value":"approvals"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"approval_groups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accounts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ApproversList"}}]}},{"kind":"Field","name":{"kind":"Name","value":"marketplace_job_profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"charge_base_hourly_rate_cents"}}]}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ApprovalActions"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CancelProInfo"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Job"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"professional"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"account"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"is_any_favorite"}},{"kind":"Field","name":{"kind":"Name","value":"kind"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CancelJobModal"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Job"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"assignment_id"}},{"kind":"Field","name":{"kind":"Name","value":"assignment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"cancellation_fee_window"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"location_id"}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"company_id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"positions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"display_name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"professional"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"account"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"first_name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"starts_date"}},{"kind":"Field","name":{"kind":"Name","value":"starts_time"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"CancelProInfo"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BlockFavoriteButtons"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Professional"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"account"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"is_blocked"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"location_ids"},"value":{"kind":"Variable","name":{"kind":"Name","value":"location_ids"}}}]},{"kind":"Field","name":{"kind":"Name","value":"is_favorite"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"location_ids"},"value":{"kind":"Variable","name":{"kind":"Name","value":"location_ids"}}}]}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BlockFavoriteMenu"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Professional"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"account"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"is_blocked"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"location_ids"},"value":{"kind":"Variable","name":{"kind":"Name","value":"location_ids"}}}]},{"kind":"Field","name":{"kind":"Name","value":"is_favorite"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"location_ids"},"value":{"kind":"Variable","name":{"kind":"Name","value":"location_ids"}}}]}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DetailsTitle"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Job"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"approval_status"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"professional"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"account"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"kind"}},{"kind":"Field","name":{"kind":"Name","value":"nickname"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"BlockFavoriteButtons"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"BlockFavoriteMenu"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AddClockInDialog"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Job"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"current_ends_time"}},{"kind":"Field","name":{"kind":"Name","value":"current_starts_time"}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"timezone_lookup"}}]}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"starts_time"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ContactButton"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Job"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"professional"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"account"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"professional_number"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EditShiftTimeDialog"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Job"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"approved_clock_in"}},{"kind":"Field","name":{"kind":"Name","value":"approval_status"}},{"kind":"Field","name":{"kind":"Name","value":"current_ends_time"}},{"kind":"Field","name":{"kind":"Name","value":"current_starts_time"}},{"kind":"Field","name":{"kind":"Name","value":"ends_time"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"timezone_lookup"}}]}},{"kind":"Field","name":{"kind":"Name","value":"professional"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"account"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"shift_type"}},{"kind":"Field","name":{"kind":"Name","value":"starts_time"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"JobStatusActions"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Job"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"approval_status"}},{"kind":"Field","name":{"kind":"Name","value":"ends_time"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"shift_type"}},{"kind":"Field","name":{"kind":"Name","value":"starts_time"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"timezone_lookup"}}]}},{"kind":"Field","name":{"kind":"Name","value":"professional"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"AddClockInDialog"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ContactButton"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"EditShiftTimeDialog"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PostedBySection"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Job"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"created_by"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"account_type"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"job_irregularities"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"irregularity_type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"JobDetails"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Job"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"approval_status"}},{"kind":"Field","name":{"kind":"Name","value":"approved_clock_in"}},{"kind":"Field","name":{"kind":"Name","value":"assignment_id"}},{"kind":"Field","name":{"kind":"Name","value":"bonus_one_time_cents"}},{"kind":"Field","name":{"kind":"Name","value":"charge_base_hourly_rate_cents"}},{"kind":"Field","name":{"kind":"Name","value":"charge_on_call_hourly_rate_cents"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"current_ends_time"}},{"kind":"Field","name":{"kind":"Name","value":"current_starts_time"}},{"kind":"Field","name":{"kind":"Name","value":"detail"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"agencies"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"timezone_lookup"}}]}},{"kind":"Field","name":{"kind":"Name","value":"location_id"}},{"kind":"Field","name":{"kind":"Name","value":"marketplace_bonus_one_time_cents"}},{"kind":"Field","name":{"kind":"Name","value":"marketplace_charge_base_hourly_rate_cents"}},{"kind":"Field","name":{"kind":"Name","value":"positions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"display_name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"professional_id"}},{"kind":"Field","name":{"kind":"Name","value":"release_audience"}},{"kind":"Field","name":{"kind":"Name","value":"shift_type"}},{"kind":"Field","name":{"kind":"Name","value":"specialties"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"label"}}]}},{"kind":"Field","name":{"kind":"Name","value":"starts_date"}},{"kind":"Field","name":{"kind":"Name","value":"starts_time"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"CancelJobModal"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"DetailsTitle"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"JobStatusActions"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PostedBySection"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TimesheetDetailsClockEventAttachment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ClockEventAttachment"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"clock_event_id"}},{"kind":"Field","name":{"kind":"Name","value":"clock_event_type"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"file"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"}},{"kind":"Field","name":{"kind":"Name","value":"reasons"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DisputableDetailsSection"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Job"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"status"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RegularHoursSection"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Job"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"charge_overtime_multiplier"}},{"kind":"Field","name":{"kind":"Name","value":"job_price_differentials"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"recommendation_used"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"Field","name":{"kind":"Name","value":"job_billing_sums"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"charge_overtime_amount_cents"}},{"kind":"Field","name":{"kind":"Name","value":"charge_overtime_hours"}},{"kind":"Field","name":{"kind":"Name","value":"charge_regular_amount_cents"}},{"kind":"Field","name":{"kind":"Name","value":"charge_regular_hours"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CancelDisputeButtonContainer"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Job"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DisputeFormDisplayHelpers"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Job"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"job_irregularities"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"irregularity_type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"track_unpaid_breaks"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ClockOutHelperText"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Job"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"approved_clock_out"}},{"kind":"Field","name":{"kind":"Name","value":"ends_time"}},{"kind":"Field","name":{"kind":"Name","value":"job_irregularities"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"irregularity_type"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DisputeFormContent"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Job"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"approved_clock_in"}},{"kind":"Field","name":{"kind":"Name","value":"ends_time"}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"timezone_lookup"}}]}},{"kind":"Field","name":{"kind":"Name","value":"professional"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"starts_date"}},{"kind":"Field","name":{"kind":"Name","value":"starts_time"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"DisputeFormDisplayHelpers"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ClockOutHelperText"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ValidateForm"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Job"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"approved_clock_in"}},{"kind":"Field","name":{"kind":"Name","value":"approved_clock_out"}},{"kind":"Field","name":{"kind":"Name","value":"job_billing_sums"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"total_breaks_minutes"}}]}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"timezone_lookup"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"DisputeFormDisplayHelpers"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DisputeForm"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Job"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"approved_clock_in"}},{"kind":"Field","name":{"kind":"Name","value":"approved_clock_out"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"track_unpaid_breaks"}},{"kind":"Field","name":{"kind":"Name","value":"job_billing_sums"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"total_breaks_minutes"}}]}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"timezone_lookup"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"DisputeFormContent"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ValidateForm"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DisputeModal"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Job"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"job_irregularities"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"label"}}]}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"DisputeForm"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DisputeButtonsContainer"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Job"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"approved_clock_in"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"job_irregularities"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"approved_by_account_id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"company_id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"DisputeModal"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TimesheetDetailsButton"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Job"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"CancelDisputeButtonContainer"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"DisputeButtonsContainer"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TimesheetDetails"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Job"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"approved_clock_in"}},{"kind":"Field","name":{"kind":"Name","value":"approved_clock_out"}},{"kind":"Field","name":{"kind":"Name","value":"assignment_id"}},{"kind":"Field","name":{"kind":"Name","value":"attachment"}},{"kind":"Field","name":{"kind":"Name","value":"check_ins"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"clock_event_attachments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"file"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"}},{"kind":"Field","name":{"kind":"Name","value":"reasons"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"TimesheetDetailsClockEventAttachment"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"check_outs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"clock_event_attachments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"file"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"}},{"kind":"Field","name":{"kind":"Name","value":"reasons"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"TimesheetDetailsClockEventAttachment"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"ends_time"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"is_w2"}},{"kind":"Field","name":{"kind":"Name","value":"job_billing_sums"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"charge_callback_hours"}},{"kind":"Field","name":{"kind":"Name","value":"charge_double_hours"}},{"kind":"Field","name":{"kind":"Name","value":"charge_overtime_hours"}},{"kind":"Field","name":{"kind":"Name","value":"charge_total_amount_cents"}},{"kind":"Field","name":{"kind":"Name","value":"total_breaks_minutes"}},{"kind":"Field","name":{"kind":"Name","value":"total_hours"}},{"kind":"Field","name":{"kind":"Name","value":"total_on_call_hours"}}]}},{"kind":"Field","name":{"kind":"Name","value":"job_irregularities"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"label"}}]}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"enable_geo_fence"}},{"kind":"Field","name":{"kind":"Name","value":"require_upload_on_clock_out"}},{"kind":"Field","name":{"kind":"Name","value":"timezone_lookup"}}]}},{"kind":"Field","name":{"kind":"Name","value":"positions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"display_name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"specialties"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"label"}}]}},{"kind":"Field","name":{"kind":"Name","value":"starts_date"}},{"kind":"Field","name":{"kind":"Name","value":"starts_time"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"track_unpaid_breaks"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"DetailsTitle"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"DisputableDetailsSection"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PostedBySection"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"RegularHoursSection"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"TimesheetDetailsButton"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Experience"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Professional"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"account"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"phone_number"}},{"kind":"Field","name":{"kind":"Name","value":"ssn_last_4"}}]}},{"kind":"Field","name":{"kind":"Name","value":"dob"}},{"kind":"Field","name":{"kind":"Name","value":"has_active_jobs_here"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"location_ids"},"value":{"kind":"Variable","name":{"kind":"Name","value":"location_ids"}}}]},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"positions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"display_name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"specialties"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"positions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"shifts_completed"}},{"kind":"Field","name":{"kind":"Name","value":"shifts_completed_here"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"location_ids"},"value":{"kind":"Variable","name":{"kind":"Name","value":"location_ids"}}}]},{"kind":"Field","name":{"kind":"Name","value":"years_experience"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"JobDetailsLayout"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Job"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"approval_status"}},{"kind":"Field","name":{"kind":"Name","value":"approvals"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"JobApprovalDetails"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"JobDetails"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"TimesheetDetails"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"JobLocationSync"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Job"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"assignment_id"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"location_id"}},{"kind":"Field","name":{"kind":"Name","value":"professional_id"}},{"kind":"Field","name":{"kind":"Name","value":"shift_type"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"assignment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"professional"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PerDiemJobForm"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Job"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"approval_status"}},{"kind":"Field","name":{"kind":"Name","value":"bonus_one_time_cents"}},{"kind":"Field","name":{"kind":"Name","value":"charge_base_hourly_rate_cents"}},{"kind":"Field","name":{"kind":"Name","value":"clinical_contact"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"covid_care"}},{"kind":"Field","name":{"kind":"Name","value":"detail"}},{"kind":"Field","name":{"kind":"Name","value":"ends_date"}},{"kind":"Field","name":{"kind":"Name","value":"ends_time"}},{"kind":"Field","name":{"kind":"Name","value":"favorite_ids"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"timezone_lookup"}}]}},{"kind":"Field","name":{"kind":"Name","value":"location_id"}},{"kind":"Field","name":{"kind":"Name","value":"marketplace_bonus_one_time_cents"}},{"kind":"Field","name":{"kind":"Name","value":"marketplace_charge_base_hourly_rate_cents"}},{"kind":"Field","name":{"kind":"Name","value":"override_rates"}},{"kind":"Field","name":{"kind":"Name","value":"patient_population"}},{"kind":"Field","name":{"kind":"Name","value":"position_ids"}},{"kind":"Field","name":{"kind":"Name","value":"positions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"display_name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"posting_field_contents"}},{"kind":"Field","name":{"kind":"Name","value":"professional"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"professional_id"}},{"kind":"Field","name":{"kind":"Name","value":"release_audience"}},{"kind":"Field","name":{"kind":"Name","value":"release_to_marketplace_strategy"}},{"kind":"Field","name":{"kind":"Name","value":"release_to_platform"}},{"kind":"Field","name":{"kind":"Name","value":"reserved_for_favorites_only"}},{"kind":"Field","name":{"kind":"Name","value":"specialties"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"starts_date"}},{"kind":"Field","name":{"kind":"Name","value":"starts_time"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"surgery_types"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<GetJobForJobRootQuery, GetJobForJobRootQueryVariables>;
export const GetProfessionalForHourSummaryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetProfessionalForHourSummary"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"professional"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"account"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"professional_saas_details"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"max_weekly_hours"}}]}}]}}]}}]} as unknown as DocumentNode<GetProfessionalForHourSummaryQuery, GetProfessionalForHourSummaryQueryVariables>;
export const GetScheduleDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetSchedule"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"assignmentDateRange"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DateRangeInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"assignmentInput"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AssignmentQueryInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"assignmentJobsInput"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"JobQueryInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"getAssignmentJobs"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"getAssignments"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"getPerDiemJobs"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"isDayView"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"isWeekView"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"isMonthView"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"perDiemJobInput"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"JobQueryInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"assignmentJobs"},"name":{"kind":"Name","value":"jobs"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"assignmentJobsInput"}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"getAssignmentJobs"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SchedulerDayJob"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"isDayView"}}}]}]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"SchedulerWeekJob"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"isWeekView"}}}]}]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"SchedulerMonthJob"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"isMonthView"}}}]}]},{"kind":"Field","name":{"kind":"Name","value":"approval_status"}},{"kind":"Field","name":{"kind":"Name","value":"assignment_id"}},{"kind":"Field","name":{"kind":"Name","value":"current_ends_time"}},{"kind":"Field","name":{"kind":"Name","value":"current_starts_time"}},{"kind":"Field","name":{"kind":"Name","value":"ends_time"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"timezone_lookup"}}]}},{"kind":"Field","name":{"kind":"Name","value":"positions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"display_name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"shift_type"}},{"kind":"Field","name":{"kind":"Name","value":"starts_time"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}},{"kind":"Field","name":{"kind":"Name","value":"assignments"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"assignmentInput"}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"getAssignments"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SchedulerWeekAssignment"}},{"kind":"Field","name":{"kind":"Name","value":"ends_date"}},{"kind":"Field","name":{"kind":"Name","value":"ends_time"}},{"kind":"Field","name":{"kind":"Name","value":"existing_job_hours"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"range"},"value":{"kind":"Variable","name":{"kind":"Name","value":"assignmentDateRange"}}}]},{"kind":"Field","name":{"kind":"Name","value":"guaranteed_minimum_hours"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_shifts_per_week"}},{"kind":"Field","name":{"kind":"Name","value":"positions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"starts_date"}},{"kind":"Field","name":{"kind":"Name","value":"starts_time"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"perDiemJobs"},"name":{"kind":"Name","value":"jobs"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"perDiemJobInput"}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"getPerDiemJobs"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SchedulerDayJob"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"isDayView"}}}]}]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"SchedulerWeekJob"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"isWeekView"}}}]}]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"SchedulerMonthJob"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"isMonthView"}}}]}]},{"kind":"Field","name":{"kind":"Name","value":"approval_status"}},{"kind":"Field","name":{"kind":"Name","value":"assignment_id"}},{"kind":"Field","name":{"kind":"Name","value":"current_ends_time"}},{"kind":"Field","name":{"kind":"Name","value":"current_starts_time"}},{"kind":"Field","name":{"kind":"Name","value":"ends_time"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"timezone_lookup"}}]}},{"kind":"Field","name":{"kind":"Name","value":"positions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"display_name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"shift_type"}},{"kind":"Field","name":{"kind":"Name","value":"starts_time"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"StatusIconJob"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Job"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"approval_status"}},{"kind":"Field","name":{"kind":"Name","value":"current_ends_time"}},{"kind":"Field","name":{"kind":"Name","value":"current_starts_time"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"positions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"display_name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"professional_id"}},{"kind":"Field","name":{"kind":"Name","value":"shift_type"}},{"kind":"Field","name":{"kind":"Name","value":"starts_time"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SchedulerCard"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Job"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"approval_status"}},{"kind":"Field","name":{"kind":"Name","value":"current_ends_time"}},{"kind":"Field","name":{"kind":"Name","value":"current_starts_time"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"positions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"display_name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"professional_id"}},{"kind":"Field","name":{"kind":"Name","value":"shift_type"}},{"kind":"Field","name":{"kind":"Name","value":"starts_time"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"StatusIconJob"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SchedulerCardContainerJob"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Job"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SchedulerCard"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"JobListDialog"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Job"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"approval_status"}},{"kind":"Field","name":{"kind":"Name","value":"assignment_id"}},{"kind":"Field","name":{"kind":"Name","value":"current_ends_time"}},{"kind":"Field","name":{"kind":"Name","value":"current_starts_time"}},{"kind":"Field","name":{"kind":"Name","value":"ends_time"}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"timezone_lookup"}},{"kind":"Field","name":{"kind":"Name","value":"unit"}}]}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"positions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"display_name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"professional"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"account"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"agency_id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"professional_saas_details"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"employment_type"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"shift_type"}},{"kind":"Field","name":{"kind":"Name","value":"starts_time"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SchedulerCardContainerDuplicateJob"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Job"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"JobListDialog"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"QuickAddNoCard"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Job"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"assignment_id"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"location_id"}},{"kind":"Field","name":{"kind":"Name","value":"positions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"display_name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"starts_time"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SchedulerDayJob"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Job"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"approval_status"}},{"kind":"Field","name":{"kind":"Name","value":"assignment_id"}},{"kind":"Field","name":{"kind":"Name","value":"ends_time"}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"unit"}}]}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"positions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"display_name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"professional"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"account"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"agency_id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"professional_saas_details"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"employment_type"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"starts_time"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SchedulerWeekJob"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Job"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"assignment_id"}},{"kind":"Field","name":{"kind":"Name","value":"ends_time"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"location_id"}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"timezone_lookup"}}]}},{"kind":"Field","name":{"kind":"Name","value":"positions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"display_name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"professional"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"account"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"agency_id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"professional_saas_details"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"employment_type"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"shift_type"}},{"kind":"Field","name":{"kind":"Name","value":"specialties"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"starts_date"}},{"kind":"Field","name":{"kind":"Name","value":"starts_time"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"surgery_types"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"SchedulerCardContainerJob"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"SchedulerCardContainerDuplicateJob"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"QuickAddNoCard"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SchedulerMonthJob"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Job"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"approval_status"}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"timezone_lookup"}}]}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"positions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"display_name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"professional"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"account"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"starts_date"}},{"kind":"Field","name":{"kind":"Name","value":"starts_time"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SchedulerWeekAssignment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Assignment"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"is_extension"}},{"kind":"Field","name":{"kind":"Name","value":"positions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"display_name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"professional"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"account"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"agency_id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"professional_saas_details"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"employment_type"}}]}}]}}]}}]} as unknown as DocumentNode<GetScheduleQuery, GetScheduleQueryVariables>;